<template>
  <div class="w100">
    <div
        class="styleCard"
        :class="{ 'styleCard-enlarge': enlargeCompanyTable }"
    >
      <div class="nav-tabs-custom">
        <div class="favorites-wrapper"></div>
        <ul class="nav nav-tabs center-assign-nav">
          <li
              v-if="
              selectedMainTab !== 't4' &&
                (CheckUserPermission([1, 2, 3, 4, 5, 6, 8, 12]) &&
                  auth.user.id !== 114) &&
                selectedClients.length > 0
            "
              class="center-assign"
          >
            <div class="dropdown btn-group">
              <button
                  type="button"
                  class="btn btn-primary dropdown-toggle center-assign-btn center-assign-btn-first"
                  data-toggle="dropdown"
              >
                {{ selectedClients.length }} - <span class="caret"></span>
              </button>
              <button
                  type="button"
                  class="btn btn-primary center-assign-btn center-assign-btn-last"
                  @click="selectAllClientsToAssign"
                  v-if="!selectAllClients"
              >
                All
              </button>
              <button
                  type="button"
                  class="btn btn-primary center-assign-btn center-assign-btn-last"
                  @click="cancelAllClientsToAssign"
                  v-if="selectAllClients"
              >
                <span class="far fa-times-circle"></span>
              </button>

              <!--              <a class="bulk-assign-a" data-toggle="dropdown"-->
              <!--                >{{ selectedClients.length }} - -->
              <!--              </a>-->

              <!--              <a-->
              <!--                @click="selectAllClientsToAssign"-->
              <!--                v-if="!selectAllClients"-->
              <!--                class="bulk-assign-a-all"-->
              <!--                >ALL</a-->
              <!--              >-->
              <!--              <a-->
              <!--                @click="cancelAllClientsToAssign"-->
              <!--                v-if="selectAllClients"-->
              <!--                class="bulk-assign-a-cancel"-->
              <!--                ><i class="fa fa-close"></i-->
              <!--              ></a>-->
              <!--Team Leader missing from auth-->
              <ul
                  v-if="CheckUserPermission([1, 2, 3, 4, 5, 12])"
                  class="dropdown-menu dropdown-menu-assign  p-xy-8"
              >
                <div
                    v-if="
                    selectedMainTab === 'clients' || selectedMainTab === 'ended'
                  "
                >
                  <div class="add-tag-menu-item-title">Assign To</div>
                  <input
                      class="input-standard"
                      type="search"
                      placeholder="Search name"
                      v-model="bulkAssignToQuery"
                      @keyup="
                      bulkAssignToResults = filterFunction(bulkAssignToQuery)
                    "
                  />

                  <div class="dropdown-divider"></div>
                  <div v-if="bulkAssignToResults.length > 0">
                    <li
                        @click="bulkAssignClients(person.id)"
                        class="assign-menu-item"
                        v-for="person in FilterUsersByRole(
                        FilterNonActiveUsers(bulkAssignToResults),
                        [1, 2, 3, 8, 9, 10, 11, 12]
                      )"
                        :key="person.id"
                    >
                      {{ person.first_name + " " + person.last_name }}
                    </li>
                  </div>
                  <div v-if="bulkAssignToResults.length === 0">
                    <li
                        class="assign-menu-item"
                        v-for="person in FilterUsersByRole(
                        FilterNonActiveUsers(),
                        [1, 2, 3, 8, 9, 10, 11, 12]
                      )"
                        :key="person.id"
                        @click="bulkAssignClients(person.id)"
                    >
                      {{ person.first_name + " " + person.last_name }}
                    </li>
                  </div>
                  <div class="dropdown-divider"></div>
                </div>
                <!--                v-if="
              selectedMainTab === 'bn' ||
              selectedMainTab === 'ni' ||
              selectedMainTab === 'na'
              "-->
                <div>
                  <div class="add-tag-menu-item-title">
                    Move To Status Group
                  </div>
                  <li
                      @click="bulkGroupAssignClients(group.id)"
                      class="assign-menu-item"
                      v-for="group in dictionaries.activity
                      .assignment_group_types"
                      :key="group.id"
                  >
                    {{ group.id !== 0 ? group.type : null }}
                  </li>
                  <div class="dropdown-divider"></div>
                </div>

                <div class="add-tag-menu-item-title">
                  Operations
                </div>
                <div
                    v-if="
                    selectedMainTab === 'bn' ||
                      selectedMainTab === 'ni' ||
                      selectedMainTab === 'na'
                  "
                >
                  <li
                      @click="
                      newDuplicate.op = 1;
                      newDuplicate.client = null;
                      newDuplicate.selectedMainTab = selectedMainTab;
                      showBulkDuplicateAssign = true;
                    "
                      class="assign-menu-item"
                  >
                    Duplicate
                  </li>
                </div>
                <li
                    v-if="
                    selectedMainTab !== 'bn' &&
                      selectedMainTab !== 'ni' &&
                      selectedMainTab !== 'na' &&
                      selectedMainTab !== 't4'
                  "
                    @click="checkMergeSelections"
                    class="assign-menu-item"
                >
                  Merge
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <div v-if="openMergeOptions" class="floating-wrapper">
          <div class="floating-merge-details">
            <div>
              <select class="select-standard" v-model="merge.mergetToClientId">
                <option :value="null">Select Primary Client</option>
                <option
                    v-for="type in selectedClients"
                    :key="type"
                    :value="type"
                >
                  #{{ type }}
                </option>
              </select>
              <div class="contact-details-edit">
                <div class="contact-details-edit-checkboxes">
                  <div class="contact-details-edit-checkboxes">
                    <input
                        type="checkbox"
                        v-model="merge.mergeEmails"
                        aria-label="primary"
                    />
                    <label>Copy Emails</label>
                  </div>
                  <div class="contact-details-edit-checkboxes">
                    <input
                        type="checkbox"
                        v-model="merge.mergePhones"
                        aria-label="primary"
                    />
                    <label>Copy Phones</label>
                  </div>
                </div>
              </div>
              <textarea
                  class="form-control input-sm comment-box-scheduled "
                  placeholder="Comment"
                  v-model.trim="merge.mergeComments"
                  maxlength="160"
              ></textarea>
              <span class="text-counter-scheduled"
              >{{ merge.mergeComments.length }}/160</span
              >
              <!--              <p
                v-if="merge.mergeComments.length > 0"
                class="help-block"
              >
                {{ scheduledCallCommentError }}
              </p>-->
            </div>
            <br />
            <tag-form-buttons
                @accepted="saveMergeOp(merge)"
                @cancelled="
                openMergeOptions = false;
                resetAllForms();
              "
            ></tag-form-buttons>
          </div>
        </div>

        <div class="floating-bn-menu">
          <!--            <bn-group-multi-select-->
          <!--              @status="bnTabStatusFilter"-->
          <!--              :options="dictionaries.activity.bad_number_states"-->
          <!--              :open="openBnGroupMenu && selectedMainTab === 'bn'"-->
          <!--              @close="openBnGroupMenu = false"-->
          <!--              @reset="resetBnSelector"-->
          <!--              @apply="debouncedClientsQuery"-->
          <!--              :reset-list="resetMultiSelects"-->
          <!--              :initiated-filtering="resetMsAfterFilter"-->
          <!--              :query-object="getQueryParamsToMs"-->
          <!--            ></bn-group-multi-select>-->
          <multi-select
              @excludeValueChanged="filters.exclude_bn_filter = $event;"
              :background="{
              mainBg: 'background: black',
              btnBg: 'background-color: #f5f1f1; border-color: none;',
              color: 'white'
            }"
              @close="openBnGroupMenu = false"
              :selected-main-tab="selectedMainTab"
              :expandToRight="true"
              :sector="'bad_number'"
              @status="bnTabStatusFilter"
              :open="openBnGroupMenu && selectedMainTab === 'bn'"
              @reset="resetBnSelector"
              @apply="debouncedClientsQuery"
              :reset-list="resetMultiSelects"
              :initiated-filtering="resetMsAfterFilter"
              :query-object="getQueryParamsToMs"
          >
          </multi-select>
        </div>
        <div class="floating-ni-menu" >
          <multi-select
              @excludeValueChanged="filters.exclude_ni_filter = $event;"
              :background="{
              mainBg: 'background: black;',
              btnBg: 'background-color: white; border-color: none;',
              color: 'white'
            }"
            :selected-main-tab="selectedMainTab"
            :expandToRight="true"
            :sector="'not_interested'"
            @not_interested="niTabStatusFilter"
            :open="openNiGroupMenu && selectedMainTab === 'ni'"
            @close="openNiGroupMenu = false"
            @reset="resetNiSelector"
            @apply="debouncedClientsQuery"
            :reset-list="resetMultiSelects"
            :initiated-filtering="resetMsAfterFilter"
            :query-object="getQueryParamsToMs"
          ></multi-select>
        </div>
        <div
            v-if="auth.user.id !== 114 && showBulkDuplicateAssign"
            class="assignment-dropdown"
        >
          <ul
              v-if="CheckUserPermission([1, 2, 3, 4, 5, 12])"
              class="p-xy-8 bulk-duplicate-assignment-dropdown-menu"
          >
            <div class="add-tag-menu-item-title">
              Assign New Duplicate to:
            </div>
            <li
                class="assign-menu-item"
                @click="
                showBulkDuplicateAssign = false;
                newDuplicate.op = null;
                newDuplicate.client = {};
                newDuplicate.selectedMainTab = '';
              "
            >
              <span class="cancel-edit-menu-item"
              >Cancel <span class="fa fa-close remove-tag-icon"></span
              ></span>
            </li>
            <li
                @click="
                saveBulkClientOperation(
                  newDuplicate.op,
                  newDuplicate.selectedMainTab,
                  person.id
                )
              "
                class="assign-menu-item"
                v-for="person in FilterUsersByRole(FilterNonActiveUsers(), [
                1,
                2,
                3,
                8,
                9,
                10,
                11,
                12
              ])"
                :key="person.id"
            >
              {{ person.first_name + " " + person.last_name }}
            </li>
          </ul>
        </div>

        <!--        <users-table-->
        <!--          v-if="-->
        <!--            CheckUserPermission([1, 2, 3, 12]) && selectedMainTab === 'users'-->
        <!--          "-->
        <!--          :selected-tab="selectedTab"-->
        <!--          :users-table-data="usersTableData"-->
        <!--          @default_tab="selectedTab = 'campaign stats'"-->
        <!--          @set-page="setPage"-->
        <!--        >-->
        <!--        </users-table>-->
        <!--        <brokers-table-->
        <!--          v-if="selectedMainTab === 'brokers'"-->
        <!--          @set-page="setPage"-->
        <!--          :brokers-data="brokersTableData"-->
        <!--          :selected-tab="selectedTab"-->
        <!--          @default_tab="selectedTab = 'ORDERS'"-->
        <!--        ></brokers-table>-->
        <affiliation-table
            v-if="
            (CheckUserPermission([1, 2, 3, 12]) || auth.user.id === 114) &&
              selectedMainTab === 'affiliation'
          "
            @set-page="setPage"
            :clicked-clients="clickedClients"
        ></affiliation-table>
        <div
            class="tab-content"
            v-if="
            selectedMainTab !== 'affiliation' &&
              selectedMainTab !== 'users' &&
              selectedMainTab !== 'brokers'
          "
        >
          <div class="tab-pane active tab-pane-wrapper">
            <table class="table main-table main-table-with-scroller">
              <thead>
              <tr class="tr-info">
                <th colspan="100%" class="th-status">
                  <div class="status-main">
                    <div class="status-tags">
                      <div class="select-all-wrapper">
                        <input
                            v-if="CheckUserPermission([1, 2, 3, 4, 5, 12])"
                            :title="'Select All Clients'"
                            class="client-details-checkbox"
                            @click="selectAll"
                            v-model="bulkCheckBoxChecked"
                            type="checkbox"
                        />
                      </div>
                      <div
                          class="forPermitWidth"
                          :class="{ hideIt: !viewResetBtn }"
                      >
                        <i
                            :class="{ hideIt: !viewResetBtn }"
                            v-tooltip="{ content: `Reset` }"
                            v-if="viewResetBtn"
                            @click="resetThFields"
                            href="javascript:void(0);"
                            class="far fa-times-circle"
                            aria-hidden="true"
                        ></i>
                      </div>
                      <div
                          class="floating-wrapper bb-wrapper-arrows-left"
                          :class="{ nonOpacity: selectedClients.length !== 0 }"
                      >
                        <div class="grandfather">
                          <HeaderSubMenuClientsTable
                              :tabsList="tabsListForSubMenu"
                              :direction="'left'"
                              :mainTabPagination="mainTabPagination"
                              @paginate="setMainTabPagination"
                          />
                        </div>
                        <div class="dropdown mainforAllBtns ">
                          <button
                              v-show="selectedClients.length === 0"
                              class="dropdown-toggle "
                              id="dropdownMenu2"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                          >
                              <span class="current-main-tab">
                                <i class="fas fa-bars for-stat"></i>
                                {{ selectedTab.toUpperCase() }}
                                {{
                                  selectedTab === "questions"
                                      ? mainTabPagination.questionSector
                                      : ""
                                }}
                              </span>
                          </button>
                          <div
                              class="dropdown-menu for-stats-menu"
                              :class="{
                                forAllBtns:
                                  selectedTab === 'campaign' ||
                                  selectedTab === 'campaign-2' ||
                                  selectedTab === 'cost' ||
                                  selectedTab === 'status' ||
                                  mainTabPagination.currentTab === 2 ||
                                  mainTabPagination.currentTab === 3 ||
                                  mainTabPagination.currentTab === 4
                              }"
                              aria-labelledby="dropdownMenu2"
                          >
                            <div
                                :class="{ opts: selectedTab !== 'status' }"
                                v-if="selectedTab !== 'status'"
                                @click="emmitSetMainTab('status')"
                            >
                              <!--                                <div class="forIcon">-->
                              <!--                                  <i class="fas fa-bars dropdown-item"> </i>-->
                              <!--                                </div>-->
                              <span class="clickable">STATUS</span>
                            </div>
                            <div
                                v-if="mainTabPagination.currentTab !== 2"
                                :class="{
                                  opts: mainTabPagination.currentTab !== 2
                                }"
                                @click="
                                  [
                                    emmitSetMainTab('questions1'),
                                    emitSetClientsTableSelectedTab(1)
                                  ]
                                "
                            >
                              <!--                                <div class="forIcon">-->
                              <!--&lt;!&ndash;                                  <i class="fas fas fa-question dropdown-item">&ndash;&gt;-->
                              <!--&lt;!&ndash;                                    .I&ndash;&gt;-->
                              <!--&lt;!&ndash;                                  </i>&ndash;&gt;-->
                              <!--                                </div>-->
                              <span class="clickable">QUESTIONS-1</span>
                            </div>
                            <div
                                v-if="mainTabPagination.currentTab !== 3"
                                :class="{
                                  opts: mainTabPagination.currentTab !== 3
                                }"
                                @click="
                                  [
                                    emmitSetMainTab('questions2'),
                                    emitSetClientsTableSelectedTab(2)
                                  ]
                                "
                            >
                              <!--                                <div class="forIcon">-->
                              <!--&lt;!&ndash;                                  <i class="fas fa-question dropdown-item">&ndash;&gt;-->
                              <!--&lt;!&ndash;                                    .II&ndash;&gt;-->
                              <!--&lt;!&ndash;                                  </i>&ndash;&gt;-->
                              <!--                                </div>-->
                              <span class="clickable">QUESTIONS-2</span>
                            </div>
                            <div
                                v-if="mainTabPagination.currentTab !== 4"
                                :class="{
                                  opts: mainTabPagination.currentTab !== 4
                                }"
                                @click="
                                  [
                                    emmitSetMainTab('questions3'),
                                    emitSetClientsTableSelectedTab(3)
                                  ]
                                "
                            >
                              <!--                                <div class="forIcon">-->
                              <!--&lt;!&ndash;                                  <i class="fas fa-question dropdown-item"&ndash;&gt;-->
                              <!--&lt;!&ndash;                                    >.III&ndash;&gt;-->
                              <!--&lt;!&ndash;                                  </i>&ndash;&gt;-->
                              <!--                                </div>-->
                              <span class="clickable">QUESTIONS-3</span>
                            </div>
                            <div
                                v-if="
                                  selectedTab !== 'campaign' &&
                                    CheckUserPermission([1, 2, 3, 4, 7, 12])
                                "
                                :class="{ opts: selectedTab !== 'campaign' }"
                                @click="emmitSetMainTab('campaign')"
                            >
                              <!--                                <div class="forIcon">-->
                              <!--&lt;!&ndash;                                  <i class="fas fas fa-bullhorn dropdown-item"&ndash;&gt;-->
                              <!--&lt;!&ndash;                                    >.I&ndash;&gt;-->
                              <!--&lt;!&ndash;                                  </i>&ndash;&gt;-->
                              <!--                                </div>-->
                              <span class="clickable">CAMPAIGN-1</span>
                            </div>
                            <div
                                v-if="
                                  selectedTab !== 'campaign-2' &&
                                    CheckUserPermission([1, 2, 3, 4, 7, 12])
                                "
                                :class="{ opts: selectedTab !== 'campaign-2' }"
                                @click="emmitSetMainTab('campaign-2')"
                            >
                              <!--                                <div class="forIcon">-->
                              <!--&lt;!&ndash;                                  <i class="fas fas fa-bullhorn dropdown-item">&ndash;&gt;-->
                              <!--&lt;!&ndash;                                    .II&ndash;&gt;-->
                              <!--&lt;!&ndash;                                  </i>&ndash;&gt;-->
                              <!--                                </div>-->
                              <span class="clickable">CAMPAIGN-2</span>
                            </div>
                            <div
                                v-if="
                                  selectedTab !== 'cost' &&
                                    CheckUserPermission([1, 2, 3, 4, 12])
                                "
                                :class="{ opts: selectedTab !== 'cost' }"
                                @click="emmitSetMainTab('cost')"
                            >
                              <!--                                <div class="forIcon">-->
                              <!--&lt;!&ndash;                                  <i class="fas fa-dollar-sign dropdown-item">&ndash;&gt;-->
                              <!--&lt;!&ndash;                                  </i>&ndash;&gt;-->
                              <!--                                </div>-->
                              <span class="clickable">COST</span>
                            </div>
                          </div>
                        </div>
                        <HeaderSubMenuClientsTable
                            :tabsList="tabsListForSubMenu"
                            :direction="'right'"
                            :mainTabPagination="mainTabPagination"
                            @paginate="setMainTabPagination"
                        />
                        <!--                          <div class="grandfather home-wrapper-second">-->
                        <!--                            <span-->
                        <!--                              class="tab-sub-menu-btn"-->
                        <!--                              @click="goHome"-->
                        <!--                              v-show="mainTabPagination.currentTab > 1"-->
                        <!--                            >-->
                        <!--                              <i class="fas fa-home"></i>-->
                        <!--                            </span>-->
                        <!--                          </div>-->
                      </div>
                      <div
                          class="floating-wrapper bb-wrapper-total tags-right-margin"
                      >
                        <AllActiveBreadButton
                            @reset="resetAllActive"
                            @filter="filterProductivity"
                            @filterSingleTag="filterSingleTag"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @resetSelectors="clearPrimaryTagFilters()"
                            @leading_active="filterByActiveLeading()"
                            :stats-leading-active="stats.leading_active"
                            @regular="
                              filters.last_modified_personal !== false
                                ? ''
                                : clearPrimaryTagFilters()
                            "
                            :bg-color="statusBtnColors.bgAll"
                            :disabled="startUpAllTagFilter"
                            :if-calendar-selected="filters.registered_on"
                            :disabled-leading="filters.is_leading"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="
                              filters.last_modified_personal !== false ||
                              startUpAllTagFilter === false
                                ? 'ALL'
                                : ''
                            "
                            :stats="stats.total"
                            :total-disable="
                              filters.last_modified_personal.length
                            "
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            :selectedMainTab="selectedMainTab"
                        />
                      </div>
                      <!--                        <div-->
                      <!--                          v-if="auth.user.role !== 7"-->
                      <!--                          class="floating-wrapper bb-wrapper-all tags-right-margin tags-scale"-->
                      <!--                          :class="{-->
                      <!--                            'bb-wrapper-all-agent': auth.user.role === 7-->
                      <!--                          }"-->
                      <!--                        >-->
                      <!--                          <all-bread-button-->
                      <!--                            @reset="clearPrimaryTagFilters()"-->
                      <!--                            @filterSingleTag="filterSingleTag"-->
                      <!--                            @closeActiveTag="closeActiveTag"-->
                      <!--                            @closeSecondActiveTag="closeSecondActiveTag"-->
                      <!--                            @openActiveTag="openActiveTag"-->
                      <!--                            @openSecondActiveTag="openSecondActiveTag"-->
                      <!--                            @resetSelectors="clearPrimaryTagFilters()"-->
                      <!--                            @leading_active="filterByActiveLeading()"-->
                      <!--                            :stats-leading-active="stats.leading_active"-->
                      <!--                            @regular="-->
                      <!--                              filters.last_modified_personal !== false-->
                      <!--                                ? ''-->
                      <!--                                : clearPrimaryTagFilters()-->
                      <!--                            "-->
                      <!--                            :bg-color="statusBtnColors.bgAll"-->
                      <!--                            :disabled="startUpAllTagFilter"-->
                      <!--                            :disabled-leading="filters.is_leading"-->
                      <!--                            :txt-color="statusBtnColors.txtWhite"-->
                      <!--                            :text="-->
                      <!--                              filters.last_modified_personal !== false ||-->
                      <!--                              startUpAllTagFilter === false-->
                      <!--                                ? 'ALL'-->
                      <!--                                : ''-->
                      <!--                            "-->
                      <!--                            :stats="stats.total"-->
                      <!--                            :total-disable="-->
                      <!--                              filters.last_modified_personal.length-->
                      <!--                            "-->
                      <!--                            :activeTags="activeTags"-->
                      <!--                            :secondActiveTagsArr="secondActiveTagsArr"-->
                      <!--                            :selectedMainTab="selectedMainTab"-->
                      <!--                            :if-calendar-selected="filters.registered_on"-->
                      <!--                          ></all-bread-button>-->
                      <!--                        </div>-->
                      <div
                          class="floating-wrapper bb-wrapper-online tags-right-margin tags-scale"
                      >
                        <button
                            type="button"
                            class="btn btn-online-bb"
                            :class="{
                              'greyed-out': selectedMainTab === 'bn',
                              'online-filter-selected-bb': filters.online
                            }"
                            @click="filterByOnline"
                            id="online"
                        >
                            <span
                                :class="
                                stats.is_online == 0
                                  ? 'offline-filter-selected-bb'
                                  : 'online-active'
                              "
                            >{{
                                stats.is_online > 0 ? stats.is_online : "ON"
                              }}</span
                            >
                          <div
                              class="bb-title-wrapper upper-title "
                              :class="{ 'online-selected': filters.online }"
                          >
                            <span class="">Online</span>
                          </div>
                        </button>
                      </div>
                      <div
                          class="floating-wrapper bb-wrapper-new tags-right-margin tags-scale"
                          :class="{
                            'bb-wrapper-new-agent': auth.user.role === 7
                          }"
                      >
                        <NWBreadcrumbButton
                            @resetSelectors="clearPrimaryTagFilters()"
                            @closeTimeBtnFilter="closeNewTimeFilterMenu"
                            @checkWhereClicked="dateHasentBeenChooseed"
                            @regular="filterByNew(1)"
                            @selling_group="filterByNew(0)"
                            @other_new="filterByNew(2)"
                            @leading_new="filterByNew(3)"
                            @loosing_new="filterByNew(4)"
                            @filter_all="filterByNew(1)"
                            :regCalPresetsStats="regCalPresetsStats"
                            :dateHasentBeenChooseed="tempWhereChoosed"
                            :disabled-other-new="filters.other_new"
                            :disabled="filters.is_new"
                            :disabled-selling-group="filters.selling_group"
                            :disabled-leading-new="filters.leading_new"
                            :disabled-loosing-new="filters.loosing_new"
                            :bg-color="statusBtnColors.bgNew"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="'NW'"
                            :stats="stats.is_new"
                            :stats-selling-group="stats.selling_group_count"
                            :left-ear="stats.other_new"
                            :stats-leading-new="stats.leading_new"
                            :stats-loosing-new="stats.loosing_new"
                            :query-object="getQueryParamsToMs"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            :selectedMainTab="selectedMainTab"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @openMs="openMs"
                            @reset="resetCAselectors"
                            @filterSingleTag="filterSingleTag"
                            :if-calendar-selected="filters.registered_on"
                        />
                      </div>
                      <div
                          v-if="auth.user.role !== 7"
                          class="floating-wrapper bb-wrapper-new tags-right-margin tags-scale"
                          :class="{
                            'bb-wrapper-new-agent': auth.user.role === 7
                          }"
                      >
                        <NotAssNewBreadcrumbButton
                            @resetSelectors="clearPrimaryTagFilters()"
                            @closeTimeBtnFilter="closeNewTimeFilterMenu"
                            @checkWhereClicked="dateHasentBeenChooseed"
                            @regular="filterByNew(1)"
                            @selling_group="filterByNew(0)"
                            @other_new="filterByNew(2)"
                            @leading_new="filterByNew(3)"
                            @loosing_new="filterByNew(4)"
                            @filter_all="filterByNew(1)"
                            :regCalPresetsStats="regCalPresetsStats"
                            :dateHasentBeenChooseed="tempWhereChoosed"
                            :disabled-other-new="filters.other_new"
                            :disabled="filters.is_new"
                            :disabled-selling-group="filters.selling_group"
                            :disabled-leading-new="filters.leading_new"
                            :disabled-loosing-new="filters.loosing_new"
                            :bg-color="statusBtnColors.bgNew"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="'NW'"
                            :stats="stats.is_new"
                            :stats-selling-group="stats.selling_group_count"
                            :left-ear="stats.other_new"
                            :stats-leading-new="stats.leading_new"
                            :stats-loosing-new="stats.loosing_new"
                            :query-object="getQueryParamsToMs"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            :selectedMainTab="selectedMainTab"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @openMs="openMs"
                            @reset="resetCAselectors"
                            @filterSingleTag="filterSingleTag"
                            :if-calendar-selected="filters.registered_on"
                        />
                      </div>
                      <div
                          v-if="auth.user.role !== 7"
                          class="floating-wrapper bb-wrapper-new tags-right-margin tags-scale"
                          :class="{
                            'bb-wrapper-new-agent': auth.user.role === 7
                          }"
                      >
                        <AgentsNewBreadcrumbButton
                            @resetSelectors="clearPrimaryTagFilters()"
                            @closeTimeBtnFilter="closeNewTimeFilterMenu"
                            @checkWhereClicked="dateHasentBeenChooseed"
                            @regular="filterByNew(1)"
                            @selling_group="filterByNew(0)"
                            @other_new="filterByNew(2)"
                            @leading_new="filterByNew(3)"
                            @loosing_new="filterByNew(4)"
                            @filter_all="filterByNew(1)"
                            :regCalPresetsStats="regCalPresetsStats"
                            :dateHasentBeenChooseed="tempWhereChoosed"
                            :disabled-other-new="filters.other_new"
                            :disabled="filters.is_new"
                            :disabled-selling-group="filters.selling_group"
                            :disabled-leading-new="filters.leading_new"
                            :disabled-loosing-new="filters.loosing_new"
                            :bg-color="statusBtnColors.bgNew"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="'NW'"
                            :stats="stats.is_new"
                            :stats-selling-group="stats.selling_group_count"
                            :left-ear="stats.other_new"
                            :stats-leading-new="stats.leading_new"
                            :stats-loosing-new="stats.loosing_new"
                            :query-object="getQueryParamsToMs"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            :selectedMainTab="selectedMainTab"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @openMs="openMs"
                            @reset="resetCAselectors"
                            @filterSingleTag="filterSingleTag"
                            :if-calendar-selected="filters.registered_on"
                        />
                      </div>
                      <div
                          v-if="auth.user.role !== 7"
                          class="floating-wrapper bb-wrapper-new tags-right-margin tags-scale"
                          :class="{
                            'bb-wrapper-new-agent': auth.user.role === 7
                          }"
                      >
                        <LeadingNewBreadcrumbButton
                            @leading_active="filterByActiveLeading()"
                            @resetSelectors="clearPrimaryTagFilters()"
                            @closeTimeBtnFilter="closeNewTimeFilterMenu"
                            @checkWhereClicked="dateHasentBeenChooseed"
                            @regular="filterByNew(1)"
                            @selling_group="filterByNew(0)"
                            @other_new="filterByNew(2)"
                            @leading_new="filterByNew(3)"
                            @loosing_new="filterByNew(4)"
                            @filter_all="filterByNew(1)"
                            :regCalPresetsStats="regCalPresetsStats"
                            :dateHasentBeenChooseed="tempWhereChoosed"
                            :disabled-other-new="filters.other_new"
                            :disabled="filters.is_new"
                            :disabled-selling-group="filters.selling_group"
                            :disabled-leading-new="filters.leading_new"
                            :disabled-loosing-new="filters.loosing_new"
                            :bg-color="statusBtnColors.bgNew"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="'NW'"
                            :stats="stats.is_new"
                            :statsIsLeading="stats.is_leading"
                            :stats-selling-group="stats.selling_group_count"
                            :left-ear="stats.other_new"
                            :stats-leading-new="stats.leading_new"
                            :stats-loosing-new="stats.loosing_new"
                            :query-object="getQueryParamsToMs"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            :selectedMainTab="selectedMainTab"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @openMs="openMs"
                            @reset="resetNWselectors"
                            @filterSingleTag="filterSingleTag"
                            :if-calendar-selected="filters.registered_on"
                            :filtersNW="{
                              isNew: filters.leading_new,
                              isLeading: filters.is_leading
                            }"
                        />
                      </div>
                      <div
                          v-if="auth.user.role !== 7"
                          class="floating-wrapper bb-wrapper-new tags-right-margin tags-scale"
                          :class="{
                            'bb-wrapper-new-agent': auth.user.role === 7
                          }"
                      >
                        <LoosingNewBreadcrumbButton
                            @resetSelectors="clearPrimaryTagFilters()"
                            @closeTimeBtnFilter="closeNewTimeFilterMenu"
                            @checkWhereClicked="dateHasentBeenChooseed"
                            @regular="filterByNew(1)"
                            @other_new="filterByNew(2)"
                            @leading_new="filterByNew(3)"
                            @loosing_new="filterByNew(4)"
                            @filter_all="filterByNew(1)"
                            :regCalPresetsStats="regCalPresetsStats"
                            :dateHasentBeenChooseed="tempWhereChoosed"
                            :disabled-loosing-new="filters.loosing_new"
                            :bg-color="statusBtnColors.bgNew"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="'NW'"
                            :stats-loosing-new="stats.loosing_new"
                            :query-object="getQueryParamsToMs"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            :selectedMainTab="selectedMainTab"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @openMs="openMs"
                            @reset="resetCAselectors"
                            @filterSingleTag="filterSingleTag"
                            :if-calendar-selected="filters.registered_on"
                        />
                      </div>
                      <div
                          class="floating-wrapper bb-wrapper-ca tags-right-margin tags-scale"
                      >
                        <NextCallsBreadcrumbButton
                            @regular="callFilterMenuHandler"
                            :selectedMainTab="selectedMainTab"
                            :disabled="filters.scheduled_calls"
                            :disabled-comming="filters.coming_calls"
                            :disabled-missed="filters.missed_calls"
                            :disabled-today="filters.today_calls"
                            :disabled-auto-missed="filters.auto_missed_calls"
                            :bg-color="statusBtnColors.bgCall"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="'SC'"
                            :stats="stats.scheduled_calls"
                            :right-ear="stats.ca_missed"
                            :left-ear="stats.ca_comming"
                            :today-ear="stats.ca_today"
                            :auto-missed-ear="stats.auto_ca_missed"
                            @missed="missedCallsFilterMenuHandler"
                            @coming="comingCallsFilterMenuHandler"
                            @today="todayCallsFilterMenuHandler"
                            @auto_missed="autoMissedCallsFilterMenuHandler"
                            @resetSelectors="resetCAselectors"
                            :query-object="getQueryParamsToMs"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @openMs="openMs"
                            @reset="resetCAselectors"
                            @filterSingleTag="filterSingleTag"
                            :filtersBarArr="filtersBarArr"
                            :if-calendar-selected="filters.registered_on"
                        />
                      </div>

                      <div
                          class="floating-wrapper bb-wrapper-ca tags-right-margin tags-scale"
                          v-click-outside="caOutClose"
                      >
                        <SCBreadcrumbButton
                            :selectedMainTab="selectedMainTab"
                            :disabled="filters.scheduled_calls"
                            :bg-color="statusBtnColors.bgCall"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="'SC'"
                            :stats="stats.scheduled_calls"
                            :stats_past="stats.past_scheduled_calls"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @openMs="openMs"
                            @filterSingleTag="filterSingleTag"
                        />
                        <multi-select
                            @excludeValueChanged="filters.exclude_ca_filter = $event;"

                            :background="{
                              mainBg: 'background:#fb9324;',
                              btnBg:
                                'background-color: #e67634; border-color: none;',
                              color: ''
                            }"
                            :selected-main-tab="selectedMainTab"
                            :sector="'call_again'"
                            @users="caMsUsers"
                            @reasons="caStatusesFilter"
                            @auto_status="caAutoStatusesFilter"
                            @priority="priorityFilter"
                            :open="openCaMenu"
                            @close="openCaMenu = false"
                            @excludetag="excludeCATag"
                            @conditionForFiltering="conditionForFiltering"
                            @exclude_autos="excludeAutoCATag"
                            @apply="debouncedClientsQuery"
                            :reset-list="resetMultiSelects"
                            :initiated-filtering="resetMsAfterFilter"
                            :query-object="getQueryParamsToMs"
                            :has-tabs="true"
                            @reset="resetCAselectors"
                        ></multi-select>
                      </div>
                      <!--                        @reset="resetCAselectors"-->

                      <!--                        <div-->
                      <!--                          class="floating-wrapper bb-wrapper-ca tags-right-margin tags-scale"-->
                      <!--                        >-->
                      <!--                          <TodayCallsBreadcrumbButton-->
                      <!--                            @regular="callFilterMenuHandler"-->
                      <!--                            :selectedMainTab="selectedMainTab"-->
                      <!--                            :disabled="filters.scheduled_calls"-->
                      <!--                            :disabled-comming="filters.coming_calls"-->
                      <!--                            :disabled-missed="filters.missed_calls"-->
                      <!--                            :disabled-today="filters.today_calls"-->
                      <!--                            :disabled-auto-missed="filters.auto_missed_calls"-->
                      <!--                            :bg-color="statusBtnColors.bgCall"-->
                      <!--                            :txt-color="statusBtnColors.txtWhite"-->
                      <!--                            :text="'SC'"-->
                      <!--                            :stats="stats.scheduled_calls"-->
                      <!--                            :right-ear="stats.ca_missed"-->
                      <!--                            :left-ear="stats.ca_comming"-->
                      <!--                            :today-ear="stats.ca_today"-->
                      <!--                            :auto-missed-ear="stats.auto_ca_missed"-->
                      <!--                            @missed="missedCallsFilterMenuHandler"-->
                      <!--                            @coming="comingCallsFilterMenuHandler"-->
                      <!--                            @today="todayCallsFilterMenuHandler"-->
                      <!--                            @auto_missed="autoMissedCallsFilterMenuHandler"-->
                      <!--                            @resetSelectors="resetCAselectors"-->
                      <!--                            :query-object="getQueryParamsToMs"-->
                      <!--                            :activeTags="activeTags"-->
                      <!--                            :secondActiveTagsArr="secondActiveTagsArr"-->
                      <!--                            @closeActiveTag="closeActiveTag"-->
                      <!--                            @closeSecondActiveTag="closeSecondActiveTag"-->
                      <!--                            @openActiveTag="openActiveTag"-->
                      <!--                            @openSecondActiveTag="openSecondActiveTag"-->
                      <!--                            @openMs="openMs"-->
                      <!--                            @reset="resetCAselectors"-->
                      <!--                            @filterSingleTag="filterSingleTag"-->
                      <!--                            :filtersBarArr="filtersBarArr"-->
                      <!--                            :if-calendar-selected="filters.registered_on"-->
                      <!--                          />-->
                      <!--                        </div>-->
                      <div
                          class="floating-wrapper bb-wrapper-ca tags-right-margin tags-scale"
                          v-if="false"
                      >
                        <!--                          Canceled/Disabled  RESCH.M By Guy request 02.02.21-->
                        <AutoRescheduleCallsBreadcrumbButton
                            @regular="callFilterMenuHandler"
                            :selectedMainTab="selectedMainTab"
                            :disabled="filters.auto_missed_calls"
                            :bg-color="statusBtnColors.bgCall"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="'SC'"
                            :stats="stats.call_rescheduled"
                            @auto_missed="autoMissedCallsFilterMenuHandler"
                            @resetSelectors="resetCAselectors"
                            :query-object="getQueryParamsToMs"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @openMs="openMs"
                            @reset="resetCAselectors"
                            @filterSingleTag="filterSingleTag"
                            :filtersBarArr="filtersBarArr"
                            :if-calendar-selected="filters.registered_on"
                        />
                      </div>
                      <div
                          class="floating-wrapper bb-wrapper-ca tags-right-margin tags-scale"
                      >
                        <MissedCallsBreadcrumbButton
                            @regular="callFilterMenuHandler"
                            :selectedMainTab="selectedMainTab"
                            :disabled="filters.scheduled_calls"
                            :disabled-comming="filters.coming_calls"
                            :disabled-missed="filters.missed_calls"
                            :disabled-today="filters.today_calls"
                            :disabled-auto-missed="filters.auto_missed_calls"
                            :bg-color="statusBtnColors.bgCall"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="'SC'"
                            :stats="stats.scheduled_calls"
                            :right-ear="stats.ca_missed"
                            :left-ear="stats.ca_comming"
                            :today-ear="stats.ca_today"
                            :auto-missed-ear="stats.auto_ca_missed"
                            @missed="missedCallsFilterMenuHandler"
                            @coming="comingCallsFilterMenuHandler"
                            @today="todayCallsFilterMenuHandler"
                            @auto_missed="autoMissedCallsFilterMenuHandler"
                            @resetSelectors="resetCAselectors"
                            :query-object="getQueryParamsToMs"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @openMs="openMs"
                            @reset="resetCAselectors"
                            @filterSingleTag="filterSingleTag"
                            :filtersBarArr="filtersBarArr"
                            :if-calendar-selected="filters.registered_on"
                        />
                      </div>

                      <div
                          class="floating-wrapper bb-wrapper-na tags-right-margin tags-scale"
                          v-click-outside="naOutClose"
                      >
                        <na-bread-button
                            @resetAll="resetThFields"
                            @openMs="openMs"
                            @reset="resetNAselectors"
                            @regular="naFilterMenuHandler"
                            @na_all="naRegCloseFilterMenuHandler"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            :resetNaButtons="filters.na"
                            :resetNaAllButtons="filters.na_all"
                            :disabled="filters.na"
                            :filtersNa="{
                              na: filters.na,
                              naAll: filters.na_all
                            }"
                            :disabled-na-reg="filters.na_all"
                            :bg-color="statusBtnColors.bgNA"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="'NA'"
                            :stats="stats.na"
                            :stats-na-all="stats.na_all_count"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            @filterSingleTag="filterSingleTag"
                            :selectedMainTab="selectedMainTab"
                            :if-calendar-selected="filters.registered_on"
                        ></na-bread-button>
                        <!--                          :stats-reg-na="stats.na_all_count"-->

                        <multi-select
                            @excludeValueChanged="filters.exclude_na_filter = $event;"

                            :background="{
                              mainBg: 'background:#F4511E',
                              btnBg:
                                'background-color: #e63434; border-color: none;',
                              color: ''
                            }"
                            :selected-main-tab="selectedMainTab"
                            :sector="'no_answer'"
                            @users="naUsersMsFilter"
                            :has-tabs="true"
                            :open="openNaMenu"
                            @close="openNaMenu = false"
                            @reset="resetNAselectors"
                            @excludetag="excludeNATag"
                            @apply="debouncedClientsQuery"
                            :reset-list="resetMultiSelects"
                            :initiated-filtering="resetMsAfterFilter"
                            :query-object="getQueryParamsToMs"
                        ></multi-select>
                      </div>
                      <div
                          class="floating-wrapper bb-wrapper-tr tags-right-margin tags-scale"
                          :class="{
                            'bb-wrapper-tr-agent': auth.user.role === 7
                          }"
                          v-click-outside="transOutClose"
                      >
                        <BreadButton
                            :selectedMainTab="selectedMainTab"
                            :disabled="filters.transfer"
                            :bg-color="statusBtnColors.bgTR"
                            :txt-color="statusBtnColors.txtWhite"
                            :stats="stats.transfer"
                            :text="'TR'"
                            :resetTrButtons="filters.transfer"
                            @resetSelectors="resetTRselector"
                            @regular="transferFilterMenuHandler"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @openMs="openMs"
                            @reset="resetTRselector"
                            @filterSingleTag="filterSingleTag"
                            :if-calendar-selected="filters.registered_on"
                        ></BreadButton>
                        <!--                          <span class="bb-title single-bb-title">Transferred</span>-->

                        <multi-select
                            @excludeValueChanged="filters.exclude_tr_filter = $event;"

                            :background="{
                              mainBg: 'background-color: #827717;',
                              btnBg: 'background-color: #827717;',
                              color: ''
                            }"
                            :selected-main-tab="selectedMainTab"
                            :sector="'transfer'"
                            :has-tabs="true"
                            :query-object="getQueryParamsToMs"
                            @transto="transToFilter"
                            @transfrom="transFromFilter"
                            @transby="transByFilter"
                            @types="transTypesFilter"
                            @place="transPlaceFilter"
                            :open="openTransferMenu"
                            @close="openTransferMenu = false"
                            @reset="resetTRselector"
                            @excludetag="excludeTRTag"
                            @apply="debouncedClientsQuery"
                            :reset-list="resetMultiSelects"
                            :initiated-filtering="resetMsAfterFilter"
                        ></multi-select>
                      </div>

                      <div
                          class="floating-wrapper bb-wrapper-rf tags-right-margin tags-scale"
                          v-click-outside="refOutClose"
                      >
                        <RfBreadButton
                            @resetSelectors="resetRFSelectors"
                            :disabled="filters.referral"
                            :bg-color="statusBtnColors.bgRF"
                            :txt-color="statusBtnColors.txtWhite"
                            :stats="stats.referral"
                            :resetButtons="filters.referral"
                            :text="'RF'"
                            @regular="referralFilterMenuHandler"
                            :show-overall="true"
                            :stats-ov="stats.referral_ov"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @openMs="openMs"
                            @reset="resetRFSelectors"
                            @filterSingleTag="filterSingleTag"
                            :selectedMainTab="selectedMainTab"
                            :if-calendar-selected="filters.registered_on"
                        ></RfBreadButton>

                        <multi-select
                            @excludeValueChanged="filters.exclude_rf_filter = $event;"

                            :background="{
                              mainBg: 'background-color: #af3131;',
                              btnBg: '',
                              color: ''
                            }"
                            :selected-main-tab="selectedMainTab"
                            :sector="'referral'"
                            :has-tabs="true"
                            :open="openReferralMenu"
                            @brokers="referralBrokersFilter"
                            @users="referralUsersFilter"
                            v-model="filters.referral_campaigns"
                            @reset="resetRFSelectors"
                            @excludetag="excludeRFTag"
                            @apply="debouncedClientsQuery"
                            :reset-list="resetMultiSelects"
                            :initiated-filtering="resetMsAfterFilter"
                            :query-object="getQueryParamsToMs"
                        >
                        </multi-select>
                      </div>
                      <div
                          class="floating-wrapper bb-wrapper-ld tags-right-margin tags-scale"
                          v-click-outside="leadOutClose"
                      >
                        <LdBreadButton
                            @openMs="openMs"
                            @reset="resetLDselector"
                            @filterSingleTag="filterSingleTag"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            :disabled="filters.leads"
                            :bg-color="statusBtnColors.bgLD"
                            :txt-color="statusBtnColors.txtWhite"
                            :stats="stats.leads"
                            :stats-ov="stats.leads_ov"
                            :text="'LD'"
                            :resetButtons="filters.leads"
                            :show-overall="true"
                            @regular="leadFilterMenuHandler"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            :selectedMainTab="selectedMainTab"
                            :if-calendar-selected="filters.registered_on"
                        ></LdBreadButton>
                        <!--                          <span class="bb-title single-bb-title" style="margin-left: 10px">Leads</span>-->
                        <!--                          :stats-overall="stats.brokers_leads_stats"-->
                        <multi-select
                            @excludeValueChanged="filters.exclude_ld_filter = $event;"

                            :has-tabs="true"
                            :ext-search="false"
                            :sector="'leads'"
                            :background="{
                              mainBg: 'background:#4275ec',
                              btnBg: 'background-color: #1335ff;',
                              color: ''
                            }"
                            :selected-main-tab="selectedMainTab"
                            :open="openLeadFilterMenu"
                            @brokers="leadsCampaignFilter"
                            @users="leadsCampaignUsersFilter"
                            @reset="resetLDselector"
                            @excludetag="excludeLDTag"
                            @apply="debouncedClientsQuery"
                            :reset-list="resetMultiSelects"
                            :initiated-filtering="resetMsAfterFilter"
                            :query-object="getQueryParamsToMs"
                        ></multi-select>
                        <!--                          <ld-multi-select-->
                        <!--                            @brokers="leadsCampaignFilter"-->
                        <!--                            @users="leadsCampaignUsersFilter"-->
                        <!--                            :open="openLeadFilterMenu"-->
                        <!--                            @close="openLeadFilterMenu = false"-->
                        <!--                            @reset="resetLDselector"-->
                        <!--                            @excludetag="excludeLDTag"-->
                        <!--                            @apply="debouncedClientsQuery"-->
                        <!--                            :reset-list="resetMultiSelects"-->
                        <!--                            :initiated-filtering="resetMsAfterFilter"-->
                        <!--                            :query-object="getQueryParamsToMs"-->
                        <!--                          ></ld-multi-select>-->
                      </div>
                      <div
                          class="floating-wrapper bb-wrapper-dp tags-right-margin tags-scale"
                      >
                        <DepositsBreadcrumbButton
                            :disabled="filters.deposit"
                            :disabled-cc-decline="filters.cc_decline_clients"
                            :disabled-deposit="filters.deposit_clients"
                            :bg-color="statusBtnColors.bgDP"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="'DP'"
                            :show-overall="true"
                            :stats="stats.deposits"
                            :stats-overall="stats.brokers_deposits_stats"
                            :resetDpButtons="filters.deposit"
                            :resetCcdclButtons="filters.cc_decline_clients"
                            :resetCLButtons="filters.deposit_clients"
                            @regular="depositFilterMenuHandler"
                            @resetSelectors="resetDPSelectors"
                            :ear-left="true"
                            :ear-right="true"
                            @ccdecline="depositCCFilterMenuHandler"
                            @clientsdep="depositDepFilterMenuHandler"
                            :query-object="getQueryParamsToMs"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @openMs="openMs"
                            @reset="resetDPSelectors"
                            @filterSingleTag="filterSingleTag"
                            :selectedMainTab="selectedMainTab"
                            :if-calendar-selected="filters.registered_on"
                        />
                      </div>
                      <div
                          class="floating-wrapper bb-wrapper-dp tags-right-margin tags-scale"
                          v-click-outside="depOutClose"
                      >
                        <CCDBreadcrumbButton
                            :disabled="filters.deposit"
                            :disabled-cc-decline="filters.cc_decline_clients"
                            :disabled-deposit="filters.deposit_clients"
                            :bg-color="statusBtnColors.bgDP"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="'DP'"
                            :show-overall="true"
                            :stats="stats.deposits"
                            :stats-overall="stats.brokers_deposits_stats"
                            :stats-overall-cc="stats.brokers_deposits_cc_stats"
                            :resetDpButtons="filters.deposit"
                            :resetCcdclButtons="filters.cc_decline_clients"
                            :resetCLButtons="filters.deposit_clients"
                            @regular="depositFilterMenuHandler"
                            @resetSelectors="resetDPSelectors"
                            :ear-left="true"
                            :ear-right="true"
                            @ccdecline="depositCCFilterMenuHandler"
                            @clientsdep="depositDepFilterMenuHandler"
                            :query-object="getQueryParamsToMs"
                            :activeTags="activeTags"
                            :secondActiveTagsArr="secondActiveTagsArr"
                            @closeActiveTag="closeActiveTag"
                            @closeSecondActiveTag="closeSecondActiveTag"
                            @openActiveTag="openActiveTag"
                            @openSecondActiveTag="openSecondActiveTag"
                            @openMs="openMs"
                            @reset="resetDPSelectors"
                            @filterSingleTag="filterSingleTag"
                            :selectedMainTab="selectedMainTab"
                            :if-calendar-selected="filters.registered_on"
                          />
<!--                          //TODO kobi-->
                          <multi-select
                              @excludeValueChanged="filters.exclude_dp_filter = $event;"
                            :background="{
                              mainBg: 'background-color: #ae3ede;',
                              btnBg: '',
                              color: ''
                            }"
                            :selected-main-tab="selectedMainTab"
                            :sector="'deposits'"
                            :has-tabs="true"
                            :query-object="getQueryParamsToMs"
                            @status="depositsStatusMsFilter"
                            @depamount="depositAmountFilter"
                            @quantity="depositBrokerQuantityFilter"
                            @brokers="depositBrokerFilter"
                            @users="depositUserFilter"
                            @answers="depositAnswersFilter"
                            @secusers="depositSecUserFilter"
                            @leading="depositLeadUserFilter"
                            @apply="debouncedClientsQuery"
                            @clientsdep="depositDepFilterMenuHandler"
                            @to_rem_convert="depositToRemConvertedFilter"
                            @from_cc_convert="depositFromCCConvertedFilter"
                            @from_sup_convert="
                              depositFromSupportConvertedFilter
                            "
                            :open="openDepositsMenu"
                            @close="openDepositsMenu = false"
                            @reset="resetDPSelectors"
                            @excludetag="excludeDPTag"
                            @excludefilter="excludeDPFilters"
                            :reset-list="resetMultiSelects"
                            :initiated-filtering="resetMsAfterFilter"
                        ></multi-select>
                      </div>

                      <div class="floating-wrapper bb-wrapper-fn tags-scale">
                        <BreadButton
                            v-on:click.native="processFilterMenuHandler"
                            :bg-color="statusBtnColors.bgWT"
                            :txt-color="statusBtnColors.txtWhite"
                            :text="addTextFn()"
                        ></BreadButton>
                        <div
                            v-if="openProcessMenu"
                            class="floating-process-switcher"
                            v-click-outside="closeFnMenu"
                        >
                          <div
                              v-if="CheckUserPermission([1, 2, 3, 4, 5, 6, 12])"
                          >
                            <BreadButton
                                v-if="selectedMainTab !== 'clients'"
                                v-on:click.native="
                                  filterByAutoRem();
                                  slectedFnFilter = 'AUTO_REM';
                                  openProcessMenu = false;
                                "
                                :disabled="filters.auto_removal"
                                :bg-color="statusBtnColors.bgWT"
                                :txt-color="statusBtnColors.txtWhite"
                                :stats="stats.auto_removal"
                                :text="'ARFA'"
                            ></BreadButton>
                            <!--                              <div-->
                            <!--                                class="clear-fix-fn"-->
                            <!--                                v-if="selectedMainTab !== 'clients'"-->
                            <!--                              ></div>-->
                            <BreadButton
                                v-on:click.native="
                                  filterByBtgp();
                                  slectedFnFilter = 'BTGP';
                                  openProcessMenu = false;
                                "
                                :disabled="filters.btgp"
                                :bg-color="statusBtnColors.bgWT"
                                :txt-color="statusBtnColors.txtWhite"
                                :stats="stats.btgp"
                                :text="'BTGP'"
                            ></BreadButton>
                            <!--                              <div class="clear-fix-fn"></div>-->

                            <BreadButton
                                v-if="
                                  CheckUserPermission([1, 2, 3, 4, 5, 6, 12])
                                "
                                v-on:click.native="
                                  filterByDup();
                                  slectedFnFilter = 'DUP';
                                  openDupMenu = true;
                                "
                                :disabled="filters.dup"
                                :bg-color="statusBtnColors.bgWT"
                                :txt-color="statusBtnColors.txtWhite"
                                :stats="stats.dup"
                                :text="'DUP'"
                            ></BreadButton>

                            <!--                              <div class="clear-fix-fn"></div>-->
                            <BreadButton
                                v-if="
                                  CheckUserPermission([1, 2, 3, 4, 5, 6, 12]) &&
                                    selectedMainTab !== 'clients'
                                "
                                v-on:click.native="
                                  filterBySourceDup();
                                  slectedFnFilter = 'S-DUP';
                                  openProcessMenu = false;
                                "
                                :disabled="filters.dup_source"
                                :bg-color="statusBtnColors.bgWT"
                                :txt-color="statusBtnColors.txtWhite"
                                :stats="stats.dup_source"
                                :text="'S-DUP'"
                            ></BreadButton>
                            <!--                              <div-->
                            <!--                                class="clear-fix-fn"-->
                            <!--                                v-if="-->
                            <!--                                  CheckUserPermission([1, 2, 3, 4, 5, 6, 12]) &&-->
                            <!--                                    selectedMainTab !== 'clients'-->
                            <!--                                "-->
                            <!--                              ></div>-->
                            <BreadButton
                                v-if="
                                  CheckUserPermission([1, 2, 3, 4, 5, 6, 12]) &&
                                    selectedMainTab !== 'clients'
                                "
                                v-on:click.native="
                                  filterByExcludeSourceDup();
                                  slectedFnFilter = 'EX-S-DUP';
                                  openProcessMenu = false;
                                "
                                :disabled="filters.ex_dup_source"
                                :bg-color="statusBtnColors.bgWT"
                                :txt-color="statusBtnColors.txtWhite"
                                :text="'EX-S-DUP'"
                            ></BreadButton>
                            <!--                              <div-->
                            <!--                                class="clear-fix-fn"-->
                            <!--                                v-if="-->
                            <!--                                  CheckUserPermission([1, 2, 3, 4, 5, 6, 12]) &&-->
                            <!--                                    selectedMainTab !== 'clients'-->
                            <!--                                "-->
                            <!--                              ></div>-->

                            <BreadButton
                                v-if="
                                  CheckUserPermission([1, 2, 3, 4, 5, 6, 12])
                                "
                                v-on:click.native="
                                  filterWithExcludeDup();
                                  slectedFnFilter = 'EXCLUDE-DUP';
                                  openProcessMenu = false;
                                "
                                :disabled="filters.dup_exclude"
                                :bg-color="statusBtnColors.bgWT"
                                :txt-color="statusBtnColors.txtWhite"
                                :text="'EX-DUP'"
                            ></BreadButton>
                          </div>
                          <div>
                            <BreadButton
                                v-on:click.native="
                                  filterByTech();
                                  slectedFnFilter = 'TECH';
                                  openProcessMenu = false;
                                "
                                :disabled="filters.tech"
                                :bg-color="statusBtnColors.bgWT"
                                :txt-color="statusBtnColors.txtWhite"
                                :text="'TECH'"
                            ></BreadButton>
                          </div>
                          <div>
                            <!--
                          @exclude_tag="excludeDupTag"
-->
                            <dup-multi-select
                                @dup_users="dupUsersFilter"
                                @dup_na="dupNaFilter"
                                @dup_ni="dupNiFilter"
                                @dup_bn="dupBnFilter"
                                @dup_na_ar="dupNAARFilter"
                                @close="openDupMenu = false"
                                @reset="resetDupSelectors"
                                @apply="debouncedClientsQuery"
                                :open="openDupMenu"
                                :reset-list="resetMultiSelects"
                                :initiated-filtering="resetMsAfterFilter"
                                :query-object="getQueryParamsToMs"
                            ></dup-multi-select>
                          </div>
                        </div>
                      </div>

                      <div
                          class="floating-wrapper bb-wrapper-sort-menu widthForIt"
                      >
                        <div class="dropdown">
                          <button
                              style="width: 30px;"
                              class="tab-sub-menu-btn btn sorting-btn"
                              data-toggle="dropdown"
                          >
                            <i class="fa" :class="sortingIcon"></i>
                            <i
                                class="fa fa-sort-amount-down"
                                v-if="sortActive.cre.up"
                            ></i>

                            <div
                                class="bb-title-wrapper upper-title title-padding"
                            >
                              <span class="">Filter</span>
                            </div>
                          </button>
                          <div class="dropdown-menu filter-drop-menu">
                            <p class="sort-drop-flex-wraper">
                              <button
                                  @click.stop="applyAmountSorting('up')"
                                  class="btn sorting-btn fitstSortBtn sort-drop-right"
                                  :class="{ marked: sortActive.cre.up }"
                              >
                                <span class="fa fa-sort-amount-up"></span>
                              </button>
                              <span
                                  class="sort-drop-center"
                                  @click.stop="true"
                              >CREATED</span
                              >
                              <button
                                  @click.stop="applyAmountSorting('down')"
                                  class="btn sorting-btn fitstSortBtn sort-drop-left"
                                  :class="{ marked: sortActive.cre.down }"
                              >
                                <span class="fa fa-sort-amount-down"></span>
                              </button>
                            </p>
                            <p class="sort-drop-flex-wraper">
                              <button
                                  @click.stop="applyModifiedSorting('up')"
                                  class="btn sorting-btn fitstSortBtn sort-drop-right"
                                  :class="{ marked: sortActive.mod.up }"
                              >
                                <span class="fa fa-sort-amount-up"></span>
                              </button>
                              <span
                                  class="sort-drop-center"
                                  @click.stop="true"
                              >MODIFIED</span
                              >
                              <button
                                  @click.stop="applyModifiedSorting('down')"
                                  class="btn sorting-btn fitstSortBtn sort-drop-left"
                                  :class="{ marked: sortActive.mod.down }"
                              >
                                <span class="fa fa-sort-amount-down"></span>
                              </button>
                            </p>
                            <p class="sort-drop-flex-wraper">
                              <button
                                  @click.stop="applyNumericSorting('up')"
                                  class="btn sorting-btn sort-drop-right"
                                  :class="{ marked: sortActive.id.up }"
                              >
                                <span class="fa fa-sort-numeric-up"></span>
                              </button>

                              <span
                                  class="sort-drop-center"
                                  @click.stop="true"
                              >ID</span
                              >
                              <button
                                  @click.stop="applyNumericSorting('down')"
                                  class="btn sorting-btn sort-drop-left"
                                  :class="{ marked: sortActive.id.down }"
                              >
                                <span class="fa fa-sort-numeric-down"></span>
                              </button>
                            </p>
                            <p class="sort-drop-flex-wraper">
                              <button
                                  @click.stop="applyAlphaSorting('up')"
                                  class="btn sorting-btn sort-drop-right"
                                  :class="{ marked: sortActive.name.up }"
                              >
                                <span class="fa fa-sort-alpha-up"></span>
                              </button>

                              <span
                                  class="sort-drop-center"
                                  @click.stop="true"
                              >NAME</span
                              >
                              <button
                                  @click.stop="applyAlphaSorting('down')"
                                  class="btn sorting-btn sort-drop-left"
                                  :class="{ marked: sortActive.name.down }"
                              >
                                <span class="fa fa-sort-alpha-down"></span>
                              </button>
                            </p>
                            <p class="sort-drop-flex-wraper">
                              <button
                                  class="fas fa-history sorting-icon-head  btn sorting-btn sort-drop-right"
                                  :class="{ marked: sortActive4 }"
                                  @click.stop="
                                    [
                                      resetSorting(),
                                      (this.sortingIcon = `fa-sort-amount-down`)
                                    ]
                                  "
                              ></button>
                            </p>
                            <!--                              <recent-suggestion-select-->
                            <!--                                :search-string="filters.client"-->
                            <!--                                :filter-type="'FULL_NAME'"-->
                            <!--                                v-model.trim="filters.client"-->
                            <!--                              >-->
                            <!--                              </recent-suggestion-select>-->
                          </div>
                        </div>
                      </div>

                      <div class="vertical-scroll-buttons">
                        <button
                            :disabled="pagination.currentPage === 1"
                            class="vertical-scroll-btn-first"
                            type="button"
                            @click="setPage(1)"
                        >
                          <i class="fas fa-angle-double-left"></i>
                        </button>
                        <button
                            :disabled="pagination.currentPage === 1"
                            class="vertical-scroll-btn-second"
                            @click="setPage(pagination.currentPage - 1)"
                        >
                            <span>
                              <i class="fas fa-angle-left"></i>
                            </span>
                          <!--                          <span>-->
                          <!--                            {{ pagination.from }}-->
                          <!--                          </span>-->
                        </button>
                        <button
                            class="vertical-scroll-btn-menu"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            @click="paginationDropDownUp = true"
                            v-if="pagination.total !== 0 || true"
                        >
                            <span class="pagination-info-span"
                            >{{ pagination.from }}/{{ pagination.to }} of
                              {{ pagination.total }}</span
                            >
                          <span
                              v-if="
                                pagination.lastPage === 1 &&
                                  pagination.total < 8
                              "
                          ><i class="fas fa-bars"></i
                          ></span>
                        </button>
                        <div
                            class="dropdown-menu p-xy-8 pagination-vertical-dropdown"
                            :class="{
                              'pagination-vertical-dropdown-down': !paginationDropDownUp
                            }"
                        >
                          <div class="listview-pagenum m-xy-0 p-x-8 m-b-4">
                              <span>Page {{ pagination.currentPage }}</span
                              >&nbsp; &nbsp; <span>of</span>&nbsp;
                            <strong
                            ><span id="totalPageCount">{{
                                pagination.lastPage
                              }}</span></strong
                            >
                          </div>
                          <div class="listViewPagingBox">
                            <input
                                v-model="pageNumInput"
                                type="search"
                                placeholder="Jump To"
                                class="listViewPagingInput p-xy-0"
                            />&nbsp;
                            <button
                                type="button"
                                id="listViewPagingInputSubmit"
                                @click="setPage(pageNumInput)"
                                :disabled="pageNumInput > pagination.lastPage"
                            >
                              GO
                            </button>
                          </div>
                        </div>
                        <button
                            :disabled="
                              pagination.currentPage === pagination.lastPage
                            "
                            class="vertical-scroll-btn-third"
                            @click="setPage(pagination.currentPage + 1)"
                        >
                          <!--                          <span>-->
                          <!--                            {{ pagination.to }}-->
                          <!--                          </span>-->

                          <span>
                              <i class="fas fa-angle-right"></i>
                            </span>
                        </button>
                        <button
                            class="vertical-scroll-btn-fourth"
                            :disabled="
                              pagination.currentPage === pagination.lastPage &&
                                pagination.total
                            "
                            @click="setPage(pagination.lastPage)"
                        >
                          <i class="fas fa-angle-double-right"></i>
                        </button>
                      </div>
                      <div
                          class="floating-wrapper bb-wrapper-arrows-right"
                          v-if="false"
                      >
                        <HeaderSubMenuClientsTable
                            :tabsList="tabsList"
                            :direction="'right'"
                            :mainTabPagination="mainTabPagination"
                            @paginate="setMainTabPagination"
                        />
                        <div
                            class="grandfather"
                            v-if="mainTabPagination.currentTab > 1"
                        >
                            <span class="tab-sub-menu-btn" @click="goHome">
                              <i class="fas fa-home"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <fav-drop-down v-if="false"></fav-drop-down>
                    </div>
                  </th>
                </tr>
                <tr class="tr-info">
                  <th class="th-assigned-to" >
                    <div class="filter-multiselect" >
                      <div class="floating-wrapper"  style="width: 100%">
                        <multi-select
                            @excludeValueChanged="this.filters.exclude_as_filter = $event;"
                          :background="{
                            mainBg: 'background: #abce40',
                            btnBg: 'background-color: #35c958;',
                            color: ''
                          }"
                          :external-width="{ min: '100%', max: 'unset' }"
                          :selected-main-tab="selectedMainTab"
                          :expand-to-right="true"
                          :sector="'assignments'"
                          :ext-search="true"
                          @assignments="assignmentsMsFilter"
                          @rank_1="assignRank1Filter"
                          @rank_2="assignRank2Filter"
                          @rank_3="assignRank3Filter"
                          @assigned_rankings="assignedByRankFilter"
                          :reset-list="resetMultiSelects"
                          @reset="resetAssignSelector"
                          @apply="debouncedClientsQuery"
                          :initiated-filtering="resetMsAfterFilter"
                          :query-object="getQueryParamsToMs"
                          :has-tabs="true"
                      ></multi-select>
                    </div>
                  </div>
                </th>
                <th class="th-phones">
                  <div class="filter-phones">
                    <multi-select
                        @excludeValueChanged="filters.exclude_sms_filter = $event;"

                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :expand-to-right="true"
                        :sector="'sms'"
                        @preset="smsPresetFilter"
                        @status="smsStatusFilter"
                        @returned="smsReturnedFilter"
                        :ext-search="false"
                        :reset-list="resetMultiSelects"
                        @reset="resetAssignSelector"
                        @apply="debouncedClientsQuery"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                        :has-tabs="true"
                    >
                    </multi-select>

                    <div class="floating-wrapper">
                      <input
                          autocomplete="false"
                          type="search"
                          placeholder="Phone"
                          v-model.trim="filters.phone"
                          class="name-input"
                          v-on:keyup.enter="debouncedClientsQuery"
                      />
                      <!--                        <recent-suggestion-select-->
                      <!--                            :search-string="filters.phone"-->
                      <!--                            :filter-type="'PHONE'"-->
                      <!--                            v-model.trim="filters.phone"-->
                      <!--                        >-->
                      <!--                        </recent-suggestion-select>-->
                    </div>
                    <div class="floating-wrapper">
                      <phone-calls-multi-select
                          :query-object="getQueryParamsToMs"
                          :initiated-filtering="resetMsAfterFilter"
                      ></phone-calls-multi-select>
                    </div>
                  </div>
                </th>

                <th class="th-emails">

                  <div class="filter-emails">
                    <span v-tooltip="{ content:  `Total Unread Emails` }"  class="totalUnReadEmails">{{totalRepEmails != 0 ? totalRepEmails : ''}} </span>
                    <input
                        autocomplete="false"
                        type="search"
                        placeholder="Email"
                        v-model.trim="filters.email"
                        class="name-input"
                        v-on:keyup.enter="debouncedClientsQuery"
                    />

                    <!--                      <recent-suggestion-select-->
                    <!--                          :search-string="filters.email"-->
                    <!--                          :filter-type="'EMAIL'"-->
                    <!--                          v-model.trim="filters.email"-->
                    <!--                      >-->
                    <!--                      </recent-suggestion-select>-->
                  </div>
                </th>
                <th class="th-country">
                  <div class="filter-multiselect ">
                    <div class="floating-wrapper">
                      <multi-select
                          @excludeValueChanged="filters.exclude_co_filter = $event;"

                          :background="{ mainBg: '', btnBg: '', color: '' }"
                          :selected-main-tab="selectedMainTab"
                          :reset-list="resetMultiSelects"
                          :sector="'countries'"
                          :has-tabs="true"
                          :countriesms="true"
                          @countries="countriesMsFilter"
                          :query-object="getQueryParamsToMs"
                          @tiers="countryTierFilter"
                          @parents="countryParentFilter"
                          :initiated-filtering="resetMsAfterFilter"
                          @apply="debouncedClientsQuery"
                      ></multi-select>
                    </div>
                    <div class="floating-wrapper">
                      <country-time-multi-select
                          @update="updateCountryTimeFilter"
                          :reset-list="resetMultiSelects"
                          :initiated-filtering="resetMsAfterFilter"
                          :query-object="getQueryParamsToMs"
                      ></country-time-multi-select>
                    </div>
                  </div>
                </th>

                <th class="th-name">
                  <div class="f-wrapper">
                    <div class="name-input-group">
                      <input
                          autocomplete="false"
                          type="search"
                          placeholder="ID / Name / Age"
                          v-model.trim="filters.client"
                          class="name-input last-input"
                          v-on:keyup.enter="debouncedClientsQuery"
                      />
                      <div
                          class="forPockeSort"
                          @click="openMenuForPockeSort = !openMenuForPockeSort"
                      ></div>
                    </div>
                  </div>
                </th>

                <th
                    :class="{
                      'th-test-agent': auth.user.role === 7,
                      'th-test': auth.user.role !== 7
                    }"
                    v-show="selectedTab === 'status'"
                ></th>
                <th class="th-plus" v-show="selectedTab !== 'status'"></th>
                <th
                    class="th-question-11"
                    v-show="selectedTab === 'questions' && questionsSector == 1"
                >
                  <div class="floating-wrapper" @mouseleave="q11 = false">
                    <multi-select
                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :ext-search="true"
                        :sector="'questions'"
                        :question-tab="true"
                        :question-id="11"
                        v-model="filters.answers11"
                        :reset-list="resetMultiSelects"
                        :stats-data1="stats.client_answers_count"
                        @retired="addRetiredFilter"
                        @reset="resetAnswer1Selector"
                        @apply="debouncedClientsQuery"
                        :initiated-filtering="resetMsAfterFilter"
                        :has-tabs="false"
                        :query-object="getQueryParamsToMs"
                        :question-sector="questionsSector"
                    >
                    </multi-select>
                    <div v-if="q11" class="floating-question-text">
                        <span>{{
                            dictionaries.general.client_questions[0].question
                          }}</span>
                    </div>
                  </div>
                </th>
                <th
                    class="th-question-1"
                    v-show="selectedTab === 'questions' && questionsSector == 1"
                >
                  <div class="floating-wrapper" @mouseleave="q1 = false">
                    <multi-select
                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :ext-search="true"
                        :sector="'questions'"
                        :question-tab="true"
                        :question-id="1"
                        :external-width="{ min: '100px', max: '100px' }"
                        v-model="filters.answers1"
                        :reset-list="resetMultiSelects"
                        :stats-data1="stats.client_answers_count"
                        @retired="addRetiredFilter"
                        @reset="resetAnswer1Selector"
                        @apply="debouncedClientsQuery"
                        :initiated-filtering="resetMsAfterFilter"
                        :has-tabs="false"
                        :query-object="getQueryParamsToMs"
                        :question-sector="questionsSector"
                    >
                    </multi-select>
                    <div v-if="q1" class="floating-question-text">
                        <span>{{
                            dictionaries.general.client_questions[0].question
                          }}</span>
                    </div>
                  </div>
                </th>

                <th
                    class="th-question-9"
                    v-show="selectedTab === 'questions' && questionsSector == 1"
                >
                  <div class="floating-wrapper" @mouseleave="q9 = false">
                    <multi-select
                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :ext-search="true"
                        :sector="'questions'"
                        :question-tab="true"
                        :question-id="9"
                        :has-tabs="false"
                        v-model="filters.answers9"
                        :reset-list="resetMultiSelects"
                        @retired="addRetiredFilter"
                        @reset="resetAnswer1Selector"
                        @apply="debouncedClientsQuery"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                        :question-sector="questionsSector"
                    >
                    </multi-select>
                    <div v-if="q9" class="floating-question-text">
                        <span>{{
                            dictionaries.general.client_questions[8].question
                          }}</span>
                    </div>
                  </div>
                </th>

                <th
                    class="th-question-2"
                    v-show="selectedTab === 'questions' && questionsSector == 1"
                >
                  <div class="floating-wrapper" @mouseleave="q2 = false">
                    <multi-select
                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :ext-search="true"
                        :sector="'questions'"
                        :has-tabs="false"
                        :question-tab="true"
                        :question-id="2"
                        v-model="filters.answers2"
                        :reset-list="resetMultiSelects"
                        @retired="addRetiredFilter"
                        @reset="resetAnswer1Selector"
                        @apply="debouncedClientsQuery"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                        :question-sector="questionsSector"
                    >
                    </multi-select>
                    <div v-if="q2" class="floating-question-text">
                        <span>{{
                            dictionaries.general.client_questions[1].question
                          }}</span>
                    </div>
                  </div>
                </th>

                <th
                    class="th-question-3"
                    v-show="selectedTab === 'questions' && questionsSector == 2"
                >
                  <div class="floating-wrapper" @mouseleave="q3 = false">
                    <multi-select
                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :ext-search="true"
                        :sector="'questions'"
                        :has-tabs="false"
                        :question-tab="true"
                        :question-id="3"
                        v-model="filters.answers3"
                        :reset-list="resetMultiSelects"
                        @retired="addRetiredFilter"
                        @reset="resetAnswer1Selector"
                        @apply="debouncedClientsQuery"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                        :question-sector="questionsSector"
                    >
                    </multi-select>
                    <div v-if="q3" class="floating-question-text">
                        <span>{{
                            dictionaries.general.client_questions[2].question
                          }}</span>
                    </div>
                  </div>
                </th>

                <th
                    class="th-question-4"
                    v-show="selectedTab === 'questions' && questionsSector == 2"
                >
                  <div class="floating-wrapper" @mouseleave="q4 = false">
                    <multi-select
                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :ext-search="true"
                        :sector="'questions'"
                        :has-tabs="false"
                        :question-tab="true"
                        :question-id="4"
                        v-model="filters.answers4"
                        :reset-list="resetMultiSelects"
                        :stats-data1="stats.client_answers_count"
                        @retired="addRetiredFilter"
                        @reset="resetAnswer1Selector"
                        @apply="debouncedClientsQuery"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                        :question-sector="questionsSector"
                    >
                    </multi-select>
                    <div v-if="q4" class="floating-question-text">
                        <span>{{
                            dictionaries.general.client_questions[3].question
                          }}</span>
                    </div>
                  </div>
                </th>

                <th
                    class="th-question-5"
                    v-show="selectedTab === 'questions' && questionsSector == 2"
                >
                  <div class="floating-wrapper" @mouseleave="q5 = false">
                    <multi-select
                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :ext-search="true"
                        :sector="'questions'"
                        :has-tabs="false"
                        :question-tab="true"
                        :question-id="5"
                        v-model="filters.answers5"
                        :reset-list="resetMultiSelects"
                        @retired="addRetiredFilter"
                        @reset="resetAnswer1Selector"
                        @apply="debouncedClientsQuery"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                        :question-sector="questionsSector"
                    >
                    </multi-select>
                    <div v-if="q5" class="floating-question-text">
                        <span>{{
                            dictionaries.general.client_questions[4].question
                          }}</span>
                    </div>
                  </div>
                </th>

                <th
                    class="th-question-6"
                    v-show="selectedTab === 'questions' && questionsSector == 2"
                >
                  <div class="floating-wrapper" @mouseleave="q6 = false">
                    <multi-select
                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :ext-search="true"
                        :sector="'questions'"
                        :has-tabs="false"
                        :question-tab="true"
                        :question-id="6"
                        v-model="filters.answers6"
                        :reset-list="resetMultiSelects"
                        @retired="addRetiredFilter"
                        @reset="resetAnswer1Selector"
                        @apply="debouncedClientsQuery"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                        :question-sector="questionsSector"
                    >
                    </multi-select>
                    <div v-if="q6" class="floating-question-text">
                        <span>{{
                            dictionaries.general.client_questions[5].question
                          }}</span>
                    </div>
                  </div>
                </th>

                <th
                    class="th-question-7"
                    v-show="selectedTab === 'questions' && questionsSector == 3"
                >
                  <div class="floating-wrapper" @mouseleave="q7 = false">
                    <multi-select
                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :ext-search="true"
                        :sector="'questions'"
                        :has-tabs="false"
                        :question-tab="true"
                        :question-id="7"
                        v-model="filters.answers7"
                        :reset-list="resetMultiSelects"
                        @retired="addRetiredFilter"
                        @reset="resetAnswer1Selector"
                        @apply="debouncedClientsQuery"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                        :question-sector="questionsSector"
                    >
                    </multi-select>
                    <div v-if="q7" class="floating-question-text">
                        <span>{{
                            dictionaries.general.client_questions[6].question
                          }}</span>
                    </div>
                  </div>
                </th>

                <th
                    class="th-question-8"
                    v-show="selectedTab === 'questions' && questionsSector == 3"
                >
                  <div class="floating-wrapper" @mouseleave="q8 = false">
                    <multi-select
                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :ext-search="true"
                        :sector="'questions'"
                        :question-tab="true"
                        :question-id="8"
                        v-model="filters.answers8"
                        :reset-list="resetMultiSelects"
                        @retired="addRetiredFilter"
                        @reset="resetAnswer1Selector"
                        @apply="debouncedClientsQuery"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                        :question-sector="questionsSector"
                    >
                    </multi-select>
                    <div v-if="q8" class="floating-question-text">
                        <span>{{
                            dictionaries.general.client_questions[7].question
                          }}</span>
                    </div>
                  </div>
                </th>
                <th
                    class="th-question-10"
                    v-show="selectedTab === 'questions' && questionsSector == 3"
                >
                  <div class="floating-wrapper" @mouseleave="q10 = false">
                    <multi-select
                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :ext-search="true"
                        :sector="'questions'"
                        :question-tab="true"
                        :question-id="10"
                        v-model="filters.answers10"
                        :reset-list="resetMultiSelects"
                        @retired="addRetiredFilter"
                        @reset="resetAnswer1Selector"
                        @apply="debouncedClientsQuery"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                        :question-sector="questionsSector"
                    >
                    </multi-select>
                    <div v-if="q10" class="floating-question-text">
                        <span>{{
                            dictionaries.general.client_questions[9].question
                          }}</span>
                    </div>
                  </div>
                </th>
                <th
                    class="th-question-status"
                    v-show="selectedTab === 'questions' && questionsSector == 3"
                >
                  <div class="floating-wrapper">
                    <multi-select
                        @excludeValueChanged="filters.exclude_qs_filter = $event;"

                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :ext-search="true"
                        :question-tab="true"
                        :sector="'questions_status'"
                        v-model="filters.answers_status"
                        :reset-list="resetMultiSelects"
                        @reset="resetAnswerStatusSelector"
                        @apply="debouncedClientsQuery"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                    ></multi-select>
                  </div>
                </th>
                <th class="th-date" v-show="selectedTab === 'campaign'">
                  <!--                  <span class="span-th-date">REGISTERED</span>-->
                </th>
                <th class="th-date" v-show="selectedTab === 'campaign-2'">
                  <!--                  <span class="span-th-date">REGISTERED</span>-->
                </th>
                <th
                    class="th-campaign-id"
                    v-show="
                       selectedTab === 'campaign'
                    "
                >
                  <div :class="!statsSelectedAaid ? 'floating-wrapper' : ''">
                    <multi-select
                        @excludeValueChanged="filters.exclude_ad_filter = $event;"

                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :sector="'advertising'"
                        :campaign-tab="true"
                        :ext-search="true"
                        v-model="filters.aaids"
                        :reset-list="resetMultiSelects"
                        @reset="resetAaidSelector"
                        @stats_sel="statsSelectedAaid = true"
                        @main_sel="statsSelectedAaid = false"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                        @apply="debouncedClientsQuery"
                    ></multi-select>
                  </div>
                </th>
                <th class="th-kyword" v-show="selectedTab === 'campaign'">
                  <div
                      :class="!statsSelectedKeyword ? 'floating-wrapper' : ''"
                  >
                    <multi-select
                        @excludeValueChanged="filters.exclude_kw_filter = $event;"

                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :sector="'keyword'"
                        :campaign-tab="true"
                        :ext-search="true"
                        v-model="filters.keywords"
                        :reset-list="resetMultiSelects"
                        @reset="resetKeywordSelector"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                        @apply="debouncedClientsQuery"
                    ></multi-select>
                  </div>
                </th>

                <th class="th-device" v-show="selectedTab === 'campaign'">
                  <div class="floating-wrapper">
                    <multi-select
                        @excludeValueChanged="filters.exclude_de_filter = $event;"

                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :sector="'device'"
                        :campaign-tab="true"
                        :ext-search="true"
                        v-model="filters.device"
                        :reset-list="resetMultiSelects"
                        @reset="resetDeviceSelector"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                    ></multi-select>
                  </div>
                </th>

                <th
                    class="th-click-on-site"
                    v-show="selectedTab === 'campaign-2'"
                >
                  <!-- Click on site select -->
                  <div class="floating-wrapper">
                    <multi-select
                        @excludeValueChanged="filters.exclude_ct_filter = $event;"

                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :sector="'click_type'"
                        :campaign-tab="true"
                        :ext-search="true"
                        v-model="filters.click_on_site"
                        :reset-list="resetMultiSelects"
                        @reset="resetClickTypeSelector"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                    ></multi-select>
                  </div>
                </th>

                <!-- tab related columns - geo_campaign -->
                <!--//campign2  location-camp-->
                <th class="th-loc-phys" v-show=" selectedTab === 'campaign-2'">
                  <div class="floating-wrapper">
                    <multi-select
                        @excludeValueChanged="filters.exclude_lc_filter = $event;"

                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :sector="'location'"
                        :has-tabs="false"
                        :campaign-tab="true"
                        :ext-search="true"
                        v-model="filters.loc_phys_ms"
                        :reset-list="resetMultiSelects"
                        @reset="resetLocPhysSelector"
                        :initiated-filtering="resetMsAfterFilter"
                        :query-object="getQueryParamsToMs"
                    ></multi-select>
                  </div>
                </th>
                <th class="th-ip" v-show="selectedTab === 'campaign-2'">
                  <input
                      autocomplete="false"
                      type="search"
                      class="input-standard"
                      v-model="filters.last_ip"
                      placeholder="Last IP Address"
                      v-on:keyup.enter="debouncedClientsQuery"
                  />
                </th>

                <!--                  capp-->
                <th
                    class="th-placement"
                    v-show="selectedTab === 'campaign'"
                >
                  <div class="floating-wrapper">
                    <multi-select
                        @excludeValueChanged="filters.exclude_pl_filter = $event;"

                        :background="{ mainBg: '', btnBg: '', color: '' }"
                        :selected-main-tab="selectedMainTab"
                        :reset-list="resetMultiSelects"
                        :sector="'placement'"
                        :campaign-tab="true"
                        :ext-search="true"
                        @reset="resetPlacementSelector"
                        v-model="filters.placement"
                        :query-object="getQueryParamsToMs"
                        :initiated-filtering="resetMsAfterFilter"
                    ></multi-select>
                  </div>
                </th>

                <th class="th-total" v-show="selectedTab === 'cost'">
                  <div class="spans-costs">
                    Total
                    <span v-if="stats.cost_totals.total !== 0"
                    >{{
                        kFormatter(stats.cost_totals.total.toFixed(0))
                      }}₪</span
                    >
                  </div>
                </th>
                <th class="th-cpl" v-show="selectedTab === 'cost'">
                  <div class="spans-costs">
                    CPL
                    <span v-if="stats.cost_totals.total_cpl !== 0"
                    >{{ kFormatter(stats.cost_totals.total_cpl) }}₪</span
                    >
                  </div>
                </th>
                <th class="th-phone-cost" v-show="selectedTab === 'cost'">
                  <div class="spans-costs">
                    Phone
                    <span v-if="stats.cost_totals.total_phone !== 0"
                    >{{ kFormatter(stats.cost_totals.total_phone) }}₪</span
                    >
                  </div>
                </th>
                <th class="th-sms-cost" v-show="selectedTab === 'cost'">
                  <div class="spans-costs">
                    SMS
                    <span v-if="stats.cost_totals.total_sms !== 0"
                    >{{
                        kFormatter(stats.cost_totals.total_sms.toFixed(0))
                      }}₪</span
                    >
                  </div>
                </th>
              </tr>
              </thead>

              <tbody>
              <tr
                  v-for="(client, idx) in clients"
                  :key="client.id"
                  class="forLineH"
                  :class="{
                    'selected-client-hover':
                      client.id === highlightedHoverClientId && idx % 2 != 0,
                    'selected-odd-client-hover':
                      client.id === highlightedHoverClientId && idx % 2 == 0,
                    'odd-nums': idx % 2 == 0,
                    'selected-client': client.id === highlightedClientId
                  }"
                  @click="highlightedClientId = client.id"
                  @mouseenter="highlightedHoverClientId = client.id"
                  @mouseleave="[(highlightedHoverClientId = null)]"
              >
                <td>
                  <template>
                    <div class="client-checkbox-div">
                      <input
                          v-if="CheckUserPermission([1, 2, 3, 4, 5, 12])"
                          type="checkbox"
                          v-model="selectedClients"
                          @click="pushOneClient(client.id)"
                          :value="client.id"
                      />
                    </div>
                    <div class="dropdown assignment-dropdown">
                      <client-assignment
                          v-if="client.assignment !== null"
                          :client="client"
                          :logs="client.assignmentLog"
                          :group-logs="client.assignment_group_log"
                          :is-new="client.is_new"
                          :inEdit="false"
                          data-toggle="dropdown"
                          @transferSuggestions="getSuggestedUsers(client)"
                      ></client-assignment>
                      <span
                          v-else
                          data-toggle="dropdown"
                          style="cursor: pointer"
                      >Click to add</span
                      >
                      <ul
                          v-if="
                            selectedMainTab !== 't4' &&
                              (CheckUserPermission([1, 2, 3, 4, 5, 12]) &&
                                auth.user.id !== 114)
                          "
                          class="dropdown-menu p-xy-8 assignment-dropdown-menu"
                      >
                        <div
                            v-if="
                              selectedMainTab === 'clients' ||
                                selectedMainTab === 'ended'
                            "
                        >
                          <div class="add-tag-menu-item-title">Assign To</div>
                          <input
                              class="input-standard"
                              type="search"
                              autocomplete="false"
                              placeholder="Search name"
                              v-model="assignToQuery"
                          />

                          <div class="dropdown-divider"></div>
                          <div v-if="suggestedUsers.length > 0">
                              <span class="add-tag-menu-item-title"
                              >SUGGESTED</span
                              >
                            <li
                                @click="
                                  saveAssignment(suggested['data'], client)
                                "
                                class="assign-menu-item suggested-users"
                                v-for="(suggested, idx) in suggestedUsers"
                                :key="idx"
                                :value="{
                                  user: suggested[`data`],
                                  idx: idx + 1
                                }"
                            >
                              {{ suggested["data"].full_name }}|
                              {{ suggested["score"] }}
                            </li>
                            <hr />
                          </div>
                          <div v-if="uniqueUsers.length > 0">
                            <span class="add-tag-menu-item-title"> ALL</span>
                            <li
                                @click="saveAssignment(person, client)"
                                class="assign-menu-item"
                                v-for="(person, idx) in FilterUsersByRole(
                                  FilterNonActiveUsers(uniqueUsers),
                                  [1, 2, 3, 8, 9, 10, 11, 12]
                                )"
                                :key="idx"
                                :value="{ user: person, idx: null }"
                            >
                              {{ person.full_name }}
                            </li>
                            <hr />
                          </div>
                          <div v-if="unSuggestedUsers.length > 0">
                              <span class="add-tag-menu-item-title"
                              >UNSUGGESTED</span
                              >
                            <li
                                @click="
                                  saveAssignment(unsuggested['data'], client)
                                "
                                class="assign-menu-item unsuggested-users"
                                v-for="(unsuggested, idx) in unSuggestedUsers"
                                :key="idx"
                                :value="{
                                  user: unsuggested[`data`],
                                  idx: -1 - idx
                                }"
                            >
                              {{ unsuggested["data"].full_name }}|
                              {{ unsuggested["score"] }}
                            </li>
                            <hr />
                          </div>

                          <div class="dropdown-divider"></div>
                        </div>
                        <div class="add-tag-menu-item-title">
                          Move to Status Group
                        </div>
                        <li
                            @click="saveGroupAssignment(group.id, client)"
                            class="assign-menu-item"
                            v-for="group in dictionaries.activity
                              .assignment_group_types"
                            :key="group.id"
                        >
                          {{ group.id !== 0 ? group.type : null }}
                        </li>
                        <div
                            v-if="
                              selectedMainTab === 'bn' ||
                                selectedMainTab === 'ni' ||
                                selectedMainTab === 'na'
                            "
                            class="dropdown-divider"
                        ></div>
                        <div
                            v-if="
                              selectedMainTab === 'bn' ||
                                selectedMainTab === 'ni' ||
                                selectedMainTab === 'na'
                            "
                            class="add-tag-menu-item-title"
                        >
                          Operations
                        </div>
                        <div
                            v-if="
                              selectedMainTab === 'bn' ||
                                selectedMainTab === 'ni' ||
                                selectedMainTab === 'na'
                            "
                        >
                          <li
                              @click="
                                newDuplicate.op = op.id;
                                newDuplicate.client = client;
                                newDuplicate.selectedMainTab = selectedMainTab;
                                showDuplicateAssign = client.id;
                              "
                              class="assign-menu-item"
                              v-for="op in dictionaries.activity
                                .client_op_types"
                              :key="op.id"
                          >
                            {{ op.type }}
                          </li>
                        </div>
                      </ul>
                    </div>

                    <div
                        v-if="showDuplicateAssign === client.id"
                        class="assignment-dropdown"
                    >
                      <ul
                          v-if="CheckUserPermission([1, 2, 3, 4, 5, 12])"
                          class="p-xy-8 duplicate-assignment-dropdown-menu"
                      >
                        <div class="add-tag-menu-item-title">
                          Assign New Duplicate to:
                        </div>
                        <li
                            class="assign-menu-item"
                            @click="showDuplicateAssign = null"
                        >
                            <span class="cancel-edit-menu-item"
                            >Cancel
                              <span class="fa fa-close remove-tag-icon"></span
                              ></span>
                        </li>
                        <li
                            @click="
                              saveClientOperation(
                                newDuplicate.op,
                                newDuplicate.client,
                                newDuplicate.selectedMainTab,
                                person.id
                              )
                            "
                            class="assign-menu-item"
                            v-for="person in FilterNonActiveUsers()"
                            :key="person.id"
                        >
                          {{ person.first_name + " " + person.last_name }}
                        </li>
                      </ul>
                    </div>
                  </template>
                </td>
                <!-- Phones -->
                <td>
                  <client-phones
                      :client="client"
                      @edit="editPhones(client.phones,some)"
                      @invalidPhones="invalidNumbers"
                      @sms="openSMSdialog(client, 0)"
                  ></client-phones>

                  <template v-if="edit.phonesClientId === client.id">
                    <div class="floating-wrapper">
                      <!-- edit phones form-->
                      <div class="floating-edit-phones">
                        <div
                            class="form-group "
                            v-for="(phone, phoneIndex) in form.phones"
                            :key="phone.id"
                            :class="{
                              'has-error': form.errorBag.hasOwnProperty(
                                'phones.' + phoneIndex + '.' + 'contact_value'
                              )
                            }"
                        >
                          <div class="input-group input-group-sm ">
                              <span class="input-group-addon">
                                <input
                                    type="checkbox"
                                    v-model="phone.is_primary"
                                    @click="cancelOtherPrimaryPhones(phone.id)"
                                    aria-label="primary"
                                />
                              </span>
                            <input
                                type="search"
                                v-model.trim="phone.contact_value"
                                autocomplete="false"
                                class="form-control"
                                aria-label="value"
                            />
                            <a
                                v-if="phoneIndex !== 0"
                                class="small-delete-btn input-group-addon "
                                href="javascript:void(0)"
                                @click="deletePhone(phone)"
                                ><span
                                  class="fa fa-close email-delete-icon"
                                ></span
                              ></a>
                            </div>
                            <p v-if="isValidPhone(phone)"  class="invalid-phone">Invalid Phone Number</p>

                          <p
                              class="help-block"
                              v-if="
                                form.errorBag.hasOwnProperty(
                                  'phones.' + phoneIndex + '.contact_value'
                                )
                              "
                          >
                            {{
                              form.errorBag[
                              "phones." + phoneIndex + ".contact_value"
                                  ]
                            }}
                          </p>
                        </div>
                        <div
                            v-if="form.phones.length < 3"
                            class="input-group input-group-sm"
                        >
                            <span class="input-group-addon">
                              <input
                                  type="checkbox"
                                  v-model="form.newPhone.is_primary"
                                  @click="cancelOtherPrimaryEmails(phone.id)"
                                  aria-label="primary"
                              />
                            </span>
                          <input
                              type="search"
                              autocomplete="false"
                              v-model="form.newPhone.contact_value"
                              class="form-control "
                              aria-label="value"
                              placeholder="New Phone"
                          />
                        </div>
                        <form-buttons
                            @save="savePhones"
                            @cancel="cancelPhonesEdit"
                        ></form-buttons>
                      </div>
                    </div>
                  </template>
                  <template
                      v-if="auth.user.id !== 114 && edit.sendSMS === client.id"
                  >
                    <div class="floating-wrapper">
                      <!-- edit phones form-->
                      <div class="floating-sms-presets">
                        <div class="sms-form-title">
                          Choose SMS/WhatsApp Preset:
                        </div>
                        <ul class="sms-preset-list">
                          <li
                              class="assign-menu-item"
                              v-for="preset in dictionaries.activity
                                .sms_presets"
                              :key="preset.id"
                          >
                            <br />{{ preset.preset }}

                            <i
                                v-if="CheckUserPermission([1, 2, 12])"
                                class="fab fa-whatsapp fa-1x "
                                @click="sendWhatsApp(client, preset)"
                            ></i>
                            <i
                                class="fas fa-sms  sms-send-ico"
                                @click="sendSMSPresetRequest(client, preset)"
                            >
                            </i>

                            <br />
                          </li>

                          <li class="assign-menu-item " @click="cleanForm">
                              <span class="cancel-edit-menu-item"
                              >Cancel
                                <span
                                    class="fa fa-close fa-3x remove-tag-icon"
                                ></span
                                ></span>
                          </li>
                        </ul>
                        <!--  <form-buttons
                                  @save="sendSMS"
                                  @cancel="cancelSMSSend"
                          ></form-buttons>-->
                      </div>
                    </div>
                  </template>
                </td>

                <!-- Emails -->

                <td>
                  <!--
                                        <div v-click-outside="emailEditClose" >
                    -->

                  <div>
                    <client-emails
                        :changeToNotReIcone="changeToNotReIcone"
                        :changeAutoIcone="changeAutoIcone"
                        :contacts="client.emails"
                        :client="client"
                        @edit="editEmails(client.emails)"
                    ></client-emails>

                    <template v-if="edit.emailsClientId === client.id">
                      <div class="floating-wrapper">
                        <!-- edit phones form-->
                        <div class="floating-edit-emails">
                          <div
                              class="form-group "
                              v-for="(email, emailIndex) in form.emails"
                              :key="email.id"
                              :class="{
                                'has-error': form.errorBag.hasOwnProperty(
                                  'emails.' + emailIndex + '.' + 'contact_value'
                                )
                              }"
                          >
                            <div class="contact-details-edit">
                              <div class="contact-details-edit-checkboxes">
                                <input
                                    type="checkbox"
                                    v-model="email.is_primary"
                                    @click="cancelOtherPrimaryEmails(email.id)"
                                    aria-label="primary"
                                /><label>Primary</label>
                              </div>
                              <div class="contact-details-edit-checkboxes">
                                <input
                                    type="checkbox"
                                    v-model="email.deposit_email"
                                    @click="cancelOtherDepositEmails(email.id)"
                                    aria-label="primary"
                                />
                                <label>Deposit</label>
                              </div>
                              <input
                                  type="search"
                                  autocomplete="false"
                                  class="input-standard"
                                  v-model.trim="email.contact_value"
                                  aria-label="value"
                                  placeholder="New Email"
                              />

                              <a
                                  v-if="emailIndex !== 0"
                                  class="small-delete-btn input-group-addon "
                                  href="javascript:void(0)"
                                  @click="deleteEmail(email)"
                              ><span
                                  class="fa fa-close email-delete-icon"
                              ></span
                              ></a>
                            </div>
                            <p
                                class="help-block"
                                v-if="
                                  form.errorBag.hasOwnProperty(
                                    'emails.' + emailIndex + '.contact_value'
                                  )
                                "
                            >
                              {{
                                form.errorBag[
                                "emails." + emailIndex + ".contact_value"
                                    ]
                              }}
                            </p>
                          </div>
                          <hr />
                          <div class="contact-details-edit">
                            <div class="contact-details-edit-checkboxes">
                              <input
                                  type="checkbox"
                                  v-model="form.newEmail.is_primary"
                                  aria-label="primary"
                              /><label>Primary</label>
                            </div>
                            <div class="contact-details-edit-checkboxes">
                              <input
                                  type="checkbox"
                                  v-model="form.newEmail.deposit_email"
                                  aria-label="primary"
                              />
                              <label>Deposit</label>
                            </div>
                            <input
                                type="search"
                                class="input-standard"
                                autocomplete="false"
                                v-model.trim="form.newEmail.contact_value"
                                aria-label="value"
                                placeholder="New Email"
                                :class="{
                                  'has-error-new-mail':
                                    form.errorBag.contact_value
                                }"
                            />
                          </div>
                          <p
                              class="help-block has-error-new-mail"
                              v-if="form.errorBag.contact_value"
                          >
                            {{ form.errorBag.contact_value }}
                          </p>
                          <form-buttons
                              @save="saveEmails"
                              @cancel="cancelEmailsEdit"
                          ></form-buttons>
                          <md-progress-spinner
                              v-if="emailsUpdateBusy"
                              :md-diameter="18"
                              :md-stroke="3"
                              md-mode="indeterminate"
                          ></md-progress-spinner>
                        </div>
                      </div>
                    </template>
                  </div>
                </td>

                <!-- Client time / Country -->
                <td>
                  <div class="dropdown">
                    <client-county-info
                        :client="client"
                        data-toggle="dropdown"
                        @edit="openCountryEditMenu(client.id)"
                    ></client-county-info>
                    <ul
                        v-if="
                          auth.user.id !== 114 &&
                            showEditClientCountry === client.id
                        "
                        class="dropdown-menu  update-country-dropdown"
                    >
                      <div class="add-tag-menu-item-title">Edit Country</div>
                      <li
                          @click="updateCountry(country.id, client)"
                          class="assign-menu-item"
                          v-for="country in dictionaries.general.countries"
                          :key="country.id"
                      >
                        {{ country.name }}
                      </li>
                    </ul>
                  </div>
                </td>

                <!-- Client info to -->

                <td>
                  <div>
                    <div v-if="edit.mainInfoClientId === client.id">
                      <div class="floating-wrapper ">
                        <!-- edit phones form-->
                        <div class="floating-edit-details ">
                          <div
                              class="form-group"
                              :class="{
                                'has-error': form.errorBag.hasOwnProperty(
                                  'first_name'
                                )
                              }"
                          >
                            <p
                                v-if="
                                  form.errorBag.hasOwnProperty('first_name')
                                "
                                class="help-block"
                            >
                              {{ form.errorBag.first_name }}
                            </p>
                            <input
                                type="search"
                                autocomplete="false"
                                v-model="form.main.first_name"
                                class="form-control input-sm input-standard"
                            />
                          </div>

                          <div
                              class="form-group"
                              :class="{
                                'has-error': form.errorBag.hasOwnProperty(
                                  'last_name'
                                )
                              }"
                          >
                            <p
                                v-if="form.errorBag.hasOwnProperty('last_name')"
                                class="help-block"
                            >
                              {{ form.errorBag.last_name }}
                            </p>
                            <input
                                type="search"
                                autocomplete="false"
                                v-model="form.main.last_name"
                                class="form-control input-sm input-standard"
                            />
                          </div>
                          <div class="forClientAge">
                            <client-answer
                                :client="client"
                                :question-id="11"
                                :send-updated="sendUpdated"
                                @updated="fetchClients"
                                @unlock="resetLock"
                            ></client-answer>
                          </div>

                          <form-buttons
                              @save="saveClientInfo"
                              @cancel="cancelClientInfoEdit"
                          ></form-buttons>
                        </div>
                      </div>
                    </div>

                    <div v-if="cms.cmsPasswordClientID === client.id"></div>
                    <div v-if="cms.cmsPasswordClientID === client.id">
                      <div class="floating-wrapper">
                        <div class="floating-password-reset">
                          <div class="form-group">
                            <!--                              <input-->
                            <!--                                class="input-standard"-->
                            <!--                                type="search"-->
                            <!--                                autocomplete="false"-->
                            <!--                                v-model="cms.edit.cmsNewPassword"-->
                            <!--                                placeholder="New password"-->
                            <!--                              />-->
                            <label>Thank you,</label>
                            <label>The password Changed to 123456</label>

                            <div class="form-buttons">
                              <button
                                  class="bttn pull-right "
                                  v-on:click="cleanForm"
                              >
                                OK
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="(cms.cmsPlanClientId === client.id) && (CheckUserPermission([1, 2,3,4, 12]) ||  (auth.user.id === 45))">
                      <div class="floating-wrapper">
                        <div class="floating-plan-change">
                          <div class="form-group">
                            <select
                                class="select-standard"
                                v-model="cms.edit.cmsNewPlan"
                            >
                              <option
                                  class="opt-standard"
                                  v-for="option in dictionaries.general
                                    .client_plans"
                                  :key="option.id"
                                  :value="option.id"
                              >{{ option.title }}
                              </option>
                            </select>
                            <form-buttons
                                @save="saveCmsPlan(client)"
                                @cancel="cleanForm"
                            ></form-buttons>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                        v-if="cms.cmsSignalsClientId === client.id"
                        v-click-outside="closeSigTable"
                    >
                      <div class="floating-wrapper-client-op">
                        <div class="floating-signals-table">
                          <ul class="nav nav-tabs temp">
                            <li
                                class="pull-left"
                                v-for="tab in signalsTabs"
                                :key="tab.id"
                                :class="{
                                  active: selectedSignalTab === tab.alias
                                }"
                            >
                              <a
                                  href="javascript:void(0)"
                                  @click="selectedSignalTab = tab.alias"
                              >
                                <span>{{ tab.name }}</span>
                              </a>
                            </li>
                          </ul>
                          <div
                              class="signals-table"
                              v-if="selectedSignalTab === 'OPEN_SIGNALS'"
                          >
                            <table class="table ">
                              <thead>
                              <tr class="bg-info">
                                <th class="th-signals1">
                                  Asset
                                </th>
                                <th class="th-signals2">
                                  Str
                                </th>

                                <th class="th-signals3">
                                  Str
                                </th>
                                <th class="th-signals3">
                                  Str
                                </th>
                                <th class="th-signals3">
                                  TP1
                                </th>
                                <th class="th-signals3">
                                  TP2
                                </th>
                                <th class="th-signals3">
                                  TP3
                                </th>
                                <th class="th-signals3">
                                  SL
                                </th>
                                <th class="th-signals3">
                                  Dir
                                </th>
                                <th class="th-signals3">
                                  Type
                                </th>
                                <th class="th-signals3">
                                  Img
                                </th>
                              </tr>
                              </thead>

                              <tr></tr>
                              <tr
                                  v-for="(signal, idx) in cms.CMSClientSignals
                                    .open_signals"
                                  :key="idx"
                              >
                                <td class="td-signals">
                                  {{ signal.asset }}
                                </td>
                                <td class="td-signals sec-td">
                                  {{ signal.strike_date }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.strike_range }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.strike_rate }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.take_profit }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.take_profit2 }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.take_profit3 }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.stop_loss }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.direction }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.type }}
                                </td>
                                <td class="td-signals">
                                  <img :src="signal.img" />
                                </td>
                              </tr>
                            </table>
                          </div>
                          <div
                              class="signals-table"
                              v-if="selectedSignalTab === 'ENDED_SIGNALS'"
                          >
                            <table class="table ">
                              <thead>
                              <tr class="bg-info">
                                <th class="th-signals1">
                                  Asset
                                </th>
                                <th class="th-signals2">
                                  Strike
                                </th>

                                <th class="th-signals3">
                                  Strike
                                </th>
                                <th class="th-signals3">
                                  Strike
                                </th>
                                <th class="th-signals3">
                                  TP
                                </th>
                                <!--                                  <th class="th-signals3">
                                    TP2
                                  </th>
                                  <th class="th-signals3">
                                    TP3
                                  </th>-->
                                <th class="th-signals3">
                                  SL
                                </th>
                                <th class="th-signals3">
                                  Direction
                                </th>
                                <th class="th-signals3">
                                  Type
                                </th>
                                <th class="th-signals3">
                                  Status
                                </th>
                                <th class="th-signals3">
                                  Img
                                </th>
                              </tr>
                              </thead>

                              <tr></tr>
                              <tr
                                  v-for="(signal, idx) in cms.CMSClientSignals
                                    .ended_signals"
                                  :key="idx"
                              >
                                <td class="td-signals">
                                  {{ signal.asset }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.strike_date }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.strike_range }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.strike_rate }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.take_profit }}
                                </td>
                                <!--                                  <td class="td-signals">
                                    {{ signal.take_profit2 }}
                                  </td>
                                  <td class="td-signals">
                                    {{ signal.take_profit3 }}
                                  </td>-->
                                <td class="td-signals">
                                  {{ signal.stop_loss }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.direction }}
                                </td>
                                <td class="td-signals">
                                  {{ signal.type }}
                                </td>
                                <td class="td-signals">
                                  <strong>{{ signal.success }}</strong>
                                </td>
                                <td class="td-signals">
                                  <img :src="signal.img" />
                                </td>
                              </tr>
                            </table>
                          </div>
                          <signals-table-buttons
                              @close="cms.cmsSignalsClientId = null"
                              @update="
                                getSignals(client.emails[0].contact_value)
                              "
                          ></signals-table-buttons>
                        </div>
                      </div>
                    </div>
                    <div class="floating-wrapper">
                      <div
                          v-if="
                            cms.cmsPlanHistoryClientId === client.id &&
                              client.cms_plan_log.length > 0
                          "
                          class="floating-plan-history-table"
                      >
                        <div
                            class="table-responsive cms-edit-history-table-responsive"
                        >
                          <table class="table cms-edit-history-table">
                            <tbody>
                            <tr
                                v-for="history in client.cms_plan_log"
                                :key="history.id"
                            >
                              <td>
                                {{ formatDateTable(history.created_at) }}
                              </td>
                              <td>
                                {{ history.created_at | shortTime }}
                              </td>
                              <td>
                                {{ history.user.full_name }}
                              </td>
                              <td>
                                {{ history.plan_type.title }}
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <!-- history -->
                    <div class="floating-wrapper">
                      <div
                          v-if="
                            cms.cmsPasswordHistoryClientId === client.id &&
                              client.cms_password_resets.length > 0
                          "
                          class="floating-password-reset-history"
                      >
                        <div
                            class="table-responsive cms-edit-history-table-responsive"
                        >
                          <table class="table cms-edit-history-table">
                            <tbody>
                            <tr
                                v-for="history in client.cms_password_resets"
                                :key="history.id"
                            >
                              <td>
                                {{ formatDateTable(history.created_at) }}
                              </td>
                              <td>{{ history.created_at | shortTime }}</td>
                              <td>{{ history.user.full_name }}</td>
                              <td>{{ history.new_password }}</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div class="floating-wrapper">
                        <div
                            v-if="
                              cms.cmsSMSHistoryClientId === client.id &&
                                client.cms_sms_log.length > 0
                            "
                            class="floating-password-reset-history"
                        >
                          <div
                              class="table-responsive cms-edit-history-table-responsive"
                          >
                            <table class="table cms-edit-history-table">
                              <tbody>
                              <tr
                                  v-for="history in client.cms_sms_log"
                                  :key="history.id"
                              >
                                <td>
                                  {{ formatDateTable(history.created_at) }}
                                </td>
                                <td>
                                  {{ history.created_at | shortTime }}
                                </td>
                                <td>{{ history.user.full_name }}</td>
                                <td>{{ history.active }}</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- v-else-->
                    <template>
                      <div class="floating-wrapper-client-op-menu  ">
                        <client-main-info
                            :client="client"
                            @id="filterIndividual(client.id)"
                            @clicked="openClientOpMenu(client.id)"
                            data-toggle="dropdown"
                            @updated="fetchClients"
                        ></client-main-info>
                        <client-online
                            :client-obj="client"
                            :client="client.is_online"
                            :contact-value="
                              client.emails.length > 0
                                ? client.emails[0].contact_value
                                : 'no-contact'
                            "
                            :last-online="client.last_online"
                            @viewsignals="
                              [
                                (cms.cmsSignalsClientId = client.id),
                                (showClientOpMenu = null),
                                Globals.cms.signals_stats,
                                getSignals(
                                  client.emails.length > 0
                                    ? client.emails[0].contact_value
                                    : 'no-contact'
                                )
                              ]
                            "
                        ></client-online>

<!--                          client SCHEDULED Calls diff in time-->
                          <client-scheduled-calls-diff
                          :client="client"
                          :key="update"
                          v-if="client.scheduled_calls && client.scheduled_calls.length > 0"
                          />
                          <ul
                            v-if="
                              auth.user.id !== 114 &&
                                showClientOpMenu === client.id
                            "
                            class="dropdown-menu  client-op-dropdown"
                        >
                          <div class="add-tag-menu-item-title">
                            Client Operations
                          </div>
                          <li
                              @click="editClientInfo(client)"
                              class="assign-menu-item"
                          >
                            Change Personal Details
                          </li>
                          <div class="add-tag-menu-item-title">
                            CMS Operations
                          </div>
                          <li
                              v-if="Globals.cms.change_password"
                              @click="
                                [
                                  (cms.cmsPasswordClientID = client.id),
                                  (showClientOpMenu = null),
                                  (cms.cmsPasswordHistoryClientId = null),
                                  saveCmsPassword(client)
                                ]
                              "
                              class="assign-menu-item"
                              @mouseleave="
                                cms.cmsPasswordHistoryClientId = null
                              "
                              @mouseenter="
                                cms.cmsPasswordHistoryClientId = client.id
                              "
                          >
                            Change CMS Password
                          </li>
                          <li
                              v-if="
                                Globals.cms.change_plan &&
                                  CheckUserPermission([1, 2, 3, 4,5, 8, 12])
                              "
                              class="assign-menu-item"
                              @click="
                                cms.cmsPlanClientId = client.id;
                                showClientOpMenu = null;
                                cms.cmsPlanHistoryClientId = null;
                                cms.edit.cmsNewPlan =
                                  client.cms_plan !== null
                                    ? client.cms_plan.plan_type.id
                                    : 1;
                              "
                              @mouseleave="cms.cmsPlanHistoryClientId = null"
                              @mouseenter="
                                cms.cmsPlanHistoryClientId = client.id
                              "
                          >
                            Change Plan -
                            {{
                              client.cms_plan !== null
                                  ? client.cms_plan.plan_type.cms_id
                                  : "2"
                            }}
                          </li>
                            <li
                                v-if="
                                Globals.cms.change_plan &&
                                  auth.user.id === 45
                              "
                                class="assign-menu-item"
                                @click="
                                cms.cmsPlanClientId = client.id;
                                showClientOpMenu = null;
                                cms.cmsPlanHistoryClientId = null;
                                cms.edit.cmsNewPlan =
                                  client.cms_plan !== null
                                    ? client.cms_plan.plan_type.id
                                    : 1;
                              "
                                @mouseleave="cms.cmsPlanHistoryClientId = null"
                                @mouseenter="
                                cms.cmsPlanHistoryClientId = client.id
                              "
                            >
                              Change Plan -
                              {{
                                client.cms_plan !== null
                                    ? client.cms_plan.plan_type.cms_id
                                    : "2"
                              }}
                            </li>

                          <li
                              v-if="
                                Globals.cms.sms_power_signals &&
                                  CheckUserPermission([1, 2, 3, 4, 5, 8, 12])
                              "
                              @click="
                                [
                                  (cms.cmsSMSClientID = client.id),
                                  (showClientOpMenu = null),
                                  (cms.cmsSMSHistoryClientId = null),
                                  changeCmsSMS(client)
                                ]
                              "
                              class="assign-menu-item"
                              @mouseleave="cms.cmsSMSHistoryClientId = null"
                              @mouseenter="
                                cms.cmsSMSHistoryClientId = client.id
                              "
                          >
                              <span
                                  v-if="
                                  Object.keys(client.cms_sms_log).length > 0
                                "
                              >
                                {{
                                  client.cms_sms_log.active === 1
                                      ? "Disable"
                                      : "Activate"
                                }}</span
                              ><span v-else>Activate</span> SMS Power Signals
                          </li>
                          <!--                            <li
                              @click="
                                cms.cmsSignalsClientId = client.id;
                                showClientOpMenu = null;
                                getSignals(client.emails[0].contact_value)
                              "
                              class="assign-menu-item"
                            >
                              View Signals
                            </li>-->
                        </ul>
                      </div>
                    </template>
                  </div>
                </td>
                <td
                    class="forTheMoreBtns"
                    :class="{ 'forLineH-status': selectedTab !== 'status' }"
                    v-if="selectedTab === 'status'"
                >
                  <client-tags
                      @naAutoEmailNotReYet="changeAutoEmailNotReIclone"
                      @naAutoEmailSent="changeAutoEmailSentIclone"
                      :tab-alias="selectedMainTab"
                      :client="client"
                      @added="checkIfIsNew"
                      @updated="fetchClients"
                      :send-updated="sendUpdated"
                      @origin="showOriginClient"
                      @merged="filterIndividual"
                      :selected-main-tab="selectedMainTab"
                      :selected-tab="selectedTab"
                      :selected-tag-to-filter="selectedTagToFilter"
                      @lock="blockClient"
                      :initiated-filtering="resetMsAfterFilter"
                      :query-object="getQueryParamsToMs"
                      :openSchedualerObj="openCaComponent"
                  ></client-tags>
                </td>
                <td class="tab-ovrd" v-if="selectedTab !== 'status'">
                  <client-tags
                      :tab-alias="selectedMainTab"
                      :client="client"
                      @updated="fetchClients"
                      :send-updated="sendUpdated"
                      @origin="showOriginClient"
                      :show-tags="false"
                      :selected-main-tab="selectedMainTab"
                      :selected-tag-to-filter="selectedTagToFilter"
                      :openSchedualerObj="openCaComponent"
                  ></client-tags>
                </td>
                <!--tab related columns - campaign -->
                <td
                    class="td-camp-date"
                    v-show="
                      selectedTab === 'campaign' || selectedTab === 'campaign-2'
                    "
                >
                    <span
                        class="span-camp-date"
                        v-if="client.created_at"
                        @click="
                        $store.commit(
                          'clients/setCampRegDate',
                          client.created_at
                        )
                      "
                    >{{ formatDateTimeTable(client.created_at) }}
                      <span
                          class="forDif"
                          :class="{
                          up: !uperOrLowerMinuts || !uperOrLowerH,
                          lower: uperOrLowerMinuts || uperOrLowerH
                        }"
                          v-if="
                          CheckUserPermission([1, 2, 3, 4, 12]) &&
                            (selectedTab === 'campaign' ||
                              selectedTab === 'campaign-2')
                        "
                      >
                        {{ checkDepositConversionTime(client) }}
                      </span></span
                    >
                </td>
                <td
                    class="td-camp"
                    v-show="
                      selectedTab === 'campaign'
                    "
                >
                    <span v-if="client.campaign_aaid !== null">
                      <span :title="client.campaign_aaid">
                        {{ client.campaign_aaid | truncate(12) }}
                      </span></span
                    >
                </td>
                <td class="td-camp" v-show="selectedTab === 'campaign'">
                    <span v-if="client.keyword !== null">
                      <span :title="client.keyword">{{
                          client.keyword | truncate(12)
                        }}</span></span
                    >
                </td>
                <td
                    class="td-center td-camp"
                    v-show="selectedTab === 'campaign'"
                >
                    <span v-if="client.device !== null">
                      <span :title="client.device">
                        {{
                          client.device === null
                              ? ""
                              : client.device | truncate(2)
                        }}
                      </span></span
                    >
                </td>

                <td
                    class="td-center td-camp"
                    v-show="selectedTab === 'campaign-2'"
                >
                  <!--              <click-on-site
                      :click-type="client.click_on_site"
                    ></click-on-site>-->
                  {{ client.click_on_site | truncate(11) }}
                </td>
                <!--                  campign-2-->
                <td v-show=" selectedTab === 'campaign-2'">
                  <client-city-info :client="client"></client-city-info>
                </td>
                <td class="td-camp" v-show="selectedTab === 'campaign-2'">
                    <span v-if="client.last_ip !== null">
                      <span :title="client.last_ip">
                        {{ client.last_ip }}
                      </span></span
                    >
                </td>
                <!--                  capp-->
                <td class="td-camp" v-show="selectedTab === 'campaign'">
                    <span v-if="client.placement !== null">
                      <span :title="client.placement">

                  {{client.placement | truncate(18)}}

                      </span></span
                    >
                </td>
                <td
                    v-show="selectedTab === 'questions' && questionsSector == 1"
                >
                  <div
                      class="floating-wrapper"
                      @mouseleave="showQuestionByInd0 = null"
                      @mouseenter="showQuestionByInd0 = client.id"
                  >
                    <client-answer
                        :client="client"
                        :question-id="11"
                        :send-updated="sendUpdated"
                        @updated="fetchClients"
                        @unlock="resetLock"
                    ></client-answer>
                    <!--             <div
                        v-if="showQuestionByInd1 === client.id"
                        class="floating-question-text"
                      >
                        <span>{{
                          dictionaries.general.client_questions[0].question
                        }}</span>
                      </div>-->
                  </div>
                </td>
                <td
                    v-show="selectedTab === 'questions' && questionsSector == 1"
                >
                  <div
                      class="floating-wrapper"
                      @mouseleave="showQuestionByInd1 = null"
                      @mouseenter="showQuestionByInd1 = client.id"
                  >
                    <client-answer
                        :client="client"
                        :question-id="1"
                        :send-updated="sendUpdated"
                        @updated="fetchClients"
                        @unlock="resetLock"
                    ></client-answer>
                    <!--             <div
                        v-if="showQuestionByInd1 === client.id"
                        class="floating-question-text"
                      >
                        <span>{{
                          dictionaries.general.client_questions[0].question
                        }}</span>
                      </div>-->
                  </div>
                </td>
                <td
                    v-show="selectedTab === 'questions' && questionsSector == 1"
                >
                  <div
                      class="floating-wrapper"
                      @mouseleave="showQuestionByInd8 = null"
                      @mouseenter="showQuestionByInd8 = client.id"
                  >
                    <client-answer
                        :client="client"
                        :answers-list="dictionaries.general"
                        :question-id="9"
                        :send-updated="sendUpdated"
                        @updated="fetchClients"
                        @unlock="resetLock"
                    ></client-answer>
                  </div>
                </td>
                <td
                    v-show="selectedTab === 'questions' && questionsSector == 1"
                >
                  <div
                      class="floating-wrapper"
                      @mouseleave="showQuestionByInd2 = null"
                      @mouseenter="showQuestionByInd2 = client.id"
                  >
                    <client-answer
                        :client="client"
                        :answers-list="dictionaries.general"
                        :question-id="2"
                        :send-updated="sendUpdated"
                        @updated="fetchClients"
                        @unlock="resetLock"
                    ></client-answer>
                  </div>
                </td>
                <td
                    v-show="selectedTab === 'questions' && questionsSector == 2"
                >
                  <div
                      class="floating-wrapper"
                      @mouseleave="showQuestionByInd3 = null"
                      @mouseenter="showQuestionByInd3 = client.id"
                  >
                    <client-answer
                        :client="client"
                        :answers-list="dictionaries.general"
                        :question-id="3"
                        :send-updated="sendUpdated"
                        @updated="fetchClients"
                        @unlock="resetLock"
                    ></client-answer>
                  </div>
                </td>
                <td
                    v-show="selectedTab === 'questions' && questionsSector == 2"
                >
                  <div
                      class="floating-wrapper"
                      @mouseleave="showQuestionByInd4 = null"
                      @mouseenter="showQuestionByInd4 = client.id"
                  >
                    <client-answer
                        :client="client"
                        :answers-list="dictionaries.general"
                        :question-id="4"
                        :send-updated="sendUpdated"
                        @updated="fetchClients"
                        @unlock="resetLock"
                    ></client-answer>
                  </div>
                </td>
                <td
                    v-show="selectedTab === 'questions' && questionsSector == 2"
                >
                  <div
                      class="floating-wrapper"
                      @mouseleave="showQuestionByInd5 = null"
                      @mouseenter="showQuestionByInd5 = client.id"
                  >
                    <client-answer
                        :client="client"
                        :answers-list="dictionaries.general"
                        :question-id="5"
                        :send-updated="sendUpdated"
                        @updated="fetchClients"
                        @unlock="resetLock"
                    ></client-answer>
                  </div>
                </td>
                <td
                    v-show="selectedTab === 'questions' && questionsSector == 2"
                >
                  <div
                      class="floating-wrapper"
                      @mouseleave="showQuestionByInd6 = null"
                      @mouseenter="showQuestionByInd6 = client.id"
                  >
                    <client-answer
                        :client="client"
                        :answers-list="dictionaries.general"
                        :question-id="6"
                        :send-updated="sendUpdated"
                        @updated="fetchClients"
                        @unlock="resetLock"
                    ></client-answer>
                  </div>
                </td>
                <td
                    v-show="selectedTab === 'questions' && questionsSector == 3"
                >
                  <div
                      class="floating-wrapper"
                      @mouseleave="showQuestionByInd7 = null"
                      @mouseenter="showQuestionByInd7 = client.id"
                  >
                    <client-answer
                        :client="client"
                        :answers-list="dictionaries.general"
                        :question-id="7"
                        :send-updated="sendUpdated"
                        @updated="fetchClients"
                        @unlock="resetLock"
                    ></client-answer>
                  </div>
                </td>
                <td
                    v-show="selectedTab === 'questions' && questionsSector == 3"
                >
                  <div
                      class="floating-wrapper"
                      @mouseleave="showQuestionByInd9 = null"
                      @mouseenter="showQuestionByInd9 = client.id"
                  >
                    <client-answer
                        :client="client"
                        :answers-list="dictionaries.general"
                        :question-id="8"
                        :send-updated="sendUpdated"
                        @updated="fetchClients"
                        @unlock="resetLock"
                    ></client-answer>
                  </div>
                </td>
                <td
                    v-show="selectedTab === 'questions' && questionsSector == 3"
                >
                  <div
                      class="floating-wrapper"
                      @mouseleave="showQuestionByInd10 = null"
                      @mouseenter="showQuestionByInd10 = client.id"
                  >
                    <client-answer
                        :client="client"
                        :answers-list="dictionaries.general"
                        :question-id="10"
                        :send-updated="sendUpdated"
                        @updated="fetchClients"
                        @unlock="resetLock"
                    ></client-answer>
                  </div>
                </td>
                <td
                    class="td-traffic"
                    v-show="selectedTab === 'questions' && questionsSector == 3"
                >
                  <div class="traffic-light">
                    <dot-indicator :client="client"></dot-indicator>
                  </div>
                </td>
                <!--tab related columns - geo_campaign -->

                <td class="td-costs" v-show="selectedTab === 'cost'">
                  {{
                    client.cpl +
                    (client.scheduled_calls.length +
                        client.deposits.length +
                        client.leads.length) *
                    10 +
                    client.sms_log.length * 1.73
                  }}₪
                </td>
                <td class="td-costs" v-show="selectedTab === 'cost'">
                  <span v-if="client.cpl !== null">{{ client.cpl }}₪</span>
                  <span v-else>0₪</span>
                </td>
                <td class="td-costs" v-show="selectedTab === 'cost'">
                    <span
                        v-if="
                        client.scheduled_calls.length > 0 ||
                          client.deposits.length > 0 ||
                          client.leads.length > 0
                      "
                    ><!--{{(client.scheduled_calls.length + client.deposits.length + client.leads.length) * 10}}-->10₪</span
                    >
                  <span v-else>0₪</span>
                </td>
                <td class="td-costs" v-show="selectedTab === 'cost'">
                    <span v-if="client.sms_log.length > 0"
                    >{{ (client.sms_log.length * 1.73).toFixed(1) }} ₪</span
                    >
                  <span v-else>0₪</span>
                </td>

                <!--                  <td v-show="selectedTab === 'campaign'"></td>-->
              </tr>
              <!--                <tr class="fake-tr"></tr>-->
              <div v-show="clients.length < 2" class="cartoon">
                <img src="/img/cartoon/homer.jpg" />
              </div>
              <tr
                  class="fake-tr forLineH"
                  colspan="100%"
                  :key="fakeItem"
                  v-for="fakeItem in Math.max(0, 7 - clients.length)"
              >
                <td>1</td>
              </tr>
              </tbody>
              <!--              <thead v-show="clients.length > 0">-->
              <thead>
              <!--              main search should be here-->
              </thead>

              <!-- </table>-->
            </table>
          </div>
          <div
              class="table-locker"
              v-if="blockTable && selectedTab !== 'questions'"
          >
            <span class="table-locker-text"
            >Please answer all questions for user
              <a
                  class="block-id-lnk"
                  @click="filterIndividualForQuestions(blockClientCauseId)"
              >#{{ blockClientCauseId }}</a
              ></span
            >
          </div>
        </div>
      </div>
      <div class="enlarge-div" v-if="clients.length >= 7">
        <span>
          <i
              v-if="!enlargeCompanyTable"
              class="fas fa-sort-down enlarge-table-down"
              @click="enlargeClientsTable(true)"
          ></i>

          <i
              v-else
              class="fas fa-arrow-up enlarge-table"
              @click="enlargeClientsTable(false)"
          ></i>
        </span>
      </div>
    </div>
    <!--      v-show="checkPermissions(auth, [1, 2, 3, 4, 5, 12])"-->

    <calendars-dashboard-v4
        @filter_lm="setLastModifiedDate"
        @filter_lm_tag="setModifiedTagDate"
        @filter_ca="setCaDate"
        @filter_ca_past="setCaPastDate"
        @filter_assign="setAssignDate"
        @filter_transfers="setTransferDate"
        @filter_deposits="setDepositDate"
        @filter_referrals="setReferralDate"
        @filter_support="setSupportDate"
        @filter_na_tag="setNaTagDate"
        @filter_bn_tag="setBnTagDate"
        @filter_lead_tag="setLeadTagDate"
        @filter_group_tag="setGroupTagDate"
        @regDate="setRegDate"
        @setHoursFilter="setHours"
        @pushTCTag="pushTCTag('sc')"
        @resetHoursFilter="resetHours"
        :reset-calendars="resetCalendars"
        @caopened="filterByCaCalendar"
        @regopened="filterByRegCalendar"
        @resetAllCalendars="resetAllCalendars"
        :initiated-filtering="resetMsAfterFilter"
        :query-object="getQueryParamsToMs"
        @filterexdup="setFilterByDup"
        @resetOneCalendar="resetOneCalendar"
        @selectTag="setTagFromCal"
        ref="resetAllCalendars"
        :selected-main-tab="selectedMainTab"
        :selected-tab="selectedTab"
        @change_selected_main_tab="changeSelectedMainTab"
        @fetchScStats="fetchScStats"
        :view-hide-reset="viewHideResetBtn"
        :next-ca="stats.ca_comming"
        :bn-calendar-trigger="bnCalendarTrigger"
    >
    </calendars-dashboard-v4>
    <calendars-ranges-controller
        :filter-new-date="filterNewDate"
        :active-tags="activeTags"
    />
    <main-charts-controller :active-tags="activeTags" />
    <div class="rootForPock" v-if="openMenuForPockeSort">
      <div class="scroller-div">
        <div class="radio">
          <p>
            sort poke ball
          </p>
          <ul>
            <li style="color: green"><span>green - green</span></li>
            <li style="color: red"><span>red - red</span></li>
            <li style="color: green">
              <span>green -<span style="color: red"> red</span></span>
            </li>
            <li style="color: red">
              <span>red -<span style="color: green"> green</span></span>
            </li>
          </ul>
        </div>
      </div>

      <div class="dropdown-divider"></div>
      <div class="tag-form-btns">
        <a
            class="tag-form-ok-btn"
            href="javascript:void(0)"
            @click.prevent="resetSelect"
        ><span class="fas fa-check"></span
        ></a>
        <a
            class="tag-form-cancel-btn"
            href="javascript:void(0)"
            @click="openMenuForPockeSort = false"
        ><span class="fas fa-times"></span
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment/moment";
import axios from "axios";
import { mapState, mapGetters, mapActions } from "vuex";
import ClientModel from "../components/ClientModel";
import apiClientCreator from "../../../../../helpers/api/request";
import { groupAssignment } from "../api/clients_table.api";
import UsersActiveScope from "../mixins/UsersActiveScope";
import { Globals } from "../../../../../global_constants/constants";
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
import ClientMainInfo from "../components/ClientMainInfo.component";
import ClientPhones from "../components/ClientPhones";
import ClientEmails from "../components/ClientEmails";
import ClientTags from "../components/ClientTags";
import FormButtons from "../components/misc/FormButtons";
import SignalsTableButtons from "../components/misc/SignalsTableButtons";
import ClientAssignment from "../components/ClientAssignment.component";
import LdBreadButton from "../components/misc/LdBreadcrumbButton.component";
import RfBreadButton from "../components/misc/RfBreadcrumbButton.component";
import BreadButton from "../components/misc/BreadcrumbButton.component";
import ClickOutside from "v-click-outside";
import ClientOnline from "../components/ClientOnline.component";
import ClientScheduledCallsDiff from "../components/ClientScheduledCallsDiff.component";
import ClientCountyInfo from "../components/ClientCountyInfo";
import ClientCityInfo from "../components/ClientCityInfo";
import ClientAnswer from "../components/questioner/ClientAnswer.component";
import CountryTimeMultiSelect from "../components/MultiSelect/CountryTimeMultiSelect.component";
import PhoneCallsMultiSelect from "../components/MultiSelect/PhoneCallsMultiSelect.component";
import DupMultiSelect from "../components/MultiSelect/DupMultiSelect.component";
import DotIndicator from "../components/questioner/DotIndicator.component";
import TagFormButtons from "../components/tags/TagFormButtons";
import CalendarsDashboardV4 from "../components/date_range_filtering_dashboard_v4/CalendarsDashboard";
import CalendarsRangesController from "../components/date_range_filtering_dashboard_v4/CalendarRangesController";
import AllBreadButton from "../components/misc/AllBreadcrumbButton.component";
import NaBreadButton from "../components/misc/NaBreadcrumbButton.component";
import FavDropDown from "../components/FavDropDown.Component";
import AffiliationTable from "../../../../affiliation.feature/containers/AffiliationTable.container";
import SocketEndpoints from "../../../../../mixins/system/SocketEndpoints";
import FilterUsersByRole from "../../../../../mixins/user/auth/FilterUsersByRole";
//import UsersTable from "../users_mgmt_table.sub_feature.company/UsersTable.container";
import MultiSelect from "../components/MultiSelect/MultiSelect/MultiSelect.container";
//import BrokersTable from "../brokers_table.sub_feature/BrokersTable.container";
import HeaderSubMenuClientsTable from "../components/menu/HeaderSubMenuClientsTable.component";
import NWBreadcrumbButton from "../components/misc/NWBreadcrumbButton.component";
import NotAssNewBreadcrumbButton from "../components/misc/NotAssNewBreadcrumbButton.component";
import AgentsNewBreadcrumbButton from "../components/misc/AgentsNewBreadcrumbButton.component";
import LeadingNewBreadcrumbButton from "../components/misc/LeadingNewBreadcrumbButton.component";
import LoosingNewBreadcrumbButton from "../components/misc/LoosingNewBreadcrumbButton.component";
import SCBreadcrumbButton from "../components/misc/SCBreadcrumbButton.component";
import NextCallsBreadcrumbButton from "../components/misc/NextCallsBreadcrumbButton.component";
import AutoRescheduleCallsBreadcrumbButton from "../components/misc/AutoRescheduleCallsBreadcrumbButton.component";
import MissedCallsBreadcrumbButton from "../components/misc/MissedCallsBreadcrumbButton.component";
import DepositsBreadcrumbButton from "../components/misc/DepositsBreadcrumbButton.component";
import CCDBreadcrumbButton from "../components/misc/CCDBreadcrumbButton.component";
import AllActiveBreadButton from "../components/misc/AllActiveBreadcrumbButton.component";
import calendarCheck from "@/mixins/tags/calendarCheck";
import breadButtonsFunctionsUtil from "../mixins/breadButtonsFunctionsUtil";
import MainChartsController from "../../graph.sub-feature.company/controllers/MainChartsController";


export default {
  name: "clients-table-container",

  components: {
    ClientScheduledCallsDiff,
    AllActiveBreadButton,
    CCDBreadcrumbButton,
    DepositsBreadcrumbButton,
    MissedCallsBreadcrumbButton,
    AutoRescheduleCallsBreadcrumbButton,
    NextCallsBreadcrumbButton,
    SCBreadcrumbButton,
    LoosingNewBreadcrumbButton,
    LeadingNewBreadcrumbButton,
    AgentsNewBreadcrumbButton,
    NotAssNewBreadcrumbButton,
    NWBreadcrumbButton,
    CalendarsRangesController,
    HeaderSubMenuClientsTable,
    MultiSelect,
    // BrokersTable,
    // UsersTable,
    AffiliationTable,
    ClientCountyInfo,
    ClientCityInfo,
    ClientMainInfo,
    TagFormButtons,
    ClientPhones,
    ClientEmails,
    ClientTags,
    FormButtons,
    SignalsTableButtons,
    ClientAssignment,
    BreadButton,
    LdBreadButton,
    RfBreadButton,
    // AllBreadButton,
    ClientOnline,
    NaBreadButton,
    ClientAnswer,
    CountryTimeMultiSelect,
    PhoneCallsMultiSelect,
    DotIndicator,
    DupMultiSelect,
    FavDropDown,
    CalendarsDashboardV4,
    MainChartsController
  },
  mixins: [
    UsersActiveScope,
    UsersPermissionCheck,
    SocketEndpoints,
    calendarCheck,
    FilterUsersByRole,
    breadButtonsFunctionsUtil
  ],
  props: {
    statsRegPreset: {
      type: Object
    },
    tabs: {
      type: Array,
      required: true
    },
    usersTabs: {
      type: Array,
      required: true
    },
    brokersTabs: {
      type: Array,
      required: true
    },

    mainTabs: {
      type: Array,
      required: true
    },

    salesPersonList: {
      type: Array,
      required: true
    },
    update: {
      type: Boolean,
      required: false
    }
  },
  directives: {
    clickOutside: ClickOutside.directive
  },
  data() {
    return {
      requestHash:{
        deposits:null,
      },
      invNumbers:[],
      ncTimeOut: null,
      activeTags: [],
      secondActiveTagsArr: [],
      sortingIcon: "fa-sort-amount-down",
      tabsListForSubMenu: [],
      mainTabPagination: {
        prevTab: 0,
        currentTab: 1,
        nextTab: 2,
        questionSector: null
      },
      openNameSortingBar: false,
      brokersTableData: [],
      paginationDropDownUp: true,
      showPasswordInput: false,
      Globals: Globals,
      clients: [],
      clickedClients: [],
      openMergeOptions: false,
      merge: {
        mergeComments: "",
        mergedClientId: null,
        mergetToClientId: null,
        mergeEmails: false,
        mergePhones: false
      },
      signalsTabs: [
        {
          id: 1,
          name: "Open Signals",
          alias: "OPEN_SIGNALS"
        },
        {
          id: 2,
          name: "Ended Signals",
          alias: "ENDED_SIGNALS"
        }
      ],
      secondClick: {
        tr: false,
        rf: false,
        ld: false
      },
      selectedSignalTab: "ENDED_SIGNALS",

      filtersBarArr: [],
      blockTable: false,
      blockClientCauseId: null,

      selectedTag: {
        name: "",
        stats: 0
      },
      agreeNextCalls: false,
      stats: {
        next_calls: [],
        total: 0,
        nac: 0,
        btgp: 0,
        auto_removal: 0,
        dup: 0,
        dup_source: 0,
        ex_dup_source: 0,
        is_new: 0,
        is_leading: 0,
        selling_group_count: 0,
        other_new: 0,
        is_online: 0,

        is_online_bn: 0,
        is_online_ni: 0,
        is_online_na: 0,
        is_online_t4: 0,

        name_found_t4: 0,
        name_found_ni: 0,
        name_found_bn: 0,
        name_found_na: 0,
        name_found_end: 0,

        email_found_t4: 0,
        email_found_ni: 0,
        email_found_bn: 0,
        email_found_na: 0,
        email_found_end: 0,

        phone_found_t4: 0,
        phone_found_ni: 0,
        phone_found_bn: 0,
        phone_found_na: 0,
        phone_found_end: 0,

        id_found_t4: 0,
        id_found_ni: 0,
        id_found_bn: 0,
        id_found_na: 0,
        id_found_end: 0,

        active: 0,
        scheduled_calls: 0,
        past_scheduled_calls: 0,
        users_ca: [],
        na: 0,
        na_reg_close_count: 0,
        na_all_count: 0,
        users_na: [],
        leads: 0,
        deposits: 0,

        referral: 0,
        referral_ov: 0,

        waiting: 0,
        ended: 0,
        transfer: 0,
        merged: 0,
        tier: 0,
        na_group_count: 0,
        bn_group_count: 0,
        ni_group_count: 0,
        active_group_count: 0,
        brokers_leads_stats: 0,
        brokers_deposits_stats: 0,
        brokers_deposits_cc_stats: 0,
        brokers_dep_status_stats: [],
        brokers_dep_quantity_stats: [],
        brokers_ref_stats: [],
        users_transfer: [],
        user_assignments: [],
        client_countries: [],

        client_answers_status_count: [],
        client_answers_count: [],
        users_na_count: [],
        users_ca_count: [],

        client_campaign_click_type_count: [],
        client_campaign_device_count: [],

        calendar_brokers_dep: [],
        users_ca_status_count: [],
        ca_missed: 0,
        auto_ca_missed: 0,
        ca_comming: 0,
        ca_today: 0,
        call_rescheduled: 0,
        country_time_ranges: [],

        country_tier_count: [],

        priority: [],
        sms_sent: 0,
        sms_return: 0,
        sms_status: 0,
        sms_preset: 0,

        cost_totals: {
          total_cpl_tab: 0,
          total_cpl: 0,
          total_sms: 0,
          total_phone: 0,
          total: 0
        },
        dwa: 0
      },

      getQueryParamsToMs: {},
      resetMsAfterFilter: false,
      showClientOpMenu: null,
      showEditClientCountry: false,
      startUpAllTagFilter: true,
      resetCalendars: false,
      closeCalendars: false,
      resetMultiSelects: false,
      switcherDepDate: true,
      switcherAssignDate: true,
      switcherLastModDate: true,
      switcherLastModDateTagAlias: "",
      settedTagLastModDate: false,
      sendUpdated: "",
      showBulkAssign: false,
      bulkCheckBoxChecked: false,
      filteredClientIds: [],
      selectAllClients: false,
      prevPageNumInput: "",
      pageNumInput: 1,
      viewResetBtn: false,
      allSelected: false,
      allSelectedInPage: false,
      timeRangeSelected: "Reset",
      // selectedTab: this.clientsTableSelectedTab,
      selectedTab: "status",
      selectedMainTab: "clients",
      // selectedMainTab: this.clientsTableSelectedMainTab,
      bnCalendarTrigger: 0,
      usersTableData: [],
      selectedTagToFilter: "",
      selectedClients: [],
      showOrigin: false,
      cameFromDuplicate: null,
      showDuplicateBackBtn: false,
      showAssignToResults: false,
      assignToResults: [],
      suggestedUsers: [],
      unSuggestedUsers: [],
      uniqueUsers: [],
      clientToSuggest: null,
      assignToQuery: "",
      showBulkAssignToResults: false,
      bulkAssignToResults: [],
      bulkAssignToQuery: "",
      rank1_users_stats: [],
      rank2_users_stats: [],
      rank3_users_stats: [],
      openLeadFilterMenu: false,
      openTransferMenu: false,
      openDepositsMenu: false,
      openReferralMenu: false,
      openProcessMenu: false,
      openNaMenu: false,
      openCaMenu: false,
      showFn: false,
      showEn: false,
      showBtgp: false,
      menuTimeouts: [],
      q11: false,
      q1: false,
      q2: false,
      q3: false,
      q4: false,
      q5: false,
      q6: false,
      q7: false,
      q8: false,
      q9: false,
      q10: false,
      showQuestionByInd0: null,
      showQuestionByInd1: null,
      showQuestionByInd2: null,
      showQuestionByInd3: null,
      showQuestionByInd4: null,
      showQuestionByInd5: null,
      showQuestionByInd6: null,
      showQuestionByInd7: null,
      showQuestionByInd8: null,
      showQuestionByInd9: null,
      showQuestionByInd10: null,

      redTraffic: false,
      greenTraffic: false,
      yellowTraffic: false,

      emailsUpdateBusy: false,

      timeTypes: [
        {
          id: 1,
          name: "Day"
        },

        {
          id: 2,
          name: "Night"
        },

        {
          id: 3,
          name: "Work Hours"
        },
        {
          id: 4,
          name: "Evening Hours"
        }
      ],

      statusBtnColors: {
        bgCall: "#fa8100",
        bgNew: "#00c853",
        bgActive: "#008b00",
        bgNA: "#F4511E",
        bgBN: "#000",
        bgNIN: "#424242",
        bgRF: "#d32f2f",
        bgTR: "#827717",
        bgWT: "#00796b",
        bgDP: "#7b1fa2",
        bgLD: "#1144bc",
        bgAll: "#311b92",
        txtGrey: "#212121",
        txtWhite: "#ffffff"
      },

      switcherRegCa: false,
      pagination: {
        currentPage: 1,
        perPage: 10,
        from: 1,
        to: 1,
        lastPage: 1,
        total: 0
      },

      slectedFnFilter: "DEFAULT",
      slectedFnFilterCounter: 0,
      selectedFnFilterTotalCounter: [],

      filters: {
        enlarge_leads: false,
        sortByColumn: "id",
        order_by: false,
        sort_order: false,

        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        countryTime: {
          from: false,
          to: false
        },
        sms_status: [],
        sms_preset: [],
        sms_returned: false,
        priority: [],
        show_country_stats: false,
        client: "",
        click_on_site: [],
        last_ip: "",
        keyword: "",
        keywords: [],
        aaid: "",
        aaids: [],
        loc_phys_ms: [],
        placement: [],
        device: [],
        countries: [],
        country_tiers: [],
        country_parent: [],
        assigned: [],
        assigned_rank1: [],
        assigned_rank2: [],
        assigned_rank3: [],
        assigned_by_rank: [],
        orig_assigned: [],
        group_assigned: false,
        recent_searches: false,
        group_assigned_at: false,
        assigned_at: false, /// was []
        registered_on: false, // was []
        scheduled_call_to: false,
        deposit_at: false,
        support_at: false,
        last_modified: false,
        hours_at: false,
        //hours calendars
        registered_hours_at: false,
        last_modified_hours_at: false,
        last_modified_personal_hours_at: false,
        last_sc_tag_hours_at: false,
        scheduled_calls_hours_at: false,
        assigned_hours_at: false,
        transfers_hours_at: false,
        deposits_hours_at: false,
        referrals_hours_at: false,
        supports_hours_at: false,
        lead_tag_hours_at: false,
        na_tag_hours_at: false,
        group_assigned_hours_at: false,
        //end hours calendars

        last_sc_tag: false,
        last_modified_na: false,
        last_modified_leads: false,
        last_modified_ca: false,
        last_modified_bn: false,
        last_modified_ni: false,
        last_modified_wt: false,
        last_modified_en: false,
        last_modified_nac: false,
        last_modified_btgp: false,
        last_modified_answers: false,
        last_transfer: false,
        last_referral: false,
        scheduled_calls: false,
        missed_calls: false,
        auto_missed_calls: false,
        coming_calls: false,
        today_calls: false,
        is_new: false,
        other_new: false,
        selling_group: false,
        leading_new: false,
        loosing_new: false,
        online: false,
        active: true,
        is_leading: false,
        nac: false,
        btgp: false,
        auto_removal: false,
        dup_source: false,
        ex_dup_source: false,
        dup: false,
        reg_dup_total: false,
        dup_exclude: false,
        dup_users: [],
        dup_na: [],
        dup_ni: [],
        dup_bn: [],
        dup_na_ar: [],
        merged: false,
        tech: false,
        bad_number: false,
        bn_status: [],
        ni_status: [],
        not_interested: false,
        na: false,
        na_reg_close: false,
        na_all: false,
        na_users: [],
        ca_users: [],
        ca_status: [],
        ca_auto_status: [],
        leads: false,
        lead_campaigns: [],
        referral_brokers: [],
        referral_users: [],
        lead_campaigns_users: [],
        referral_campaigns_users: [],
        referral_campaigns: [],
        transfer: false,
        client_transfers: [],
        client_transfer_place: [],
        client_transfers_type: [],
        client_transfers_from: [],
        client_transfers_by: [],
        waiting: false,
        ended: false,
        ended_sort_by_name: false,
        referral: false,
        deposit_statuses: [],
        deposit_brokers: [],
        deposit_users: [],
        deposit_sec_users: [],
        deposit_lead_users: [],
        deposit_answers: [],
        deposit_brokers_quantity: [],
        deposit: false,
        deposit_amount: null,
        deposit_clients: false,
        cc_decline_clients: false,
        deposit_at_hour: null,
        last_na_hour: null,
        last_lead_hour: null,
        deposit_to_rem: false,
        deposit_from_cc: false,
        deposit_from_sup: false,
        tier: false,
        answers1: [],
        answers2: [],
        answers3: [],
        answers4: [],
        answers5: [],
        answers6: [],
        answers7: [],
        answers8: [],
        answers9: [],
        answers10: [],
        answers11: [],
        answers_status: [],

        fetch_questions_stats: false,
        fetch_camp_stats: false,
        fetch_countries_stats: false,
        fetch_tiers_stats: false,
        fetch_client_assign_stats: false,
        fetch_sms_stats: false,

        last_modified_order: null,
        tags_last_mod: false,
        last_modified_personal: false,
        retired: null,

        //kobi super important
        //kobi exclude kobi
        exclude_cc_decline_clients: false,

        exclude_bn_filter:false, //bad number
        exclude_ni_filter:false, //not interested
        exclude_ca_filter: false, // call again
        exclude_na_filter: false, //no answer
        exclude_tr_filter: false, // transfer
        exclude_rf_filter: false, // ref
        exclude_ld_filter: false, //lead
        exclude_dp_filter: false, //deposits
        exclude_as_filter: false, //assignments
        exclude_sms_filter: false, //sms
        exclude_co_filter: false, //countries
        exclude_qs_filter: false, //questions status
        exclude_ad_filter: false, //advertising
        exclude_kw_filter: false, //keyword
        exclude_de_filter: false, //device
        exclude_ct_filter: false, //click type
        exclude_lc_filter: false, //location
        exclude_pl_filter: false, //placement

        exclude_auto_ca: false, //not in use
        exclude_ca: false, //not in use
        exclude_na: false, //not in use
        exclude_tr: false, //not in use
        exclude_rf: false, //not in use
        exclude_ld: false, //not in use
        exclude_dp: false, //not in use

        waiting_approval: false,
        dwa: false,
        reschedule_type: false
      },

      form: {
        errorBag: {},
        main: {
          first_name: "",
          last_name: "",
          birth_date: null
        },
        phones: [],
        newPhone: {
          client_id: null,
          contact_value: "",
          id: null,
          is_primary: 0
        },
        emailEditIsOpen: false,
        emails: [],
        newEmail: {
          client_id: null,
          contact_value: "",
          id: null,
          is_primary: 0,
          deposit_email: 0
        },
        assignedTo: {
          full_name: "",
          id: null
        }
      },

      edit: {
        mainInfoClientId: null,
        phonesClientId: null,
        emailsClientId: null,
        assignmentClientId: null,
        sendSMS: null,
        sendSMSto: null
      },

      cms: {
        cmsPasswordClientID: null,
        cmsSignalsClientId: null,
        cmsPlanClientId: null,
        cmsSMSClientId: null,
        edit: {
          cmsNewPassword: null,
          cmsNewPlan: null
        },
        cmsPasswordHistoryClientId: null,
        cmsPlanHistoryClientId: null,
        cmsSMSHistoryClientId: null,
        cmsPlanCurrentClientId: 2,
        requestCMSClientSignalsBusy: false,
        CMSClientSignals: {
          open_signals: [],
          ended_signals: []
        }
      },
      highlightedClientId: null,
      highlightedHoverClientId: null,

      adminData: {
        id: null,
        full_name: null
      },
      openDupMenu: false,
      openNiGroupMenu: false,
      openBnGroupMenu: false,
      showNewClientForm: false,
      expandCalendar: false,
      showCalendarPopup: false,
      fieldsDisable: true,
      resetNewClientMultiSelects: false,
      favDataParams: [],
      newClient: {
        firstName: "",
        lastName: "",
        birthDate: "",
        prf: "",
        phone: "",
        email: "",
        country: "",
        keyword: "",
        device: "",
        aaid: "",
        clickType: "",
        locPhysMs: "",
        placement: ""
      },

      newDuplicate: {
        op: null,
        client: {},
        selectedMainTab: ""
      },
      interval: null,
      showBulkDuplicateAssign: false,
      showDuplicateAssign: null,
      selectedClientsFrom: [],

      statsSelectedAaid: false,
      statsSelectedKeyword: false,
      openEmailReplayBox: false,
      openEmailsCountRelayBox: false,
      editorSettings: {
        modules: {
          imageResize: { displaySize: true }
        }
      },
      openNewFilteringDates: false,
      dateChooserFromBtnsTimeFillter: false,
      tempWhereChoosed: false,
      regCalPresetsStats: {},
      sortOrderAlpha: "asc",
      sortOrderNumeric: "asc",
      sortOrderAmount: "asc",
      sortActive1: false,
      sortActive2: false,
      sortActive3: false,
      sortActive4: true,
      sortActive: {
        cre: {
          up: false,
          down: false
        },
        mod: {
          up: false,
          down: false
        },
        id: {
          up: false,
          down: false
        },
        name: {
          up: false,
          down: false
        }
      },
      changeAutoIcone: false,
      changeToNotReIcone: false,
      changeResesColor: false,
      hoursCalsList: [
        "registered_hours_at",
        "last_modified_hours_at",
        "last_sc_tag_hours_at",
        "scheduled_calls_hours_at",
        "assigned_hours_at",
        "transfers_hours_at",
        "deposits_hours_at",
        "referrals_hours_at",
        "supports_hours_at",
        "lead_tag_hours_at",
        "na_tag_hours_at",
        "group_assigned_hours_at"
      ],
      questionsSector: null,
      totalDiffDepAndReg: null,
      uperOrLowerH: null,
      uperOrLowerMinuts: null,
      showAllOpt: false,
      filterNewDate: false,
      openMenuForPockeSort: false,
      totalRepEmails: 0
      //preventOutClose: false
    };
  },

  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "dictionaries",
      "filterClientId",
      "filterCaMissed",
      "filterClientCall",
      "filterDepTimeFrame",
      "depositClientsFilter",
      "enlargeCompanyTable",
      "AssigmentChoseAll",
      "LastModChoseTimeForChart",
      "LastModChoseFromStatsTable",
      "updateAfterCongrats",
      "dataFromFavs",
      "selectedMainCalendar",
      "filterDepStatus",
      "graphDataToTable",
      "scDataToTable",
      "regCalFilterNoDate",
      "generalChartFilter",
      "chartsMainView",
      "dynamicChartUsers",
      "dynamicChartDates",
      "clientsTableSelectedMainTab",
      "clientsTableSelectedTab",
      "clientsTableCalendarSubMenuOpened",
      "clientsTableCalendarSubMenuSubMs",
      "refreshAll",
      "DebounceAll",
      "tabsList",
      "FilterToMain",
      "stopProcess",
      "shortCutsToBlocks",
      "openCaComponent",
      "chartsViewBlocks",
      "clientsTableSelectedMainTab"
    ]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"])
  },

  mounted() {
    this.filters.active = true
    //this.resetThFields()
    this.getTabListByRole(this.auth.user.role, this.tabsList);
    // this.selectedMainTab = this.clientsTableSelectedMainTab;
    this.$store.commit('clients/setClientsTableSelectedMainTab','clients')
    this.selectedMainTab = 'clients';
    if (!this._skipInitialFetch) {
      this.fetchClients();
    }
    this.$store.dispatch("tasks/getTaskDictionary");
    this.$store.commit("clients/setClientsTableStatsObject", this.stats);
    $(document).ready(function() {
      $('[data-toggle="tooltip"]').tooltip({ container: "body" });
    });
    // this.triggerSortNameJquery()
  },

  created() {
    //this.resetThFields()
    if (!this.CheckUserPermission([5])) {
      this.getCaNextCallsClientsStats();
    }
    setInterval(() => {
      if (this.$router.currentRoute.name === "Main" && this.auth.user.id) {
        this.getOnlineClientsCountStats();
        this.getCaCommingClientsCountStats();
        this.$store.commit("clients/setRefreshGeneralLiveSmallStatsChart", true);

      }
    }, 120000);
    this.checkBlockInStorage();
  },
  watch: {
    filters: {
      handler() {
        this.viewHideResetBtn();
      },
      deep: true
    },

    selectedTagToFilter: function() {
      this.$store.commit(
          "clients/setGeneralQueryObject",
          this.getQueryParams()
      );
      this.$store.commit("clients/setSelectedTopTag", this.selectedTagToFilter);
    },
    "FilterToMain.ld": function() {
      if (this.FilterToMain.ld) {
        this.filterByLead();
      }
    },

    "FilterToMain.rf": function() {
      if (this.FilterToMain.rf) {
        this.filterByReferral();
      }
    },
    "FilterToMain.tr": function() {
      if (this.FilterToMain.tr) {
        this.filterByTransfer();
      }
    },

    "FilterToMain.nr": function() {
      if (this.FilterToMain.nr) {
        this.filterByNoAnswer(0);
      }
    },

    "FilterToMain.end": function() {
      if (this.FilterToMain.end) {
        this.filterByEnded();
      }
    },

    // 'FilterToMain.bn':function () {
    // if(this.FilterToMain.bn){
    //   this.bnTabStatusFilter();
    //   // this.getBnGroupClientsCountStats();
    // }
    //
    // },

    //   'FilterToMain.ni':function () {
    //   if(this.FilterToMain.ni){
    //     // this.niTabStatusFilter();
    //     this.selectedMainTab = "ni";
    //
    //     this.$store.commit("clients/setClientsTableTab", this.selectedMainTab);
    //
    //
    //     // this.getNiGroupClientsCountStats();
    //   }
    // },
    "FilterToMain.sc": function() {
      if (this.FilterToMain.sc) {
        this.filterByTodayCalls();
      }
    },
    "FilterToMain.nw": function() {
      if (this.FilterToMain.nw) {
        this.filterByNew(1);
      }
    },
    "FilterToMain.dep": function() {
      if (this.FilterToMain.dep) {
        this.filterByDeposit();
      }
    },
    DebounceAll: function() {
      this.debouncedClientsQuery();
    },
    refreshAll: function() {
      if(this.refreshAll){
        this.resetThFields();
      }
      this.$store.commit("clients/setRefreshAll", false);
    },


    clientsTableCalendarSubMenuOpened: function() {
      this.getAllStats();
    },
    /* naAutoEmailSent:function(){
      if(this.naAutoEmailSent){
        this.emailIcone = "autoEmailSent.svg";
      }
    },*/
    generalChartFilter: function() {
      if (this.generalChartFilter) {
        let filter = this.generalChartFilter.filter.toLowerCase();
        if (filter !== "cost" && filter !== "c2c" && filter !== "sms") {
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          this.filterFromGeneralChart(this.generalChartFilter);
          //this.$store.commit("clients/setGeneralChartFilter",null);
        }
        if (filter === "on") {
          this.filterByOnline();
        }
      }
    },
    dynamicChartUsers: function() {
      if (this.dynamicChartUsers.length > 0) {
        this.filters.deposit_users = [];
        this.dynamicChartUsers.map(user => {
          this.filters.deposit_users.push({ id: user });
        });
        this.debouncedClientsQuery();
      }
    },
    dynamicChartDates: function() {
      if (this.dynamicChartDates.start && this.dynamicChartDates.end) {
        this.filters.deposit_clients = true;
        this.filters.deposit_at = [
          this.dynamicChartDates.start,
          this.dynamicChartDates.end
        ];
        this.filters.deposit = true;
        this.debouncedClientsQuery();
      }
    },
    regCalFilterNoDate: function(filter) {
      //if (filter) {
      if (filter === "DUP") {
        this.filters.dup_exclude = false;
        this.filters.dup = true;
        this.filters.reg_dup_total = false;
        this.debouncedClientsQuery();
        return this.viewHideResetBtn();
      }

      if (filter === "ALL") {
        this.filters.dup_exclude = false;
        this.filters.dup = false;
        // this.filters.reg_dup_total = true;
        this.debouncedClientsQuery();
        return this.viewHideResetBtn();
      }

      if (filter === "REG") {
        this.filters.dup_exclude = true;
        this.filters.dup = false;
        this.filters.reg_dup_total = false;
        this.debouncedClientsQuery();
        return this.viewHideResetBtn();
      }

      ///   this.$store.commit("clients/setRegCalFilterNoDate", null);
      //}
    },
    scDataToTable: function() {
      if (this.scDataToTable.filter) {
        this.filters.scheduled_call_to = [
          this.scDataToTable.queryParamsToday.scheduled_call_to_from,
          this.scDataToTable.queryParamsToday.scheduled_call_to_to
        ];
        if (
            this.scDataToTable.queryParamsToday.hasOwnProperty(
                "last_modified_from"
            )
        ) {
          this.filters.last_modified = [
            this.scDataToTable.queryParamsToday.last_modified_from,
            this.scDataToTable.queryParamsToday.last_modified_to
          ];
        }
      }
    },
    graphDataToTable: function() {
      if (this.graphDataToTable.filters) {
        let filter = this.graphDataToTable.filters;
        if (this.graphDataToTable.dates) {
          if (filter === "DEP") {
            this.handleDepDataFromChart();
          }
          if (filter === "ASMT" || filter === "MDFY") {
            this.handleAsmtDataFromChart();
          }
        }
      }
    },
    filterDepStatus: function() {
      if (this.filterDepStatus === "DEP_STATUS_BACK_TO_SALES") {
        this.filters.deposit = true;
        this.filters.deposit_statuses = [{ id: 9 }];
        this.debouncedClientsQuery();
        this.$store.commit("clients/setFilterDepStatus", null);
      }
    },
    favDataParams: function() {
      clearInterval(this.interval);
      this.interval = setTimeout(() => {
        //this.$refs.triggerFavs.saveToFavorites();
        clearInterval(this.interval);
      }, 10000);
    },
    dataFromFavs: function() {
      if (this.dataFromFavs) {
        this.resetThFields();
        let tempObj = this.dataFromFavs;
        let keys = Object.keys(tempObj);

        keys.map(key => {
          this.filters[key] = tempObj[key];
        });
        this.$store.commit("clients/setQueryFromFavs", false);
      }
    },
    updateAfterCongrats: function() {
      if (this.updateAfterCongrats !== null) {
        this.resetTRselector();
        this.resetDPSelectors();
        this.resetCAselectors();
        this.resetRFSelectors();
        this.resetLDselector();
        this.resetNAselectors();
        this.filters.dup = false;
        // this.filters.deposit_users = [{id: this.updateAfterCongrats}];
        this.filters.client = "#" + this.updateAfterCongrats;
        // this.filters.deposit = true;
        this.selectedMainTab = "clients";

        this.$store.commit("clients/setUpdateAfterCongrats", null);
        return this.$store.commit("main/setShowVikiMsg", {
          show: false,
          id: null,
          msg: "",
          type: "",
          op: {
            type: "",
            clientId: null,
            userId: null
          }
        });
      }
    },
    AssigmentChoseAll: function() {
      this.$store.commit("clients/setSelectedMainCalendar", ["ASSIGN"]);
      // alert(this.AssigmentChoseAll.type)
      // switch (this.AssigmentChoseAll.type) {
      //
      //   case  "ALL_CLIENTS":
      //     alert('all')
      //     this.filters.dup = false;
      //     this.filters.dup_exclude = false;
      //     break;
      //   case "DUP_CLIENTS":
      //     alert('dup')
      //     this.filters.dup_exclude = false;
      //     this.filters.dup = true;
      //     break;
      //   case "EX_DUP":
      //     this.filters.dup_exclude = true;
      //     this.filters.dup = false;
      //     break;
      //
      //   case "ORIG_ASSIGN":
      //
      //     break;
      //
      //   case "WITH_REG_DATE":
      //    // this.$store.commit("clients/setSelectedMainCalendar", [...this.selectedMainCalendar,"REG"]);
      //
      //     break;
      // }
      this.$store.commit("clients/setAssigmentChoseTimeForChart", {
        time: this.AssigmentChoseAll.time,
        enabled: true
      });

      if (this.AssigmentChoseAll.dup) {
        this.filters.dup_exclude = false;
        this.filters.dup = true;
      } else {
        this.filters.dup = false;
      }
      if (this.AssigmentChoseAll.ex_dup) {
        this.filters.dup = false;
        this.filters.dup_exclude = true;
      } else {
        this.filters.dup_exclude = false;
      }
      if (this.AssigmentChoseAll.with_reg_date) {
        this.$store.commit("clients/setSelectedMainCalendar", [
          "ASSIGN",
          "REG"
        ]);
        this.$store.commit(
            "clients/setRegCalendarDate",
            this.AssigmentChoseAll.time
        );
      } else {
        this.filters.registered_on = false;
        this.$store.commit("clients/setRegCalendarDate", "RESET");
      }
      this.$store.commit("clients/setLastModChoseTimeForChart", {
        time: "RST",
        enabled: true
      });

      this.$store.commit("clients/setAssigmentChoseTimeForChart", {
        time: this.AssigmentChoseAll.time,
        enabled: true
      });

      if (
          this.filters.assigned.length === 0 &&
          this.AssigmentChoseAll.filter === "all_clients"
      ) {
        this.resetTRselector();
        this.resetDPSelectors();
        this.resetCAselectors();
        this.resetRFSelectors();
        this.resetLDselector();
        this.resetNAselectors();
        this.debouncedClientsQuery();
        return (this.selectedMainTab = "clients");
      }
      this.filters.assigned = [this.AssigmentChoseAll.user];

      if (this.AssigmentChoseAll.orig_assign) {
        this.filters.orig_assigned = [this.AssigmentChoseAll.user];
        this.filters.assigned = [this.AssigmentChoseAll.user];
      } else {
        this.filters.orig_assigned = [];
      }

      if (
          this.filters.assigned.length > 0 ||
          this.filters.orig_assigned.length > 0
      ) {
        if (this.AssigmentChoseAll.filter === "active") {
          this.selectedMainTab = "clients";
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          return;
        }
        if (this.AssigmentChoseAll.filter === "ca") {
          this.selectedMainTab = "clients";
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          this.filterByTodayCalls();
          return;
        }
        if (this.AssigmentChoseAll.filter === "na") {
          this.selectedMainTab = "clients";
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          this.filterByNoAnswer();
          return;
        }

        if (this.AssigmentChoseAll.filter === "tr") {
          this.selectedMainTab = "clients";
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          this.filterByTransfer();
          return;
        }

        if (this.AssigmentChoseAll.filter === "trOnline") {
          this.selectedMainTab = "clients";
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          this.filters.client_transfers_type = [{ id: 2 }];
          this.filterByTransfer();
          return;
        }
        if (this.AssigmentChoseAll.filter === "trLive") {
          this.selectedMainTab = "clients";
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          this.filters.client_transfers_type = [{ id: 1 }];
          this.filterByTransfer();
          return;
        }

        if (this.AssigmentChoseAll.filter === "rf") {
          this.selectedMainTab = "clients";
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          this.filterByReferral();
          return;
        }

        if (this.AssigmentChoseAll.filter === "ld") {
          this.selectedMainTab = "clients";
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          this.filterByLead();
          return;
        }

        if (this.AssigmentChoseAll.filter === "ni") {
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          return (this.selectedMainTab = "ni");
        }
        if (this.AssigmentChoseAll.filter === "nr") {
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          return (this.selectedMainTab = "na");

          // this.filters.group_assigned = [{ id: 2 }];
        }
        if (this.AssigmentChoseAll.filter === "bn") {
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          return (this.selectedMainTab = "bn");
        }
        if (this.AssigmentChoseAll.filter === "CLT") {
          this.selectedMainTab = "clients";
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          this.filters.deposit_users = [this.AssigmentChoseAll.user];
          this.filters.deposit_clients = true;
          // this.filterByDeposit();
          return;
        }
        if (this.AssigmentChoseAll.filter === "dp") {
          this.selectedMainTab = "clients";
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          this.filters.deposit_users = [this.AssigmentChoseAll.user];
          this.filters.deposit_clients = true;
          // this.filterByDeposit();
          return;
        }
        if (this.AssigmentChoseAll.filter === "name") {
          this.selectedMainTab = "clients";
          this.resetTRselector();
          this.resetDPSelectors();
          this.resetCAselectors();
          this.resetRFSelectors();
          this.resetLDselector();
          this.resetNAselectors();
          this.debouncedClientsQuery();
          return;
        }
      }
    },
    LastModChoseFromStatsTable: function() {
      if (this.LastModChoseFromStatsTable.dup) {
        this.filters.dup_exclude = false;
        this.filters.dup = true;
      } else {
        this.filters.dup = false;
      }
      if (this.LastModChoseFromStatsTable.ex_dup) {
        this.filters.dup = false;
        this.filters.dup_exclude = true;
      } else {
        this.filters.dup_exclude = false;
      }
      if (this.LastModChoseFromStatsTable.with_reg_date) {
        // this.$store.commit("clients/setSelectedMainCalendar", ["ASSIGN","REG"]);
        this.$store.commit(
            "clients/setRegCalendarDate",
            this.LastModChoseFromStatsTable.time
        );
      } else {
        this.filters.registered_on = false;
        this.$store.commit("clients/setRegCalendarDate", "RESET");
      }

      this.$store.commit("clients/setAssigmentChoseTimeForChart", {
        time: "RST",
        enabled: true
      });

      this.$store.commit("clients/setLastModChoseTimeForChart", {
        time: this.LastModChoseFromStatsTable.time,
        enabled: true
      });
      this.filters.assigned = [];
      // if (this.LastModChoseTimeForChart.user === null && this.AssigmentChoseAll.filter === "all_clients") {
      //   this.resetTRselector();
      //   this.resetDPSelectors();
      //   this.resetCAselectors();
      //   this.resetRFSelectors();
      //   this.resetLDselector();
      //   this.resetNAselectors();
      //   this.debouncedClientsQuery();
      //   return (this.selectedMainTab = "active");
      // }

      // if (this.filters.assigned.length > 0) {
      //    if (this.AssigmentChoseAll.filter === "active") {
      //      this.resetTRselector();
      //      this.resetDPSelectors();
      //      this.resetCAselectors();
      //      this.resetRFSelectors();
      //      this.resetLDselector();
      //      this.resetNAselectors();
      //      this.filters.dup_exclude=true
      //      return (this.selectedMainTab = "active");  /// TODO: not clickable - Last Mod
      //    }

      if (this.LastModChoseFromStatsTable.filter === "ca") {
        this.selectedMainTab = "clients";
        this.resetTRselector();
        this.resetDPSelectors();
        this.resetCAselectors();
        this.resetRFSelectors();
        this.resetLDselector();
        this.resetNAselectors();
        this.filters.na_users = [];
        this.filters.ca_users = [this.LastModChoseFromStatsTable.user];
        this.filterByTodayCalls();
        return;
      }
      if (this.LastModChoseFromStatsTable.filter === "na") {
        this.resetTRselector();
        this.resetDPSelectors();
        this.resetCAselectors();
        this.resetRFSelectors();
        this.resetLDselector();
        this.resetNAselectors();
        this.filterByNoAnswer();
        this.filters.ca_users = [];
        this.filters.na_users = [this.LastModChoseFromStatsTable.user];
        return (this.selectedMainTab = "clients");
      }

      if (this.LastModChoseFromStatsTable.filter === "tr") {
        this.selectedMainTab = "clients";
        this.resetTRselector();
        this.resetDPSelectors();
        this.resetCAselectors();
        this.resetRFSelectors();
        this.resetLDselector();
        this.resetNAselectors();
        this.filterByTransfer();
        this.filters.ca_users = [];
        this.filters.na_users = [];
        this.filters.client_transfers = [this.LastModChoseFromStatsTable.user];
        return;
      }

      if (this.LastModChoseFromStatsTable.filter === "trOnline") {
        this.selectedMainTab = "clients";
        this.resetTRselector();
        this.resetDPSelectors();
        this.resetCAselectors();
        this.resetRFSelectors();
        this.resetLDselector();
        this.resetNAselectors();
        this.filters.ca_users = [];
        this.filters.na_users = [];
        this.filters.client_transfers_type = [{ id: 2 }];
        this.filters.client_transfers = [this.LastModChoseFromStatsTable.user];
        this.filterByTransfer();
        return;
      }
      if (this.LastModChoseFromStatsTable.filter === "trLive") {
        this.selectedMainTab = "clients";
        this.resetTRselector();
        this.resetDPSelectors();
        this.resetCAselectors();
        this.resetRFSelectors();
        this.resetLDselector();
        this.resetNAselectors();
        this.filters.ca_users = [];
        this.filters.na_users = [];
        this.filters.client_transfers_type = [{ id: 1 }];
        this.filters.client_transfers = [this.LastModChoseFromStatsTable.user];
        this.filterByTransfer();
        return;
      }

      if (this.LastModChoseFromStatsTable.filter === "ld") {
        this.selectedMainTab = "clients";
        this.resetTRselector();
        this.resetDPSelectors();
        this.resetCAselectors();
        this.resetRFSelectors();
        this.resetLDselector();
        this.resetNAselectors();
        this.filters.ca_users = [];
        this.filters.na_users = [];
        this.filters.lead_campaigns_users = [
          this.LastModChoseFromStatsTable.user
        ];
        this.filterByLead();
        return;
      }

      if (this.LastModChoseFromStatsTable.filter === "CLT") {
        this.selectedMainTab = "clients";
        this.resetTRselector();
        this.resetDPSelectors();
        this.resetCAselectors();
        this.resetRFSelectors();
        this.resetLDselector();
        this.resetNAselectors();
        this.filters.na_users = [];
        this.filters.deposit_users = [this.LastModChoseFromStatsTable.user];
        this.filters.deposit_clients = true;
        // this.filterByDeposit();
        return;
      }
      if (this.LastModChoseFromStatsTable.filter === "dp") {
        this.selectedMainTab = "clients";
        this.resetTRselector();
        this.resetDPSelectors();
        this.resetCAselectors();
        this.resetRFSelectors();
        this.resetLDselector();
        this.resetNAselectors();
        this.filters.na_users = [];
        this.filters.deposit_users = [this.LastModChoseFromStatsTable.user];
        this.filters.deposit_clients = true;
        // this.filterByDeposit();
        return;
      }

      // if (this.AssigmentChoseAll.filter === "name") {
      //   this.resetTRselector();
      //   this.resetDPSelectors();
      //   this.resetCAselectors();
      //   this.resetRFSelectors();
      //   this.resetLDselector();
      //   this.resetNAselectors();
      //   this.debouncedClientsQuery();
      //   return (this.selectedMainTab = "active");
      // }

      // }
    },
    update: function() {
      this.fetchClients();
    },
    depositClientsFilter: function(val) {
      val
          ? (this.filters.deposit_clients = true)
          : (this.filters.deposit_clients = false);
    },
    filterDepTimeFrame: function(timeframe) {
      if (this.filterDepTimeFrame) {
        if (timeframe === "TODAY") {
          this.filters.deposit_at = [
            moment().format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          this.filters.deposit_clients = true;
          this.debouncedClientsQuery();
        }
        if (timeframe === "YESTERDAY") {
          this.filters.deposit_at = [
            moment()
                .subtract(1, "days")
                .format("YYYY-MM-DD"),
            moment()
                .subtract(1, "days")
                .format("YYYY-MM-DD")
          ];
          this.filters.deposit_clients = true;
          this.debouncedClientsQuery();
        }

        if (timeframe === "WEEK") {
          this.filters.deposit_at = [
            moment()
                .startOf("isoWeek")
                .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          this.filters.deposit_clients = true;
          this.debouncedClientsQuery();
        }
        if (timeframe === "THIS_MONTH") {
          this.filters.deposit_at = [
            moment()
                .startOf("month")
                .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          this.filters.deposit_clients = true;
          this.debouncedClientsQuery();
        }
        if (timeframe === "LAST_MONTH") {
          this.filters.deposit_at = [
            moment()
                .subtract(1, "months")
                .startOf("month")
                .format("YYYY-MM-DD"),
            moment()
                .subtract(1, "months")
                .endOf("month")
                .format("YYYY-MM-DD")
          ];
          this.filters.deposit_clients = true;
          this.debouncedClientsQuery();
        }
        this.$store.commit("clients/setFilterDepTimeFrame", null);
      }
    },
    filterClientId: function() {
      //this.resetThFields();
      this.filterIndividual(this.filterClientId);
    },
    filterClientCall: function() {
      if (this.filterClientCall) {
        this.resetThFields();

        this.filters.client = "#" + this.filterClientCall;
        this.pagination.currentPage = 1;

        this.fetchClientsAndCall();
        this.viewHideResetBtn();
      }
    },
    filterCaMissed: function() {
      if (this.filterCaMissed) {
        this.resetThFields();
        this.filterByMissedCalls();
      }
    },
    clientsTableSelectedMainTab: function() {
      this.selectedMainTab = this.clientsTableSelectedMainTab;
    },

    clientsTableSelectedTab: function() {
      this.selectedTab = this.clientsTableSelectedTab.tabAlias;
      this.questionsSector = this.clientsTableSelectedTab.questionSection;
    },
    selectedMainTab: function() {
      if (this.selectedMainTab === "total") {
        // this.selectedTab = "status";
        // //  this.filters.assigned = false;
        // // this.filters.assigned_rank1 = false;
        // // this.filters.assigned_rank2 = false;
        // // this.filters.assigned_rank3 = false;
        // this.filters.recent_searches = false;
        // this.filters.waiting_approval = false;
        // this.filters.merged = false;
        // this.filters.assigned_by_rank = false;
        // this.filters.tier = false;
        // this.filters.ended = false;
        // this.filters.ended_sort_by_name = false;
        // this.filters.group_assigned = false;
        this.filters.recent_searches = false;
        this.filters.waiting_approval = false;
        this.filters.merged = false;
        this.filters.assigned_by_rank = false;
        this.filters.tier = false;
        this.filters.ended = false;
        this.filters.ended_sort_by_name = false;
        this.filters.group_assigned = false;
        this.filters.active = false;
        this.$store.commit("clients/setClientsTableTab", this.selectedMainTab);
        this.$store.commit(
            "clients/setClientsTableSelectedMainTab",
            this.selectedMainTab
        );
        return this.debouncedClientsQuery();
      }
      if (this.selectedMainTab === "clients") {
        this.selectedTab = "status";
        //  this.filters.assigned = false;
        // this.filters.assigned_rank1 = false;
        // this.filters.assigned_rank2 = false;
        // this.filters.assigned_rank3 = false;
        this.filters.recent_searches = false;
        this.filters.waiting_approval = false;
        this.filters.merged = false;
        this.filters.assigned_by_rank = false;
        this.filters.tier = false;
        this.filters.ended = false;
        this.filters.ended_sort_by_name = false;
        this.filters.group_assigned = false;
        this.filters.active = true;

        this.$store.commit("clients/setClientsTableTab", this.selectedMainTab);
        return this.debouncedClientsQuery();
      }

      if (this.selectedMainTab === "na") {
        this.filters.active = false;
        this.filters.tier = false;
        this.filters.recent_searches = false;
        this.filters.waiting_approval = false;
        this.filters.merged = false;
        this.filters.group_assigned = [{ id: 2 }];
        this.filters.ended = false;
        this.filters.ended_sort_by_name = false;

        this.$store.commit("clients/setClientsTableTab", this.selectedMainTab);

        this.clearScheduledCallsTagsStats(); // clear CA all stats
        this.clearNewGroupTagsStats(); // clear CA all stats
        return this.debouncedClientsQuery();
      }

      if (this.selectedMainTab === "ni") {
        this.filters.active = false;

        this.filters.tier = false;
        this.filters.recent_searches = false;
        this.filters.waiting_approval = false;
        this.filters.merged = false;
        this.filters.group_assigned = [{ id: 3 }];
        this.clearPrimaryTagFilters();
        this.filters.ended = false;
        this.filters.ended_sort_by_name = false;
        // this.openNiGroupMenu = true
        this.$store.commit("clients/setClientsTableTab", this.selectedMainTab);
        this.clearScheduledCallsTagsStats(); // clear CA all stats
        this.clearNewGroupTagsStats(); // clear CA all stats
        return this.debouncedClientsQuery();
      }
      this.filters.tier = false;
      if (this.selectedMainTab === "bn") {
        this.filters.active = false;
        this.filters.tier = false;
        this.filters.recent_searches = false;
        this.filters.waiting_approval = false;
        this.filters.merged = false;
        this.filters.group_assigned = [{ id: 4 }];
        this.filters.ended = false;
        this.filters.ended_sort_by_name = false;

        this.clearPrimaryTagFilters();
        //  this.openBnGroupMenu = true
        this.$store.commit("clients/setClientsTableTab", this.selectedMainTab);
        this.clearScheduledCallsTagsStats(); // clear CA all stats
        this.clearNewGroupTagsStats(); // clear CA all stats
        this.bnCalendarTrigger++;
        return this.debouncedClientsQuery();
      }

      if (this.selectedMainTab === "ended") {
        this.filters.active = false;
        this.filters.group_assigned = false;
        this.filters.recent_searches = false;
        this.filters.waiting_approval = false;
        this.filters.merged = false;
        this.filters.tier = false;
        this.clearPrimaryTagFilters();
        this.filters.ended = true;
        this.filters.ended_sort_by_name = true;
        this.$store.commit("clients/setClientsTableTab", this.selectedMainTab);
        this.clearScheduledCallsTagsStats(); // clear CA all stats
        this.clearNewGroupTagsStats(); // clear CA all stats
        return this.debouncedClientsQuery();
      }
      if (this.selectedMainTab === "t4") {
        this.filters.active = false;

        this.filters.group_assigned = false;
        this.filters.recent_searches = false;
        this.filters.waiting_approval = false;
        this.filters.merged = false;
        this.filters.tier = [{ id: 4 }];
        this.filters.ended = false;
        this.filters.ended_sort_by_name = false;
        this.clearPrimaryTagFilters();
        this.$store.commit("clients/setClientsTableTab", this.selectedMainTab);
        this.clearScheduledCallsTagsStats(); // clear CA all stats
        this.clearNewGroupTagsStats(); // clear CA all stats
        return this.debouncedClientsQuery();
      }
      if (this.selectedMainTab === "recent") {
        //  this.filters.assigned = false;
        // this.filters.assigned_rank1 = false;
        // this.filters.assigned_rank2 = false;
        // this.filters.assigned_rank3 = false;
        // this.filters.assigned_by_rank = false;
        this.filters.active = false;

        this.filters.merged = false;
        this.filters.tier = false;
        this.filters.group_assigned = false;
        this.filters.recent_searches = true;
        this.filters.waiting_approval = false;
        this.filters.ended = false;
        this.filters.ended_sort_by_name = false;
        return this.debouncedClientsQuery();
      }
      if (this.selectedMainTab === "newLd") {
        this.filters.active = false;

        //  this.filters.assigned = false;
        // this.filters.assigned_rank1 = false;
        // this.filters.assigned_rank2 = false;
        // this.filters.assigned_rank3 = false;
        // this.filters.assigned_by_rank = false;
        this.filters.tier = false;
        this.filters.group_assigned = false;
        this.filters.recent_searches = false;
        this.filters.waiting_approval = true;
        this.filters.ended = false;
        this.filters.ended_sort_by_name = false;
        this.filters.merged = false;
        return this.debouncedClientsQuery();
      }
      if (this.selectedMainTab === "merged") {
        this.filters.active = false;

        //  this.filters.assigned = false;
        // this.filters.assigned_rank1 = false;
        // this.filters.assigned_rank2 = false;
        // this.filters.assigned_rank3 = false;
        // this.filters.assigned_by_rank = false;
        this.filters.tier = false;
        this.filters.group_assigned = false;
        this.filters.recent_searches = false;
        this.filters.waiting_approval = false;
        this.filters.ended = false;
        this.filters.ended_sort_by_name = false;
        this.filters.merged = true;
        this.clearScheduledCallsTagsStats(); // clear CA all stats
        this.clearNewGroupTagsStats(); // clear CA all stats
        return this.debouncedClientsQuery();
      }
    },
    selectedTab: function() {
      if (this.selectedTab !== "personal details") {
        this.showPasswordInput = false;
      }
      if (
          this.selectedTab === "cost" &&
          (this.filters.deposit_at !== false ||
              this.filters.registered_on !== false ||
              this.filters.last_modified !== false ||
              this.filters.last_modified_personal !== false ||
              this.filters.last_transfer !== false ||
              this.filters.last_referral !== false ||
              this.filters.scheduled_call_to !== false ||
              this.filters.assigned_at !== false ||
              this.filters.support_at !== false)
      ) {
        this.getCostTabTotals();
      }
      this.$store.commit("clients/setClientsTableSelectedTab", {
        tabAlias: this.selectedTab,
        questionSection: this.questionsSector
      });
    },

    selectedClients: function() {
      this.viewHideResetBtn();
    },

    "filters.client": function(prev, current) {
      this.clearPrimaryTagFilters();
      setTimeout(() => {
        this.getSearchNameCountResults();
        this.getSearchIdCountResults();
      }, 4000);

      if (current.length < 2) {
        this.stats.name_found_bn = 0;
        this.stats.name_found_ni = 0;
        this.stats.name_found_na = 0;
        this.stats.name_found_t4 = 0;
        return false;
      }
      this.viewHideResetBtn();
      //this.debouncedClientsQuery();
      this.longDebouncedClientsQuery();
    },

    "filters.phone": function() {
      this.clearPrimaryTagFilters();
      if (this.filters.phone.length > 2) {
        //this.debouncedClientsQuery();
        setTimeout(() => {
          this.getSearchPhoneCountResults();
        }, 4000);
      }
      if (this.filters.phone.length < 2) {
        this.stats.phonel_found_bn = 0;
        this.stats.phone_found_ni = 0;
        this.stats.phone_found_na = 0;
        this.stats.phone_found_t4 = 0;
        this.stats.phone_found_end = 0;
      }
      this.longDebouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.email": function() {
      this.clearPrimaryTagFilters();

      if (this.filters.email.length > 2) {
        //  this.debouncedClientsQuery();
        setTimeout(() => {
          this.getSearchEmailCountResults();
        }, 4000);
      }
      if (this.filters.email.length < 2) {
        this.stats.email_found_bn = 0;
        this.stats.email_found_ni = 0;
        this.stats.email_found_na = 0;
        this.stats.email_found_t4 = 0;
      }
      this.longDebouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.last_ip": function() {
      if (this.filters.last_ip.length > 1) {
        // this.debouncedClientsQuery();
        this.longDebouncedClientsQuery();
      }
      this.viewHideResetBtn();
    },

    "filters.keywords": function(prev, current) {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.aaids": function(prev, current) {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.loc_phys_ms": function(prev, current) {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.placement": function(prev, current) {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.device": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.click_on_site": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.countries": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    "filters.reschedule_type": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    "filters.registered_on": function() {
      if (this.filters.registered_on !== false) {
        // this.openActiveTag("aac");
        //set selected Main tab to total when calendar has been selected
        // this.$store.commit("clients/setClientsTableSelectedMainTab", 'total');
        // this.activeTags.push('aac')
      } else {
        // this.closeActiveTag("aac");
      }
    },

    "filters.retired": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    "filters.answers1": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.answers2": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.answers3": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.answers4": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.answers5": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.answers6": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.answers7": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.answers8": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.answers9": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    "filters.answers10": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    "filters.answers11": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.answers_status": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.countryTime": {
      handler: function() {
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
      },
      deep: true
    },

    "filters.assigned": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.assigned_rank1": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.assigned_rank2": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.assigned_rank3": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.assigned_by_rank": function() {
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.group_assigned": function() {
      if (this.showOrigin !== true) {
        //return this.resetThFields();
      }
      //  this.debouncedClientsQuery();
      this.showOrigin = false;
    },

    "filters.support_at": function() {
      if (this.filters.support_at[0] === undefined) {
        this.filters.support_at = false;
      }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.last_transfer": function() {
      if (this.filters.last_transfer[0] === undefined) {
        this.filters.last_transfer = false;
      }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.last_referral": function() {
      if (this.filters.last_referral[0] === undefined) {
        this.filters.last_referral = false;
      }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.deposit_at": function() {
      if (this.filters.deposit_at[0] === undefined) {
        this.filters.deposit_at = false;
      }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.last_modified": function() {
      if (this.filters.last_modified[0] === undefined) {
        this.filters.last_modified = false;
      }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.scheduled_call_to": function() {
      if (this.filters.scheduled_call_to[0] === undefined) {
        this.filters.scheduled_call_to = false;
      }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.last_modified_personal": function() {
      if (this.filters.last_modified_personal[0] === undefined) {
        this.filters.last_modified_personal = false;
      }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.assigned_at": function() {
      /*      if (
/!*        (!this.filters.group_assigned &&
          this.filters.assigned_at[0] === undefined &&*!/
          this.filters.assigned_at[0] === undefined ||
          this.filters.group_assigned[0] === undefined
      ) {*/
      if (this.filters.assigned_at[0] === undefined) {
        this.filters.assigned_at = false;
        //  alert(this.filters.assigned_at)
      }

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    "filters.group_assigned_at": function() {
      if (this.filters.group_assigned_at[0] === undefined) {
        this.filters.group_assigned_at = false;
      }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    assignToQuery: function(val) {
      if (val.length > 1) {
        this.suggestedUsers = this.filterTransSugUserFunction(
            this.suggestedUsers,
            val
        );
        this.unSuggestedUsers = this.filterTransSugUserFunction(
            this.unSuggestedUsers,
            val
        );
        return (this.uniqueUsers = this.filterUsersFunction(
            this.uniqueUsers,
            val
        ));
      }

      if ((val.length === 0 || val === "") && this.clientToSuggest != null) {
        return this.getSuggestedUsers(this.clientToSuggest);
      }
    },
    stats: {
      handler: function(stats) {
        this.$store.commit("clients/setClientsTableStatsObject", stats);
      },
      deep: true
    },
    clientsTableCalendarSubMenuSubMs: {
      handler: function(clientsTableCalendarSubMenuSubMs) {
        if (clientsTableCalendarSubMenuSubMs.opened === false) {
          this.openBnGroupMenu = false;
          this.openNiGroupMenu = false;
        } else {
          if (clientsTableCalendarSubMenuSubMs.subMsType == "BN") {
            this.selectedMainTab = "bn";
            this.openBnGroupMenu = true;
            // this.openLeadFilterMenu = true;
          }
          if (clientsTableCalendarSubMenuSubMs.subMsType == "NI") {
            this.openNiGroupMenu = true;
          }
        }
      },
      deep: true
    }
  },

  methods: {

    log(str){
      // console.log(str);
    },
    // excludeAssignmentValueChanged(newVal){
    //   this.isExcludeAssignments = newVal;
    // },


    closeSigTable() {
      this.cms.cmsSignalsClientId = null;
    },
    fetchScStats() {
      this.debouncedClientsQuery();
    },
    emmitSetMainTab(tab) {
      switch (tab) {
        case "status":
          this.selectedTab = tab;
          this.mainTabPagination = {
            prevTab: 0,
            currentTab: 1,
            nextTab: 2,
            questionSector: null
          };
          break;
        case "questions1":
          this.selectedTab = tab;
          this.mainTabPagination = {
            prevTab: 1,
            currentTab: 2,
            nextTab: 3,
            questionSector: 1
          };
          break;
        case "questions2":
          this.selectedTab = tab;
          this.mainTabPagination = {
            prevTab: 2,
            currentTab: 3,
            nextTab: 4,
            questionSector: 2
          };
          break;
        case "questions3":
          this.selectedTab = tab;
          this.mainTabPagination = {
            prevTab: 3,
            currentTab: 4,
            nextTab: 5,
            questionSector: 3
          };
          break;
        case "campaign":
          // if (this.auth.user.role !== 7) {
          this.selectedTab = tab;
          this.mainTabPagination = {
            prevTab: 4,
            currentTab: 5,
            nextTab: 6,
            questionSector: null
          };
          // }

          break;
        case "campaign-2":
          // if (this.auth.user.role !== 7) {
          this.selectedTab = tab;
          this.mainTabPagination = {
            prevTab: 5,
            currentTab: 6,
            nextTab: 7,
            questionSector: null
          };
          // }

          break;
        case "cost":
          if (this.auth.user.role !== 7) {
            this.selectedTab = tab;
            this.mainTabPagination = {
              prevTab: 6,
              currentTab: 7,
              nextTab: 8,
              questionSector: null
            };
          }
          break;
      }

      //
      // switch (this.mainTabPagination.nextTab) {
      //   case 0:
      //     // this.setTabClientsTable("STATUS", "status");
      //     break;
      //   case 6:
      //     if (this.auth.user.role !== 7) {
      //       this.setTabClientsTable("COST", "cost");
      //     }
      //     break;
      //   case 5:
      //     if (this.auth.user.role !== 7) {
      //       this.setTabClientsTable("CAMPAIGN", "campaign");
      //     }
      //     break;
      //   case 2:
      //     this.setTabClientsTable("QUESTIONS", "questions");
      //     break;
      //   case 3:
      //     this.setTabClientsTable("QUESTIONS", "questions");
      //     break;
      //   case 4:
      //     this.setTabClientsTable("QUESTIONS", "questions");
      //     break;
      // }
    },
    emitSetClientsTableSelectedTab(questionSector) {
      this.$store.commit("clients/setClientsTableSelectedTab", {
        tabAlias: "questions",
        questionSection: questionSector
      });
    },
    // getDepDiff(to, regIn) {
    //   // let duration = moment.duration(moment(this.task.created_at).diff(time));
    //   let duration = moment.duration(moment(to).diff(regIn));
    //   // let hours = duration.asHours();
    //
    //   let hours = duration.humanize();
    //   let str = null;
    //   if (hours.indexOf("minutes") > 2) {
    //     str = hours.substr(0, 4);
    //   } else if (hours.indexOf("hours") > 2) {
    //     str = hours.substr(0, 4);
    //   } else if (hours.indexOf("days") > 2) {
    //     str = hours.substr(0, 4);
    //   } else if (hours.indexOf("years") > 2) {
    //     str = hours.substr(0, 4);
    //   } else {
    //     str = hours.substr(0, 3);
    //   }
    //
    //   // this.uperOrLowerH = str.includes("h");
    //   if (str.includes("h")) {
    //     this.uperOrLowerH = str.includes("h");
    //   }
    //   if (str.includes("mi")) {
    //     this.uperOrLowerMinuts = str.includes("mi");
    //   }
    //   if (str.includes("an")) {
    //     str = str.replace("n", "h");
    //   }
    //   if (str.includes("a")) {
    //     str = str.replace("a", "1");
    //   }
    //
    //   return str;
    // },
    checkDepositConversionTime(client) {
      if (client.hasOwnProperty("deposits") && client.deposits.length > 0) {
        let to = null;
        if (client.deposits.length > 0) {
          if (client.deposits.length > 1) {
            to = moment(client.deposits[client.deposits.length - 1].created_at);
          } else {
            to = moment(client.deposits[0].created_at);
          }
          const duration = moment.duration(to.diff(client.created_at));
          if (duration._data.days > 0) {
            return (
                duration._data.days + "d" + " & " + duration._data.hours + "h"
            );
          } else {
            if (duration._data.hours > 0) {
              return (
                  duration._data.hours +
                  "h" +
                  " & " +
                  duration._data.minutes +
                  "m"
              );
            } else {
              return duration._data.minutes + "m";
            }
          }
        }
      }
    },
    getSortingIcon() {
      return "fa-sort-amount-down";
    },
    goHome() {
      this.selectedTab = "status";
      this.mainTabPagination = {
        prevTab: 0,
        currentTab: 1,
        nextTab: 2,
        questionSector: 1
      };
    },
    setMainTabPagination(paginationObj) {
      this.mainTabPagination = paginationObj;
    },
    triggerSortNameJquery() {
      jQuery.fn.reverse = [].reverse;
      $(".sub-menu")
          .children("li")
          .addClass("noopen");

      $(".drop-link").on("click", function(e) {
        var dropLink = $(this);
        var parentLink = dropLink.parent();
        var subMenuLink = parentLink.children(".sub-menu").children("li");

        if (parentLink.hasClass("active")) {
          parentLink.removeClass("active");
          subMenuLink.reverse().each(function(i) {
            var $li = $(this);
            setTimeout(function() {
              $li.removeClass("open");
              $li.addClass("noopen");
            }, 100 * i);
          });
        } else {
          parentLink.addClass("active");
          subMenuLink.each(function(i) {
            var $li = $(this);
            setTimeout(function() {
              $li.removeClass("noopen");
              $li.addClass("open");
            }, 100 * i);
          });
        }

        return false;
      });
    },
    changeAutoEmailNotReIclone() {
      this.changeToNotReIcone = true;
    },
    changeAutoEmailSentIclone() {
      this.changeAutoIcone = true;
    },

    applyAlphaSorting(value) {
      this.sortingIcon = `fa-sort-alpha-${value}`;

      let currentSortOrder = this.sortOrderAlpha;
      this.filters.ended_sort_by_name = true;
      // reverse sortOrder
      if (this.sortOrderAlpha.toString() === "asc") {
        this.sortOrderAlpha = "desc";
        currentSortOrder = "desc";

        return this.onSort({
          order_by: "first_name",
          sort_order: currentSortOrder
        });
      }

      if (this.sortOrderAlpha.toString() === "desc") {
        this.sortOrderAlpha = "asc";
        currentSortOrder = "asc";

        return this.onSort({
          order_by: "first_name",
          sort_order: currentSortOrder
        });
      }
      if (value == "up") {
        (this.sortActive.cre.up = false),
            (this.sortActive.cre.down = false),
            (this.sortActive.mod.up = false),
            (this.sortActive.mod.down = false),
            (this.sortActive.id.up = false),
            (this.sortActive.id.down = false),
            (this.sortActive.name.up = true),
            (this.sortActive.name.down = false);
      }
      if (value == "down") {
        (this.sortActive.cre.up = false),
            (this.sortActive.cre.down = false),
            (this.sortActive.mod.up = false),
            (this.sortActive.mod.down = false),
            (this.sortActive.id.up = false),
            (this.sortActive.id.down = false),
            (this.sortActive.name.up = false),
            (this.sortActive.name.down = true);
      }
    },
    applyNumericSorting(value) {
      this.sortingIcon = `fa-sort-numeric-${value}`;
      let currentSortOrder = this.sortOrderNumeric;

      // reverse sortOrder
      if (this.sortOrderNumeric.toString() === "asc") {
        this.sortOrderNumeric = "desc";
        currentSortOrder = "desc";

        return this.onSort({
          order_by: "id",
          sort_order: currentSortOrder
        });
      }

      if (this.sortOrderNumeric.toString() === "desc") {
        this.sortOrderNumeric = "asc";
        currentSortOrder = "asc";

        return this.onSort({
          order_by: "id",
          sort_order: currentSortOrder
        });
      }
      if (value == "up") {
        this.sortActive.cre.up = false;
        this.sortActive.cre.down = false;
        this.sortActive.mod.up = false;
        this.sortActive.mod.down = false;
        this.sortActive.id.up = true;
        this.sortActive.id.down = false;
        this.sortActive.name.up = false;
        this.sortActive.name.down = false;
        // this.sortingIcon ='fa-sort-numeric-up';
      }
      if (value == "down") {
        this.sortActive.cre.up = false;
        this.sortActive.cre.down = false;
        this.sortActive.mod.up = false;
        this.sortActive.mod.down = false;
        this.sortActive.id.up = false;
        this.sortActive.id.down = true;
        this.sortActive.name.up = false;
        this.sortActive.name.down = false;
      }
    },
    applyAmountSorting(value) {
      this.sortingIcon = `fa-sort-amount-${value}`;

      let currentSortOrder = this.sortOrderAmount;

      // reverse sortOrder
      if (this.sortOrderAmount.toString() === "asc") {
        this.sortOrderAmount = "desc";
        currentSortOrder = "desc";

        return this.onSort({
          order_by: "created_at",
          sort_order: currentSortOrder
        });
        /* return this.$emit("sort", {
          order_by: this.columnAmount,
          sort_order: currentSortOrder
        });*/
      }

      if (this.sortOrderAmount.toString() === "desc") {
        this.sortOrderAmount = "asc";
        currentSortOrder = "asc";
        return this.onSort({
          order_by: "created_at",
          sort_order: currentSortOrder
        });
        /* return this.$emit("sort", {
          order_by: this.columnAmount,
          sort_order: currentSortOrder
        });*/
      }

      if (value == "up") {
        (this.sortActive.cre.up = true),
            (this.sortActive.cre.down = false),
            (this.sortActive.mod.up = false),
            (this.sortActive.mod.down = false),
            (this.sortActive.id.up = false),
            (this.sortActive.id.down = false),
            (this.sortActive.name.up = false),
            (this.sortActive.name.down = false);
      }
      if (value == "down") {
        (this.sortActive.cre.up = false),
            (this.sortActive.cre.down = true),
            (this.sortActive.mod.up = false),
            (this.sortActive.mod.down = false),
            (this.sortActive.id.up = false),
            (this.sortActive.id.down = false),
            (this.sortActive.name.up = false),
            (this.sortActive.name.down = false);
      }
    },
    applyModifiedSorting(value) {
      this.sortingIcon = `fa-sort-amount-${value}`;
      let currentSortOrder = this.sortOrderAmount;

      // reverse sortOrder
      if (this.sortOrderAmount.toString() === "asc") {
        this.sortOrderAmount = "desc";
        currentSortOrder = "desc";

        return this.onSort({
          order_by: "updated_at",
          sort_order: currentSortOrder
        });
        /* return this.$emit("sort", {
          order_by: this.columnAmount,
          sort_order: currentSortOrder
        });*/
      }

      if (this.sortOrderAmount.toString() === "desc") {
        this.sortOrderAmount = "asc";
        currentSortOrder = "asc";
        return this.onSort({
          order_by: "created_at",
          sort_order: currentSortOrder
        });
        /* return this.$emit("sort", {
          order_by: this.columnAmount,
          sort_order: currentSortOrder
        });*/
      }
      if (value == "up") {
        (this.sortActive.cre.up = false),
            (this.sortActive.cre.down = false),
            (this.sortActive.mod.up = true),
            (this.sortActive.mod.down = false),
            (this.sortActive.id.up = false),
            (this.sortActive.id.down = false),
            (this.sortActive.name.up = false),
            (this.sortActive.name.down = false),
            (this.sortingIcon = "fa-sort-amount-up");
      }
      if (value == "down") {
        (this.sortActive.cre.up = false),
            (this.sortActive.cre.down = false),
            (this.sortActive.mod.up = false),
            (this.sortActive.mod.down = true),
            (this.sortActive.id.up = false),
            (this.sortActive.id.down = false),
            (this.sortActive.name.up = false),
            (this.sortActive.name.down = false)(
                (this.sortingIcon = "fa-sort-amount-up")
            );
      }
    },
    filterFromGeneralChart(object) {
      let user = object.user ? [{ id: object.user }] : [];
      let filter = object.filter.toLowerCase();
      let date = object.date;
      let tier = object.tier;
      let lead_filter = object.lead_filter;
      this.selectedMainTab = "clients";
      this.filters.ca_users = [];
      this.filters.na_users = [];
      this.filters.group_assigned_at = false;
      this.filters.registered_on = false;
      this.filters.last_modified = false;
      this.filters.scheduled_call_to = false;
      this.filters.last_sc_tag = false;
      this.filters.last_modified = false;
      this.filters.last_referral = false;
      this.filters.last_modified_personal = false;
      this.filters.deposit_at = false;
      this.filters.last_transfer = false;
      this.filters.deposit_clients = false;
      this.filters.is_new = false;
      this.selectedTagToFilter = "";
      this.filters.country_tiers = false;
      this.filters.dup = false;
      this.filters.dup_exclude = false;

      switch (lead_filter) {
        case "DUP":
          this.filters.dup = true;
          break;
        case "REG":
          this.filters.dup_exclude = true;
          break;
      }
      if (tier) {
        this.filters.country_tiers = [{ id: tier }];
      }
      if (filter === "reg") {
        //this.filters.registered_on = [date[0], date[1]];
      }
      if (filter === "new") {
        //this.filters.registered_on = [date[0], date[1]];
        this.filters.is_new = true;
      }
      if (filter === "nr") {
        //this.filters.group_assigned_at = [date[0], date[1]];
        this.selectedMainTab = "na";
        this.$store.commit("clients/setCalendarDates", {
          calendar: "GR_ASGN",
          dates: {
            start: date[0],
            end: date[1]
          }
        });
      }
      if (filter === "ni") {
        //this.filters.group_assigned_at = [date[0], date[1]];
        this.selectedMainTab = "ni";
        this.$store.commit("clients/setCalendarDates", {
          calendar: "GR_ASGN",
          dates: {
            start: date[0],
            end: date[1]
          }
        });
      }
      if (filter === "bn") {
        //this.filters.group_assigned_at = [date[0], date[1]];
        this.selectedMainTab = "bn";
        this.$store.commit("clients/setCalendarDates", {
          calendar: "GR_ASGN",
          dates: {
            start: date[0],
            end: date[1]
          }
        });
      }
      if (filter === "nu") {
        //this.filters.registered_on = [date[0], date[1]];
        this.selectedMainTab = "t4";
        this.$store.commit("clients/setClientsTableSelectedMainTab");
        this.$store.commit("clients/setCalendarDates", {
          calendar: "REG",
          dates: {
            start: date[0],
            end: date[1]
          }
        });
      }
      if (filter === "ended") {
        this.filters.last_modified = [date[0], date[1]];
        this.filters.last_modified_personal = [date[0], date[1]];
        this.selectedMainTab = "ended";
      }
      if (filter === "ca") {
        this.$store.commit("clients/setCalendarDates", {
          calendar: "CA_P",
          dates: {
            start: date[0],
            end: date[1]
          }
        });
        this.filters.ca_users = user;
        //this.filters.scheduled_calls = true;
      }
      if (filter === "na") {
        //this.selectedTagToFilter = "NA";
        //this.filters.last_modified_personal = [date[0], date[1]];
        this.filters.na_users = user;
        //this.filters.na_all = true;
        this.$store.commit("clients/setCalendarDates", {
          calendar: "NA_TAG",
          dates: {
            start: date[0],
            end: date[1]
          }
        });
      }
      if (filter === "rf") {
        // this.selectedTagToFilter = "RF";
        // this.filters.last_referral = [date[0], date[1]];
        this.filters.referral_campaigns_users = user;
        this.filters.referral = true;
        this.$store.commit("clients/setCalendarDates", {
          calendar: "REF",
          dates: {
            start: date[0],
            end: date[1]
          }
        });
      }
      if (filter === "ld") {
        // this.selectedTagToFilter = "LD";
        // this.filters.last_modified_personal = [date[0], date[1]];
        this.filters.lead_campaigns_users = user;
        this.filters.leads = true;
        this.$store.commit("clients/setCalendarDates", {
          calendar: "LEAD_TAG",
          dates: {
            start: date[0],
            end: date[1]
          }
        });
      }
      if (filter.includes("dp")) {
        this.selectedTagToFilter = "DP";
        // this.filters.deposit_clients = true;
        // this.filters.deposit_at = [date[0], date[1]];
        this.$store.commit("clients/setCalendarDates", {
          calendar: "DEP",
          dates: {
            start: date[0],
            end: date[1]
          }
        });
        this.filters.deposit_users = user;
        this.filters.deposit = true;
      }
      if (filter === "tr-lv") {
        // this.selectedTagToFilter = "TR";
        // this.filters.last_transfer = [date[0], date[1]];
        this.filters.client_transfers = user;
        this.filters.transfer = true;
        this.filters.client_transfers_type = [{ id: 1 }];
        this.$store.commit("clients/setCalendarDates", {
          calendar: "TRA",
          dates: {
            start: date[0],
            end: date[1]
          }
        });
      }
      if (filter === "tr-on") {
        // this.selectedTagToFilter = "TR";
        // this.filters.last_transfer = [date[0], date[1]];
        this.filters.client_transfers = user;
        this.filters.transfer = true;
        this.filters.client_transfers_type = [{ id: 2 }];
        this.$store.commit("clients/setCalendarDates", {
          calendar: "TRA",
          dates: {
            start: date[0],
            end: date[1]
          }
        });
      }

      this.$store.commit(
          "clients/setClientsTableSelectedMainTab",
          this.selectedMainTab
      );
      // this.filters.client_transfers_type = [{ id: 2 }];
      // this.filters.client_transfers = [this.LastModChoseFromStatsTable.user];
      //this.filterByTransfer();
      return;
    },
    enterPersonalTab() {
      this.showPasswordInput = false;
      this.selectedTab = "personal details";
    },
    checkTab(tab) {
      if (tab.id === 16) {
        this.showPasswordInput = true;
      } else {
        this.selectedTab = tab.alias;
      }
    },
    changeSelectedMainTab(tab) {
      this.selectedMainTab = tab;
    },
    resetOneCalendar(cal) {
      switch (cal.calendar) {
        case "REG":
          this.filters.registered_on = false;
          this.selectedMainTab = "clients";
          this.$store.commit(
              "clients/setClientsTableSelectedMainTab",
              this.selectedMainTab
          );
          break;
        case "DEP":
          this.filters.deposit_at = false;
          this.filters.deposit_clients = false;
          this.selectedMainTab = "clients";
          this.$store.commit(
              "clients/setClientsTableSelectedMainTab",
              this.selectedMainTab
          );
          break;
        case "LAST_MOD":
          this.filters.last_modified = false;
          break;
        case "LAST_MOD_TAG":
          this.filters.last_modified_personal = false;
          break;
        case "CA_F":
          this.filters.scheduled_call_to = false;
          break;
        case "CA_P":
          this.filters.last_sc_tag = false;
          break;
        case "ASSIGN":
          this.filters.assigned_at = false;
          break;
        case "TRA":
          this.filters.last_transfer = false;
          break;
        case "REF":
          this.filters.last_referral = false;
          break;
        case "LEAD_TAG":
          this.filters.last_modified_leads = false;
          break;
        case "NA_TAG":
          this.filters.last_modified_na = false;
          break;
        case "GR_ASGN":
          this.filters.group_assigned_at = false;
          break;
        case "SUP":
          this.filters.support_at = false;
          break;
      }
      if (cal.tag) {
        this.closeActiveTag(cal.tag, false);
      }
      // if (this.selectedMainTab === "total") {
      //   this.selectedMainTab = "clients";
      //   this.$store.commit(
      //     "clients/setClientsTableSelectedMainTab",
      //     this.selectedMainTab
      //   );
      //   this.$store.commit("clients/setClientsTableTab", "CLIENTS");
      // }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    pushTCTag(btnTitle) {
      this.activeTags.push(btnTitle);
      this.$store.commit("clients/setSelectedTag", btnTitle);
    },
    setHours(hours) {
      //this.filters.hours_at = [hours.from, hours.to];

      let cal = hours.calendar;
      switch (cal) {
        case "REG":
          this.filters.registered_hours_at = [hours.from, hours.to];
          break;
        case "LAST_MOD":
          this.filters.last_modified_hours_at = [hours.from, hours.to];
          break;
        case "LAST_MOD_TAG":
          this.filters.last_modified_personal_hours_at = [hours.from, hours.to];
          break;
        case "CA_F":
          this.filters.scheduled_calls_hours_at = [hours.from, hours.to];
          break;
        case "CA_P":
          this.filters.last_sc_tag_hours_at = [hours.from, hours.to];
          break;
        case "ASSIGN":
          this.filters.assigned_hours_at = [hours.from, hours.to];
          break;
        case "TRA":
          this.filters.transfers_hours_at = [hours.from, hours.to];
          break;
        case "DEP":
          this.filters.deposits_hours_at = [hours.from, hours.to];
          break;
        case "REF":
          this.filters.referrals_hours_at = [hours.from, hours.to];
          break;
        case "SUP":
          this.filters.supports_hours_at = [hours.from, hours.to];
          break;
        case "LEAD_TAG":
          this.filters.lead_tag_hours_at = [hours.from, hours.to];
          break;
        case "NA_TAG":
          this.filters.na_tag_hours_at = [hours.from, hours.to];
          break;
        case "GR_ASGN":
          this.filters.group_assigned_hours_at = [hours.from, hours.to];
          break;
        case "LIVE":
          return;
      }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    resetHours(calendar) {
      //this.filters.hours_at = false;

      let cal = calendar;
      switch (cal) {
        case "REG":
          this.filters.registered_hours_at = false;
          break;
        case "LAST_MOD":
          this.filters.last_modified_hours_at = false;
          break;
        case "LAST_MOD_TAG":
          this.filters.last_modified_personal_hours_at = false;
          break;
        case "CA_F":
          this.filters.scheduled_calls_hours_at = false;
          break;
        case "CA_P":
          this.filters.last_sc_tag_hours_at = false;
          break;
        case "ASSIGN":
          this.filters.assigned_hours_at = false;
          break;
        case "TRA":
          this.filters.transfers_hours_at = false;
          break;
        case "DEP":
          this.filters.deposits_hours_at = false;
          break;
        case "REF":
          this.filters.referrals_hours_at = false;
          break;
        case "SUP":
          this.filters.supports_hours_at = false;
          break;
        case "LEAD_TAG":
          this.filters.lead_tag_hours_at = false;
          break;
        case "NA_TAG":
          this.filters.na_tag_hours_at = false;
          break;
        case "GR_ASGN":
          this.filters.group_assigned_hours_at = false;
          break;
        case "LIVE":
          return;
      }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    resetAllCalendars() {
      this.filters.assigned_at = false;
      this.filters.last_modified_personal = false;
      this.filters.scheduled_call_to = false;
      this.filters.last_modified = false;
      this.filters.deposit_at = false;
      this.filters.last_referral = false;
      this.filters.last_modified_order = null;
      this.filters.last_transfer = false;
      this.filters.support_at = false;
      this.filters.registered_on = false;
      this.filters.hours_at = false;
      this.filters.last_modified_na = false;
      this.filters.last_modified_leads = false;
      this.filters.group_assigned_at = false;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    handleAsmtDataFromChart() {
      if (this.graphDataToTable.filters === "ASMT") {
        this.filters.assigned = [{ id: this.graphDataToTable.userId }];
        this.filters.assigned_at = [
          this.graphDataToTable.dates.start,
          this.graphDataToTable.dates.end
        ];
      } else {
        this.filters.assigned_at = [];
        this.filters.assigned = [];
      }

      this.filters.last_modified_personal = [
        this.graphDataToTable.dates.start,
        this.graphDataToTable.dates.end
      ];

      if (this.graphDataToTable.userId) {
        let user_id = this.graphDataToTable.userId;
        if (this.graphDataToTable.sub_filter) {
          let subFilter = this.graphDataToTable.sub_filter;
          if (subFilter === "NA") {
            this.filters.na_users = [{ id: user_id }];
            this.filters.na = true;
          } else {
            this.filters.na_users = [];
            this.filters.na = false;
          }

          if (subFilter === "LD") {
            this.filters.lead_campaigns_users = [{ id: user_id }];
            this.filters.leads = true;
          } else {
            this.filters.lead_campaigns_users = [];
            this.filters.leads = false;
          }

          if (subFilter === "RF") {
            this.filters.referral_campaigns_users = [{ id: user_id }];
            this.filters.referral = true;
          } else {
            this.filters.referral_campaigns_users = [];
            this.filters.referral = false;
          }

          if (subFilter === "DP") {
            this.filters.deposit_users = [{ id: user_id }];
            this.filters.deposit = true;
            this.filters.deposit_clients = true;
          } else {
            this.filters.deposit_users = [];
            this.filters.deposit = false;
            this.filters.deposit_clients = false;
          }

          if (subFilter === "SC") {
            this.filters.ca_users = [{ id: user_id }];
            this.filters.scheduled_calls = true;
          } else {
            this.filters.ca_users = [];
            this.filters.scheduled_calls = false;
          }

          if (subFilter === "TR") {
            this.filters.client_transfers = [{ id: user_id }];
            this.filters.transfer = true;
            this.filters.client_transfers_type = [{ id: 1 }, { id: 2 }];
          } else {
            this.filters.client_transfers = [];
            this.filters.transfer = false;
            this.filters.client_transfers_type = [];
          }
        }
      }
    },
    handleDepDataFromChart() {
      this.filters.deposit_at = [
        this.graphDataToTable.dates.start,
        this.graphDataToTable.dates.end
      ];

      if (this.graphDataToTable.deposit_user) {
        this.filters.deposit_users = [
          { id: this.graphDataToTable.deposit_user }
        ];
        this.filters.deposits = true;
      } else {
        this.filters.deposit_users = [];
      }

      if (this.graphDataToTable.broker) {
        this.filters.deposit_brokers = [{ id: this.graphDataToTable.broker }];
        this.filters.deposits = true;
      } else {
        this.filters.deposit_brokers = [];
      }
    },
    filterTransSugUserFunction(arr, searchTerm) {
      let temp = [
        ...this.uniqueUsers,
        ...this.suggestedUsers,
        ...this.unSuggestedUsers
      ];
      return arr.filter(usr => {
        searchTerm = searchTerm.trim();
        searchTerm = searchTerm.toLowerCase();
        let afterRegex = searchTerm.replace(/[.*+\-?^${}()|[\]\\]/g, "");
        return usr.data.full_name.toLowerCase().includes(afterRegex);
      });
    },
    filterUsersFunction(arr, userInput) {
      // let temp = [
      //   ...this.uniqueUsers,
      //   ...this.suggestedUsers,
      //   ...this.unSuggestedUsers
      // ];
      return arr.filter(user => {
        userInput = userInput.trim();
        userInput = userInput.toLowerCase();
        let afterRegex = userInput.replace(/[.*+\-?^${}()|[\]\\]/g, "");
        return user.full_name.toLowerCase().includes(afterRegex);
      });
    },
    // putTagOn(){
    //   this.filters.selling_group = false;
    //   this.filters.is_new = true;
    //   this.filters.other_new = false;
    //   this.filters.leading_new = false;
    //   this.filters.loosing_new = false;
    // },
    addRetiredFilter(value) {
      if (value) {
        this.filters.retired = 1;
      } else {
        this.filters.retired = null;
      }
    },
    dateHasentBeenChooseed() {
      // let tempObj = Object.assign({}, this.getQueryParams());
      // if (tempObj.hasOwnProperty("registered_on_from")) {
      //   this.tempWhereChoosed = false;
      // } else {
      //   this.tempWhereChoosed = true;
      // }
      // if (!this.requestRegCalPresetsBusy) {
      //   this.requestRegCalPresetsBusy = true;
      //   apiClientCreator(`client/stats/calendar/reg/presets`)
      //     .get("", { params: tempObj })
      //     .then(res => {
      //       this.regCalPresetsStats = res.data;
      //
      //       this.requestRegCalPresetsBusy = false;
      //     })
      //     .catch(err => {
      //       this.requestRegCalPresetsBusy = false;
      //     });
      // }
    },

    sendEmails(emailinfo, clientId) {
      //TODO: ?????
    },
    cancelEmailReplayBox() {
      this.openEmailReplayBox = false;
    },

    enlargeClientsTable(cond) {
      if (cond) {
        this.filters.enlarge_leads = true;
        this.fetchClients();
      } else {
        this.filters.enlarge_leads = false;
        this.fetchClients();
      }
    },

    /////////////////////////////// COST TAB METHODS

    sumCPLForTabTitle() {
      return this.clients.reduce((a, b) => ({
        cpl: a.cpl + b.cpl
      }));
    },

    sumTotalCost() {},

    ///////////////////////////////// COST TAB METHODS END
    closeNewTimeFilterMenu() {
      this.openNewFilteringDates = false;
    },
    closeFnMenu() {
      if (this.openProcessMenu || this.openDupMenu) {
        this.openProcessMenu = false;
        this.openDupMenu = false;
      }
    },

    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },

    checkMergeSelections() {
      if (this.selectedClients.length > 2) {
        return this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "You can only merge 2 clients at single operation",
          type: "WARNING",
          op: {
            type: "MERGE"
          }
        });
      }
      if (this.selectedClients.length < 2) {
        return this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Please select second client to merge",
          type: "WARNING",
          op: {
            type: "MERGE"
          }
        });
      }

      if (this.selectedClients.length === 2) {
        this.openMergeOptions = true;
      }
    },

    blockClient(id) {
      // alert("this.client.questions_status")
      localStorage.setItem("lock-client", id);
      this.blockClientCauseId = id;
      this.blockTable = true;
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "To continue work please answer all questions on client",
        type: "WARNING_BLOCK",
        op: { type: "SYSTEM" }
      });
    },
    resetLock() {
      localStorage.removeItem("lock-client");
      this.blockTable = false;
      this.clearPrimaryTagFilters();
    },

    checkBlockInStorage() {
      const block = localStorage.getItem("lock-client");
      if (block !== null) {
        this.blockClientCauseId = block;
        this.blockTable = true;
        setTimeout(() => {
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg: "To continue work please answer all questions on client",
            type: "WARNING_BLOCK",
            op: { type: "SYSTEM" }
          });
        }, 3000);

        this.$notification.show(
            "Answer Questions !",
            {
              body: `The questions for client #${this.blockClientCauseId} not fully answered!`
            },
            {}
        );
      }
    },
    outGroupClose() {
      if (this.openNiGroupMenu === true) {
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
        this.openNiGroupMenu = false;
      }
      if (this.openBnGroupMenu === true) {
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
        this.openBnGroupMenu = false;
      }
    },

    fetchCountriesMSstats() {
      this.filters.fetch_countries_stats = true;

      this.filters.fetch_client_assign_stats = false;
      this.filters.fetch_sms_stats = false;
      this.updateStats();
    },

    // fetchAssignmentsMSstats() {
    //   this.filters.fetch_client_assign_stats = true;
    //
    //   this.filters.fetch_countries_stats = false;
    //   this.filters.fetch_sms_stats = false;
    //   this.updateStats();
    // },
    getRank1UsersStats(val) {
      this.stats.rank1_users_stats = val;
    },
    getRank2UsersStats(val) {
      this.stats.rank2_users_stats = val;
    },
    getRank3UsersStats(val) {
      this.stats.rank3_users_stats = val;
    },
    filterByCaCalendar() {
      if (!this.filters.scheduled_calls) {
        this.filterByTodayCalls();
      }
    },
    filterByRegCalendar(val) {
      if (this.filters.scheduled_calls) {
        this.clearPrimaryTagFilters();
      }
    },
    /*    setFilterByLastModTag(val) {
      if (!val) {
        //  this.resetLasdModCalendarTags();
        return (this.switcherLastModDate = true);
      }
      if (val) {
        //  this.resetLasdModCalendarTags();
        return (this.switcherLastModDate = false);
      }

      //this.resetLasdModCalendarTags();
      // this.switcherLastModDate = false;
    },*/
    resetLasdModCalendarTags() {
      this.filters.last_modified_na = false;
      this.filters.last_modified_ca = false;
      this.filters.last_modified_bn = false;
      this.filters.last_modified_ni = false;
      this.filters.last_modified_leads = false;
      this.filters.last_modified_wt = false;
      this.filters.last_modified_en = false;
      this.filters.last_modified_nac = false;
      this.filters.last_modified_btgp = false;
      this.filters.last_modified_answers = false;
    },
    filterByDepositCalendar() {
      if (!this.filters.deposit) {
        //  this.filterByDeposit();
      }
    },

    filterByReferralCalendar() {
      if (!this.filters.referral) {
        this.filterByReferral();
      }
    },
    openCountryEditMenu(id) {
      this.showEditClientCountry = id;
    },
    openClientOpMenu(id) {
      this.showClientOpMenu = id;
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY ");
    },
    formatDateTimeTable(date) {
      return moment(String(date)).format("DD/MM/YY HH:mm ");
    },
    filterIndividual(val) {
      this.filters.client = "#" + val;
      this.pagination.currentPage = 1;
      this.fetchClients();
      this.viewHideResetBtn();
    },
    filterIndividualForQuestions(val) {
      this.filters.client = "#" + val;
      this.pagination.currentPage = 1;
      this.selectedTab = "questions";
      this.fetchClients();
      this.viewHideResetBtn();
    },

    cancelAddClient() {
      this.resetNewClientFields();
      this.showNewClientForm = false;
    },
    resetNewClientFields() {
      this.fieldsDisable = true;
      this.newClient.country = "";
      this.newClient.firstName = "";
      this.newClient.lastName = "";
      this.newClient.email = "";
      this.newClient.prf = "";
      this.newClient.phone = "";
      this.newClient.birthDate = "";
      this.newClient.keyword = "";
      this.newClient.device = "";
      this.newClient.aaid = "";
      this.newClient.clickType = "";
      this.newClient.locPhysMs = "";
      this.newClient.placement = "";
      this.resetNewClientMultiSelects = true;
    },

    /*async addNewClient() {
      if (this.newClient.firstName.length < 1) {
        return alert("First Name field empty or too short, minimum 2 letters");
      }
      if (this.newClient.lastName.length < 1) {
        return alert("Last Name field empty or too short, minimum 2 letters");
      }
      if (this.newClient.email.length < 5) {
        return alert("Email field empty or too short, minimum 5 letters");
      }
      if (this.newClient.phone.length < 4) {
        return alert("Phone field empty or too short, minimum 4 numbers");
      }
      if (this.newClient.birthDate.length < 1) {
        return alert("Birth Date missing");
      }
      try {
        this.$store.commit("clients/setLoading", true);
        const addNewClientRequest = apiClientCreator(`client/new`);

        const newClient = {
          first_name: this.newClient.firstName,
          last_name: this.newClient.lastName,
          phone_number: this.newClient.prf.substr(1) + this.newClient.phone,
          email: this.newClient.email,
          country: this.newClient.country.alpha2,
          birthday: this.newClient.birthDate,
          click_on_site: this.newClient.clickType.type || null,
          aaid: this.newClient.aaid,
          keyword: this.newClient.keyword,
          device: this.newClient.device.type || null,
          loc_physical_ms: this.newClient.locPhysMs,
          placement: this.newClient.placement
        };

        await addNewClientRequest.post("", newClient);
        this.cancelAddClient();
        this.fetchClients();

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "New Client Added successfully",
          type: "DONE"
        });

        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error Adding Client " +
            " " +
            " Error Status: " +
            e.response.status,
          type: "ERROR"
        });
        this.$store.commit("clients/setLoading", false);
      }
    },*/
    /*    formsOutClose(){
    },*/
    /*    emailEditClose(){
  //  if( this.emailEditIsOpen){
    //  this.cancelEmailsEdit()

       // this.emailEditIsOpen = false
  //   }
    },*/

    depOutClose() {
      /*
      this.openDepositsMenu = false;
      this.closeCalendars = true;
      this.openProcessMenu = false;
      if (
        this.filters.deposit_statuses.length > 0 ||
        this.filters.deposit_brokers.length > 0 ||
        this.filters.deposit_brokers_quantity.length > 0 ||
        this.filters.deposit_amount.length > 0
      ) {
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
      }
*/
      if (this.openDepositsMenu === true) {
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
        this.openDepositsMenu = false;
      }
    },

    leadOutClose() {
      if (this.openLeadFilterMenu === true) {
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
        this.openLeadFilterMenu = false;
      }
    },
    refOutClose() {
      /*   this.openReferralMenu = false;
      if (this.filters.referral_campaigns.length > 0) {
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
      }*/
      if (this.openReferralMenu === true) {
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
        this.openReferralMenu = false;
      }
    },
    transOutClose() {
      /*      this.openTransferMenu = false;
      if (this.filters.client_transfers.length > 0) {
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
      }*/
      if (this.openTransferMenu === true) {
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
        this.openTransferMenu = false;
      }
    },
    caOutClose() {
      //  this.openCaMenu = false;

      // if (this.filters.ca_users.length > 0 || this.filters.ca_status.length>0 ) {
      if (this.openCaMenu === true) {
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
        this.openCaMenu = false;
      }
      //  }
    },
    naOutClose() {
      // if (this.filters.na_users.length > 0) {
      if (this.openNaMenu === true) {
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
        this.openNaMenu = false;
      }
    },

    referralBrokersFilter(val) {
      this.filters.referral_brokers = val;
    },

    referralUsersFilter(val) {
      this.filters.referral_users = val;
    },

    leadsCampaignFilter(val) {
      this.filters.lead_campaigns = val;
    },
    leadsCampaignUsersFilter(val) {
      this.filters.lead_campaigns_users = val;
    },

    depositBrokerFilter(val) {
      this.filters.deposit_brokers = val;
    },

    depositUserFilter(val) {
      this.filters.deposit_users = val;
    },
    depositSecUserFilter(val) {
      this.filters.deposit_sec_users = val;
    },
    depositLeadUserFilter(val) {
      this.filters.deposit_lead_users = val;
    },
    depositAnswersFilter(val) {
      this.filters.deposit_answers = val;
    },
    depositBrokerQuantityFilter(val) {
      this.filters.deposit_brokers_quantity = val;
    },
    depositAmountFilter(val) {
      this.filters.deposit_amount = val;
    },
    depositsStatusMsFilter(val) {
      this.filters.deposit_statuses = val;
      // console.log('status fml', this.filters.deposit_statuses);
    },
    depositToRemConvertedFilter(val) {
      this.filters.deposit_to_rem = val;
    },
    depositFromCCConvertedFilter(val) {
      this.filters.deposit_from_cc = val;
    },
    depositFromSupportConvertedFilter(val) {
      this.filters.deposit_from_sup = val;
    },

    caMsUsers(val) {
      this.filters.ca_users = val;
    },

    caStatusesFilter(val) {
      this.filters.ca_status = val;
    },
    caAutoStatusesFilter(val) {
      this.filters.ca_auto_status = val;
    },
    priorityFilter(val) {
      this.filters.priority = val;
    },
    countryTierFilter(val) {
      this.filters.country_tiers = val;
    },
    countryParentFilter(val) {
      this.filters.country_parent = val;
    },
    countriesMsFilter(val) {
      this.filters.countries = val;
    },
    assignmentsMsFilter(val) {
      this.filters.assigned = val;
    },
    assignRank1Filter(val) {
      this.filters.assigned_rank1 = val;
    },
    assignRank2Filter(val) {
      this.filters.assigned_rank2 = val;
    },
    assignRank3Filter(val) {
      this.filters.assigned_rank3 = val;
    },
    assignedByRankFilter(val) {
      this.filters.assigned_by_rank = val;
    },
    transTypesFilter(val) {
      this.filters.client_transfers_type = val;
    },
    transPlaceFilter(val) {
      this.filters.client_transfer_place = val;
    },
    transToFilter(val) {
      this.filters.client_transfers = val;
      this.filters.client_transfers_from = [];
      this.filters.client_transfers_by = [];
    },
    transFromFilter(val) {
      this.filters.client_transfers_from = val;
      this.filters.client_transfers = [];
      this.filters.client_transfers_by = [];
    },
    transByFilter(val) {
      this.filters.client_transfers_by = val;
      this.filters.client_transfers_from = [];
      this.filters.client_transfers = [];
    },
    smsPresetFilter(val) {
      this.filters.sms_preset = val;
    },
    smsStatusFilter(val) {
      this.filters.sms_status = val;
    },
    smsReturnedFilter(val) {
      this.filters.sms_returned = val;
    },

    niTabStatusFilter(val) {
      this.filters.bn_status = [];
      this.filters.ni_status = val;
      this.$store.commit("clients/setFilterToMain", {
        title: "ni",
        type: false
      });
    },
    bnTabStatusFilter(val) {
      this.filters.ni_status = [];
      this.filters.bn_status = val;
      this.$store.commit("clients/setFilterToMain", {
        title: "bn",
        type: false
      });
    },
    /*    clearMenuTimeouts() {
      for (let i = 0; i < this.menuTimeouts.length; i++) {
        clearTimeout(this.menuTimeouts[i]);
      }
      this.menuTimeouts = [];
    },*/
    excludeDupTag(val) {
      this.filters.dup_exclude = val;
    },
    dupUsersFilter(val) {
      this.filters.dup_users = val;
    },
    dupNaFilter(val) {
      this.filters.dup_na = val;
    },
    dupNiFilter(val) {
      this.filters.dup_ni = val;
    },
    dupBnFilter(val) {
      this.filters.dup_bn = val;
    },
    dupNAARFilter(val) {
      this.filters.dup_na_ar = val;
    },
    leadFilterMenuHandler() {
      if (this.openLeadFilterMenu) {
        return (this.openLeadFilterMenu = false);
      }
      if (!this.openLeadFilterMenu && this.filters.leads) {
        // return (this.openLeadFilterMenu = true);
      }
      if (this.openLeadFilterMenu && this.filters.leads) {
        return (this.openLeadFilterMenu = false);
      }

      this.filterByLead();
      // if (this.secondClick.ld) {
      //   this.openLeadFilterMenu = true;
      //   this.secondClick.ld = false;
      // } else {
      //   this.secondClick.ld = true;
      // }
    },
    filterSingleTag(tag) {
      this.resetThFields();
      this.activeTags = [tag];
      this.secondActiveTagsArr = [];
    },
    resetAllActive() {
      this.filters.registered_on = false;
      this.filters.active = true;
      this.selectedMainTab = "clients";
      this.$store.commit("clients/setClientsTableTab", this.selectedMainTab);

      this.$store.commit("clients/setClientsTableSelectedMainTab", "clients");
    },

    depositFilterMenuHandler(secondClick) {
      if (this.openDepositsMenu) {
        return (this.openDepositsMenu = false);
      }
      if (!this.openDepositsMenu && this.filters.deposit) {
        // return (this.openDepositsMenu = true);
      }
      if (this.openDepositsMenu && this.filters.deposit) {
        return (this.openDepositsMenu = false);
      }
      // if(this.filters.deposit_clients){
      //  this.filters.deposit_clients = false;
      // }
      //
      // this.filters.cc_decline_clients = false;
      this.filterByDeposit();
      if (secondClick) {
        this.openDepositsMenu = true;
      }
    },

    depositCCFilterMenuHandler(secondClick) {
      if (this.openDepositsMenu) {
        return (this.openDepositsMenu = false);
      }
      if (!this.openDepositsMenu && this.filters.cc_decline_clients) {
        // return (this.openDepositsMenu = true);
      }
      if (this.openDepositsMenu && this.filters.cc_decline_clients) {
        return (this.openDepositsMenu = false);
      }
      /*
            this.filters.deposit=false
            this.filters.deposit_clients = false;
            this.filters.cc_decline_clients = true;
      */

      this.filterByCCDeposit();
      // if (secondClick) {
      //   this.openDepositsMenu = true;
      // }
    },
    depositDepFilterMenuHandler(secondClick = null) {
      if (this.openDepositsMenu) {
        return (this.openDepositsMenu = false);
      }
      if (!this.openDepositsMenu && this.filters.deposit_clients) {
        if (!secondClick) {
          return (this.openDepositsMenu = true);
        }
      }
      if (this.openDepositsMenu && this.filters.deposit_clients) {
        return (this.openDepositsMenu = false);
      }
      /*
                  this.filters.deposit=false
                  this.filters.deposit_clients = false;
                  this.filters.cc_decline_clients = true;
            */

      this.filterByDepDeposit();
      if (secondClick) {
        this.openDepositsMenu = true;
      }
    },
    referralFilterMenuHandler() {
      if (this.openReferralMenu) {
        return (this.openReferralMenu = false);
      }
      if (!this.openReferralMenu && this.filters.referral) {
        // return (this.openReferralMenu = true);
      }
      if (this.openReferralMenu && this.filters.referral) {
        return (this.openReferralMenu = false);
      }
      this.filterByReferral();
      // if (this.secondClick.rf) {
      //   this.openReferralMenu = true;
      //   this.secondClick.rf = false;
      // } else {
      //   this.secondClick.rf = true;
      // }
    },
    transferFilterMenuHandler() {
      if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 12])) {
        if (this.openTransferMenu) {
          return (this.openTransferMenu = false);
        }
        if (!this.openTransferMenu && this.filters.transfer) {
          // return (this.openTransferMenu = true);
        }
        if (this.openTransferMenu && this.filters.transfer) {
          return (this.openTransferMenu = false);
        }
        // if (this.secondClick.tr) {
        //   this.openTransferMenu = true;
        //   this.secondClick.tr = false;
        // } else {
        //   this.secondClick.tr = true;
        // }
      }
      this.filterByTransfer();
    },
    closeMs(btnTitle) {
      switch (btnTitle) {
        case "na":
          this.openNaMenu = false;
          break;
        case "na_all":
          this.openNaMenu = false;
          break;
        case "ld":
          this.openLeadFilterMenu = false;
          break;
        case "sc":
          //this.openCaMenu = false;
          break;
        case "cc":
          //this.openCaMenu = false;
          break;
        case "am":
          //this.openCaMenu = false;
          break;
        case "tc":
          //this.openCaMenu = false;
          break;
        case "mc":
          //this.openCaMenu = false;
          break;
        case "rf":
          this.openReferralMenu = false;
          break;
        case "dp":
          this.openDepositsMenu = false;
          break;
        case "cl":
          this.openDepositsMenu = false;
          break;
        case "ccd":
          this.openDepositsMenu = false;
          break;
        case "tr":
          this.openTransferMenu = false;
          break;
      }
    },
    openMs(btnTitle) {
      switch (btnTitle) {
        case "na":
          this.openNaMenu = true;
          break;
        case "na_all":
          this.openNaMenu = true;
          break;
        case "ld":
          this.openLeadFilterMenu = true;
          break;
        case "sc":
          this.openCaMenu = true;
          break;
        case "sc-p":
          this.openCaMenu = true;
          break;
        case "cc":
          this.openCaMenu = true;
          break;
        case "am":
          this.openCaMenu = true;
          break;
        case "tc":
          this.openCaMenu = true;
          break;
        case "mc":
          this.openCaMenu = true;
          break;
        case "rf":
          this.openReferralMenu = true;
          break;
        case "dp":
          this.openDepositsMenu = true;
          break;
        case "cl":
          this.openDepositsMenu = true;
          break;
        case "ccd":
          this.openDepositsMenu = true;
          break;
        case "tr":
          this.openTransferMenu = true;
          break;
      }
    },
    naFilterMenuHandler(secondClick) {
      // if (this.isAdmin || this.isSalesManager) {
      if (this.auth.user.role !== 7) {
        if (this.openNaMenu) {
          return (this.openNaMenu = false);
        }
        if (!this.openNaMenu && this.filters.na) {
          // return (this.openNaMenu = true);
        }
        if (this.openNaMenu && this.filters.na) {
          return (this.openNaMenu = false);
        }
        // if (secondClick) {
        //   this.openNaMenu = true;
        // }
      }
      //  }
      this.filterByNoAnswer(0);
    },
    closeActiveTag(tag, resetCalendar = true) {
      this.activeTags = this.activeTags.filter(item => {
        return item !== tag;
      });

      if (this.activeTags.length === 0) {
        this.selectedTagToFilter = "";
        this.$store.commit("clients/setSelectedTopTag", "");
      }
      let blockLess = this.shortCutsToBlocks.find(tab => {
        return tab.tag === tag;
      });
      if (blockLess) {
        this.filters[blockLess.filter] = false;
        this.filtersBarArr = this.filtersBarArr.filter(
            item => item.key !== blockLess.filter
        );
      }

      if (this.activeTags.length === 0 && this.secondActiveTagsArr.length > 0) {
        this.activeTags = [this.secondActiveTagsArr[0]];
        this.secondActiveTagsArr.shift();
      }

      if (this.activeTags.length > 0) {
        // let blockLess = this.shortCutsToBlocks.find(tab => {
        //   return (
        //     tab.short ===
        //     this.activeTags[this.activeTags.length - 1].toUpperCase()
        //   );
        // });
      } else {
        // this.$store.commit('clients/setSelectedCalendarType',
        //     {
        //       alias:"REG",
        //       preset:null
        //     })
      }

      this.removeFiltersFromReset(tag, resetCalendar);
      //this.closeMs(tag);
    },
    closeSecondActiveTag(tag) {
      this.secondActiveTagsArr = this.secondActiveTagsArr.filter(item => {
        return item !== tag;
      });
      //this.closeMs(tag);
    },
    openActiveTag(btnTitle) {
      this.activeTags.push(btnTitle);
      this.$store.commit("clients/setSelectedTopTag", btnTitle);
    },
    openSecondActiveTag(btnTitle) {
      this.secondActiveTagsArr.push(btnTitle);
    },
    removeFiltersFromReset(tag, resetCalendar = true) {
      let block = this.shortCutsToBlocks.find(tab => {
        return tab.tag === tag;
      });

      if (block && resetCalendar) {
        this.$store.commit("clients/setResetOneCalendar", block.calendar);
        return;
      }
      if (tag === "nw") {
        this.filters.is_new = false;
      }
      if (tag === "aac") {
        this.$store.commit("clients/setResetOneCalendar", "REG");
      }
    },
    naRegCloseFilterMenuHandler(secondClick) {
      if (this.openNaMenu) {
        return (this.openNaMenu = false);
      }
      if (!this.openNaMenu && this.filters.na_all) {
        // return (this.openNaMenu = true);
      }
      if (this.openNaMenu && this.filters.na_all) {
        return (this.openNaMenu = false);
      }
      // if (secondClick) {
      //   this.openNaMenu = true;
      // }
      this.filterByNoAnswer(1);
    },
    callFilterMenuHandler(secondClick) {
      // if (this.isAdmin || this.isSalesManager) {
      if (this.openCaMenu) {
        //return (this.openCaMenu = false);
      }
      if (!this.openCaMenu && this.filters.scheduled_calls) {
        // return (this.openCaMenu = true);
      }
      if (this.openCaMenu && this.filters.scheduled_calls) {
        //return (this.openCaMenu = false);
      }
      // if (secondClick) {
      //   this.openCaMenu = true;
      // }
      //  }
      this.filterByTodayCalls();
    },
    missedCallsFilterMenuHandler(secondClick) {
      // this.$store.commit("clients/setSelectedCalendarType", {
      //   alias: "CA_F",
      //   preset: "YESTERDAY"
      // });

      if (this.openCaMenu) {
        //return (this.openCaMenu = false);
      }
      if (!this.openCaMenu && this.filters.missed_calls) {
        // return (this.openCaMenu = true);
      }
      if (this.openCaMenu && this.filters.missed_calls) {
        //return (this.openCaMenu = false);
      }
      if (secondClick) {
        this.openCaMenu = true;
      }

      this.filterByMissedCalls();
    },

    autoMissedCallsFilterMenuHandler(secondClick) {
      if (this.openCaMenu) {
        //return (this.openCaMenu = false);
      }
      if (!this.openCaMenu && this.filters.auto_missed_calls) {
        // return (this.openCaMenu = true);
      }
      if (this.openCaMenu && this.filters.auto_missed_calls) {
        //return (this.openCaMenu = false);
      }
      if (secondClick) {
        this.openCaMenu = true;
      }
      //  }
      this.viewHideResetBtn();
      this.filterByAutoMissedCalls();
    },

    comingCallsFilterMenuHandler(secondClick) {
      if (this.openCaMenu) {
        //return (this.openCaMenu = false);
      }
      if (!this.openCaMenu && this.filters.coming_calls) {
        // return (this.openCaMenu = true);
      }
      if (this.openCaMenu && this.filters.coming_calls) {
        //return (this.openCaMenu = false);
      }
      if (secondClick) {
        this.openCaMenu = true;
      }
      this.filterByComingCalls();
    },
    todayCallsFilterMenuHandler(secondClick) {
      // this.selectedMainTab = 'clients'
      if (this.openCaMenu) {
        //return (this.openCaMenu = false);
      }
      if (!this.openCaMenu && this.filters.today_calls) {
        // return (this.openCaMenu = true);
      }
      if (this.openCaMenu && this.filters.today_calls) {
        //return (this.openCaMenu = false);
      }
      if (secondClick) {
        this.openCaMenu = true;
      }
      //  }
      this.filterTodayCalls();
    },

    newFilter() {
      if (this.filters.last_modified_personal !== false) {
      }
    },
    sellingGroupFilter() {},
    processFilterMenuHandler() {
      if (this.openProcessMenu) {
        //    this.clearPrimaryTagFilters();
        return (this.openProcessMenu = false);
      }
      this.updateFnMenuStats();
      //this.menuTimeouts.push(
      //setTimeout(async () => {
      this.openProcessMenu = true;
      //, 1000)
      //;
    },
    processFilterMenuHandlerNew() {
      if (this.openProcessMenu) {
        return (this.openProcessMenu = false);
      }
      this.updateFnMenuStatsForNew();
    },
    backToDuplicateClient() {
      this.showOrigin = true;
      this.filters.client = "#" + this.cameFromDuplicate;
      this.filters.group_assigned = false;
      this.showDuplicateBackBtn = false;
      this.debouncedClientsQuery();
      this.selectedMainTab = "clients";
      this.cameFromDuplicate = null;
    },
    showOriginClient(val) {
      //this.resetThFields();
      if (val.type === "Bad Number") {
        this.filters.client = "#" + val.client_id;
        this.selectedMainTab = "bn";

        if (val.origin === true) {
          //  alert()
          this.filterByDup();
        }
        if (val.origin === false) {
          // alert()

          this.filterBySourceDup();
          //   this.filters.dup_source = true;
          //  this.debouncedClientsQuery();
        }
        return this.viewHideResetBtn();
        //  this.showOrigin = true;
        //  this.cameFromDuplicate = val.from;
        //  this.showDuplicateBackBtn = true;
      }
      if (val.type === "Not Interested") {
        this.filters.client = "#" + val.client_id;
        this.selectedMainTab = "ni";
        //  this.showOrigin = true;
        //  this.cameFromDuplicate = val.from;
        //  this.showDuplicateBackBtn = true;
        if (val.origin === true) {
          this.filterByDup();
        }
        if (val.origin === false) {
          this.filterBySourceDup();
        }
        return this.viewHideResetBtn();
      }

      if (val.type === "No Answer") {
        this.filters.client = "#" + val.client_id;
        this.selectedMainTab = "na";
        //  this.showOrigin = true;
        // this.cameFromDuplicate = val.from;
        //this.showDuplicateBackBtn = true;

        if (val.origin === true) {
          this.filterByDup();
        }
        if (val.origin === false) {
          this.filterBySourceDup();
        }
        return this.viewHideResetBtn();
      }
      if (val.type === "Selling Group") {
        this.filters.client = "#" + val.client_id;
        this.selectedMainTab = "clients";
        if (val.origin === true) {
          this.filterByDup();
        }
        if (val.origin === false) {
          this.filterBySourceDup();
        }
        return this.viewHideResetBtn();

        // this.showOrigin = true;
        // this.cameFromDuplicate = val.from;
        // this.showDuplicateBackBtn = true;
      }

      //this.debouncedClientsQuery();
    },
    kFormatter: function(num) {
      if (num > 0) {
        return Math.abs(num) > 999
            ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
            : Math.sign(num) * Math.abs(num);
      }
      return "";
    },

    setTagFromCal(val) {
      if (val) {
        if (
            this.activeTags.includes("tc") ||
            this.activeTags.includes("cc") ||
            this.activeTags.includes("am") ||
            this.activeTags.includes("mc") ||
            this.activeTags.includes("na") ||
            this.activeTags.includes("ccd")
        ) {
          return;
        }
        if (
            !this.activeTags.includes(val) ||
            (val === "sc" &&
                !this.activeTags.includes("tc") &&
                !this.activeTags.includes("mc"))
        ) {
          this.openActiveTag(val);
        }
      }
    },
    setLastModifiedDate(val) {
      if (val.tag === "ENDED") {
        this.selectedMainTab = "ended";
      }
      if (val.tag === "NA") {
        this.selectedMainTab = "na";
      }
      if (val.tag === "NI") {
        this.selectedMainTab = "ni";
      }
      if (val.tag === "BN") {
        this.selectedMainTab = "bn";
      }
      if (val.tag === "T4") {
        this.selectedMainTab = "t4";
      }
      this.filters.last_modified_order = "DESC";
      this.filters.last_modified = [val.date.start, val.date.end];
      if (this.filters.last_modified[0] === undefined) {
        this.filters.last_modified = false;
      }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    setModifiedTagDate(val) {
      this.filters.last_modified_personal = [val.date.start, val.date.end];
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    setAssignDate(val) {
      this.secondActiveTagsArr.push('dp')
      this.activeTags.push('test')
      if (val.tag === "ENDED") {
        this.selectedMainTab = "ended";
      }
      if (val.tag === "NA") {
        this.selectedMainTab = "na";
      }
      if (val.tag === "NI") {
        this.selectedMainTab = "ni";
      }
      if (val.tag === "BN") {
        this.selectedMainTab = "bn";
      }
      if (val.tag === "T4") {
        this.selectedMainTab = "t4";
      }

      this.filters.assigned_at = [val.date.start, val.date.end];
      if (this.filters.assigned_at[0] === undefined) {
        this.filters.assigned_at = false;
      }

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    setTransferDate(val) {
      if (val.tag === "ENDED") {
        this.selectedMainTab = "ended";
      }
      if (val.tag === "NA") {
        this.selectedMainTab = "na";
      }
      if (val.tag === "NI") {
        this.selectedMainTab = "ni";
      }
      if (val.tag === "BN") {
        this.selectedMainTab = "bn";
      }
      if (val.tag === "T4") {
        this.selectedMainTab = "t4";
      }

      this.filters.last_transfer = [val.date.start, val.date.end];
      if (this.filters.last_transfer[0] === undefined) {
        this.filters.last_transfer = false;
      }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    setSupportDate(val) {
      this.filters.support_at = [val.date.start, val.date.end];
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    setLeadTagDate(val) {
      this.filters.last_modified_leads = [val.date.start, val.date.end];
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    setGroupTagDate(val) {
      this.filters.group_assigned_at = [val.date.start, val.date.end];
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    setNaTagDate(val) {
      this.filters.last_modified_na = [val.date.start, val.date.end];
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    setBnTagDate(val) {
      this.filters.last_modified_bn = [val.date.start, val.date.end];
      this.selectedMainTab = "bn";
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    setRegDate(val) {
      if (val.tag === "ENDED") {
        this.selectedMainTab = "ended";
      }
      if (val.tag === "NA") {
        this.selectedMainTab = "na";
      }
      if (val.tag === "NI") {
        this.selectedMainTab = "ni";
      }
      if (val.tag === "BN") {
        this.selectedMainTab = "bn";
      }
      if (val.tag === "T4") {
        this.selectedMainTab = "t4";
      }

      let btnTitle = "all";

      this.filters.registered_on = [val.date.start, val.date.end];
      if (this.filters.registered_on[0] === undefined) {
        this.closeActiveTag(btnTitle);
        this.filters.registered_on = false;
      } else {
        if (!this.CheckUserPermission([7])) {
          this.activeTags.push(btnTitle);
          this.$store.commit("clients/setSelectedTag", btnTitle);
        }
      }

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    setCaDate(val) {
      this.filters.scheduled_call_to = [val.date.start, val.date.end];
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    setCaPastDate(val) {
      this.filters.last_sc_tag = [val.date.start, val.date.end];
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    setDepositDate(val) {
      if (val.tag === "ENDED") {
        this.selectedMainTab = "ended";
      }
      if (val.tag === "NA") {
        this.selectedMainTab = "na";
      }
      if (val.tag === "NI") {
        this.selectedMainTab = "ni";
      }
      if (val.tag === "BN") {
        this.selectedMainTab = "bn";
      }
      if (val.tag === "T4") {
        this.selectedMainTab = "t4";
      }

      if (this.CheckUserPermission([1, 2, 3, 4, 5, 12])) {
        this.selectedMainTab = "total";
        this.$store.commit("clients/setClientsTableTab", this.selectedMainTab);
      }

      // this.$store.commit(
      //     "clients/setClientsTableSelectedMainTab",
      //     this.selectedMainTab
      // );
      this.filters.deposit_at = [val.date.start, val.date.end];
      if (!this.activeTags.includes("ccd")) {
        this.filters.deposit_clients = true;
      }
      if (this.filters.deposit_at[0] === undefined) {
        this.filters.deposit_at = false;
        this.filters.deposit_clients = false;
      }
      // this.filters.deposit_clients = true;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    setReferralDate(val) {
      if (val.tag === "ENDED") {
        this.selectedMainTab = "ended";
      }
      if (val.tag === "NA") {
        this.selectedMainTab = "na";
      }
      if (val.tag === "NI") {
        this.selectedMainTab = "ni";
      }
      if (val.tag === "BN") {
        this.selectedMainTab = "bn";
      }
      if (val.tag === "T4") {
        this.selectedMainTab = "t4";
      }
      this.filters.last_referral = [val.date.start, val.date.end];
      if (this.filters.last_referral[0] === undefined) {
        this.filters.last_referral = false;
      }

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      // this.filters.last_referral = [val.start, val.end];
    },

    // Agents Calendar filters start

    setAgentModifiedRegDate(val) {
      this.filters.last_modified = [val.start, val.end];
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    setAgentModifiedTagDate(val) {
      this.filters.last_modified_personal = [val.start, val.end];
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    setAgentAssignDate(val) {
      this.filters.assigned_at = [val.start, val.end];
    },

    setAgentTransferDate(val) {
      this.filters.last_transfer = [val.start, val.end];
    },

    setAgentSupportDate(val) {
      this.filters.support_at = [val.start, val.end];
    },

    setAgentRegDate(val) {
      if (val.tag === "REG") {
        this.selectedMainTab = "clients";
        this.filters.dup = false;
        // this.filters.reg_dup_total = false;
      }

      if (val.tag === "TOTAL") {
        this.filters.dup = false;
        this.filters.reg_dup_total = true;
        this.selectedMainTab = "clients";
      }

      this.filters.registered_on = [val.date.start, val.date.end];
      this.filters.scheduled_call_to = false;
      if (this.filters.registered_on[0] === undefined) {
        this.filters.registered_on = false;
      }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    setAgentCaDate(val) {
      this.filters.scheduled_call_to = [val.start, val.end];
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    setAgentDepositDate(val) {
      this.filters.deposit_at = [val.start, val.end];
      this.selectedTagToFilter = "DP";
      if (this.filters.deposit_at[0] === undefined) {
        return (this.filters.deposit_clients = false);
      }
      this.filters.deposit_clients = true;
    },

    setAgentReferralDate(val) {
      this.filters.last_referral = [val.start, val.end];
    },

    // Agents Calendar filters end

    selectAll: function() {
      if (!this.bulkCheckBoxChecked) {
        this.allSelectedInPage = true;
        let client;
        for (client in this.clients) {
          let client_id = this.clients[client].id.toString();
          if(!this.selectedClients.includes(client_id)){
            this.selectedClients.push(client_id);
          }
        }
      }
      if (this.bulkCheckBoxChecked) {
        let selected = this.selectedClients;
        this.clients.forEach(client => {
          selected = selected.filter(item => item !== client.id.toString());
        });
        this.selectedClients = selected;

      }
      this.selectAllClients = false;
    },

    pushOneClient(client_id){
      if(!this.selectedClients.includes((client_id).toString())){
        this.selectedClients.push((client_id).toString());
      }
      else{
        let selected = this.selectedClients;
        selected = selected.filter(item => item !== ((client_id).toString()));
        this.selectedClients = selected;
      }
    },


    setPage(pageNum) {
      this.pagination.currentPage = pageNum;
      this.fetchClients(true);
      this.pageNumInput = "";
      this.bulkCheckBoxChecked=false;
      this.selectedClients = [...this.selectedClients];
    },

    getQueryParams() {
      let vm = this;

      let queryParams = {
        page: vm.pagination.currentPage,
        per_page: vm.pagination.perPage
        // order_by: vm.orderBy,
        // sort_order: vm.sortOrder
      };

      /** Add filters to query */
      for (let key in vm.filters) {
        if (!vm.filters.hasOwnProperty(key)) {
          continue;
        }

        if (key === "client") {
          queryParams = {
            ...queryParams,
            ...getClientQueryObject(vm.filters[key])
          };
        }

        if (vm.filters[key] === null || vm.filters[key] === false) {
          continue;
        }

        // add selectable filters to query

        if (key === "order_by" || key === "sort_order") {
          queryParams[key] = vm.filters[key];
        }

        if (key === "sms_status") {
          let slugs = [];
          // if (this.filters.click_on_site !== "Click Type") {
          vm.filters[key].forEach(function(item) {
            slugs.push(item.type);
          });
          //   }
          queryParams[key] = slugs;
        }
        if (
            key === "keywords" ||
            key === "aaids" ||
            key === "click_on_site" ||
            key === "placement" ||
            key === "device" ||
            key === "client_transfer_place"
        ) {
          let slugs = [];
          // if (this.filters.click_on_site !== "Click Type") {
          vm.filters[key].forEach(function(item) {
            slugs.push(item.id);
          });
          //   }
          queryParams[key] = slugs;
        }

        if (key === "loc_phys_ms") {
          let slugs = [];
          vm.filters[key].forEach(function(item) {
            slugs.push(item.id);
          });
          queryParams[key] = slugs;
        }

        // add searchable filters to query
        if (
            (key === "email" || key === "phone" || key === "last_ip") &&
            vm.filters[key].toString().length > 0
        ) {
          queryParams[key] = vm.filters[key];
        }

        if (
            key === "countries" ||
            key === "country_tiers" ||
            key === "referral_brokers" ||
            key === "referral_users" ||
            key === "country_parent" ||
            key === "assigned" ||
            key === "assigned_rank1" ||
            key === "assigned_rank2" ||
            key === "assigned_rank3" ||
            key === "assigned_by_rank" ||
            key === "orig_assigned" ||
            key === "group_assigned" ||
            key === "lead_campaigns" ||
            key === "lead_campaigns_users" ||
            key === "referral_campaigns_users" ||
            key === "referral_campaigns" ||
            key === "tier" ||
            key === "deposit_statuses" ||
            key === "deposit_brokers" ||
            key === "deposit_users" ||
            key === "deposit_sec_users" ||
            key === "deposit_lead_users" ||
            key === "deposit_answers" ||
            key === "deposit_brokers_quantity" ||
            key === "client_transfers" ||
            key === "client_transfers_type" ||
            key === "client_transfers_from" ||
            key === "client_transfers_by" ||
            key === "na_users" ||
            key === "ca_users" ||
            key === "priority" ||
            key === "ca_status" ||
            key === "ca_auto_status" ||
            key === "answers1" ||
            key === "answers2" ||
            key === "answers3" ||
            key === "answers4" ||
            key === "answers5" ||
            key === "answers6" ||
            key === "answers7" ||
            key === "answers8" ||
            key === "answers9" ||
            key === "answers10" ||
            key === "answers11" ||
            key === "answers_status" ||
            key === "sms_preset" ||
            key === "ni_status" ||
            key === "bn_status" ||
            key === "dup_users" ||
            key === "dup_na" ||
            key === "dup_ni" ||
            key === "dup_bn" ||
            key === "dup_na_ar"

            /*key === "click_on_site" ||
      key === "device"*/
        ) {
          let ids = [];
          vm.filters[key].forEach(function(item) {
            ids.push(item.id);
          });

          /*          if (ids.length > 0) {
            const filterToPush = this.filtersBarArr;
            const filtered = filterToPush.filter(item => item.key !== key);
            const filter_ = {
              text: key,
              stat: ids,
              key: key
            };
            this.filtersBarArr = [...filtered, filter_];
          }*/

          queryParams[key] = ids;
        }
        // if (key === "countries") {
        //   let ids = [];
        //   vm.filters[key].forEach(function(item) {
        //     ids.push(item.id);
        //   });
        //   queryParams[key] = ids;
        // }
        if (key === "registered_on" && vm.filters.registered_on) {
          queryParams.registered_on_from = moment(
              vm.filters["registered_on"][0]
          ).format("YYYY-MM-DD");
          queryParams.registered_on_to = moment(
              vm.filters["registered_on"][1]
          ).format("YYYY-MM-DD");
        }
        if (key === "scheduled_call_to" && vm.filters.scheduled_call_to) {
          queryParams.scheduled_call_to_from = moment(
              vm.filters["scheduled_call_to"][0]
          ).format("YYYY-MM-DD");
          queryParams.scheduled_call_to_to = moment(
              vm.filters["scheduled_call_to"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "deposit_at" && vm.filters.deposit_at) {
          queryParams.deposit_at_from = moment(
              vm.filters["deposit_at"][0]
          ).format("YYYY-MM-DD");
          queryParams.deposit_at_to = moment(
              vm.filters["deposit_at"][1]
          ).format("YYYY-MM-DD");
        }

        if (this.hoursCalsList.includes(key) && vm.filters[key]) {
          queryParams[`${key}_from`] = vm.filters[key][0];
          queryParams[`${key}_to`] = vm.filters[key][1];
        }

        if (key === "support_at" && vm.filters.support_at) {
          queryParams.support_at_from = moment(
              vm.filters["support_at"][0]
          ).format("YYYY-MM-DD");
          queryParams.support_at_to = moment(
              vm.filters["support_at"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "last_modified_na" && vm.filters.last_modified_na) {
          queryParams.last_modified_na_from = moment(
              vm.filters["last_modified_na"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_modified_na_to = moment(
              vm.filters["last_modified_na"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "last_modified_bn" && vm.filters.last_modified_bn) {
          queryParams.last_modified_bn_from = moment(
              vm.filters["last_modified_bn"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_modified_bn_to = moment(
              vm.filters["last_modified_bn"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "last_modified_leads" && vm.filters.last_modified_leads) {
          queryParams.last_modified_lead_from = moment(
              vm.filters["last_modified_leads"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_modified_lead_to = moment(
              vm.filters["last_modified_leads"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "last_sc_tag" && vm.filters.last_sc_tag) {
          queryParams.last_sc_tag_from = moment(
              vm.filters["last_sc_tag"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_sc_tag_to = moment(
              vm.filters["last_sc_tag"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "last_modified" && vm.filters.last_modified) {
          queryParams.last_modified_from = moment(
              vm.filters["last_modified"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_modified_to = moment(
              vm.filters["last_modified"][1]
          ).format("YYYY-MM-DD");
        }
        //  last_modified_personal

        if (
            key === "last_modified_personal" &&
            vm.filters.last_modified_personal
        ) {
          queryParams.last_modified_personal_from = moment(
              vm.filters["last_modified_personal"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_modified_personal_to = moment(
              vm.filters["last_modified_personal"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "last_transfer" && vm.filters.last_transfer) {
          queryParams.last_transfer_from = moment(
              vm.filters["last_transfer"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_transfer_to = moment(
              vm.filters["last_transfer"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "last_referral" && vm.filters.last_referral) {
          queryParams.last_referral_from = moment(
              vm.filters["last_referral"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_referral_to = moment(
              vm.filters["last_referral"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "assigned_at" && vm.filters.assigned_at) {
          queryParams.assigned_at_from = moment(vm.filters[key][0]).format(
              "YYYY-MM-DD"
          );
          queryParams.assigned_at_to = moment(vm.filters[key][1]).format(
              "YYYY-MM-DD"
          );
        }
        if (key === "group_assigned_at" && vm.filters.group_assigned_at) {
          queryParams.group_assigned_at_from = moment(
              vm.filters[key][0]
          ).format("YYYY-MM-DD");
          queryParams.group_assigned_at_to = moment(vm.filters[key][1]).format(
              "YYYY-MM-DD"
          );
        }
        if (key === "scheduled_calls" && vm.filters[key] === true) {
          queryParams[key] = 1;
        }

        if (
          key === "enlarge_leads" ||
          key === "scheduled_calls" ||
          key === "missed_calls" ||
          key === "auto_missed_calls" ||
          key === "coming_calls" ||
          key === "today_calls" ||
          key === "is_new" ||
          key === "other_new" ||
          key === "selling_group" ||
          key === "leading_new" ||
          key === "loosing_new" ||
          key === "active" ||
          key === "is_leading" ||
          key === "online" ||
          key === "nac" ||
          key === "btgp" ||
          key === "auto_removal" ||
          key === "dup_source" ||
          key === "ex_dup_source" ||
          key === "dup_exclude" ||
          key === "merged" ||
          key === "tech" ||
          key === "dup" ||
          key === "reg_dup_total" ||
          key === "bad_number" ||
          key === "not_interested" ||
          key === "na" ||
          key === "na_all" ||
          key === "waiting" ||
          key === "ended" ||
          key === "referral" ||
          key === "transfer" ||
          key === "leads" ||
          key === "deposit" ||
          key === "deposit_clients" ||
          key === "cc_decline_clients" ||
          key === "show_country_stats" ||
          key === "fetch_camp_stats" ||
          key === "fetch_questions_stats" ||
          key === "sms_returned" ||
          key === "exclude_ca" ||
          key === "exclude_auto_ca" ||
          key === "exclude_na" ||
          key === "exclude_tr" ||
          key === "exclude_rf" ||
          key === "exclude_ld" ||
          key === "exclude_dp" ||
          key === "deposit_to_rem" ||
          key === "deposit_from_cc" ||
          key === "recent_searches" ||
          key === "waiting_approval" ||
          key === "deposit_from_sup" ||
          key === "ended_sort_by_name" ||
          key === "exclude_bn_filter" ||
          key === "exclude_ni_filter" ||
          key === "exclude_ca_filter" ||
          key === "exclude_na_filter" ||
          key === "exclude_tr_filter" ||
          key === "exclude_rf_filter" ||
          key === "exclude_ld_filter" ||
          key === "exclude_dp_filter" ||
          key === "exclude_as_filter" ||
          key === "exclude_sms_filter" ||
          key === "exclude_co_filter" ||
          key === "exclude_qs_filter" ||
          key === "exclude_ad_filter" ||
          key === "exclude_kw_filter" ||
          key === "exclude_de_filter" ||
          key === "exclude_ct_filter" ||
          key === "exclude_lc_filter" ||
            key === "exclude_pl_filter"

        // key==="kobi"
        ) {
          queryParams[key] = 1;

          /*          const filterToPush = this.filtersBarArr;
          const filtered = filterToPush.filter(item => item.key !== key);
          const filter_ = {
            text: key,
            stat: "",
            key: key
          };
          this.filtersBarArr = [...filtered, filter_];*/
        }
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        if (
            key === "scheduled_calls" ||
            key === "missed_calls" ||
            key === "auto_missed_calls" ||
            key === "coming_calls" ||
            key === "today_calls" ||
            key === "is_new" ||
            key === "selling_group" ||
            key === "leading_new" ||
            key === "loosing_new" ||
            key === "other_new" ||
            key === "active" ||
            key === "is_leading" ||
            key === "online" ||
            key === "nac" ||
            key === "btgp" ||
            key === "auto_removal" ||
            key === "dup_source" ||
            key === "ex_dup_source" ||
            key === "dup_exclude" ||
            key === "merged" ||
            key === "tech" ||
            key === "dup" ||
            key === "reg_dup_total" ||
            key === "na" ||
            key === "na_all" ||
            key === "waiting" ||
            key === "ended" ||
            key === "referral" ||
            key === "transfer" ||
            key === "leads" ||
            key === "deposit" ||
            key === "deposit_clients" ||
            key === "cc_decline_clients" ||
            key === "deposit_to_rem" ||
            key === "deposit_from_cc" ||
            key === "deposit_from_sup"
        ) {
          const filterToPush = this.filtersBarArr;
          const filtered = filterToPush.filter(item => item.key !== key);
          const filter_ = {
            text: key,
            stat: "",
            key: key
          };
          this.filtersBarArr = [...filtered, filter_];
        }
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        if (key === "na" && vm.filters[key] === true) {
          queryParams[key] = 1;
        }
        if (key === "na_all" && vm.filters[key] === true) {
          queryParams[key] = 1;
        }
        if (key === "deposit_amount") {
          queryParams[key] = vm.filters[key];
        }
        if (key === "last_modified_order") {
          queryParams["sort_order"] = "DESC";
          queryParams["order_by"] = "updated_at";
        }
        if (key === "retired") {
          queryParams[key] = vm.filters.retired;
        }

        if (vm.filters.countryTime.from && vm.filters.countryTime.to) {
          queryParams["country_time_from"] = vm.filters.countryTime.from;
          queryParams["country_time_to"] = vm.filters.countryTime.to;
        }
        if (key === "reschedule_type" && key) {
          queryParams[key] = vm.filters.reschedule_type;
        }
      }
      switch (vm.clientsTableSelectedMainTab) {
        case "total":
          delete queryParams.active;
          break;
        case "clients":
          queryParams.active = 1;
          break;
      }

      //localStorage.setItem("testObject", JSON.stringify(queryParams));
      // if (this.favDataParams !== queryParams) {
      //   this.favDataParams = Object.assign({}, queryParams);
      // }
      if (vm.filters.deposit_at_hour !== null && vm.filters.deposit_at_hour !== undefined) queryParams.deposit_at_hour = vm.filters.deposit_at_hour;
      if (vm.filters.last_na_hour !== null && vm.filters.last_na_hour !== undefined) queryParams.last_na_hour = vm.filters.last_na_hour;
      if (vm.filters.last_lead_hour !== null && vm.filters.last_lead_hour !== undefined) queryParams.last_lead_hour = vm.filters.last_lead_hour;
      return queryParams;
    },
    removeFromFiltersList(filterToRemove) {
      this.filtersBarArr.forEach(filter => {
        if (filter.key === filterToRemove) {
          this.filters[filter.key] = false;
          this.filtersBarArr = this.filtersBarArr.filter(
              item => item.key !== filter.key
          );
        }
      });
      //this.selectedMainTab = "clients";

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.selectedFnFilterCounterTotal();
      /*  if(ids.length>0){
    const filterToPush = this.filtersBarArr;
    const filtered =   filterToPush.filter(item => item.key !== key)
    const filter_ ={
      text: key,
      stat:ids,
      key:key
    };
    this.filtersBarArr = [...filtered ,filter_];
    */
    },

    debouncedClientsQuery: _.debounce(function() {
      if(this.$router.currentRoute.name === "Main"){
        const paramsObj = this.getQueryParams();
        this.pagination.currentPage = 1;
        this.$store.commit("clients/setGeneralQueryObject", paramsObj);
        this.viewHideResetBtn();
        this.fetchClients();
      }
    }, 700),

    longDebouncedClientsQuery: _.debounce(function() {
      //TODO: solution for slow typing in search boxes
      this.pagination.currentPage = 1;
      this.fetchClients();
    }, 2000),

    resetSorting() {
      this.sortingIcon = `fa-sort-amount-down`;
      (this.sortActive.cre.up = false),
          (this.sortActive.cre.down = false),
          (this.sortActive.mod.up = false),
          (this.sortActive.mod.down = false),
          (this.sortActive.id.up = false),
          (this.sortActive.id.down = false),
          (this.sortActive.name.up = false),
          (this.sortActive.name.down = false),
          // this.filters.sortByColumn=false
          (this.filters.order_by = false);
      this.filters.sort_order = false;
      this.debouncedClientsQuery();
    },

    onSort(ev) {
      this.filters.order_by = ev.order_by;
      this.filters.sort_order = ev.sort_order;
      this.debouncedClientsQuery();
    },

    /*    onOnlineSort(ev) {
      this.sortOrder2 = ev.sortOrder;
    },*!/*/

    editPhones(phones,isValid) {
      this.cleanForm();
      let vm = this;
      let phonesForEdit = [];
      phones.forEach(function(phone) {
        phonesForEdit.push({ ...phone });
      });
      vm.form.phones = phonesForEdit;
      vm.edit.phonesClientId = phones[0].client_id;
    },
    invalidNumbers(invNumbers){
this.invNumbers=invNumbers;
    },
    isValidPhone(phone){
      if(this.invNumbers.find(num=>num===phone.contact_value)) return true;
    },

    cancelPhonesEdit() {
      this.cleanForm();
    },

    cancelOtherPrimaryPhones(exceptId) {
      this.form.phones.forEach(function(item) {
        if (item.id !== exceptId) {
          item.is_primary = false;
        }
      });
    },

    cancelOtherPrimaryEmails(exceptId) {
      this.form.emails.forEach(function(item) {
        if (item.id !== exceptId) {
          item.is_primary = false;
        }
      });
    },
    cancelOtherDepositEmails(exceptId) {
      this.form.emails.forEach(function(item) {
        if (item.id !== exceptId) {
          item.deposit_email = false;
        }
      });
    },
    cancelClientInfoEdit() {
      this.cleanForm();
    },

    filterByTodayCalls() {
      // this.selectedTagToFilter = "CA";
      let tag = "CA";
      let tagTitle = "sc";
      if (this.activeTags.length > 0) {
        if (this.activeTags[0] === "sc-p") {
          tag = "CA_P";
          tagTitle = "sc-p";
        }
      }
      this.selectedTagToFilter = tag;
      this.startUpAllTagFilter = false;
      this.$store.commit("clients/setFilterToMain", {
        title: tagTitle,
        type: false
      });
      //bad number filter
      if(
          this.filters.exclude_bn_filter === false
      ){
        this.filters.bad_number = false;
      }
      //not interested filter
      if(
          this.filters.exclude_ni_filter === false
      ){
        this.filters.not_interested = false;
      }
      //call again filter
      if(
          this.filters.exclude_ca_filter === false
      ){
        // this.filters.not_interested = false; //TODO kobi
      }
      //assignments filter
      if(
          this.filters.exclude_as_filter === false
      ){
        // this.filters.not_interested = false; //TODO kobi
      }
      //sms filter
      if(
          this.filters.exclude_sms_filter === false
      ){
        // this.filters.not_interested = false; //TODO kobi
      }
      //countries filter
      if(
          this.filters.exclude_co_filter === false
      ){
        this.filters.countries = false;
      }
      //questions status filter
      if(
          this.filters.exclude_qs_filter === false
      ){
        this.filters.fetch_questions_stats = false;
      }
      //advertising filter
      if(
          this.filters.exclude_ad_filter === false
      ){
        // this.filters.not_interested = false; //TODO kobi
      }
      //keyword filter
      if(
          this.filters.exclude_kw_filter === false
      ){
        this.filters.keyword = false;
      }
      //device filter
      if(
          this.filters.exclude_de_filter === false
      ){
        this.filters.device = false;
      }
      //click type filter
      if(
          this.filters.exclude_ct_filter === false
      ){
        // this.filters.not_interested = false; //TODO kobi
      }
      //location filter
      if(
          this.filters.exclude_lc_filter === false
      ){
        // this.filters.not_interested = false; //TODO kobi
      }
      //placement filter
      if(
          this.filters.exclude_pl_filter === false
      ){
        this.filters.placement = false;
      }

      if (
        this.filters.deposit_statuses.length === 0 &&
        this.filters.deposit_brokers.length === 0 &&
        this.filters.deposit_users.length === 0 &&
        this.filters.deposit_lead_users.length === 0 &&
        this.filters.deposit_sec_users.length === 0 &&
        this.filters.deposit_answers.length === 0 &&
        this.filters.deposit_amount === null &&
          //TODO: KOBI IMPORTANT
        this.filters.exclude_dp === false &&
        this.filters.exclude_dp_filter === false &&
        this.filters.deposit_to_rem === false &&
        this.filters.deposit_from_cc === false &&
        this.filters.deposit_from_sup === false
      ) {
        this.filters.deposit = false;
      }

      if (
          this.filters.referral_campaigns.length === 0 &&
          this.filters.exclude_rf === false
      ) {
        this.filters.referral = false;
      }
      if (
          this.filters.client_transfers.length === 0 &&
          this.filters.client_transfer_place.length === 0 &&
          this.filters.client_transfers_by.length === 0 &&
          this.filters.client_transfers_from.length === 0 &&
          this.filters.client_transfers_type.length === 0 &&
          this.filters.exclude_tr === false
      ) {
        this.filters.transfer = false;
      }
      /////////////////////////////////////////////////////////////// need to check
      if (
          this.filters.na_users.length === 0 &&
          this.filters.na_all === false &&
          this.filters.exclude_na === false
      ) {
        this.filters.na = false;
      }
      /////////////////////////////////////////////////////////////// need to check

      if (
          this.filters.lead_campaigns.length === 0 &&
          this.filters.lead_campaigns_users.length === 0 &&
          this.filters.exclude_ld === false
      ) {
        this.filters.leads = false;
      }

      this.filters.is_new = false;
      this.filters.is_leading = false;
      this.filters.selling_group = false;
      this.filters.leading_new = false;
      this.filters.loosing_new = false;
      this.filters.other_new = false;
      this.filters.active = true;
      this.filters.coming_calls = false;
      this.filters.missed_calls = false;
      this.filters.auto_missed_calls = false;
      this.filters.today_calls = false;
      this.filters.scheduled_calls = true;

      this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    filterByMissedCalls() {
      // this.selectedTagToFilter = "MC";
      this.startUpAllTagFilter = false;
      this.filters.coming_calls = false;
      this.filters.scheduled_calls = false;
      this.filters.today_calls = false;
      this.filters.auto_missed_calls = false;
      this.filters.missed_calls = true;

      //  this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.$store.commit("clients/setFilterCaMissedClient", false);
    },

    filterByAutoMissedCalls() {
      this.selectedTagToFilter = "ACA";
      this.startUpAllTagFilter = false;
      this.filters.coming_calls = false;
      this.filters.scheduled_calls = false;
      this.filters.today_calls = false;
      this.filters.missed_calls = false;
      this.filters.auto_missed_calls = true;

      //   this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.$store.commit("clients/setFilterCaMissedClient", false);
    },
    filterByComingCalls() {
      this.selectedTagToFilter = "CCA";
      this.startUpAllTagFilter = false;
      this.filters.missed_calls = false;
      this.filters.auto_missed_calls = false;
      this.filters.today_calls = false;
      this.filters.scheduled_calls = false;
      this.filters.coming_calls = true;

      // this.clearPrimaryTagStats();
      this.$store.commit("clients/setSelectedCalendarType", {
        alias: "CA_F",
        preset: "TODAY"
      });
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    filterTodayCalls() {
      this.filters.today_calls = true;

      this.selectedTagToFilter = "CA_T";
      this.startUpAllTagFilter = false;
      this.filters.missed_calls = false;
      this.filters.auto_missed_calls = false;
      this.filters.scheduled_calls = false;
      this.filters.coming_calls = false;
      // this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    filterByNew(cond) {
      this.$store.commit("clients/setChartsMainView", "DEP");
      this.selectedTagToFilter = "NEW";
      this.startUpAllTagFilter = false;
      this.filters.deposit_statuses = [];
      this.filters.deposit_brokers = [];
      this.filters.deposit_users = [];
      this.filters.deposit_lead_users = [];
      this.filters.deposit_sec_users = [];
      this.filters.deposit_answers = [];
      this.filters.deposit_clients = false;
      this.filters.cc_decline_clients = false;
      this.filters.deposit_amount = null;
      this.filters.deposit_to_rem = false;
      this.filters.deposit_from_cc = false;
      this.filters.deposit_from_sup = false;
      this.filters.deposit = false;
      this.filters.lead_campaigns = [];
      this.filters.lead_campaigns_users = [];
      this.filters.na_users = [];
      this.filters.ca_users = [];
      this.filters.ca_status = [];
      this.filters.ca_auto_status = [];
      this.filters.referral_campaigns = [];
      this.filters.client_transfers = [];
      this.filters.client_transfer_place = [];
      this.filters.client_transfers_type = [];
      this.filters.client_transfers_by = [];
      this.filters.client_transfers_from = [];
      this.filters.exclude_ca = false;
      this.reschedule_type = false;
      this.filters.exclude_ca_filter = false;
      this.filters.exclude_auto_ca = false;
      this.filters.exclude_dp = false;
      this.filters.exclude_dp_filter = false;
      this.filters.exclude_na = false;
      this.filters.exclude_na_filter = false;
      this.filters.exclude_tr = false;
      this.filters.exclude_tr_filter = false;
      this.filters.exclude_rf = false;
      this.filters.exclude_rf_filter = false;
      this.filters.exclude_ld = false;
      this.filters.exclude_id_filter = false;
      this.filters.active = true;
      this.filters.bad_number = false;
      this.filters.not_interested = false;
      this.filters.scheduled_calls = false;
      this.filters.coming_calls = false;
      this.filters.missed_calls = false;
      this.filters.auto_missed_calls = false;
      this.filters.today_calls = false;
      this.filters.na = false;
      this.filters.na_all = false;
      this.filters.exclude_na = false;
      this.filters.referral = false;
      this.filters.waiting = false;
      this.filters.transfer = false;
      this.filters.leads = false;
      this.filters.ended = false;
      this.filters.ended_sort_by_name = false;
      this.filters.nac = false;
      this.filters.btgp = false;
      this.filters.auto_removal = false;
      this.filters.dup_source = false;
      this.filters.ex_dup_source = false;
      this.filters.dup = false;
      this.filters.reg_dup_total = false;
      this.filters.dup_exclude = false;
      this.filters.merged = false;
      this.filters.tech = false;
      this.filters.is_leading = false;
      switch (cond) {
        case 0:
          this.filters.selling_group = true;
          this.filters.is_new = false;
          this.filters.other_new = false;
          this.filters.leading_new = false;
          this.filters.loosing_new = false;
          break;
        case 1:
          this.filters.selling_group = false;
          this.filters.is_new = true;
          this.filters.other_new = false;
          this.filters.leading_new = false;
          this.filters.loosing_new = false;
          break;
        case 2:
          this.filters.selling_group = false;
          this.filters.is_new = false;
          this.filters.other_new = true;
          this.filters.leading_new = false;
          this.filters.loosing_new = false;
          break;
        case 3:
          this.filters.selling_group = false;
          this.filters.is_new = false;
          this.filters.other_new = false;
          this.filters.leading_new = true;
          this.filters.loosing_new = false;
          break;
        case 4:
          this.filters.selling_group = false;
          this.filters.is_new = false;
          this.filters.other_new = false;
          this.filters.leading_new = false;
          this.filters.loosing_new = true;
          break;
        default:
      }
      // if (cond) {
      //   this.filters.selling_group = true;
      //   this.filters.is_new = false;
      // } else {
      //   this.filters.selling_group = false;
      //   this.filters.is_new = true;
      // }
      this.filters.dup_users = []; /// ????
      this.filters.dup_na = []; /// ????
      this.filters.dup_ni = []; /// ????
      this.filters.dup_bn = []; /// ????
      this.filters.dup_na_ar = [];

      this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;

      // if(cond2 === 1) {
      //
      // }
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.$store.commit("clients/setFilterToMain", {
        title: "nw",
        type: false
      });
    },

    filterByActiveLeading() {
      // this.selectedTagToFilter = "NEW";
      this.startUpAllTagFilter = false;
      this.filters.deposit_statuses = [];
      this.filters.deposit_brokers = [];
      this.filters.deposit_users = [];
      this.filters.deposit_lead_users = [];
      this.filters.deposit_sec_users = [];
      this.filters.deposit_answers = [];
      this.filters.deposit_clients = false;
      this.filters.cc_decline_clients = false;
      this.filters.deposit_amount = null;
      this.filters.deposit_to_rem = false;
      this.filters.deposit_from_cc = false;
      this.filters.deposit_from_sup = false;
      this.filters.deposit = false;
      this.filters.lead_campaigns = [];
      this.filters.lead_campaigns_users = [];
      this.filters.na_users = [];
      this.filters.ca_users = [];
      this.filters.ca_status = [];
      this.filters.ca_auto_status = [];
      this.filters.referral_campaigns = [];
      this.filters.client_transfers = [];
      this.filters.client_transfer_place = [];
      this.filters.client_transfers_type = [];
      this.filters.client_transfers_by = [];
      this.filters.client_transfers_from = [];
      this.filters.exclude_ca = false;
      this.filters.exclude_ca_filter = false;
      this.filters.exclude_auto_ca = false;
      this.filters.exclude_dp = false;
      this.filters.exclude_dp_filter = false;
      this.filters.exclude_na = false;
      this.filters.exclude_na_filter = false;
      this.filters.exclude_tr = false;
      this.filters.exclude_tr_filter = false;
      this.filters.exclude_rf = false;
      this.filters.exclude_rf_filter = false;
      this.filters.exclude_ld = false;
      this.filters.exclude_id_filter = false;
      this.filters.active = true;
      this.filters.bad_number = false;
      this.filters.not_interested = false;
      this.filters.scheduled_calls = false;
      this.filters.coming_calls = false;
      this.filters.missed_calls = false;
      this.filters.auto_missed_calls = false;
      this.filters.today_calls = false;
      this.filters.na = false;
      this.filters.na_all = false;
      this.filters.exclude_na = false;
      this.filters.referral = false;
      this.filters.waiting = false;
      this.filters.transfer = false;
      this.filters.leads = false;
      this.filters.ended = false;
      this.filters.ended_sort_by_name = false;
      this.filters.nac = false;
      this.filters.btgp = false;
      this.filters.auto_removal = false;
      this.filters.dup_source = false;
      this.filters.ex_dup_source = false;
      this.filters.dup = false;
      this.filters.reg_dup_total = false;
      this.filters.dup_exclude = false;
      this.filters.merged = false;
      this.filters.tech = false;

      this.pagination.currentPage = 1;
      this.filters.is_leading = true;
      this.debouncedClientsQuery();
      return this.viewHideResetBtn();
    },

    filterByOnline() {
      this.selectedTagToFilter = "ONLINE";

      if (!this.filters.online) {
        if (!this.CheckUserPermission([7])) {
          this.selectedMainTab = "total";
          this.$store.commit(
              "clients/setClientsTableSelectedMainTab",
              this.selectedMainTab
          );
        }
        this.filters.online = true;
        this.pagination.currentPage = 1;
        this.debouncedClientsQuery();
        return this.viewHideResetBtn();
      }
      if (this.filters.online) {
        this.selectedMainTab = "clients";
        this.$store.commit(
            "clients/setClientsTableSelectedMainTab",
            this.selectedMainTab
        );
        this.removeFromFiltersList("online");
        this.pagination.currentPage = 1;
        this.debouncedClientsQuery();
        return this.viewHideResetBtn();
      }

      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    filterByActive() {
      this.$store.commit("clients/setChartsMainView", "DEP");
      this.selectedTagToFilter = "AC";
      this.startUpAllTagFilter = false;
      this.filters.deposit_statuses = [];
      this.filters.deposit_brokers = [];
      this.filters.deposit_users = [];
      this.filters.deposit_lead_users = [];
      this.filters.deposit_sec_users = [];
      this.filters.deposit_answers = [];
      this.filters.deposit_clients = false;
      this.filters.cc_decline_clients = false;
      this.filters.lead_campaigns = [];
      this.filters.lead_campaigns_users = [];
      this.filters.na_users = [];
      this.filters.ca_users = [];
      this.filters.ca_status = [];
      this.filters.ca_auto_status = [];
      this.filters.referral_campaigns = [];
      this.filters.client_transfers = [];
      this.filters.client_transfer_place = [];
      this.filters.client_transfers_type = [];
      this.filters.client_transfers_by = [];
      this.filters.client_transfers_from = [];
      this.filters.exclude_ca = false;
      this.filters.exclude_ca_filter = false;
      this.filters.exclude_auto_ca = false;
      this.filters.exclude_dp = false;
      this.filters.exclude_dp_filter = false;
      this.filters.exclude_na = false;
      this.filters.exclude_na_filter = false;
      this.filters.exclude_tr = false;
      this.filters.exclude_tr_filter = false;
      this.filters.exclude_rf = false;
      this.filters.exclude_rf_filter = false;
      this.filters.exclude_ld = false;
      this.filters.exclude_id_filter = false;
      this.filters.is_new = false;
      this.filters.is_leading = false;
      this.filters.selling_group = false;
      this.filters.leading_new = false;
      this.filters.loosing_new = false;
      this.filters.other_new = false;
      this.filters.bad_number = false;
      this.filters.not_interested = false;
      this.filters.scheduled_calls = false;
      this.filters.coming_calls = false;
      this.filters.missed_calls = false;
      this.filters.auto_missed_calls = false;
      this.filters.today_calls = false;
      this.filters.na = false;
      this.filters.na_all = false;
      this.filters.exclude_na = false;
      this.filters.deposit_amount = null;
      this.filters.deposit_to_rem = false;
      this.filters.deposit_from_cc = false;
      this.filters.deposit_from_sup = false;
      this.filters.referral = false;
      this.filters.waiting = false;
      this.filters.transfer = false;
      this.filters.deposit = false;
      this.filters.leads = false;
      this.filters.ended = false;
      this.filters.ended_sort_by_name = false;
      this.filters.nac = false;
      this.filters.btgp = false;
      this.filters.auto_removal = false;
      this.filters.dup_source = false;
      this.filters.ex_dup_source = false;
      this.filters.dup = false;
      this.filters.dup_exclude = false;
      this.filters.reg_dup_total = false;
      this.filters.merged = false;
      this.filters.active = true;

      this.filters.dup_users = []; /// ????
      this.filters.dup_na = []; /// ????
      this.filters.dup_ni = []; /// ????
      this.filters.dup_bn = []; /// ????
      this.filters.dup_na_ar = [];

      this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    filterByActiveWithoutFetch() {
      this.$store.commit("clients/setChartsMainView", "DEP");
      this.selectedTagToFilter = "AC";
      this.startUpAllTagFilter = false;
      this.filters.deposit_statuses = [];
      this.filters.deposit_brokers = [];
      this.filters.deposit_users = [];
      this.filters.deposit_lead_users = [];
      this.filters.deposit_sec_users = [];
      this.filters.deposit_answers = [];
      this.filters.deposit_clients = false;
      this.filters.cc_decline_clients = false;
      this.filters.lead_campaigns = [];
      this.filters.lead_campaigns_users = [];
      this.filters.na_users = [];
      this.filters.ca_users = [];
      this.filters.ca_status = [];
      this.filters.ca_auto_status = [];
      this.filters.referral_campaigns = [];
      this.filters.client_transfers = [];
      this.filters.client_transfer_place = [];
      this.filters.client_transfers_type = [];
      this.filters.client_transfers_by = [];
      this.filters.client_transfers_from = [];
      this.filters.exclude_ca = false;
      this.filters.exclude_ca_filter = false;
      this.filters.exclude_auto_ca = false;
      this.filters.exclude_dp = false;
      this.filters.exclude_dp_filter = false;
      this.filters.exclude_na = false;
      this.filters.exclude_na_filter = false;
      this.filters.exclude_tr = false;
      this.filters.exclude_tr_filter = false;
      this.filters.exclude_rf = false;
      this.filters.exclude_rf_filter = false;
      this.filters.exclude_ld = false;
      this.filters.exclude_id_filter = false;
      this.filters.is_new = false;
      this.filters.is_leading = false;
      this.filters.selling_group = false;
      this.filters.leading_new = false;
      this.filters.loosing_new = false;
      this.filters.other_new = false;
      this.filters.bad_number = false;
      this.filters.not_interested = false;
      this.filters.scheduled_calls = false;
      this.filters.coming_calls = false;
      this.filters.missed_calls = false;
      this.filters.auto_missed_calls = false;
      this.filters.today_calls = false;
      this.filters.na = false;
      this.filters.na_all = false;
      this.filters.exclude_na = false;
      this.filters.deposit_amount = null;
      this.filters.deposit_to_rem = false;
      this.filters.deposit_from_cc = false;
      this.filters.deposit_from_sup = false;
      this.filters.referral = false;
      this.filters.waiting = false;
      this.filters.transfer = false;
      this.filters.deposit = false;
      this.filters.leads = false;
      this.filters.ended = false;
      this.filters.ended_sort_by_name = false;
      this.filters.nac = false;
      this.filters.btgp = false;
      this.filters.dup_source = false;
      this.filters.ex_dup_source = false;
      this.filters.dup = false;
      this.filters.dup_exclude = false;
      this.filters.reg_dup_total = false;
      this.filters.merged = false;
      this.filters.active = true;

      this.filters.dup_users = []; /// ????
      this.filters.dup_na = []; /// ????
      this.filters.dup_ni = []; /// ????
      this.filters.dup_bn = []; /// ????
      this.filters.dup_na_ar = [];

      this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    filterByBtgp() {
      if (this.filters.btgp) {
        this.removeFromFiltersList("btgp");
        this.filters.btgp = false;
      } else {
        this.selectedTagToFilter = "BTGP";
        this.filters.btgp = true;
      }

      this.startUpAllTagFilter = false;

      this.pagination.currentPage = 1;

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.selectedFnFilterCounterTotal();
    },

    filterByAutoRem() {
      if (this.filters.auto_removal) {
        this.removeFromFiltersList("auto_rem");
        this.filters.auto_removal = false;
      } else {
        this.selectedTagToFilter = "AUTO_REM";
        this.filters.auto_removal = true;
      }

      this.startUpAllTagFilter = false;

      this.pagination.currentPage = 1;

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.selectedFnFilterCounterTotal();
    },

    setFilterByDup(val) {
      if (val) {
        this.filters.dup = true;

        this.filterWithExcludeDup();
      }
      if (!val) {
        this.filters.dup_exclude = false;
        // this.filters.reg_dup_total = false;
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
      }
    },

    filterWithExcludeDup() {
      if (this.filters.dup_exclude) {
        this.removeFromFiltersList("dup_exclude");

        this.filters.dup_exclude = false;
      } else {
        this.removeFromFiltersList("dup_source");
        this.removeFromFiltersList("ex_dup_source");
        this.removeFromFiltersList("dup");
        this.filters.dup = false;
        this.filters.dup_source = false;
        this.filters.ex_dup_source = false;
        this.filters.dup_users = []; /// ????
        this.filters.dup_na = []; /// ????
        this.filters.dup_ni = []; /// ????
        this.filters.dup_bn = []; /// ????
        this.filters.dup_na_ar = [];

        this.filters.dup_exclude = true;
      }
      this.startUpAllTagFilter = false;

      this.pagination.currentPage = 1;

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.selectedFnFilterCounterTotal();
    },

    filterByMerged() {
      if (this.filters.merged) {
        this.removeFromFiltersList("merged");
        this.filters.merged = false;
      } else {
        this.selectedTagToFilter = "AC";
        this.startUpAllTagFilter = false;
        this.filters.deposit_statuses = [];
        this.filters.deposit_brokers = [];
        this.filters.deposit_users = [];
        this.filters.deposit_lead_users = [];
        this.filters.deposit_sec_users = [];
        this.filters.deposit_answers = [];
        this.filters.deposit_clients = false;
        this.filters.cc_decline_clients = false;
        this.filters.lead_campaigns = [];
        this.filters.lead_campaigns_users = [];
        this.filters.na_users = [];
        this.filters.ca_users = [];
        this.filters.ca_status = [];
        this.filters.ca_auto_status = [];
        this.filters.referral_campaigns = [];
        this.filters.client_transfers = [];
        this.filters.client_transfer_place = [];
        this.filters.client_transfers_type = [];
        this.filters.client_transfers_by = [];
        this.filters.client_transfers_from = [];
        this.filters.exclude_ca = false;
        this.filters.exclude_ca_filter = false;
        this.filters.exclude_auto_ca = false;
        this.filters.exclude_dp = false;
        this.filters.exclude_dp_filter = false;
        this.filters.exclude_na = false;
        this.filters.exclude_na_filter = false;
        this.filters.exclude_tr = false;
        this.filters.exclude_tr_filter = false;
        this.filters.exclude_rf = false;
        this.filters.exclude_rf_filter = false;
        this.filters.exclude_ld = false;
        this.filters.exclude_id_filter = false;
        this.filters.is_new = false;
        this.filters.is_leading = false;
        this.filters.selling_group = false;
        this.filters.leading_new = false;
        this.filters.loosing_new = false;
        this.filters.other_new = false;
        this.filters.bad_number = false;
        this.filters.not_interested = false;
        this.filters.scheduled_calls = false;
        this.filters.coming_calls = false;
        this.filters.missed_calls = false;
        this.filters.auto_missed_calls = false;
        this.filters.today_calls = false;
        this.filters.na = false;
        this.filters.na_all = false;

        this.filters.exclude_na = false;
        this.filters.deposit_amount = null;
        this.filters.deposit_to_rem = false;
        this.filters.deposit_from_cc = false;
        this.filters.deposit_from_sup = false;
        this.filters.referral = false;
        this.filters.waiting = false;
        this.filters.transfer = false;
        this.filters.deposit = false;
        this.filters.leads = false;
        this.filters.ended = false;
        this.filters.ended_sort_by_name = false;
        this.filters.nac = false;
        this.filters.btgp = false;
        this.filters.auto_removal = false;
        this.filters.dup_source = false;
        this.filters.ex_dup_source = false;
        this.filters.dup = false;
        this.filters.dup_exclude = false;
        this.filters.dup_users = [];
        this.filters.dup_na = [];
        this.filters.dup_ni = [];
        this.filters.dup_bn = [];
        this.filters.dup_na_ar = [];

        this.filters.reg_dup_total = false;
        // this.filters.active = false; //todo need to check
        this.filters.merged = true;
      }
      this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.selectedFnFilterCounterTotal();
    },
    filterByTech() {
      if (this.filters.tech) {
        this.removeFromFiltersList("tech");
        this.filters.tech = false;
      } else {
        this.filters.tech = true;
      }
      this.pagination.currentPage = 1;

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.selectedFnFilterCounterTotal();
    },
    filterByDup() {
      this.startUpAllTagFilter = false;

      if (this.filters.dup) {
        this.removeFromFiltersList("dup");
        this.filters.dup = false;
      } else {
        this.removeFromFiltersList("dup_exclude");
        this.filters.dup = true;
        this.filters.dup_exclude = false;
        this.filters.reg_dup_total = false;
      }

      this.pagination.currentPage = 1;

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.selectedFnFilterCounterTotal();
    },

    filterBySourceDup() {
      if (this.filters.dup_source) {
        this.removeFromFiltersList("dup_source");
        this.filters.dup_source = false;
      } else {
        this.removeFromFiltersList("dup_exclude");
        this.removeFromFiltersList("ex_dup_source");
        this.removeFromFiltersList("dup_source");
        this.filters.dup_source = true;
        this.filters.dup_exclude = false;
        this.filters.ex_dup_source = false;
        this.filters.dup_users = []; /// ????
        this.filters.dup_na = []; /// ????
        this.filters.dup_ni = []; /// ????
        this.filters.dup_bn = []; /// ????
        this.filters.dup_na_ar = [];

        this.filters.reg_dup_total = false;
      }
      this.startUpAllTagFilter = false;

      this.pagination.currentPage = 1;

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.selectedFnFilterCounterTotal();
    },
    filterByExcludeSourceDup() {
      if (this.filters.ex_dup_source) {
        this.removeFromFiltersList("ex_dup_source");
        this.filters.ex_dup_source = false;
      } else {
        this.removeFromFiltersList("dup_exclude");
        this.removeFromFiltersList("ex_dup_source");
        this.removeFromFiltersList("dup_source");
        this.filters.ex_dup_source = true;
        this.filters.dup_source = false;
        this.filters.dup_exclude = false;
        this.filters.dup_users = []; /// ????
        this.filters.dup_na = []; /// ????
        this.filters.dup_ni = []; /// ????
        this.filters.dup_bn = []; /// ????
        this.filters.dup_na_ar = [];

        this.filters.reg_dup_total = false;
      }
      this.startUpAllTagFilter = false;

      this.pagination.currentPage = 1;

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.selectedFnFilterCounterTotal();
    },

    filterByNac() {
      if (this.filters.nac) {
        this.removeFromFiltersList("nac");
        this.startUpAllTagFilter = false;
        this.filters.nac = false;
        this.pagination.currentPage = 1;
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
      } else {
        this.startUpAllTagFilter = false;
        this.filters.nac = true;
        this.pagination.currentPage = 1;
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
      }

      this.selectedFnFilterCounterTotal();
    },

    filterByNoAnswer(cond) {
      if (cond) {
        this.selectedTagToFilter = "NA_ALL";
      } else {
        this.selectedTagToFilter = "NA";
      }
      this.startUpAllTagFilter = false;
      if (
          this.filters.deposit_statuses.length === 0 &&
          this.filters.deposit_brokers.length === 0 &&
          this.filters.deposit_users.length === 0 &&
          this.filters.deposit_lead_users.length === 0 &&
          this.filters.deposit_sec_users.length === 0 &&
          this.filters.deposit_answers.length === 0 &&
          this.filters.deposit_amount === null &&
          this.filters.exclude_dp === false &&
          this.filters.exclude_dp_filter === false &&
          this.filters.deposit_to_rem === false &&
          this.filters.deposit_from_cc === false &&
          this.filters.deposit_from_sup === false
      ) {
        this.filters.deposit = false;
      }

      if (
          this.filters.referral_campaigns.length === 0 &&
          this.filters.exclude_rf === false
      ) {
        this.filters.referral = false;
      }
      if (
          this.filters.client_transfers.length === 0 &&
          this.filters.client_transfer_place.length === 0 &&
          this.filters.client_transfers_by.length === 0 &&
          this.filters.client_transfers_from.length === 0 &&
          this.filters.client_transfers_type.length === 0 &&
          this.filters.exclude_tr === false
      ) {
        this.filters.transfer = false;
      }

      if (
          this.filters.ca_auto_status.length === 0 &&
          this.filters.ca_status.length === 0 &&
          this.filters.ca_users.length === 0 &&
          this.filters.priority.length === 0 &&
          this.filters.exclude_ca === false &&
          this.filters.exclude_auto_ca === false
      ) {
        this.filters.scheduled_calls = false;
      }

      if (
          this.filters.lead_campaigns.length === 0 &&
          this.filters.lead_campaigns_users === 0 &&
          this.filters.exclude_ld === false
      ) {
        this.filters.leads = false;
      }
      this.filters.is_new = false;
      this.filters.is_leading = false;
      this.filters.selling_group = false;
      this.filters.leading_new = false;
      this.filters.loosing_new = false;
      this.filters.other_new = false;
      // this.filters.active = false;

      if (!cond) {
        this.filters.na_all = false;
        this.filters.na = true;
      } else {
        this.filters.na = false;
        this.filters.na_all = true;
      }

      this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.$store.commit("clients/setFilterToMain", {
        title: "nr",
        type: false
      });
    },

    filterByTransfer() {
      this.selectedTagToFilter = "TR";
      this.startUpAllTagFilter = false;
      if (
          this.filters.deposit_statuses.length === 0 &&
          this.filters.deposit_brokers.length === 0 &&
          this.filters.deposit_users.length === 0 &&
          this.filters.deposit_lead_users.length === 0 &&
          this.filters.deposit_sec_users.length === 0 &&
          this.filters.deposit_answers.length === 0 &&
          this.filters.deposit_amount === null &&
          this.filters.exclude_dp === false &&
          this.filters.exclude_dp_filter === false &&
          this.filters.deposit_to_rem === false &&
          this.filters.deposit_from_cc === false &&
          this.filters.deposit_from_sup === false
      ) {
        this.filters.deposit = false;
      }

      if (
          this.filters.referral_campaigns.length === 0 &&
          this.filters.exclude_rf === false
      ) {
        this.filters.referral = false;
      }

      if (
          this.filters.ca_auto_status.length === 0 &&
          this.filters.ca_status.length === 0 &&
          this.filters.ca_users.length === 0 &&
          this.filters.priority.length === 0 &&
          this.filters.exclude_ca === false &&
          this.filters.exclude_auto_ca === false
      ) {
        this.filters.scheduled_calls = false;
      }
      //////////////////////////////////////////////// need to check
      if (
          this.filters.na_users.length === 0 &&
          this.filters.na_all === false &&
          this.filters.exclude_na === false
      ) {
        this.filters.na = false;
      }

      if (
          this.filters.lead_campaigns.length === 0 &&
          this.filters.lead_campaigns_users === 0 &&
          this.filters.exclude_ld === false
      ) {
        this.filters.leads = false;
      }

      this.filters.is_new = false;
      this.filters.is_leading = false;
      this.filters.selling_group = false;
      this.filters.leading_new = false;
      this.filters.loosing_new = false;
      this.filters.other_new = false;
      // this.filters.active = false;
      this.filters.transfer = true;
      this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.$store.commit("clients/setFilterToMain", {
        title: "tr",
        type: false
      });
    },

    filterByWaiting() {
      if (this.filters.waiting) {
        this.removeFromFiltersList("waiting");
        this.startUpAllTagFilter = false;
        this.filters.waiting = false;
        this.debouncedClientsQuery();
        this.pagination.currentPage = 1;
        this.viewHideResetBtn();
      } else {
        this.selectedTagToFilter = "WT";
        this.startUpAllTagFilter = false;
        this.filters.waiting = true;

        this.debouncedClientsQuery();
        this.pagination.currentPage = 1;
        this.viewHideResetBtn();
      }
      this.selectedFnFilterCounterTotal();
    },

    filterByEnded() {
      this.$store.commit("clients/setFilterToMain", {
        title: "end",
        type: false
      });

      if (this.filters.ended) {
        this.removeFromFiltersList("ended");
        this.startUpAllTagFilter = false;
        this.filters.ended = false;
        this.filters.ended_sort_by_name = false;
        this.pagination.currentPage = 1;
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
      } else {
        this.startUpAllTagFilter = false;
        this.filters.ended = true;
        this.filters.ended_sort_by_name = true;

        this.pagination.currentPage = 1;
        this.debouncedClientsQuery();
        this.viewHideResetBtn();
      }
      this.selectedFnFilterCounterTotal();
    },

    filterByReferral() {
      this.selectedTagToFilter = "RF";
      this.startUpAllTagFilter = false;
      if (
          this.filters.deposit_statuses.length === 0 &&
          this.filters.deposit_brokers.length === 0 &&
          this.filters.deposit_users.length === 0 &&
          this.filters.deposit_lead_users.length === 0 &&
          this.filters.deposit_sec_users.length === 0 &&
          this.filters.deposit_answers.length === 0 &&
          this.filters.deposit_amount === null &&
          this.filters.exclude_dp === false &&
          this.filters.exclude_dp_filter === false &&
          this.filters.deposit_to_rem === false &&
          this.filters.deposit_from_cc === false &&
          this.filters.deposit_from_sup === false
      ) {
        this.filters.deposit = false;
      }

      if (
          this.filters.client_transfers.length === 0 &&
          this.filters.client_transfer_place.length === 0 &&
          this.filters.client_transfers_by.length === 0 &&
          this.filters.client_transfers_from.length === 0 &&
          this.filters.client_transfers_type.length === 0 &&
          this.filters.exclude_tr === false
      ) {
        this.filters.transfer = false;
      }

      if (
          this.filters.ca_auto_status.length === 0 &&
          this.filters.ca_status.length === 0 &&
          this.filters.ca_users.length === 0 &&
          this.filters.priority.length === 0 &&
          this.filters.exclude_ca === false &&
          this.filters.exclude_auto_ca === false
      ) {
        this.filters.scheduled_calls = false;
      }
      if (
          this.filters.na_users.length === 0 &&
          this.filters.na_all === false &&
          this.filters.exclude_na === false
      ) {
        this.filters.na = false;
      }

      if (
          this.filters.lead_campaigns.length === 0 &&
          this.filters.lead_campaigns_users === 0 &&
          this.filters.exclude_ld === false
      ) {
        this.filters.leads = false;
      }
      this.filters.is_new = false;
      this.filters.is_leading = false;
      this.filters.selling_group = false;
      this.filters.leading_new = false;
      this.filters.loosing_new = false;
      this.filters.other_new = false;
      // this.filters.active = false;
      this.filters.referral = true;

      this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;

      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.$store.commit("clients/setFilterToMain", {
        title: "rf",
        type: false
      });
    },

    filterByLead() {
      this.selectedTagToFilter = "LD";
      this.startUpAllTagFilter = false;

      if (
          this.filters.deposit_statuses.length === 0 &&
          this.filters.deposit_brokers.length === 0 &&
          this.filters.deposit_users.length === 0 &&
          this.filters.deposit_lead_users.length === 0 &&
          this.filters.deposit_sec_users.length === 0 &&
          this.filters.deposit_answers.length === 0 &&
          this.filters.deposit_amount === null &&
          this.filters.exclude_dp === false &&
          this.filters.exclude_dp_filter === false &&
          this.filters.deposit_to_rem === false &&
          this.filters.deposit_from_cc === false &&
          this.filters.deposit_from_sup === false
      ) {
        this.filters.deposit = false;
      }

      if (
          this.filters.referral_campaigns.length === 0 &&
          this.filters.exclude_rf === false
      ) {
        this.filters.referral = false;
      }
      if (
          this.filters.client_transfers.length === 0 &&
          this.filters.client_transfer_place.length === 0 &&
          this.filters.client_transfers_by.length === 0 &&
          this.filters.client_transfers_from.length === 0 &&
          this.filters.client_transfers_type.length === 0 &&
          this.filters.exclude_tr === false
      ) {
        this.filters.transfer = false;
      }

      if (
          this.filters.ca_auto_status.length === 0 &&
          this.filters.ca_status.length === 0 &&
          this.filters.ca_users.length === 0 &&
          this.filters.priority.length === 0 &&
          this.filters.exclude_ca === false &&
          this.filters.exclude_auto_ca === false
      ) {
        this.filters.scheduled_calls = false;
      }
      if (
          this.filters.na_users.length === 0 &&
          this.filters.na_all === false &&
          this.filters.exclude_na === false
      ) {
        this.filters.na = false;
      }
      this.filters.is_new = false;
      this.filters.is_leading = false;
      this.filters.selling_group = false;
      this.filters.leading_new = false;
      this.filters.loosing_new = false;
      this.filters.other_new = false;
      // this.filters.active = false;
      this.filters.leads = true;

      this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.$store.commit("clients/setFilterToMain", {
        title: "ld",
        type: false
      });
    },

    filterByDeposit() {
      this.selectedTagToFilter = "DP";
      this.startUpAllTagFilter = false;
      ///////this.filters.leads = false; TODO: NOT NEEDED
      if (
          this.filters.referral_campaigns.length === 0 &&
          this.filters.exclude_rf === false
      ) {
        this.filters.referral = false;
      }
      if (
          this.filters.client_transfers.length === 0 &&
          this.filters.client_transfer_place.length === 0 &&
          this.filters.client_transfers_by.length === 0 &&
          this.filters.client_transfers_from.length === 0 &&
          this.filters.client_transfers_type.length === 0 &&
          this.filters.exclude_tr === false
      ) {
        this.filters.transfer = false;
      }

      if (
          this.filters.ca_auto_status.length === 0 &&
          this.filters.ca_status.length === 0 &&
          this.filters.ca_users.length === 0 &&
          this.filters.priority.length === 0 &&
          this.filters.exclude_ca === false &&
          this.filters.exclude_auto_ca === false
      ) {
        this.filters.scheduled_calls = false;
      }
      if (
          this.filters.na_users.length === 0 &&
          this.filters.na_all === false &&
          this.filters.exclude_na === false
      ) {
        this.filters.na = false;
      }

      if (
          this.filters.lead_campaigns.length === 0 &&
          this.filters.lead_campaigns_users === 0 &&
          this.filters.exclude_ld === false
      ) {
        this.filters.leads = false;
      }

      this.filters.is_new = false;
      this.filters.is_leading = false;
      this.filters.selling_group = false;
      this.filters.leading_new = false;
      this.filters.loosing_new = false;
      this.filters.other_new = false;
      // this.filters.active = false;
      this.filters.cc_decline_clients = false;
      this.filters.deposit_clients = false;

      this.filters.deposit = true;

      this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
      this.$store.commit("clients/setFilterToMain", {
        title: "dep",
        type: false
      });
    },

    filterByCCDeposit() {
      this.selectedTagToFilter = "CCD";
      this.startUpAllTagFilter = false;
      this.filters.deposit_clients = false;
      this.filters.deposit = false;
      this.filters.cc_decline_clients = true;
      ////  this.filters.leads = false;  //// TODO: NOT NEEDED!

      this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },

    filterByDepDeposit() {
      this.selectedTagToFilter = "DP";
      this.startUpAllTagFilter = false;
      this.filters.deposit = false;
      this.filters.cc_decline_clients = false;
      this.filters.deposit_clients = true;
      /////////  this.filters.leads = false; //// TODO: NOT NEEDED!

      this.clearPrimaryTagStats();
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.viewHideResetBtn();
    },
    clearPrimaryTagStats() {
      this.stats.active_group_count = 0;
      this.stats.na_group_count = 0;
      this.stats.ni_group_count = 0;
      this.stats.bn_group_count = 0;
      this.stats.tier = 0;

      this.stats.name_found_ni = "";
      this.stats.name_found_bn = "";
      this.stats.name_found_t4 = "";
      this.stats.name_found_na = "";
      this.stats.name_found_end = "";

      this.stats.id_found_ni = "";
      this.stats.id_found_na = "";
      this.stats.id_found_bn = "";
      this.stats.id_found_t4 = "";
      this.stats.id_found_end = "";

      this.stats.phone_found_ni = "";
      this.stats.phone_found_na = "";
      this.stats.phone_found_bn = "";
      this.stats.phone_found_t4 = "";
      this.stats.phone_found_end = "";

      if (!this.filters.leads) {
        this.stats.leads = 0;
        this.stats.leads_ov = 0;
      }
      if (!this.filters.referral) {
        this.stats.referral = 0;
        this.stats.referral_ov = 0;
      }
      if (!this.filters.transfer) {
        this.stats.transfer = 0;
      }
      if (!this.filters.scheduled_calls) {
        this.stats.scheduled_calls = 0;
        this.stats.past_scheduled_calls = 0;
        this.stats.ca_missed = 0;
        this.stats.ca_comming = 0;
        this.stats.ca_today = 0;
        this.stats.call_rescheduled = 0;
        this.stats.auto_ca_missed = 0;
      }

      if (!this.filters.active) {
        this.stats.active = 0;
      }
      if (!this.filters.is_new) {
        this.stats.is_new = 0;
      }

      if (!this.filters.is_leading) {
        this.stats.leading_active = 0;
      }

      if (!this.filters.selling_group) {
        this.stats.selling_group_count = 0;
      }
      if (!this.filters.leading_new) {
        this.stats.leading_new = 0;
      }
      if (!this.filters.loosing_new) {
        this.stats.loosing_new = 0;
      }
      if (!this.other_new) {
        this.stats.other_new = 0;
      }

      if (!this.filters.na) {
        this.stats.na = 0;
      }
      if (!this.filters.na_all) {
        this.stats.na_all_count = 0;
      }
      // if (!this.na_all) {
      //   this.stats.na_all_count = "";
      // }
      if (!this.filters.deposit) {
        this.stats.brokers_deposits_stats = 0;
      }
      if (!this.filters.cc_decline_clients) {
        this.stats.brokers_deposits_cc_stats = 0;
      }
      if (!this.filters.deposit_clients) {
        this.stats.deposits = 0;
      }
      // this.filters.transfer = false;
      this.stats.total = 0;
    },

    clearScheduledCallsTagsStats() {
      this.stats.scheduled_calls = 0;
      this.stats.past_scheduled_calls = 0;
      this.stats.ca_missed = 0;
      this.stats.ca_comming = 0;
      this.stats.ca_today = 0;
      this.stats.call_rescheduled = 0;
      this.stats.auto_ca_missed = 0; //?????? TODO:
    },

    clearNewGroupTagsStats() {
      this.stats.is_new = 0;
      this.stats.loosing_new = 0;
      this.stats.leading_new = 0;
      this.stats.other_new = 0;
      this.stats.selling_group_count = 0;
    },
    filterProductivity() {
      this.selectedTagToFilter = "ALL";
    },
    clearPrimaryTagFilters() {
      this.selectedTagToFilter = "";
      this.filtersBarArr = [];
      // this.filters.deposit_clients = false;
      // this.filters.cc_decline_clients = false;
      this.startUpAllTagFilter = true;
      this.filters.is_new = false;
      this.filters.is_leading = false;
      this.filters.selling_group = false;
      this.filters.leading_new = false;
      this.filters.loosing_new = false;
      this.filters.other_new = false;
      // this.filters.active = false;
      this.filters.na = false;
      this.filters.na_all = false;
      this.filters.scheduled_calls = false;
      this.filters.coming_calls = false;
      this.filters.missed_calls = false;
      this.filters.auto_missed_calls = false;
      this.filters.today_calls = false;
      this.filters.referral = false;
      this.filters.waiting = false;
      this.filters.ended = false;
      this.filters.ended_sort_by_name = false;
      this.filters.transfer = false;
      this.filters.deposit = false;
      this.filters.leads = false;
      this.filters.nac = false;
      this.filters.btgp = false;
      this.filters.auto_removal = false;
      this.filters.dup_source = false;
      this.filters.ex_dup_source = false;
      this.filters.dup = false;
      this.filters.dup_exclude = false;
      this.filters.dup_users = [];
      this.filters.dup_na = [];
      this.filters.dup_ni = [];
      this.filters.dup_bn = [];
      this.filters.dup_na_ar = [];
      this.filters.reg_dup_total = false;
      this.filters.merged = false;
      this.filters.tech = false;
      this.filters.deposit_statuses = [];
      this.filters.deposit_brokers = [];
      this.filters.deposit_users = [];
      this.filters.deposit_lead_users = [];
      this.filters.deposit_sec_users = [];
      this.filters.deposit_answers = [];
      this.filters.lead_campaigns = [];
      this.filters.lead_campaigns_users = [];
      this.filters.referral_campaigns_users = [];
      this.filters.na_users = [];
      this.filters.ca_users = [];
      this.filters.ca_status = [];
      this.filters.ca_auto_status = [];
      this.filters.referral_campaigns = [];
      this.filters.client_transfers = [];
      this.filters.client_transfer_place = [];
      this.slectedFnFilter = "DEFAULT";
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.filters.transfer = false;
    },
    clearPrimaryTagFiltersWihoutFetch() {
      this.selectedTagToFilter = "";
      this.startUpAllTagFilter = true;
      this.filters.is_new = false;
      this.filters.other_new = false;
      this.filters.selling_group = false;
      this.filters.leading_new = false;
      this.filters.loosing_new = false;
      // this.filters.active = false;
      this.filters.bad_number = false;
      this.filters.na = false;
      this.filters.na_all = false;
      this.filters.scheduled_calls = false;
      this.filters.not_interested = false;
      this.filters.referral = false;
      this.filters.waiting = false;
      this.filters.ended = false;
      this.filters.ended_sort_by_name = false;
      this.filters.transfer = false;
      this.filters.deposit_at = false;
      this.filters.hours_at = false;
      this.filters.support_at = false;
      this.filters.deposit = false;
      this.filters.leads = false;
      this.filters.dup = false;
      this.filters.reg_dup_total = false;
      this.filters.btgp = false;
      this.filters.dup_source = false;
      this.filters.ex_dup_source = false;
      this.pagination.currentPage = 1;
    },

    editClientInfo(client) {
      this.cleanForm();
      this.showClientOpMenu = null;
      this.edit.mainInfoClientId = client.id;
      this.form.main.first_name = client.first_name;
      this.form.main.last_name = client.last_name;
      this.form.main.birth_date = client.birth_date;
    },

    cancelAllClientsToAssign() {
      this.selectAllClients = false;
      this.selectedClients = [];
      this.bulkCheckBoxChecked = false;
    },
    resetDupSelectors() {
      this.filters.dup_users = [];
      this.filters.dup_na = [];
      this.filters.dup_ni = [];
      this.filters.dup_bn = [];
      this.filters.dup_na_ar = [];
    },

    resetDPSelectors() {
      this.filters.deposit_clients = false;
      this.filters.cc_decline_clients = false;
      this.filters.deposit = false;
      this.filters.deposit_brokers_quantity = [];
      this.filters.deposit_statuses = [];
      this.filters.deposit_users = [];
      this.filters.deposit_lead_users = [];
      this.filters.deposit_sec_users = [];
      this.filters.deposit_answers = [];
      this.filters.deposit_brokers = [];
      this.filters.deposit_amount = null;
      this.filters.deposit_to_rem = false;
      this.filters.deposit_from_cc = false;
      this.filters.deposit_from_sup = false;
      this.filters.active = true;
      this.$store.commit("clients/setClientsTableSelectedMainTab", "clients");

      this.viewHideResetBtn();
      this.debouncedClientsQuery();
    },
    excludeCATag(val) {
      this.filters.exclude_ca = val;
    },

    conditionForFiltering(val) {
      if (val === "") {
        val = false;
      }
      this.filters.reschedule_type = val;
    },
    excludeAutoCATag(val) {
      this.filters.exclude_auto_ca = val;
    },
    excludeNATag(val) {
      this.filters.exclude_na = val;
    },
    excludeTRTag(val) {
      this.filters.exclude_tr = val;
    },
    excludeRFTag(val) {
      this.filters.exclude_rf = val;
    },
    excludeLDTag(val) {
      this.filters.exclude_ld = val;
    },

    excludeDPTag(val) {
      this.filters.exclude_dp = val;
    },
    excludeDPFilters(val) {
      this.filters.exclude_dp_filter = val;
    },
    resetAllForms() {
      this.merge = {
        mergedClientId: null,
        mergetToClientId: null,
        mergeEmails: false,
        mergePhones: false,
        mergeComments: null
      };
    },
    naUsersMsFilter(val) {
      this.filters.na_users = val;
    },
    resetNAselectors() {
      this.filters.na = false;
      this.filters.na_all = false;

      this.na_users = false;
      this.filters.active = true;
      this.selectedMainTab = "clients";
      this.$store.commit("clients/setClientsTableTab", this.selectedMainTab);

      this.$store.commit("clients/setClientsTableSelectedMainTab", "clients");

      this.viewHideResetBtn();
      this.debouncedClientsQuery();
    },
    resetCAselectors() {
      this.filters.scheduled_calls = false;
      this.filters.missed_calls = false;
      this.filters.auto_missed_calls = false;
      this.filters.today_calls = false;

      this.filters.coming_calls = false;
      this.filters.ca_status = [];
      this.filters.ca_auto_status = [];
      this.filters.ca_users = [];
      this.viewHideResetBtn();
      this.debouncedClientsQuery();
    },
    resetNWselectors() {
      this.filters.is_leading = false;
      this.filters.leading_new = false;
      // this.registered_on_from= null
      // this.registered_on_to= null
      this.$store.commit("clients/setClientsTableSelectedMainTab", "clients");
      this.resetOneCalendar({ calendar: "REG", tag: null }); // TODO: Probably need to reset the regDateRange in calendar if needed

      // this.resetAllCalendars()
      this.viewHideResetBtn();
      this.debouncedClientsQuery();
    },
    resetLDselector() {
      this.secondClick.ld = false;
      this.filters.leads = false;
      this.filters.lead_campaigns = [];
      this.filters.lead_campaigns_users = [];
      this.viewHideResetBtn();
      this.debouncedClientsQuery();
    },
    resetRFSelectors() {
      this.filters.referral = false;
      this.filters.referral_campaigns = false;
      this.viewHideResetBtn();
      this.debouncedClientsQuery();
    },
    resetTRselector() {
      this.filters.transfer = false;
      this.filters.client_transfers_type = [];
      this.filters.client_transfer_place = [];
      this.filters.client_transfers_by = [];
      this.filters.client_transfers_from = [];
      this.filters.client_transfers = [];

      this.viewHideResetBtn();
      this.debouncedClientsQuery();
    },

    resetAssignSelector() {
      this.filters.assigned = false;
      this.filters.orig_assigned = false;
      this.filters.assigned_rank1 = false;
      this.filters.assigned_rank2 = false;
      this.filters.assigned_rank3 = false;
      this.filters.assigned_by_rank = [];
      this.viewHideResetBtn();
      this.debouncedClientsQuery();
    },
    resetCountrySelector() {
      this.filters.country_tiers = false;
      this.filters.country_parent = false;
      this.filters.countries = false;
      this.viewHideResetBtn();
      //this.debouncedClientsQuery();
    },

    resetDeviceSelector() {
      this.filters.device = [];
      this.viewHideResetBtn();
    },
    resetPlacementSelector() {
      this.filters.placement = [];
      this.viewHideResetBtn();
    },
    resetLocPhysSelector() {
      this.filters.loc_phys_ms = [];
      this.viewHideResetBtn();
      //this.debouncedClientsQuery();
    },

    resetClickTypeSelector() {
      this.filters.click_on_site = [];
      this.viewHideResetBtn();
    },
    resetKeywordSelector() {
      this.filters.keywords = [];
    },
    resetAaidSelector() {
      this.filters.aaids = [];
      this.viewHideResetBtn();
    },

    resetAnswer1Selector() {
      this.filters.answers1 = [];
      this.viewHideResetBtn();
    },
    resetAnswer2Selector() {
      this.filters.answers2 = [];
      this.viewHideResetBtn();
    },
    resetAnswer3Selector() {
      this.filters.answers3 = [];
      this.viewHideResetBtn();
    },
    resetAnswer4Selector() {
      this.filters.answers4 = [];
      this.viewHideResetBtn();
    },
    resetAnswer5Selector() {
      this.filters.answers5 = [];
      this.viewHideResetBtn();
    },
    resetAnswer6Selector() {
      this.filters.answers6 = [];
      this.viewHideResetBtn();
    },
    resetAnswer7Selector() {
      this.filters.answers7 = [];
      this.viewHideResetBtn();
    },
    resetAnswer8Selector() {
      this.filters.answers8 = [];
      this.viewHideResetBtn();
    },
    resetAnswer9Selector() {
      this.filters.answers9 = [];
      this.viewHideResetBtn();
    },
    resetAnswer10Selector() {
      this.filters.answers10 = [];
      this.viewHideResetBtn();
    },
    resetAnswer11Selector() {
      this.filters.answers11 = [];
      this.viewHideResetBtn();
    },
    resetSmsSelector() {
      this.filters.sms_status = [];
      this.filters.sms_preset = [];
      this.viewHideResetBtn();
    },
    resetAnswerStatusSelector() {
      this.filters.answers_status = [];
      this.viewHideResetBtn();
    },

    resetBnSelector() {
      this.filters.bn_status = [];
      this.viewHideResetBtn();
    },
    resetNiSelector() {
      this.filters.ni_status = [];
      this.viewHideResetBtn();
    },

    resetThFields(withCalendars) {

      //reset hours
      this.filters.phone = "";
      this.filters.email = "";
      this.filters.client = "";
      this.bulkCheckBoxChecked = false;
      this.viewResetBtn = false;
      this.filters.registered_hours_at = false;
      this.filters.last_modified_hours_at = false;
      this.filters.last_modified_personal_hours_at = false;
      this.filters.scheduled_calls_hours_at = false;
      this.filters.assigned_hours_at = false;
      this.filters.transfers_hours_at = false;
      this.filters.deposits_hours_at = false;
      this.filters.referrals_hours_at = false;
      this.filters.supports_hours_at = false;
      this.filters.lead_tag_hours_at = false;
      this.filters.na_tag_hours_at = false;
      this.filters.last_sc_tag_hours_at = false;
      this.filters.group_assigned_hours_at = false;
      //end reset hours

      this.filters.referral_brokers = [];
      this.filters.referral_users = [];
      this.selectedClients = [];
      this.filters.order_by = false;
      this.filters.sort_order = false;
      this.selectedTagToFilter = "";

      this.filters.fetch_countries_stats = false;
      this.fetch_questions_stats = false;
      this.filters.fetch_client_assign_stats = false;
      this.filters.fetch_sms_stats = false;
      this.filters.online = false;
      this.filtersBarArr = [];
      this.selectedClients = [];
      this.filters.show_country_stats = false;
      this.resetCalendars = true;
      this.resetLasdModCalendarTags();

      this.resetMultiSelects = true;
      this.openDepositsMenu = false;
      this.openLeadFilterMenu = false;
      this.openProcessMenu = false;
      this.openReferralMenu = false;
      this.openTransferMenu = false;
      this.filters.countries = [];
      this.filters.country_tiers = [];
      this.filters.country_parent = [];

      this.filters.countryTime.from = false;
      this.filters.countryTime.to = false;
      //this.thNameField = "";
      this.filters.client = "";
      this.filters.phone = "";
      this.filters.last_ip = "";
      this.filters.email = "";
      this.timeRangeSelected = "Reset";
      this.filters.deposit_at = false;
      this.filters.hours_at = false;
      this.filters.support_at = false;
      this.filters.assigned = false;
      this.filters.assigned_rank1 = false;
      this.filters.assigned_rank2 = false;
      this.filters.assigned_rank3 = false;
      this.filters.assigned_by_rank = [];
      this.filters.orig_assigned = false;
      this.filters.registered_on = false;
      this.filters.scheduled_call_to = false;
      this.filters.last_modified = false;
      this.filters.last_modified_na = false;
      this.filters.group_assigned_at = false;

      this.filters.last_modified_ca = false;
      this.filters.last_sc_tag = false;
      this.filters.assigned_at = false;
      this.filters.last_transfer = false;
      this.filters.last_referral = false;
      this.filters.keyword = "";
      this.filters.keywords = [];
      this.filters.placement = [];
      this.filters.loc_phys_ms = [];
      this.filters.aaid = "";
      this.filters.aaids = [];
      this.filters.device = [];
      this.click_on_site = [];
      this.filters.deposit_amount = null;
      this.filters.deposit_to_rem = false;
      this.filters.deposit_from_cc = false;
      this.filters.deposit_from_sup = false;
      this.filters.deposit_brokers_quantity = [];
      this.filters.deposit_users = [];
      this.filters.deposit_lead_users = [];
      this.filters.deposit_sec_users = [];
      this.filters.deposit_answers = [];
      this.filters.deposit_brokers = [];
      this.filters.deposit_statuses = [];
      this.filters.client_transfers = [];
      this.filters.client_transfer_place = [];
      this.filters.client_transfers_by = [];
      this.filters.client_transfers_from = [];
      this.filters.client_transfers_type = [];
      this.filters.referral_campaigns_users = [];

      this.filters.ca_auto_status = [];
      this.filters.ca_status = [];
      this.filters.ca_users = [];
      this.filters.na_users = [];
      this.filters.sms_preset = [];
      this.filters.sms_status = [];
      this.filters.sms_returned = false;
      this.filters.exclude_ca = false;
      this.filters.exclude_ca_filter = false;
      this.filters.exclude_auto_ca = false;
      this.filters.exclude_dp = false;
      this.filters.exclude_dp_filter = false;
      this.filters.exclude_na = false;
      this.filters.exclude_na_filter = false;
      this.filters.exclude_tr = false;
      this.filters.exclude_tr_filter = false;
      this.filters.exclude_rf = false;
      this.filters.exclude_rf_filter = false;
      this.filters.exclude_ld = false;
      this.filters.exclude_id_filter = false;
      this.filters.group_assigned_at = false;
      this.filters.active = true;
      this.filters.reschedule_type = false;

      // this.$store.commit("clients/setFilterDepTimeFrame", null);
      // this.$store.commit("clients/setSelectRegCalLastMonth", false);
      // this.$store.commit("clients/setSelectRegCalMonth", false);
      // this.$store.commit("clients/setChartsMainView", "DEP");
      this.$store.commit("clients/setRefreshAll", false);
      this.$store.commit("clients/setMultiSelectChartData", {
        data: {},
        selectedSector: "deposits",
        fromChart: false,
        selectedTab: null,
        hash: null
      });

      this.$store.commit("clients/setSelectedCalendarType", {
        alias: "REG",
        preset: null
      });
      this.$refs.resetAllCalendars.resetAllCalendars();
      this.clearPrimaryTagFilters();
      this.clearPrimaryTagStats();
      this.activeTags = [];
      this.secondActiveTagsArr = [];
      this.$store.commit("clients/setClientsTableSelectedMainTab", "clients");
      this.$store.commit("clients/setClientsTableTab", "CLIENTS");
    },
    selectedFnFilterCounterTotal() {
      this.selectedFnFilterTotalCounter = [
        this.filters.waiting,
        // this.filters.ended,
        this.filters.nac,
        this.filters.btgp,
        this.filters.auto_removal,
        this.filters.dup,
        this.filters.dup_source,
        this.filters.ex_dup_source,
        this.filters.dup_exclude,
        //  this.filters.merged,
        this.filters.tech
      ];
      this.slectedFnFilterCounter = this.selectedFnFilterTotalCounter.filter(
          Boolean
      ).length;
    },
    addTextFn() {
      if (this.slectedFnFilterCounter > 0) {
        return "FN +" + this.slectedFnFilterCounter;
      } else {
        return "FN";
      }
    },

    viewHideResetBtn() {
      this.selectedFnFilterCounterTotal();
      //  this.resetMsAfterFilter = true;
      if (
          this.selectedClients.length > 0 ||
          //  this.timeRangeSelected !== "Reset" ||
          this.filters.countryTime.from ||
          /// this.filters.active ||
          ///  this.filters.is_new ||
          ///   this.filters.bad_number ||
          ///  this.filters.not_interested ||
          ///   this.filters.na ||
          ///  this.filters.waiting ||
          ///   this.filters.ended ||
          ///  this.filters.referral ||
          ///   this.filters.transfer ||
          ///   this.filters.scheduled_calls ||
          this.filters.ca_status.length > 0 ||
          this.filters.ca_auto_status.length > 0 ||
          this.filters.ca_users.length > 0 ||
          this.filters.na_users.length > 0 ||
          this.filters.countries.length > 0 ||
          this.filters.country_tiers.length > 0 ||
          this.filters.country_parent.length > 0 ||
          this.filters.assigned.length > 0 ||
          this.filters.assigned_rank1.length > 0 ||
          this.filters.assigned_rank2.length > 0 ||
          this.filters.assigned_rank3.length > 0 ||
          this.filters.assigned_by_rank.length > 0 ||
          this.filters.orig_assigned.length > 0 ||
          this.filters.deposit_brokers.length > 0 ||
          this.filters.deposit_users.length > 0 ||
          this.filters.deposit_lead_users.length > 0 ||
          this.filters.deposit_sec_users.length > 0 ||
          this.filters.deposit_answers.length > 0 ||
          this.filters.deposit_statuses.length > 0 ||
          this.filters.lead_campaigns.length > 0 ||
          this.filters.lead_campaigns_users.length > 0 ||
          this.filters.referral_campaigns.length > 0 ||
          this.filters.click_on_site.length > 0 ||
          this.filters.client_transfers.length > 0 ||
          this.filters.client_transfer_place.length > 0 ||
          this.filters.client_transfers_by.length > 0 ||
          this.filters.client_transfers_from.length > 0 ||
          this.filters.client_transfers_type.length > 0 ||
          this.filters.device.length > 0 ||
          this.filters.keyword ||
          this.filters.keywords.length > 0 ||
          this.filters.placement.length > 0 ||
          this.filters.loc_phys_ms.length > 0 ||
          this.filters.aaid ||
          this.filters.aaids.length > 0 ||
          // this.thNameField !== ""  ||
          this.filters.client !== "" || //||
          ////   this.filters.client !== undefined
          this.filters.phone !== "" ||
          this.filters.last_ip !== "" ||
          this.filters.email !== "" ||
          this.filters.deposit_at !== false ||
          //check for hours stats
          this.filters.registered_hours_at !== false ||
          this.filters.last_modified_hours_at !== false ||
          this.filters.last_modified_personal_hours_at !== false ||
          this.filters.scheduled_calls_hours_at !== false ||
          this.filters.assigned_hours_at !== false ||
          this.filters.transfers_hours_at !== false ||
          this.filters.deposits_hours_at !== false ||
          this.filters.referrals_hours_at !== false ||
          this.filters.supports_hours_at !== false ||
          this.filters.na_tag_hours_at !== false ||
          this.filters.lead_tag_hours_at !== false ||
          //end checking hours stats
          this.filters.referral_brokers.length > 0 ||
          this.filters.referral_users.length > 0 ||
          this.filters.hours_at !== false ||
          this.filters.support_at !== false ||
          //  this.filters.deposit !== false ||
          this.filters.registered_on !== false ||
          this.filters.scheduled_call_to !== false ||
          this.filters.last_modified !== false ||
          this.filters.assigned_at !== false ||
          // this.filters.assigned_at[0] === undefined ||
          //this.filters.group_assigned_at !== false ||
          this.filters.last_transfer !== false ||
          this.filters.last_referral !== false ||
          this.filters.last_modified_na !== false ||
          this.filters.group_assigned_at !== false ||
          this.filters.last_modified_leads !== false ||
          this.filters.retired !== null ||
          this.filters.answers1.length > 0 ||
          this.filters.answers2.length > 0 ||
          this.filters.answers3.length > 0 ||
          this.filters.answers4.length > 0 ||
          this.filters.answers5.length > 0 ||
          this.filters.answers6.length > 0 ||
          this.filters.answers7.length > 0 ||
          this.filters.answers8.length > 0 ||
          this.filters.answers9.length > 0 ||
          this.filters.answers10.length > 0 ||
          this.filters.answers11.length > 0 ||
          this.filters.answers_status.length > 0 || //||
          this.filters.deposit_amount !== null ||
          this.filters.deposit_brokers_quantity.length > 0 ||
          this.filters.deposit_to_rem !== false ||
          this.filters.deposit_from_cc !== false ||
          this.filters.deposit_from_sup !== false ||
          // this.showWt !== true ||
          //this.startUpAllTagFilter !== true ||
          this.filters.is_new !== false ||
          this.filters.is_leading !== false ||
          this.filters.selling_group !== false ||
          this.filters.leading_new !== false ||
          this.filters.loosing_new !== false ||
          this.filters.other_new !== false ||
          this.filters.active !== true ||
          //  this.filters.bad_number = false;
          this.filters.na !== false ||
          this.filters.na_all !== false ||
          this.filters.scheduled_calls !== false ||
          this.filters.coming_calls !== false ||
          this.filters.missed_calls !== false ||
          this.filters.auto_missed_calls !== false ||
          this.filters.today_calls !== false ||
          //this.filters.not_interested = false;
          this.filters.referral !== false ||
          this.filters.waiting !== false ||
          this.filters.ended !== false ||
          this.filters.ended_sort_by_name !== false ||
          this.filters.transfer !== false ||
          // this.filters.deposit_at = false;
          this.filters.deposit !== false ||
          this.filters.deposit !== false ||
          this.filters.leads !== false ||
          this.filters.online !== false ||
          this.filters.sms_preset.length > 0 ||
          this.filters.sms_status.length > 0 ||
          this.filters.sms_returned !== false ||
          this.filters.dup_source !== false ||
          this.filters.ex_dup_source !== false ||
          this.filters.reg_dup_total !== false ||
          this.filters.dup_exclude !== false ||
          this.filters.dup_users.length > 0 ||
          this.filters.dup_na.length > 0 ||
          this.filters.dup_ni.length > 0 ||
          this.filters.dup_bn.length > 0 ||
          this.filters.dup_na_ar.length > 0 ||
          this.filters.merged !== false ||
          this.filters.tech !== false ||
          this.filters.dup !== false ||
          this.filters.ni_status.length > 0 ||
          this.filters.bn_status.length > 0 ||
          this.filters.exclude_ca !== false ||
          this.filters.reschedule_type !== false ||
          this.filters.exclude_auto_ca !== false ||
          this.filters.exclude_na !== false ||
          this.filters.exclude_tr !== false ||
          this.filters.exclude_rf !== false ||
          this.filters.exclude_ld !== false ||
          this.filters.exclude_dp !== false ||
          this.filters.exclude_dp_filter !== false ||
          this.filters.auto_removal !== false
      ) {
        this.$store.commit("clients/setShowReset", this.viewResetBtn);
        return (this.viewResetBtn = true);
      }
      // alert()

      this.$store.commit("clients/setShowReset", this.viewResetBtn);
      return (this.viewResetBtn = false);
    },

    cleanForm() {
      this.cms.cmsPasswordClientID = null;
      this.cms.edit.cmsNewPassword = null;
      this.cms.cmsPlanClientId = null;
      this.cms.edit.cmsNewPlan = null;
      this.edit.mainInfoClientId = null;
      this.edit.phonesClientId = null;
      this.edit.sendSMS = null;
      this.edit.sendSMSto = null;
      this.edit.emailsClientId = null;
      this.edit.assignmentClientId = null;
      this.form.main.first_name = "";
      this.form.main.last_name = "";
      this.form.main.birth_date = null;
      this.form.assignedTo.full_name = ""; ////
      this.form.assignedTo.id = null;
      this.form.newEmail.contact_value = "";
      this.form.newEmail.client_id = null;
      this.form.newEmail.id = null;
      this.form.newEmail.is_primary = null;
      this.form.newPhone.contact_value = "";
      this.form.newPhone.client_id = null;
      this.form.newPhone.id = null;
      this.form.newPhone.is_primary = null;
      this.form.newPhone.deposit_email = null;
      this.$set(this.form.main, "first_name", "");
      this.$set(this.form.main, "last_name", "");
      this.$set(this.form.main, "birth_date", null);
      this.$set(this.form, "phones", []);
      this.$set(this.form, "emails", []);
      this.$set(this.form, "errorBag", {});
      this.emailsUpdateBusy = false;
    },

    /////////////////////////////////////////////////////////////////////////////////////////
    ///           API REQUESTS            ////
    ///////////////////////////////////////////////////////////////////////////////////////
    async saveMergeOp(merge) {
      if (merge.mergetToClientId === this.selectedClients[0]) {
        merge.mergedClientId = this.selectedClients[1];
      }
      if (merge.mergetToClientId === this.selectedClients[1]) {
        merge.mergedClientId = this.selectedClients[0];
      }

      try {
        this.$store.commit("clients/setLoading", true);
        const bulkAssignRequest = apiClientCreator(
            `client/merge/${merge.mergetToClientId}`
        );
        await bulkAssignRequest.post("", {
          merged_client: merge.mergedClientId,
          merged_emails: merge.mergeEmails,
          merged_phones: merge.mergeEmails,
          comments: merge.mergeComments
        });

        this.selectedClients = [];
        this.resetAllForms();
        this.openMergeOptions = false;
        this.fetchClients();
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Merge Clients Operation Completed",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
              "Client Merge Error!" + " " + " Error Status: " + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },

    getSignals(clientEmail) {
      if (!this.cms.requestCMSClientSignalsBusy) {
        this.cms.requestCMSClientSignalsBusy = true;

        axios
            .post(
                `${Globals.joomla_website}api_evo_crm/user-statistics.php?token=151190&email=${clientEmail}`
            )
            .then(res => {
              this.cms.CMSClientSignals = res.data;
              this.cms.requestCMSClientSignalsBusy = false;
            })
            .catch(err => {
              this.cms.requestCMSClientSignalsBusy = false;
            });
      }
      // return this.CMSClientSignals;
    },

    checkIfIsNew() {
      let tempObj = Object.assign({}, this.getQueryParams());
      if (tempObj.hasOwnProperty("is_new")) {
        this.filterByLead();
      }
    },
    getTabListByRole(userRole, tabList) {
      // if(userRole === 1 || userRole === 2 || userRole === 3 || userRole === 4 || userRole === 12){
      if (this.CheckUserPermission([1, 2, 3, 4, 12])) {
        this.tabsListForSubMenu = tabList;
      } else {
        this.tabsListForSubMenu = tabList.filter(tab => {
          return tab.alias !== "cost";
        });
      }
    },
    fetchClients(withStats) {
      this.$store.commit("clients/setDebounceAll", false);

      this.selectedClientsFrom = [];
      this.sendUpdated = false;
      let path = "client/list";
      if (this.selectedMainTab === "affiliation") {
        path = "affiliation/client/click";
      }

      let apiClient = apiClientCreator(path);
      this.changeResesColor = true;
      this.$store.commit("clients/setLoading", true);

      const queryParams = this.getQueryParams();
      this.$store.commit("clients/setClientsDashBoardQueryParams", queryParams);
      this.getQueryParamsToMs = queryParams;
      this.resetMsAfterFilter = true;

      const clients = [];
      const filteredClients = [];
      this.filteredClientIds = [];

      apiClient
          .get("", { params: queryParams })
          .then(res => {
            this.changeResesColor = true;
            this.resetMsAfterFilter = false;

            if (this.selectedMainTab === "affiliation") {
              this.clickedClients = res.data.data;
            } else {
              res.data.data.forEach(function(data) {
                clients.push(new ClientModel(data));
              });
            }
            if (
                !withStats &&
                this.selectedMainTab !== "users" &&
                this.selectedMainTab !== "brokers"
            ) {
              if (!this.stopProcess) {
                this.updateStats();
              }
            }

            this.filteredClientIds = filteredClients;
            this.clients = clients;
            this.pagination.currentPage = res.data.current_page;
            this.pagination.perPage = res.data.per_page;
            this.pagination.from = res.data.from;
            this.pagination.to = res.data.to;
            this.pagination.lastPage = res.data.last_page;
            this.pagination.total = res.data.total;
            this.resetCalendars = false;
            this.resetMultiSelects = false;
            this.sendUpdated = true;
            this.changeResesColor = false;
            this.$store.commit("clients/setLoading", false);

            if (this.filters.enlarge_leads) {
              this.$store.commit("clients/setEnlargeCompanyTable", true);
            } else {
              this.$store.commit("clients/setEnlargeCompanyTable", false);
            }

                this.clients.forEach(client=>{
             if(client.email_replays.length > 0){
               client.email_replays.map(c=>{
                 if(c.email_review == 0){
                    this.totalRepEmails++;
                 }
               })

             }
            });
            // console.log( this.totalRepEmails);
            return res;
          })
          .catch(e => {
            this.$store.commit("clients/setLoading", false);
            if (!axios.isCancel(e)) {
              this.$store.commit("main/setShowVikiMsg", {
                show: true,
                msg: "Connection Error!" + " " + " Error Status: " + (e && e.response ? e.response.status : e),
                type: "ERROR",
                op: { type: "SYSTEM" }
              });
            }
          });
    },

    fetchClientsAndCall() {
      this.selectedClientsFrom = [];
      this.sendUpdated = false;
      let apiClient = apiClientCreator("client/list");
      this.$store.commit("clients/setLoading", true);

      const queryParams = this.getQueryParams();
      this.getQueryParamsToMs = queryParams;
      this.resetMsAfterFilter = false;

      const clients = [];
      const filteredClients = [];
      this.filteredClientIds = [];

      apiClient.get("", { params: queryParams }).then(res => {
        res.data.data.forEach(function(data) {
          clients.push(new ClientModel(data));
        });
        this.updateStats();

        this.filteredClientIds = filteredClients;
        this.clients = clients;
        this.pagination.currentPage = res.data.current_page;
        this.pagination.perPage = res.data.per_page;
        this.pagination.from = res.data.from;
        this.pagination.to = res.data.to;
        this.pagination.lastPage = res.data.last_page;
        this.pagination.total = res.data.total;
        this.resetCalendars = false;
        this.resetMultiSelects = false;
        this.sendUpdated = true;
        this.$store.commit("clients/setLoading", false);
        // this.$refs.updateAnswer.matchedAnswer();

        this.call(this.clients[0].phones[0].contact_value);

        return res;
      });
    },

    async call(number) {
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "Calling:" + " " + number + "...",
        type: "INFO",
        op: { type: "SYSTEM" }
      });
      try {
        const leg_a = this.auth.user.voip_user;
        const leg_b = number;
        //  const prefix = "380";

        this.$store.commit("clients/setLoading", true);
        const res = await axios({
          url: `https://click2call.pbx.commpeak.com/call/2/78/${leg_a}/${leg_b}/00`,
          method: "GET"
        });

        this.$store.commit("clients/setLoading", false);
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Calling:" + " " + number + "...",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setFilterClientToCall", null);
      } catch (e) {
        /*        this.$store.commit("main/setShowVikiMsg", {
                  show: true,
                  msg: "Dial Error!" + " " + " Error Status: " + e,
                  type: "ERROR"
                });*/
        this.$store.commit("clients/setLoading", false);
      }
    },
    async fetchFilteredClients() {
      const vm = this;

      try {
        const apiClient = apiClientCreator("client/filter-list");
        this.$store.commit("clients/setLoading", true);
        const response = await apiClient.get("", {
          params: vm.getQueryParams()
        });
        const clients = [];
        const filteredClients = [];
        vm.filteredClientIds = [];

        response.data.data.forEach(function(data, index) {
          clients.push(new ClientModel(data));

          filteredClients.push(clients[index].id);
        });
        vm.filteredClientIds = filteredClients;
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
              "Stats Fetching Error!" +
              " " +
              " Error Status: " +
              e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },

    handleTabSelected(tabName) {
      this.selectedTab = tabName;
    },

    async saveCmsPassword(client) {
      const formData = new FormData();
      formData.append("token", "151190");
      formData.append("email", client.emails[0].contact_value);
      formData.append("password", "123456");
      try {
        this.$store.commit("clients/setLoading", true);

        const cmsChangePasswordReq = apiClientCreator(
            `client/cms/password/${client.id}`
        );
        await cmsChangePasswordReq.post("", {
          new_password: "123456"
        });

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "CMS Client Password Changed",
          type: "DONE",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
        this.fetchClients();
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "CMS Client Password Change Error" + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      }
    },
    async changeCmsSMS(client) {
      try {
        this.$store.commit("clients/setLoading", true);
        const cmsChangePlanReq = apiClientCreator(
            `client/cms/sms/${client.id}`
        );
        await cmsChangePlanReq.get("");
        this.fetchClients();
        this.cleanForm();

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "CMS Client SMS Activation Changed",
          type: "DONE",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "CMS Client SMS Activation Error" + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },

    async saveCmsPlan(client) {
    
      try {
        this.$store.commit("clients/setLoading", true);
        const cmsChangePlanReq = apiClientCreator(
            `client/cms/plan/${client.id}`
        );
        await cmsChangePlanReq.post("", {
          plan_id: this.cms.edit.cmsNewPlan
        });
        this.fetchClients();
        this.cleanForm();

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "CMS Client Plan Changed",
          type: "DONE",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "CMS Client Plan Change Error" + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },
    openSMSdialog(client, idx) {
      this.edit.sendSMSto = client.phones[idx].contact_value; //'972529371132';//
      this.edit.sendSMS = client.id;
    },

    sendWhatsApp(client, preset) {
      const sendWhatsapp = apiClientCreator(
          `client/whatsapp/send/${client.id}`
      );

      this.edit.sendSMS = null;
      sendWhatsapp
          .post("", {
            preset_id: preset.id,
            contact_value: this.edit.sendSMSto,
            message:
                client.full_name +
                ", " +
                preset.preset +
                " " +
                client.assignment.assigned_to.full_name +
                " " +
                `${Globals.joomla_website}whatsapp.php?id=${client.id}`
          })
          .then(() => {
            this.cleanForm();
            this.$store.commit("main/setShowVikiMsg", {
              show: true,
              msg: "Sent WhatsApp Message To Client",
              type: "DONE",
              op: { type: "SYSTEM" }
            });
            // this.$store.commit("clients/setLoading", false);
            this.fetchClients();
          })
          .catch(e => {
            this.$store.commit("main/setShowVikiMsg", {
              show: true,
              msg: "Sent Whatsapp To Client Error " + e.response.status,
              type: "ERROR",
              op: { type: "SYSTEM" }
            });
            this.$store.commit("clients/setLoading", false);
          });
    },

    sendSMSPresetRequest(client, preset) {
      //  this.$store.commit("clients/setLoading", true);

      const sendSMSReq = apiClientCreator(`client/sms/send/${client.id}`);
      this.edit.sendSMS = null;
      sendSMSReq
          .post("", {
            preset_id: preset.id,
            contact_value: this.edit.sendSMSto,
            message:
                client.full_name +
                ", " +
                preset.preset +
                " " +
                client.assignment.assigned_to.full_name +
                " " +
                `${Globals.joomla_website}sms.php?id=${client.id}`
          })
          .then(() => {
            this.cleanForm();
            this.$store.commit("main/setShowVikiMsg", {
              show: true,
              msg: "Sent SMS To Client",
              type: "SMS_SENT",
              op: { type: "SYSTEM" }
            });
            // this.$store.commit("clients/setLoading", false);
            this.fetchClients();
          })

          .catch(e => {
            this.$store.commit("main/setShowVikiMsg", {
              show: true,
              msg: "Sent SMS To Client Error " + e.response.status,
              type: "ERROR",
              op: { type: "SYSTEM" }
            });
            this.$store.commit("clients/setLoading", false);
          });
    },

    saveClientInfoRequest(clientId, data) {
      let apiClient = apiClientCreator("client/" + clientId);
      return apiClient.put("", data);
    },

    deletePhone(phone) {
      const vm = this;
      if (confirm("This operation will delete this Phone, are you sure ?")) {
        const apiClient = apiClientCreator(`client/phone/${phone.id}`);
        this.$store.commit("clients/setLoading", true);
        apiClient.delete("").then(() => {
          const filtered = vm.form.phones.filter(item => {
            return item.id !== phone.id;
          });
          vm.form.phones = filtered;
          this.$store.commit("clients/setLoading", false);
        });
      }
    },

    addPhonesRequest(newPhone) {
      let apiClient = apiClientCreator(`client/phone/${newPhone.client_id}`);
      return apiClient.post("", {
        contact_value: newPhone.contact_value,
        is_primary: 0
      });
    },

    savePhonesRequest(updatedPhones) {
      let apiClient = apiClientCreator("client/phones");

      return apiClient.put("", updatedPhones);
    },

    savePhones() {
      const currClientIdx = this.clients.findIndex(client=>client.id===this.form.phones[0].client_id);
      this.clients[currClientIdx].tech_logs.find(log=>{
        if(log.asset === "PHONE_MALFORMED"){
          const invNum = log.from;
          if(!this.invNumbers.find(num=>num===invNum)){
            this.invNumbers.push(invNum)
          };
        }
      })
      let vm = this;
      let data = { phones: [] };
      vm.form.phones.forEach(function(phone) {
        data.phones.push(phone);
      });
      if (this.form.newPhone.contact_value.length > 4) {
        this.form.newPhone.client_id = this.form.phones[0].client_id;
        vm.addPhonesRequest(this.form.newPhone).then(() => {});
      }
      vm.savePhonesRequest(data)
          .then(function() {
            vm.cleanForm();
            vm.fetchClients();
          })
          .catch(vm.onRequestError);
    },
    openEmailsCountRelay() {
      this.openEmailsCountRelayBox = true;
    },
    openReplay() {
      this.openEmailReplayBox = true;
    },
    editEmails(emails) {
      this.cleanForm();
      let vm = this;
      let emailsForEdit = [];
      emails.forEach(function(email) {
        emailsForEdit.push({ ...email });
      });
      vm.form.emails = emailsForEdit;
      vm.edit.emailsClientId = emails[0].client_id;
      vm.emailEditIsOpen = true;
    },

    cancelEmailsEdit() {
      this.cleanForm();
    },

    deleteEmail(email) {
      const vm = this;

      if (confirm("This operation will delete this Email, are you sure ?")) {
        vm.emailsUpdateBusy = true;
        const apiClient = apiClientCreator(`client/email/${email.id}`);
        this.$store.commit("clients/setLoading", true);
        apiClient.delete("").then(() => {
          const filtered = vm.form.emails.filter(item => {
            return item.id !== email.id;
          });
          vm.form.emails = filtered;
          vm.emailsUpdateBusy = false;
          this.$store.commit("clients/setLoading", false);
        });
      }
    },

    addEmailRequest(newEmail) {
      let vm = this;
      let apiClient = apiClientCreator(`client/email/${newEmail.client_id}`);
      return apiClient.post("", {
        contact_value: this.form.newEmail.contact_value,
        is_primary: this.form.newEmail.is_primary || 0,
        deposit_email: this.form.newEmail.deposit_email || 0
      });
    },

    saveEmailsRequest(updatedEmails) {
      let apiClient = apiClientCreator("client/emails");
      return apiClient.put("", updatedEmails);
    },

    saveEmails() {
      let vm = this;
      let data = { emails: [] };
      vm.emailsUpdateBusy = true;
      vm.form.emails.forEach(function(email) {
        data.emails.push(email);
      });

      if (this.form.newEmail.contact_value.length > 0) {
        this.form.newEmail.client_id = this.form.emails[0].client_id;
        vm.addEmailRequest(this.form.newEmail)
            .then(() => {
              vm.cleanForm();
              vm.fetchClients();
              vm.emailsUpdateBusy = false;
            })
            .catch(vm.onRequestError);
        return;
      }
      vm.saveEmailsRequest(data)
          .then(function() {
            vm.cleanForm();
            vm.fetchClients();
            vm.emailsUpdateBusy = false;
          })

          .catch(vm.onRequestError);
      // vm.emailsUpdateBusy = false
    },

    /* Assignments requests*/
    ////////////////////////////////////////////////////////////////////////////////////

    /* fetch filtered clients id request */
    async selectAllClientsToAssign() {
      await this.fetchFilteredClients();
      this.selectedClients = this.filteredClientIds;
      this.selectAllClients = true;
    },

    /*Bulk  assign request */
    async bulkAssignClients(userId) {
      try {
        this.$store.commit("clients/setLoading", true);
        const bulkAssignRequest = apiClientCreator(
            `client/assign/bulk/${userId}`
        );

        let data = {
          clients: this.selectedClients,
          from_group: this.selectedMainTab
        };
        if (
            (this.filters.assigned_rank1.length > 0 &&
                this.stats.rank1_users_stats.length > 0) ||
            (this.filters.assigned_rank2.length > 0 &&
                this.stats.rank2_users_stats.length > 0) ||
            (this.filters.assigned_rank3.length > 0 &&
                this.stats.rank3_users_stats.length > 0)
        ) {
          if (
              this.filters.assigned_rank1.length > 1 ||
              this.filters.assigned_rank2.length > 1 ||
              this.filters.assigned_rank3.length > 1 ||
              (this.filters.assigned_rank1.length > 0 &&
                  this.filters.assigned_rank2.length > 0)
          ) {
            return this.$store.commit("main/setShowVikiMsg", {
              show: true,
              msg: "WARNING! You can assign only with one ranking Agent",
              type: "WARNING",
              op: { type: "SYSTEM" }
            });
          } else {
            let rank_place;
            if (
                this.filters.assigned_rank1.length > 0 &&
                this.stats.rank1_users_stats.length > 0
            ) {
              rank_place = 1;
            } else if (
                this.filters.assigned_rank2.length > 0 &&
                this.stats.rank2_users_stats.length > 0
            ) {
              rank_place = 2;
            } else if (
                this.filters.assigned_rank3.length > 0 &&
                this.stats.rank3_users_stats.length > 0
            ) {
              rank_place = 3;
            }
            //    const validateAssignment = this.stats.ranking_users_stats.find(user=>user.user_id === this.filters.assigned_rankings[0].id)
            Object.assign(data, {
              assigned_by_rank: rank_place
            });
          }
        }
        await bulkAssignRequest.post("", data);
        const socketData = {
          assign_to: userId,
          assigned_by: this.auth.user.id,
          clients: this.selectedClients,
          op_code: "BULK_ASSIGN"
        };
        this.msgSocket.emit("client_assignment", socketData);

        this.selectedClients = [];
        this.bulkAssignToResults = [];
        this.bulkAssignToQuery = "";

        this.fetchClients();
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Bulk Clients Assignments Complete",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
              "Client Bulk Assignment Error!" +
              " " +
              " Error Status: " +
              e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },

    /*Bulk group assign request */
    async bulkGroupAssignClients(groupId) {
      try {
        this.$store.commit("clients/setLoading", true);
        const groupBulkAssignReq = apiClientCreator(
            `client/assign/group/bulk/${groupId}`
        );
        await groupBulkAssignReq.post("", { clients: this.selectedClients });
        this.selectedClients = [];
        this.fetchClients();

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Bulk Clients Group Assignments Complete",
          type: "DONE",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
              "Client Bulk Group Assignment Error!" +
              " " +
              " Error Status: " +
              e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },

    async saveGroupAssignment(assignTo, clientId) {
      try {
        this.$store.commit("clients/setLoading", true);
        await groupAssignment(clientId, assignTo);
        this.fetchClients();

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Client Group Assignment Complete",
          type: "DONE",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
              "Client Group Assignment Error!" +
              " " +
              " Error Status: " +
              e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      }
    },

    async saveAssignment(assign, client) {
      try {
        this.$store.commit("clients/setLoading", true);
        const assignRequest = apiClientCreator(`client/assign/${assign.id}`);

        let data = {
          client_id: client.id,
          from_group: this.selectedMainTab
        };

        if (
            (this.filters.assigned_rank1.length > 0 &&
                this.stats.rank1_users_stats.length > 0) ||
            (this.filters.assigned_rank2.length > 0 &&
                this.stats.rank2_users_stats.length > 0) ||
            (this.filters.assigned_rank3.length > 0 &&
                this.stats.rank3_users_stats.length > 0)
        ) {
          if (
              this.filters.assigned_rank1.length > 1 ||
              this.filters.assigned_rank2.length > 1 ||
              this.filters.assigned_rank3.length > 1 ||
              (this.filters.assigned_rank1.length > 0 &&
                  this.filters.assigned_rank2.length > 0)
          ) {
            return this.$store.commit("main/setShowVikiMsg", {
              show: true,
              msg: "WARNING! You can assign only with one ranking Agent",
              type: "WARNING",
              op: { type: "SYSTEM" }
            });
          } else {
            let rank_place;
            if (
                this.filters.assigned_rank1.length > 0 &&
                this.stats.rank1_users_stats.length > 0
            ) {
              rank_place = 1;
            } else if (
                this.filters.assigned_rank2.length > 0 &&
                this.stats.rank2_users_stats.length > 0
            ) {
              rank_place = 2;
            } else if (
                this.filters.assigned_rank3.length > 0 &&
                this.stats.rank3_users_stats.length > 0
            ) {
              rank_place = 3;
            }
            //    const validateAssignment = this.stats.ranking_users_stats.find(user=>user.user_id === this.filters.assigned_rankings[0].id)
            Object.assign(data, {
              assigned_by_rank: rank_place
            });
          }
        } else {
          let index = undefined;
          this.suggestedUsers.forEach(function(user, i) {
            if (user["data"].id === parseInt(assign.id)) {
              index = i;
            }
          });

          if (index !== undefined) {
            Object.assign(data, {
              assigned_by_rank: index + 1
            });
          } else {
            this.unSuggestedUsers.forEach(function(user, i) {
              if (user["data"].id === parseInt(assign.id)) {
                index = i;
              }
            });
            if (index !== undefined) {
              Object.assign(data, {
                assigned_by_rank: -(index + 1)
              });
            }
          }
        }
        await assignRequest.put("", data);
        const socketData = {
          assign_to: assign.id,
          assigned_by: this.auth.user.id,
          client_id: client.id,
          op_code: "SING_ASSIGN"
        };
        this.msgSocket.emit("client_assignment", socketData);
        this.cleanForm();
        this.fetchClients();
        this.selectedClients = [];
        this.assignToResults = [];
        this.suggestedUsers = [];
        this.unSuggestedUsers = [];
        this.clientToSuggest = null;
        this.uniqueUsers = [];
        this.assignToQuery = "";
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Client Assignment Complete",
          type: "DONE",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
              "Client Assignment Error!" +
              " " +
              " Error Status: " +
              e.response.status +
              ", " +
              e.response.data,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      }
    },

    //////////////////////////// Clients Operations /////////////////////////////////////////
    async updateCountry(newCountry, client) {
      try {
        this.$store.commit("clients/setLoading", true);
        const assignRequest = apiClientCreator(`client/country/${client.id}`);
        await assignRequest.put("", { country_id: newCountry });
        this.cleanForm();
        this.fetchClients();
        this.$store.commit("clients/setLoading", false);
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Client Country Updated",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
              "Client Country Update Error!" +
              " " +
              " Error Status: " +
              e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      }
    },

    async saveClientOperation(opId, client, group, assignTo) {
      try {
        let groupId;
        this.$store.commit("clients/setLoading", true);
        if (group === "bn") {
          groupId = 4;
        }
        if (group === "ni") {
          groupId = 3;
        }
        if (group === "na") {
          groupId = 3;
        }
        if (opId === 1) {
          // const opDuplicate = (clientId,client,group) => {
          await apiClientCreator(`client/duplicate/${client.id}`).post("", {
            group_id: groupId,
            assign_to: assignTo,
            prev_user_id: client.assignment.assigned_to.id
          });

          //  opDuplicate(client.id, client, groupId,assignTo);

          groupId = null;
        }
        this.newDuplicate.op = null;
        this.newDuplicate.client = {};
        this.newDuplicate.selectedMainTab = "";
        this.showDuplicateAssign = null;
        this.fetchClients();
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Client Operation Complete",
          type: "DONE",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
              "Client Operation Error!" +
              " " +
              " Error Status: " +
              e.response.status +
              ", " +
              e.response.data,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      }
    },

    async saveBulkClientOperation(opId, group, assignTo, client) {
      try {
        let groupId;
        this.$store.commit("clients/setLoading", true);
        if (group === "clients") {
          groupId = 0;
        }
        if (group === "bn") {
          groupId = 4;
        }
        if (group === "ni") {
          groupId = 3;
        }
        if (group === "na") {
          groupId = 2;
        }
        if (opId === 1) {
          await apiClientCreator(`client/duplicate/bulk/${assignTo}`).post("", {
            group_id: groupId,
            clients: this.selectedClients
            //   prev_user_id:client.assignment.assigned_to.id
          });

          //  opDuplicate(client.id, client, groupId,assignTo);

          groupId = null;
        }
        this.newDuplicate.op = null;
        this.newDuplicate.client = {};
        this.newDuplicate.selectedMainTab = "";
        this.showBulkDuplicateAssign = false;
        this.selectedClients = [];
        this.fetchClients();
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Bulk Client Duplicate Operation Complete",
          type: "DONE",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
              "Client Duplicate Operation Error!" +
              " " +
              " Error Status: " +
              e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      }
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////////////

    onRequestError(error) {
      let vm = this;

      if (error.response) {
        for (let errorKey in error.response.data.errors) {
          if (!error.response.data.errors.hasOwnProperty(errorKey)) {
            continue;
          }

          vm.$set(
              vm.form.errorBag,
              errorKey,
              error.response.data.errors[errorKey][0]
          );
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
      } else {
        // Something happened in setting up the request that triggered an Error
      }
    },

    saveClientInfo() {
      let vm = this;
      let data = {};

      vm.form.errorBag = {};

      for (let key in vm.form.main) {
        if (!vm.form.main.hasOwnProperty(key)) {
          continue;
        }

        if (key === "birth_date") {
          delete data[key];
          continue;
        }

        data[key] = vm.form.main[key];
      }

      vm.saveClientInfoRequest(vm.edit.mainInfoClientId, data)
          .then(function() {
            vm.cleanForm();
            vm.fetchClients();
          })
          .catch(vm.onRequestError);
    },

    removeSelectedClients() {
      let vm = this;
      let apiClient = apiClientCreator("client/remove");

      if (confirm("Are you sure?")) {
        this.$store.commit("clients/setLoading", true);
        apiClient
            .put("", { clients: vm.selectedClients })
            .then(function() {
              vm.selectedClients = [];
              vm.fetchClients();
              this.$store.commit("clients/setLoading", false);
            })
            .catch(() => {
              this.$store.commit("clients/setLoading", false);
            });
      }
    },

    updateCountryTimeFilter(timeRange) {
      this.filters.countryTime.from = timeRange.from;
      this.filters.countryTime.to = timeRange.to;
    },

    getAllClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/all`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.total = res.data;
          });
      /*        .catch(err => {
          this.requestNaUsersBusy = false;
        });*/
    },
    getNewClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/new`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.is_new = res.data.is_new;
            this.stats.selling_group_count = res.data.selling_group_count;
            this.stats.leading_new = res.data.leading_new;
            this.stats.loosing_new = res.data.loosing_new;
            this.stats.other_new = res.data.other_new;
            this.stats.is_leading = res.data.is_leading;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getActiveGroupClientsCountStats() {
      this.changeResesColor = true;
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/active_group`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.active_group_count = res.data;
            this.changeResesColor = false;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },
    getActiveClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/active`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.active = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getLeadingActiveClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/active_leading`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.leading_active = res.data;
          });
    },

    getRepopulatedClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/repopulated`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.btgp = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    // getAutoRemClientsCountStats() { //TODO: temp disabled backend not finished
    //   const queryParams = this.getQueryParams();
    //   apiClientCreator(`client/stats/clients/auto_rem`)
    //           .get("", { params: queryParams })
    //           .then(res => {
    //             this.stats.auto_removal = res.data;
    //           });
    //   /*        .catch(err => {
    //             this.requestNaUsersBusy = false;
    //           });*/
    // },
    //

    getDwaClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/dwa`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.dwa = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getDuplicateClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/duplicates`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.dup = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },
    getSourceDuplicateClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/dup_source`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.dup_source = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getMergedClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/merged`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.merged = res.data;
          });
      // .catch(err => {
      //    this.requestNaUsersBusy = false;
      //  });
    },

    getEndedClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/ended`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.ended = res.data;
            this.$store.commit("clients/setFilterToMain", {
              title: "end",
              type: false
            });
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getRescheduledCallsClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/ca_rescheduled`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.call_rescheduled = res.data;
          });
    },

    getScheduledCallsClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/scheduled_calls`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.scheduled_calls = res.data;
          });
    },
    getPastScheduledCallsClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/past_scheduled_calls`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.past_scheduled_calls = res.data;
          });
    },
    getCaMissedClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/ca_missed`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.ca_missed = res.data.ca_missed;
            this.stats.auto_ca_missed = res.data.auto_ca_missed;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getCaCommingClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/ca_coming`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.ca_comming = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getCaNextCallsClientsStats() {
      if (
          !localStorage.next_calls ||
          moment().diff(moment(localStorage.next_calls, moment.ISO_8601, true), "minutes") >= 5
      ) {
        localStorage.next_calls = moment().toISOString();
        const queryParams = this.getQueryParams();
        apiClientCreator(`client/stats/clients/ca_next_calls`)
            .get("", { params: queryParams })
            .then(res => {
              this.stats.next_calls = res.data;
              //this.agreeNextCalls = true;
              this.$store.commit("clients/setNextCallsStats", res.data);
              // if(res.data.length > 0){
              //   let blocks = Object.assign({},this.chartsViewBlocks)
              //     blocks[1] = "call_again";
              //     this.$store.commit('clients/setChartsViewBlocks',blocks);
              // }
              this.nextCallsTimeOut();
            });
      } else {
        this.nextCallsTimeOut();
      }
    },

    nextCallsTimeOut() {
      if (this.ncTimeOut) {
        clearTimeout(this.ncTimeOut);
      }
      this.ncTimeOut = setTimeout(() => {
        clearTimeout(this.ncTimeOut);
        this.ncTimeOut = null;
        this.getCaNextCallsClientsStats();
      }, 5 * 60 * 1000);
    },
    getCaTodayClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/ca_today`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.ca_today = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getLeadsClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/leads`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.leads = res.data["count"];
            this.stats.leads_ov = res.data["ov_count"];
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getOverallLeadsClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/leads`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.brokers_leads_stats = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getDepositsClientsCountStats() {
      const queryParams = this.getQueryParams();
      this.requestHash.deposits = this.getHashNumber();
      apiClientCreator(`client/stats/clients/deposits`)
          .get("", { params: {...queryParams,hash:this.requestHash.deposits} })
          .then(res => {
            if (this.requestHash.deposits === res.config.params.hash)
            {
              this.stats.deposits = res.data;
            }
            //this.stats.brokers_deposits_stats = res.data.brokers_deposits;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },
    getDepositsOverallCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/deposits/ov`)
          .get("", { params: queryParams })
          .then(res => {
            //this.stats.deposits = res.data.dep_count;
            this.stats.brokers_deposits_stats = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },
    getDepositsOverallCcDeclineCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/deposits/cc`)
          .get("", { params: queryParams })
          .then(res => {
            //this.stats.deposits = res.data.dep_count;
            this.stats.brokers_deposits_cc_stats = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getReferralsClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/referrals`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.referral = res.data["count"];
            this.stats.referral_ov = res.data["ov_count"];
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },
    getTransfersClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/transfers`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.transfer = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },
    getNaClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/na`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.na = res.data.na;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getNaAllClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/na/all`) //TODO:GABI: ADD BACKEND STATS COUNT
          .get("", { params: queryParams })
          .then(res => {
            this.stats.na_all_count = res.data.na_all_count;
          });
    },

    getOnlineClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/online`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.is_online = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },
    getOnlineBnClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/online/bn`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.is_online_bn = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },
    getOnlineNiClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/online/ni`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.is_online_ni = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getOnlineNaClientsCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`client/stats/clients/online/na`)
          .get("", { params: queryParams })
          .then(res => {
            this.stats.is_online_na = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getNaGroupClientsCountStats() {
      // const queryParams = this.getQueryParams();
      const qNa = this.getQueryParams();
      const qGroup = { group_assigned: [2] };
      const query = { ...qNa, ...qGroup };
      apiClientCreator(`client/stats/clients/na_group`)
          .get("", { params: query })
          .then(res => {
            this.stats.na_group_count = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },
    getBnGroupClientsCountStats() {
      //  const queryParams = this.getQueryParams();
      const qBn = this.getQueryParams();
      const qGroup = { group_assigned: [4] };
      const query = { ...qBn, ...qGroup };
      apiClientCreator(`client/stats/clients/bn_group`)
          .get("", { params: query })
          .then(res => {
            this.stats.bn_group_count = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },
    getNiGroupClientsCountStats() {
      // const queryParams = this.getQueryParams();
      const qNi = this.getQueryParams();
      const qGroup = { group_assigned: [3] };
      const query = { ...qNi, ...qGroup };
      apiClientCreator(`client/stats/clients/ni_group`)
          .get("", { params: query })
          .then(res => {
            this.stats.ni_group_count = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    getTierGroupClientsCountStats() {
      // const queryParams = this.getQueryParams();
      const qT4 = this.getQueryParams();
      const qTier = { tier: [4] };
      const query = { ...qT4, ...qTier };
      apiClientCreator(`client/stats/clients/t4`)
          .get("", { params: query })
          .then(res => {
            this.stats.tier = res.data;
          });
      /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
    },

    //////////////////////////////////////// search opts ////////////////////////////////////////

    getSearchNameCountResults() {
      if (this.CheckUserPermission([7])) {
        const queryParams = this.getQueryParams();
        apiClientCreator(`client/stats/clients/search/name`)
            .get("", { params: queryParams })
            .then(res => {
              this.stats.name_found_t4 = res.data.name_found_t4;
              this.stats.name_found_na = res.data.name_found_na_group;
              this.stats.name_found_ni = res.data.name_found_ni_group;
              this.stats.name_found_bn = res.data.name_found_bn_group;
              this.stats.name_found_end = res.data.name_found_ended_group;
              if (
                  // this.clients.length === 0 &&
                  // this.stats.name_found_t4 === 0 &&
                  // this.stats.name_found_na === 0 &&
                  // this.stats.name_found_ni === 0 &&
                  // this.stats.name_found_bn === 0 &&
                  this.stats.name_found_end === 1
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "ended"
                );
                return (this.selectedMainTab = "ended");
                // this.filters.group_assigned = false;
                // this.filters.tier = [{ id: 4 }];
                ///  this.clearPrimaryTagFilters();
                // return this.debouncedClientsQuery();
              }
            });
      }

      if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 12])) {
        const queryParams = this.getQueryParams();
        apiClientCreator(`client/stats/clients/search/name`)
            .get("", { params: queryParams })
            .then(res => {
              this.stats.name_found_t4 = res.data.name_found_t4;
              this.stats.name_found_na = res.data.name_found_na_group;
              this.stats.name_found_ni = res.data.name_found_ni_group;
              this.stats.name_found_bn = res.data.name_found_bn_group;
              this.stats.name_found_end = res.data.name_found_ended_group;
              if (
                  this.clients.length === 0 &&
                  this.stats.name_found_na === 1 &&
                  this.stats.name_found_ni === 0 &&
                  this.stats.name_found_bn === 0 &&
                  this.stats.name_found_t4 === 0 &&
                  this.stats.name_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "na"
                );
                return (this.selectedMainTab = "na");
                //  this.filters.tier = false;
                //   this.filters.group_assigned = [{ id: 2 }];
                //this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //   return this.debouncedClientsQuery();
              }
              if (
                  this.clients.length === 0 &&
                  this.stats.name_found_ni === 1 &&
                  this.stats.name_found_na === 0 &&
                  this.stats.name_found_bn === 0 &&
                  this.stats.name_found_t4 === 0 &&
                  this.stats.name_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "ni"
                );
                return (this.selectedMainTab = "ni");
                //   this.filters.tier = false;
                //    this.filters.group_assigned = [{ id: 3 }];
                //   this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //  return this.debouncedClientsQuery();
              }

              if (
                  this.clients.length === 0 &&
                  this.stats.name_found_bn === 1 &&
                  this.stats.name_found_na === 0 &&
                  this.stats.name_found_ni === 0 &&
                  this.stats.name_found_t4 === 0 &&
                  this.stats.name_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "bn"
                );
                return (this.selectedMainTab = "bn");
                //  this.filters.tier = false;
                //  this.filters.group_assigned = [{ id: 4 }];
                // this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //   return this.debouncedClientsQuery();
              }
              if (
                  this.clients.length === 0 &&
                  this.stats.name_found_t4 === 1 &&
                  this.stats.name_found_na === 0 &&
                  this.stats.name_found_ni === 0 &&
                  this.stats.name_found_bn === 0 &&
                  this.stats.name_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "t4"
                );
                return (this.selectedMainTab = "t4");
                // this.filters.group_assigned = false;
                // this.filters.tier = [{ id: 4 }];
                ///  this.clearPrimaryTagFilters();
                // return this.debouncedClientsQuery();
              }

              if (
                  this.clients.length === 0 &&
                  this.stats.name_found_t4 === 0 &&
                  this.stats.name_found_na === 0 &&
                  this.stats.name_found_ni === 0 &&
                  this.stats.name_found_bn === 0 &&
                  this.stats.name_found_end === 1
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "ended"
                );
                return (this.selectedMainTab = "ended");
                // this.filters.group_assigned = false;
                // this.filters.tier = [{ id: 4 }];
                ///  this.clearPrimaryTagFilters();
                // return this.debouncedClientsQuery();
              }

              const tempArr = [
                this.stats.name_found_t4,
                this.stats.name_found_na,
                this.stats.name_found_ni,
                this.stats.name_found_bn,
                this.stats.name_found_end
              ];
              if (this.clients.length === 0) {
                let count = 0;
                for (let i = 0; i < tempArr.length; i++) {
                  if (tempArr[i] <= 1) {
                    count++;
                  }
                }
                if (count >= 2) {
                  this.$store.commit(
                      "clients/setClientsTableSelectedMainTab",
                      "total"
                  );
                  return (this.selectedMainTab = "total");
                }
                if (count === 0) {
                  this.$store.commit(
                      "clients/setClientsTableSelectedMainTab",
                      "clients"
                  );
                  this.$store.commit("clients/setClientsTableTab", "CLIENTS");
                  return (this.selectedMainTab = "clients");
                }
              }
            });
      }
    },
    getSearchEmailCountResults() {
      if (this.CheckUserPermission([7])) {
        const queryParams = this.getQueryParams();
        apiClientCreator(`client/stats/clients/search/email`)
            .get("", { params: queryParams })
            .then(res => {
              this.stats.email_found_t4 = res.data.email_found_t4;
              this.stats.email_found_na = res.data.email_found_na_group;
              this.stats.email_found_ni = res.data.email_found_ni_group;
              this.stats.email_found_bn = res.data.email_found_bn_group;
              this.stats.email_found_end = res.data.email_found_ended_group;

              if (
                  this.clients.length === 0 &&
                  this.stats.email_found_t4 === 0 &&
                  this.stats.email_found_na === 0 &&
                  this.stats.email_found_ni === 0 &&
                  this.stats.email_found_bn === 0 &&
                  this.stats.email_found_end === 1
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "ended"
                );
                return (this.selectedMainTab = "ended");
                // this.filters.group_assigned = false;
                // this.filters.tier = [{ id: 4 }];
                ///  this.clearPrimaryTagFilters();
                // return this.debouncedClientsQuery();
              }
            });
      }

      if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 12])) {
        const queryParams = this.getQueryParams();
        apiClientCreator(`client/stats/clients/search/email`)
            .get("", { params: queryParams })
            .then(res => {
              this.stats.email_found_t4 = res.data.email_found_t4;
              this.stats.email_found_na = res.data.email_found_na_group;
              this.stats.email_found_ni = res.data.email_found_ni_group;
              this.stats.email_found_bn = res.data.email_found_bn_group;
              this.stats.email_found_end = res.data.email_found_ended_group;

              if (
                  this.clients.length === 0 &&
                  this.stats.email_found_na === 1 &&
                  this.stats.email_found_ni === 0 &&
                  this.stats.email_found_bn === 0 &&
                  this.stats.email_found_t4 === 0 &&
                  this.stats.email_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "na"
                );
                return (this.selectedMainTab = "na");
                //  this.filters.tier = false;
                //   this.filters.group_assigned = [{ id: 2 }];
                //this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //   return this.debouncedClientsQuery();
              }
              if (
                  this.clients.length === 0 &&
                  this.stats.email_found_ni === 1 &&
                  this.stats.email_found_na === 0 &&
                  this.stats.email_found_bn === 0 &&
                  this.stats.email_found_t4 === 0 &&
                  this.stats.email_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "ni"
                );
                return (this.selectedMainTab = "ni");
                //   this.filters.tier = false;
                //    this.filters.group_assigned = [{ id: 3 }];
                //   this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //  return this.debouncedClientsQuery();
              }

              if (
                  this.clients.length === 0 &&
                  this.stats.email_found_bn === 1 &&
                  this.stats.email_found_na === 0 &&
                  this.stats.email_found_ni === 0 &&
                  this.stats.email_found_t4 === 0 &&
                  this.stats.email_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "bn"
                );
                return (this.selectedMainTab = "bn");
                //  this.filters.tier = false;
                //  this.filters.group_assigned = [{ id: 4 }];
                // this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //   return this.debouncedClientsQuery();
              }
              if (
                  this.clients.length === 0 &&
                  this.stats.email_found_t4 === 1 &&
                  this.stats.email_found_na === 0 &&
                  this.stats.email_found_ni === 0 &&
                  this.stats.email_found_bn === 0 &&
                  this.stats.email_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "t4"
                );
                return (this.selectedMainTab = "t4");
                // this.filters.group_assigned = false;
                // this.filters.tier = [{ id: 4 }];
                ///  this.clearPrimaryTagFilters();
                // return this.debouncedClientsQuery();
              }

              if (
                  this.clients.length === 0 &&
                  this.stats.email_found_t4 === 0 &&
                  this.stats.email_found_na === 0 &&
                  this.stats.email_found_ni === 0 &&
                  this.stats.email_found_bn === 0 &&
                  this.stats.email_found_end === 1
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "ended"
                );
                return (this.selectedMainTab = "ended");
                // this.filters.group_assigned = false;
                // this.filters.tier = [{ id: 4 }];
                ///  this.clearPrimaryTagFilters();
                // return this.debouncedClientsQuery();
              }
              const tempArr = [
                this.stats.email_found_t4,
                this.stats.email_found_na,
                this.stats.email_found_ni,
                this.stats.email_found_bn,
                this.stats.email_found_end
              ];
              if (this.clients.length === 0) {
                let count = 0;
                for (let i = 0; i < tempArr.length; i++) {
                  if (tempArr[i] <= 1) {
                    count++;
                  }
                }
                if (count >= 2) {
                  this.$store.commit(
                      "clients/setClientsTableSelectedMainTab",
                      "total"
                  );
                  return (this.selectedMainTab = "total");
                }
                if (count === 0) {
                  this.$store.commit(
                      "clients/setClientsTableSelectedMainTab",
                      "clients"
                  );
                  this.$store.commit("clients/setClientsTableTab", "CLIENTS");
                  return (this.selectedMainTab = "clients");
                }
              }
            });
        /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
      }
    },
    getSearchPhoneCountResults() {
      if (this.CheckUserPermission([7])) {
        const queryParams = this.getQueryParams();
        apiClientCreator(`client/stats/clients/search/phone`)
            .get("", { params: queryParams })
            .then(res => {
              this.stats.phone_found_t4 = res.data.phone_found_t4;
              this.stats.phone_found_na = res.data.phone_found_na_group;
              this.stats.phone_found_ni = res.data.phone_found_ni_group;
              this.stats.phone_found_bn = res.data.phone_found_bn_group;
              this.stats.phone_found_end = res.data.phone_found_ended_group;
              if (
                  this.clients.length === 0 &&
                  this.stats.phone_found_ni === 0 &&
                  this.stats.phone_found_na === 0 &&
                  this.stats.phone_found_bn === 0 &&
                  this.stats.phone_found_t4 === 0 &&
                  this.stats.phone_found_end === 1
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "ended"
                );
                return (this.selectedMainTab = "ended");
              }
            });
      }

      if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 12])) {
        const queryParams = this.getQueryParams();
        apiClientCreator(`client/stats/clients/search/phone`)
            .get("", { params: queryParams })
            .then(res => {
              this.stats.phone_found_t4 = res.data.phone_found_t4;
              this.stats.phone_found_na = res.data.phone_found_na_group;
              this.stats.phone_found_ni = res.data.phone_found_ni_group;
              this.stats.phone_found_bn = res.data.phone_found_bn_group;
              this.stats.phone_found_end = res.data.phone_found_ended_group;

              if (
                  this.clients.length === 0 &&
                  this.stats.phone_found_na === 1 &&
                  this.stats.phone_found_ni === 0 &&
                  this.stats.phone_found_bn === 0 &&
                  this.stats.phone_found_t4 === 0 &&
                  this.stats.phone_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "na"
                );
                return (this.selectedMainTab = "na");
                //  this.filters.tier = false;
                //   this.filters.group_assigned = [{ id: 2 }];
                //this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //   return this.debouncedClientsQuery();
              }
              if (
                  this.clients.length === 0 &&
                  this.stats.phone_found_ni === 1 &&
                  this.stats.phone_found_na === 0 &&
                  this.stats.phone_found_bn === 0 &&
                  this.stats.phone_found_t4 === 0 &&
                  this.stats.phone_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "ni"
                );
                return (this.selectedMainTab = "ni");
                //   this.filters.tier = false;
                //    this.filters.group_assigned = [{ id: 3 }];
                //   this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //  return this.debouncedClientsQuery();
              }
              if (
                  this.clients.length === 0 &&
                  this.stats.phone_found_ni === 0 &&
                  this.stats.phone_found_na === 0 &&
                  this.stats.phone_found_bn === 0 &&
                  this.stats.phone_found_t4 === 0 &&
                  this.stats.phone_found_end === 1
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "ended"
                );
                return (this.selectedMainTab = "ended");
              }

              if (
                  this.clients.length === 0 &&
                  this.stats.phone_found_bn === 1 &&
                  this.stats.phone_found_na === 0 &&
                  this.stats.phone_found_ni === 0 &&
                  this.stats.phone_found_t4 === 0 &&
                  this.stats.phone_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "bn"
                );
                return (this.selectedMainTab = "bn");
                //  this.filters.tier = false;
                //  this.filters.group_assigned = [{ id: 4 }];
                // this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //   return this.debouncedClientsQuery();
              }
              if (
                  this.clients.length === 0 &&
                  this.stats.phone_found_t4 === 1 &&
                  this.stats.phone_found_na === 0 &&
                  this.stats.phone_found_ni === 0 &&
                  this.stats.phone_found_bn === 0 &&
                  this.stats.phone_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "t4"
                );
                return (this.selectedMainTab = "t4");
                // this.filters.group_assigned = false;
                // this.filters.tier = [{ id: 4 }];
                ///  this.clearPrimaryTagFilters();
                // return this.debouncedClientsQuery();
              }
              const tempArr = [
                this.stats.phone_found_t4,
                this.stats.phone_found_na,
                this.stats.phone_found_ni,
                this.stats.phone_found_bn,
                this.stats.phone_found_end
              ];
              if (this.clients.length === 0) {
                let count = 0;
                for (let i = 0; i < tempArr.length; i++) {
                  if (tempArr[i] <= 1) {
                    count++;
                  }
                }
                if (count >= 2) {
                  this.$store.commit(
                      "clients/setClientsTableSelectedMainTab",
                      "total"
                  );
                  return (this.selectedMainTab = "total");
                }
                if (count === 0) {
                  this.$store.commit(
                      "clients/setClientsTableSelectedMainTab",
                      "clients"
                  );
                  this.$store.commit("clients/setClientsTableTab", "CLIENTS");
                  return (this.selectedMainTab = "clients");
                }
              }
            });

        /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
      }
    },
    getSearchIdCountResults() {
      if (this.CheckUserPermission([7])) {
        const queryParams = this.getQueryParams();
        apiClientCreator(`client/stats/clients/search/id`)
            .get("", { params: queryParams })
            .then(res => {
              this.stats.id_found_t4 = res.data.id_found_t4;
              this.stats.id_found_na = res.data.id_found_na_group;
              this.stats.id_found_ni = res.data.id_found_ni_group;
              this.stats.id_found_bn = res.data.id_found_bn_group;
              this.stats.id_found_end = res.data.id_found_ended_group;

              if (
                  // this.clients.length === 0 &&
                  // this.stats.id_found_ni === 0 &&
                  // this.stats.id_found_na === 0 &&
                  // this.stats.id_found_bn === 0 &&
                  // this.stats.id_found_t4 === 0 &&
                  this.stats.id_found_end === 1
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "ended"
                );
                return (this.selectedMainTab = "ended");
                //   this.filters.tier = false;
                //    this.filters.group_assigned = [{ id: 3 }];
                //   this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //  return this.debouncedClientsQuery();
              }
            });
      }

      if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 12])) {
        const queryParams = this.getQueryParams();
        apiClientCreator(`client/stats/clients/search/id`)
            .get("", { params: queryParams })
            .then(res => {
              this.stats.id_found_t4 = res.data.id_found_t4;
              this.stats.id_found_na = res.data.id_found_na_group;
              this.stats.id_found_ni = res.data.id_found_ni_group;
              this.stats.id_found_bn = res.data.id_found_bn_group;
              this.stats.id_found_end = res.data.id_found_ended_group;
              if (
                  this.clients.length === 0 &&
                  this.stats.id_found_na === 1 &&
                  this.stats.id_found_ni === 0 &&
                  this.stats.id_found_bn === 0 &&
                  this.stats.id_found_t4 === 0 &&
                  this.stats.id_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "na"
                );
                return (this.selectedMainTab = "na");
                //  this.filters.tier = false;
                //   this.filters.group_assigned = [{ id: 2 }];
                //this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //   return this.debouncedClientsQuery();
              }
              if (
                  this.clients.length === 0 &&
                  this.stats.id_found_ni === 1 &&
                  this.stats.id_found_na === 0 &&
                  this.stats.id_found_bn === 0 &&
                  this.stats.id_found_t4 === 0 &&
                  this.stats.id_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "ni"
                );
                return (this.selectedMainTab = "ni");
                //   this.filters.tier = false;
                //    this.filters.group_assigned = [{ id: 3 }];
                //   this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //  return this.debouncedClientsQuery();
              }

              if (
                  this.clients.length === 0 &&
                  this.stats.id_found_ni === 0 &&
                  this.stats.id_found_na === 0 &&
                  this.stats.id_found_bn === 0 &&
                  this.stats.id_found_t4 === 0 &&
                  this.stats.id_found_end === 1
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "ended"
                );
                return (this.selectedMainTab = "ended");
                //   this.filters.tier = false;
                //    this.filters.group_assigned = [{ id: 3 }];
                //   this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //  return this.debouncedClientsQuery();
              }

              if (
                  this.clients.length === 0 &&
                  this.stats.id_found_bn === 1 &&
                  this.stats.id_found_na === 0 &&
                  this.stats.id_found_ni === 0 &&
                  this.stats.id_found_t4 === 0 &&
                  this.stats.id_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "bn"
                );
                return (this.selectedMainTab = "bn");
                //  this.filters.tier = false;
                //  this.filters.group_assigned = [{ id: 4 }];
                // this.clearPrimaryTagFilters();
                // this.openNiGroupMenu = true
                //   return this.debouncedClientsQuery();
              }
              if (
                  this.clients.length === 0 &&
                  this.stats.id_found_t4 === 1 &&
                  this.stats.id_found_na === 0 &&
                  this.stats.id_found_ni === 0 &&
                  this.stats.id_found_bn === 0 &&
                  this.stats.id_found_end === 0
              ) {
                this.$store.commit(
                    "clients/setClientsTableSelectedMainTab",
                    "t4"
                );
                return (this.selectedMainTab = "t4");
                // this.filters.group_assigned = false;
                // this.filters.tier = [{ id: 4 }];
                ///  this.clearPrimaryTagFilters();
                // return this.debouncedClientsQuery();
              }
              const tempArr = [
                this.stats.id_found_t4,
                this.stats.id_found_na,
                this.stats.id_found_ni,
                this.stats.id_found_bn,
                this.stats.id_found_end
              ];
              if (this.clients.length === 0) {
                let count = 0;
                for (let i = 0; i < tempArr.length; i++) {
                  if (tempArr[i] <= 1) {
                    count++;
                  }
                }
                if (count >= 2) {
                  this.$store.commit(
                      "clients/setClientsTableSelectedMainTab",
                      "total"
                  );
                  return (this.selectedMainTab = "total");
                }
                if (count === 0) {
                  this.$store.commit(
                      "clients/setClientsTableSelectedMainTab",
                      "clients"
                  );
                  this.$store.commit("clients/setClientsTableTab", "CLIENTS");
                  return (this.selectedMainTab = "clients");
                }
              }
            });
        /*        .catch(err => {
                this.requestNaUsersBusy = false;
              });*/
      }
    },

    getCostTabTotals() {
      if (this.CheckUserPermission([1, 2, 3, 12])) {
        const queryParams = this.getQueryParams();
        apiClientCreator(`client/stats/costs`)
            .get("", { params: queryParams })
            .then(res => {
              this.stats.cost_totals = res.data;
            });
      }
    },
    updateFnMenuStats() {
      this.getMergedClientsCountStats();
      this.getRepopulatedClientsCountStats();
      this.getDuplicateClientsCountStats();
      this.getSourceDuplicateClientsCountStats();
    },
    updateFnMenuStatsForNew() {
      this.openNewFilteringDates = true;
      //////this.dateHasentBeenChooseed(); todo: removed 18-01-21
    },

    updateStats() {
      this.$store.commit("clients/setStopProcess", false);
      // if (this.filters.btgp && !this.openProcessMenu) {
      //   this.getRepopulatedClientsCountStats();
      // }

      // if (this.filters.dup && !this.openProcessMenu) {
      //   this.getDuplicateClientsCountStats();
      // }
      // if (this.filters.dup_source && !this.openProcessMenu) {
      //   this.getSourceDuplicateClientsCountStats();
      // }

      if (this.openProcessMenu) {
        //   this.updateFnMenuStats();
      }

      //this.getNewClientsCountStats();

      //   this.getAllClientsCountStats();
      // this.getOnlineClientsCountStats();
      if (
          this.filters.group_assigned === false &&
          this.filters.tier === false
      ) {
      }

      if (
          this.filters.deposit_at !== false ||
          this.filters.hours_at !== false ||
          this.filters.registered_on !== false ||
          this.filters.last_modified !== false ||
          this.filters.last_transfer !== false ||
          this.filters.last_referral !== false ||
          this.filters.scheduled_call_to !== false ||
          this.filters.assigned_at !== false ||
          this.filters.support_at !== false ||
          this.filters.last_modified_leads !== false ||
          this.filters.last_modified_na !== false
      ) {
        //this.getScheduledCallsClientsCountStats();
        // this.getLeadsClientsCountStats();
        // this.getReferralsClientsCountStats();
        // this.getTransfersClientsCountStats();
        // this.getNaClientsCountStats();
        // this.getDepositsClientsCountStats();
        // this.getDepositsOverallCcDeclineCountStats();
        // this.getDepositsOverallCountStats();
        // this.getNaClientsCountStats();

        if (this.selectedTab === "cost") {
          //    this.getCostTabTotals();
        }
      } else {
        // this.stats.cost_totals = {
        //   total_cpl_tab: 0,
        //   total_cpl: 0,
        //   total_sms: 0,
        //   total_phone: 0,
        //   total: 0
        // };

        if (this.filters.referral) {
          //  this.getReferralsClientsCountStats();
        }
        if (this.filters.transfer) {
          //  this.getTransfersClientsCountStats();
        }

        if (this.filters.na) {
          // this.getNaClientsCountStats();
        }
      }

      // if (
      //   this.filters.is_new ||
      //   this.filters.selling_group ||
      //   this.filters.leading_new ||
      //   this.filters.loosing_new ||
      //   this.filters.other_new
      // ) {
      //   this.getNewClientsCountStats();
      // }

      if (this.filters.active) {
        //  this.getActiveClientsCountStats();
      }

      if (this.filters.is_leading) {
        // this.getLeadingActiveClientsCountStats();
      }

      // if (this.filters.last_modified_leads || this.filters.leads) {
      //   this.getLeadsClientsCountStats();
      // }

      /**
       * Start - New Section 30/12/20
       */

      if (this.openProcessMenu) {
        this.updateFnMenuStats();
      }

      if (this.selectedTab === "cost") {
        this.getCostTabTotals();
      } else {
        this.stats.cost_totals = {
          total_cpl_tab: 0,
          total_cpl: 0,
          total_sms: 0,
          total_phone: 0,
          total: 0
        };
      }

      this.getAllClientsCountStats();
      this.getOnlineClientsCountStats();
      this.getTransfersClientsCountStats();

      this.getNaClientsCountStats();
      this.getNaAllClientsCountStats();

      if (
          this.selectedMainTab === "clients" ||
          this.selectedMainTab === "total"
      ) {
        /// this.getActiveClientsCountStats(); TODO: ??? DO IT NEEDED
        this.getRescheduledCallsClientsCountStats(); // NEW TODO: ADDED 22-01-21
        this.getScheduledCallsClientsCountStats();
        this.getPastScheduledCallsClientsCountStats();
        this.getCaMissedClientsCountStats();
        this.getCaCommingClientsCountStats();
        // this.getCaNextCallsClientsStats();
        this.getCaTodayClientsCountStats();
        this.getNewClientsCountStats();

        this.getLeadsClientsCountStats();
        this.getReferralsClientsCountStats();
        this.getDepositsClientsCountStats();
        this.getDepositsOverallCcDeclineCountStats();
        this.getDepositsOverallCountStats();

        // this.getLeadingActiveClientsCountStats();
      }

      this.getAllStats();

      /**
       * End - New Section 30/12/20
       */
    },

    getAllStats() {
      if (this.clientsTableCalendarSubMenuOpened) {
        this.getActiveGroupClientsCountStats();
        this.getEndedClientsCountStats();

        // this.getDwaClientsCountStats(); || TODO: canceled 22/12/20
        //this.getNewClientsCountStats();
        if (this.CheckUserPermission([1, 2, 3, 4, 5, 12])) {
          // if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 8, 12])) {
          // this.getNewClientsCountStats();
          this.getLeadingActiveClientsCountStats();
          // this.getEndedClientsCountStats();
          this.getMergedClientsCountStats();
          this.getNaGroupClientsCountStats();
          this.getBnGroupClientsCountStats();
          this.getNiGroupClientsCountStats();
          this.getTierGroupClientsCountStats();
        }
      } else {
        if (this.CheckUserPermission([1, 2, 3, 4, 5, 12])) {
          // if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 8, 12])) {
          switch (this.clientsTableSelectedMainTab) {
            case "clients":
              this.getActiveGroupClientsCountStats();
              break;
            case "na":
              this.getNaGroupClientsCountStats();
              break;
            case "ni":
              this.getNiGroupClientsCountStats();
              break;
            case "bn":
              this.getBnGroupClientsCountStats();
              break;
            case "t4":
              this.getTierGroupClientsCountStats();
              break;
            case "ended":
              this.getEndedClientsCountStats();
              break;
            case "merged":
              this.getMergedClientsCountStats();
              break;
            case "total":
              this.getActiveGroupClientsCountStats();
              this.getLeadingActiveClientsCountStats();
              this.getEndedClientsCountStats();
              this.getMergedClientsCountStats();
              this.getNaGroupClientsCountStats();
              this.getBnGroupClientsCountStats();
              this.getNiGroupClientsCountStats();
              this.getTierGroupClientsCountStats();
              break;
          }
        } else {
          this.clientsTableSelectedMainTab === "clients"
              ? this.getActiveGroupClientsCountStats()
              : this.clientsTableSelectedMainTab === "ended"
              ? this.getEndedClientsCountStats()
              : "";
        }
      }
      // this.getActiveGroupClientsCountStats();
      // // this.getDwaClientsCountStats(); || TODO: canceled 22/12/20
      // //this.getNewClientsCountStats();
      // if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 8, 12])) {
      //   // this.getNewClientsCountStats();
      //   this.getLeadingActiveClientsCountStats();
      //   this.getEndedClientsCountStats();
      //   this.getMergedClientsCountStats();
      //   this.getNaGroupClientsCountStats();
      //   this.getBnGroupClientsCountStats();
      //   this.getNiGroupClientsCountStats();
      //   this.getTierGroupClientsCountStats();
      // }
    },

    changeTopTagInfo() {
      if (this.filters.is_new) {
        this.selectedTag.name = "New";
        this.selectedTag.stats = this.stats.is_new;
      }
      if (this.filters.active) {
        this.selectedTag.name = "Active";
        this.selectedTag.stats = this.stats.active;
      }
      if (this.filters.scheduled_calls) {
        this.selectedTag.name = "Scheduled Calls";
        this.selectedTag.stats = this.stats.scheduled_calls;
      }
      if (this.filters.na) {
        this.selectedTag.name = "No Answer";
        this.selectedTag.stats = this.stats.na;
      }
      if (this.filters.transfer) {
        this.selectedTag.name = "Transfers";
        this.selectedTag.stats = this.stats.transfer;
      }
      if (this.filters.referral) {
        this.selectedTag.name = "Referrals";
        this.selectedTag.stats = this.stats.referral;
      }
      if (this.filters.leads) {
        this.selectedTag.name = "Leads";
        this.selectedTag.stats = this.stats.leads;
      }
      if (this.filters.deposit) {
        this.selectedTag.name = "Deposits";
        this.selectedTag.stats = this.stats.deposits;
      }
      if (this.filters.waiting) {
        this.selectedTag.name = "Waiting";
        this.selectedTag.stats = this.stats.waiting;
      }
      if (this.filters.ended) {
        this.selectedTag.name = "Ended";
        this.selectedTag.stats = this.stats.ended;
      }
      if (this.startUpAllTagFilter) {
        this.selectedTag.name = false;
      }
    },

    filterFunction(userInput) {
      return this.FilterNonActiveUsers().filter(function(broker) {
        userInput = userInput.trim();
        userInput = userInput.toLowerCase();
        let afterRegex = userInput.replace(/[.*+\-?^${}()|[\]\\]/g, "");
        return broker.full_name.toLowerCase().includes(afterRegex);
      });
    },

    async getSuggestedUsers(client) {

      try {

        this.suggestedUsers = [];
        this.unSuggestedUsers = [];
        this.clientToSuggest = client;
        this.uniqueUsers = this.salesPersonList;


        const res = await apiClientCreator(
            `reports/campaigns/performance/suggested`
        ).post("", { data: client });
        let keys = Object.keys(res.data);
        this.uniqueUsers = [];
        for (let i = 0; i < this.salesPersonList.length - 1; i++) {
          if (!keys.includes(this.salesPersonList[i].id.toString())) {
            this.uniqueUsers.push(this.salesPersonList[i]);
          }
        }
        this.suggestedUsers = keys.sort(function(a, b) {
          return res.data[b] - res.data[a];
        });
        let suggested = [];
        let unSuggested = [];
        for (let key in keys) {
          let user = {};
          user["score"] = res.data[this.suggestedUsers[key]];
          user["data"] = this.salesPersonList.find(
              item => item.id === parseInt(this.suggestedUsers[key])
          );
          if (user["score"] > 0) {
            suggested.push(user);
          } else {
            unSuggested.push(user);
          }
        }
        this.suggestedUsers = suggested;
        this.unSuggestedUsers = unSuggested;
      } catch (e) {
        this.suggestedUsers = [];
        this.unSuggestedUsers = [];
        this.uniqueUsers = this.salesPersonList;
      }
    },

    getHashNumber(){
      return Math.floor(Math.random() * 10000) + 1;

    }
  }
};

function getClientQueryObject(clientInput) {
  /** search by ID */
  let searchIdPattern = new RegExp("^#[1-9]+[0-9]*$");

  if (searchIdPattern.test(clientInput)) {
    return {
      id: parseInt(clientInput.replace("#", ""))
    };
  }

  /** search by age */
  let searchAgePattern = new RegExp("^[1-9]+[0-9]*yo$");

  if (searchAgePattern.test(clientInput)) {
    return {
      age: parseInt(clientInput.replace("yo", ""))
    };
  }

  /** search by fullName */
  let searchNamePattern = new RegExp(/^[a-z _]{3,}$/i);

  if (searchNamePattern.test(clientInput)) {
    return {
      full_name: clientInput
    };
  }

  /*  let searchLangPattern = new RegExp(/^@[a-z]{3,}$/i);

  if (searchLangPattern.test(clientInput)) {
    return {
      language: clientInput
    };
  }*/
}
</script>

<style lang="scss" scoped>
.loader {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 25%;
  text-align: center;
  font-size: 18px;
  /*z-index: 9999;*/
  opacity: 0.7;
}
input[type="search"]:focus {
  outline: none !important;
}
.loaderNewV {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 25%;
  text-align: center;
  font-size: 18px;
  /*z-index: 9999;*/
  opacity: 0.7;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: spin 2s linear infinite;
  top: 2px;
  right: 2px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading {
  opacity: 0.5;
}

.table th {
  vertical-align: middle;
}

th.th-sm,
td.th-sm {
  width: 10%;
}

th.th-md,
td.th-md {
  width: 12.5%;
}

th.th-trio,
td.th-trio {
  width: 17%;
}

th.th-half,
td.th-sm {
  width: 43%;
}

th.th-status,
td.th-sm {
  width: 51%;
  padding-top: 12px;
}

th.th-question-add-tag,
td.th-question-add-tag {
  width: 1.4%;
}
th.th-question-11,
td.th-question-11 {
  /*width: 10%;*/
  width: 12.5%;
  font-size: 9pt;
}

th.th-question-1,
td.th-question-1 {
  /*width: 10%;*/
  width: 12.5%;
  font-size: 9pt;
}

th.th-question-2,
td.th-question-2 {
  /*width: 10%;*/
  width: 12.5%;
  font-size: 9pt;
}

th.th-question-3,
td.th-question-3 {
  /*width: 10%;*/
  width: 12.5%;

  font-size: 9pt;
}

th.th-question-4,
td.th-question-4 {
  /*width: 10%;*/
  width: 12.5%;

  font-size: 9pt;
}

th.th-question-5,
td.th-question-5 {
  /*width: 10%;*/
  width: 12.5%;

  font-size: 9pt;
}

th.th-question-6,
td.th-question-6 {
  /*width: 10%;*/
  width: 12.5%;

  font-size: 9pt;
}

th.th-question-7,
td.th-question-7 {
  /*width: 10%;*/
  width: 12.5%;

  font-size: 9pt;
}

th.th-question-8,
td.th-question-8 {
  /*width: 10%;*/
  width: 12.5%;
  font-size: 9pt;
}

th.th-question-9,
td.th-question-9 {
  /*width: 10%;*/
  width: 12.5%;
  font-size: 9pt;
}

th.th-question-10,
td.th-question-10 {
  /*width: 10%;*/
  width: 12.5%;

  font-size: 9pt;
}

th.th-question-status,
td.th-question-status {
  /*width: 12.5%;*/
  min-width: 231px !important;
  max-width: 231px !important;
  font-size: 9pt;
}

th.th-date,
td.th-date {
  width: 8%;
  text-align: center;
  vertical-align: center;
}

th.th-kyword,
td.th-kyword {
  width: 15%;
  text-align: center;
}

th.th-device,
td.th-device {
  width: 8%;
}

th.th-campaign-id,
td.th-campaign-id {
  width: 11.5%;
}

th.th-click-on-site,
td.th-click-on-site {
  width: 11%;
}

th.th-loc-phys,
td.th-loc-phys {
  width: 19%;
}

th.th-ip,
td.th-ip {
  width: 7%;
}

th.th-placement,
td.th-placement {
  width: 12%;
}

th.th-clicks,
td.th-clicks {
  width: 3.344444444444444%;
  font-size: 11px;
  font-weight: normal;
}

th.th-name,
td.th-name {
  /*width: 12%;*/
  max-width: 225px !important;
  min-width: 225px !important;
}

th.th-pagination,
td.th-pagination {
  width: 13%;
}

th.th-phones,
td.th-phones {
  /*width: 11%;*/
  max-width: 213px !important;
  min-width: 213px !important;
}

th.th-emails,
td.th-emails {
  width: 10%;
  max-width: 210px !important;
  min-width: 210px !important;
}

th.th-country,
td.th-country {
  /*width: 4%;*/
  /*max-width: 92px !important;*/
}

th.th-assigned-to,
td.th-assigned-to {
  /*width: 8%;*/
  /*width: 10.5%;*/
  max-width: 196px !important;
  min-width: 196px !important;
}

th.td-xl,
td.td-xl {
  width: 50%;
}

th.th-total,
td.th-total {
  /*width: 14.37%;*/
  width: 12.875%;
  text-align: center;
  font-weight: normal;
  font-size: 13px;
  text-transform: uppercase;
}

th.th-cpl,
td.th-cpl {
  /*width: 14.25%;*/
  width: 12.875%;

  text-align: center;
  font-weight: normal;
  font-size: 13px;
  text-transform: uppercase;
}

th.th-phone-cost,
td.th-phone-cost {
  /*width: 14.25%;*/
  width: 12.875%;

  text-align: center;
  font-weight: normal;
  font-size: 13px;
  text-transform: uppercase;
}

th.th-sms-cost,
td.th-sms-cost {
  /*width: 14.25%;*/
  width: 12.875%;

  text-align: center;
  font-weight: normal;
  font-size: 13px;
}

td.td-costs {
  text-align: center !important;
  font-size: 13px;
}

td.td-signals {
  text-align: center;
}

th.th-signals1,
td.th-signals1 {
  width: 4.1%;
  text-align: center;
}

th.th-signals2,
td.th-signals2 {
  width: 5.2%;
  text-align: center;
}

th.th-signals3,
td.th-signals3 {
  width: 3.1%;
  text-align: center;
}

th.th-signals4,
td.th-signals4 {
  width: 7.1%;
  text-align: center;
}

th.th-signals5,
td.th-signals5 {
  width: 3.1%;
  text-align: center;
}

th.th-signals6,
td.th-signals6 {
  width: 3.1%;
  text-align: center;
}

th.th-signals7,
td.th-signals7 {
  width: 2.1%;
  text-align: center;
}

th.th-signals8,
td.th-signals8 {
  width: 3.1%;
  text-align: center;
}

th.th-signals9,
td.th-signals9 {
  width: 3.1%;
  text-align: center;
}

th.th-signals10,
td.th-signals10 {
  width: 3.1%;
  text-align: center;
}

th.th-signals11,
td.th-signals11 {
  width: 3.1%;
  text-align: center;
}

th.th-signals11,
td.th-signals11 {
  width: 3.1%;
  text-align: center;
}

.td-camp-date {
  font-size: 13px;
  padding-top: 11.5px;
  tetixt-align: center !important;
}

.span-camp-date {
  margin-top: 4px !important;
  cursor: pointer;
  padding: 2px;
  font-size: 11px;
  white-space: nowrap;
}

.span-camp-date:hover {
  background: #44a2d2;
  /*font-weight: bold;*/
  color: white;
}

.td-camp {
  font-size: 13px;
  text-align: center;
}

.td-traffic {
}

.traffic-light {
  margin-right: 20px;
}

.span-th-date {
  font-size: 11px;
  font-weight: normal;
}

.filter-phones {
  /*  margin-left: -7px;*/
  /*  margin-right: 3px;*/
  display: flex;
}

.filter-emails {
  /*margin-right: 7px;*/
  /*  margin-left: -3px;*/
  position: relative;
}

.filter-multiselect {
  display: flex;
}

.filter-assigned-datapicker {
  margin-left: 5px;
  margin-top: -5px;
}

.main-table {
  margin-bottom: 0px;
  background-color: white;
  font-family: "Montserrat";
  min-height: 418px;
}
.main-table-with-scroller {
  /*width: 99%;*/
  border-radius: 12px;
  //padding-right: 12px;
  //padding-left: 12px;
  //padding-right: 12px;
  //padding-bottom: 12px;
  padding-left: 12px;
}
.selected-client-hover {
  background-color: #eceff1 ;
}
.selected-odd-client-hover {
  background-color: #eceff5 !important;
}

.main-table > tbody > tr::selection,
.selected-client {
  background-color: #cfd8dc !important; ;
}
.selected-client:hover{
  background-color: #afcedc  !important;
}

.main-table td {
  border-color: #cfd8dc;
  padding-bottom: 1px;
  text-align: left;
}

.tr-hover-override :hover {
  background-color: #eceff1;
}

.tr-info {
  border-top-width: thin;
  border-left-width: thin;
  border-right-width: thin;
}

.contact {
  font-weight: 100;
}

.contact-phone a {
  color: #00a700;
}

.contact-email a {
  color: #1a8fd2;
}

.primary-contact {
  font-weight: 400;
}

.status-filters {
  padding-top: 5px;
}

.tag-new {
  background-color: #1cdb42;
  color: #fff;
  font-weight: 500;
  margin: 2px;
  font-family: "Montserrat" !important;
  border-right: 0 !important;
}

.tag-active {
  background-color: #0fb97b;
  font-weight: 500;
  margin: 2px;
  font-family: "Montserrat" !important;
  border-right: 0 !important;
}

.tag-not-interested {
  background-color: #657171;
  margin: 3px;
  font-weight: 500;
  font-family: "Montserrat" !important;
  border-right: 0 !important;
  text-transform: uppercase;
}

.tag-na {
  background-color: #8e1cdb;
  margin: 2px;
  font-weight: 500;
  font-family: "Montserrat" !important;
  border-right: 0 !important;
}

.tag-scheduled-call {
  background-color: #e3ca0b;
  margin: 2px;
  font-weight: 500;
  font-family: "Montserrat" !important;
  border-right: 0 !important;
}

.tag-lead {
  background-color: #1144bc;
  margin: 2px;
  font-weight: 500;
  font-family: "Montserrat" !important;
  border-right: 0 !important;
}

.tag-deposit {
  background-color: #159e52;
  margin: 2px;
  font-weight: 500;
  font-family: "Montserrat" !important;
  border-right: 0 !important;
}

.main {
  background-color: #cfd8dc;
}

.status-main {
  display: flex;
  /*padding-left: 40px;*/
  /*padding-left: 24px;*/
}

.status-tags {
  /*margin-top: 0px;*/
  margin-top: -12px;
  display: flex;
  margin-right: -80px;
  padding-top: 12px;
  //padding-right: 12px;
  //padding-left: 12px;
  border-radius: 12px;
}

.status-reg-date-picker {
  margin-top: -5px;
  margin-left: 4px;
  position: relative;
}

.status-dep-date-picker {
  margin-top: -5px;
}

.status-lead-select {
  margin-right: 10px;
  max-width: 128px;
}

.status-multiselect-deposit {
  max-width: 125px;
}

.status-deposit-input {
  margin-left: 10px;

  margin-right: -30px;
}

.status-label-top {
  float: left;
  color: #212121;
}

.status-phones {
}

.status-emails {
}

.multiselect.invalid .multiselect__tags,
.multiselect.invalid .multiselect__tags span,
.multiselect.invalid .multiselect__tags input {
  background: red;
}

.client-details-checkbox {
  /*<!--margin-left: 0.8rem;-->*/
  /*<!--!*margin-right: 0.5rem;*!-->*/
  /*<!--margin-top: 1.5rem;-->*/
  /*<!--transform: translateY(-50%) translateX(-50%);-->*/
  /*<!--font-weight: 100 !important;-->*/
  margin-left: 0.6rem;
  margin-right: 0.2rem;
  margin-top: 1.5rem;
  -webkit-transform: translateY(-50%) translateX(-50%);
}

.client-details-sorting {
  margin-left: 5px;
}

/*.name-input {*/
/*  font-family: "Montserrat" !important;*/
/*  margin-left: 8px;*/
/*  width: 100%;*/
/*  position: relative;*/
/*  display: inline-block;*/
/*  padding: 4px 4px 4px 10px;*/
/*  //border-radius: 4px;*/
/*  border: 0;*/
/*  background: #f5f7ff;*/
/*  height: 30px;*/
/*  overflow: hidden;*/
/*  max-width: 100%;*/
/*  text-overflow: ellipsis;*/
/*  font-size: 11px;*/
/*  -webkit-appearance: none;*/
/*  -moz-appearance: none;*/
/*  -o-appearance: none;*/
/*  box-sizing: border-box;*/
/*  text-transform: capitalize;*/
/*  font-weight: normal;*/
/*}*/
::placeholder {
  //font-weight: 800 !important;
  color: #546e7a !important;
}
.name-input {
  font-family: "Montserrat" !important;
  margin-left: 2px;
  width: 90%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  //border-radius: 4px;

  //background: #f5f7ff;
  height: 30px;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
  text-transform: capitalize;
  font-weight: normal;
  //background: #f5f7ff;
  border-radius: 4px;
  //font-weight: 600;
  border: 1px solid #d7d7d7;
}

.input-new-calendar {
  border-color: transparent;
  width: 110px;
  margin-top: -2px;
}

.calendar-expend {
  margin-left: 4px;
  width: 150px;
  position: absolute;
  display: inline-block;
  padding: 5px 4px 5px 5px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
}

.input-new-calendar-div {
  margin-left: 4px;
  width: 30px;
  position: absolute;
  display: inline-block;
  padding: 4px 5px 3px 6px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
}

.input-new-calendar-div-ico {
  height: 16px;
  float: right;

  cursor: pointer;
}

.input-new-calendar-div-ico-closed {
  height: 16px;
  cursor: pointer;
}

.input-standard {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  //border-radius: 4px;
  border: 0.1px solid #fff4f4;

  height: 30px;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
  box-sizing: border-box;
  font-weight: normal;
}

.select-standard {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-weight: bold;
  font-size: 8pt;
  box-sizing: border-box;
}

.opt-standard {
  font-weight: bold;
}

.input-firstname {
  width: 37%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
}

.input-lastname {
  width: 37%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
  margin-left: 5px;
}

.input-phone-prefix {
  width: 30%;
  position: relative;

  padding: 1px 1px 1px 6px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
  float: left;
}

.new-client-birthdate {
  float: right;
  margin-right: 15px;
  margin-top: -5px;
}

.input-phone {
  width: 65%;
  position: relative;
  float: right;
  padding: 1px 1px 1px 6px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
}

.keyword-input {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
  /*  background: url(../../../../../assets/svg_icons/keyword-research.svg)
    no-repeat right #fff;
  background-size: 18px;
  background-position: 97% 3px;*/
}

.deposit-input {
  width: 70%;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
  /*  background: url(../../../../../assets/svg_icons/coin.svg) no-repeat right #fff;
  background-size: 20px;
  background-position: 97% 4px;*/
}

.click-select {
  width: 90%;
  height: 30px;
  position: relative;
  display: inline-block;
  border-radius: 5px;
  color: black;
  background: #fff;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 10pt;
  /*  background: url(../../../../../assets/svg_icons/cursor.svg) no-repeat right
    #fff;
  background-size: 18px;
  background-position: 95% 3px;*/
}

.time-select {
  cursor: pointer;
  margin-left: 5px;
  width: 0px;
  height: 30px;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  color: black;
  //background: #fff;
  margin-bottom: 5px;
  max-width: 100%;
  font-size: 10pt;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  background: url(../../../../../assets/svg_icons/clock-circular-outline.svg)
  no-repeat right #d7d7d7;
  background-size: 18px;
  background-position: 50% 4px;
}

/*.time-select:hover{
background:#CFD8DC;
}*/

.time-select-highlight {
  border-color: #4fc3f7;
  border-style: solid;
  border-width: 2px;
}

.clock {
  float: right;
  margin-top: -30px;
  margin-right: 5px;
  pointer-events: none;
  background-color: #fff;
  padding-right: 5px;
}

.floating-birthdate-text {
  position: absolute;
  bottom: 35px;
  right: -6px;
  width: max-content;
  z-index: 10001;
  padding: 5px;
  font-size: 8pt;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  font-weight: bold;
}

.floating-question-text {
  position: absolute;
  bottom: 35px;
  right: 0px;
  width: max-content;
  z-index: 10001;
  padding: 5px;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: Montserrat !important;
  font-weight: bold;
  font-size: 12px;
}
.floating-process-switcher-for-new {
  position: absolute;
  top: 321px;
  right: 785px;
  width: 82px;
  z-index: 10001;
  padding: 5px;
  padding-top: 5px;
  background-color: white;
  font-size: 8pt;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: Montserrat !important;
}
.floating-process-switcher {
  position: absolute;
  top: 38px;
  left: -15px;
  /*width: 99px;*/
  /*width: 134%;*/
  z-index: 10001;
  padding: 5px;
  font-size: 8pt;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: Montserrat !important;
  border-radius: 5px;
}

.floating-process-dup-switcher {
  position: absolute;
  top: 125px;
  left: -190px;
  width: 182px;
  z-index: 10001;
  height: auto;
  max-height: 400px;
  padding: 5px;
  font-size: 8pt;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: Montserrat !important;
}

.floating-edit-emails {
  position: absolute;
  top: -13px;
  right: 0px;
  width: max-content;
  z-index: 10001;
  padding: 10px;
  background-color: #f3f2f2;
  /*border: solid 1px #90a4ae;*/
  font-family: Montserrat;
  text-transform: uppercase;
}

.floating-edit-emails hr {
  margin-top: 0;
}

.floating-edit-phones {
  position: absolute;
  top: -10px;
  right: 42px;
  width: 230px;
  z-index: 10001;
  padding: 10px;
  background-color: #f3f2f2;
  /*border: solid 1px #90a4ae;*/
  /*  border-radius: 5px;*/
  /*  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
}
.floating-sms-presets {
  position: absolute;
  top: -5px;
  left: 0;
  width: max-content;
  z-index: 10001;
  padding: 10px;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  /*  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
  font-size: 13px;
}
.floating-edit-details {
  position: absolute;
  top: 20px;
  left: 40px;
  width: 200px;
  z-index: 10001;
  padding: 10px;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.floating-merge-details {
  position: absolute;
  top: 20px;
  right: 860px;
  width: max-content;
  z-index: 10001;
  padding: 10px;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.floating-assignment-details {
  position: absolute;
  bottom: -10px;
  right: 20px;
  width: 200px;
  z-index: 10001;
  border: solid 1px #ccc;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.floating-lead-menu {
  position: absolute;
  top: 25px;
  right: -10px;
  width: 100px;
  z-index: 10001;
  border: solid 1px #ccc;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.floating-plan-history-table {
  position: absolute;
  top: 120px;
  right: 220px;
  width: max-content;
  z-index: 10001;
  padding: 10px;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.floating-password-reset-history {
  position: absolute;
  top: 100px;
  right: 220px;
  width: max-content;
  z-index: 10001;
  padding: 10px;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.floating-password-reset {
  position: absolute;
  top: 20px;
  right: 55px;
  width: max-content;
  z-index: 10001;
  padding: 10px;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.floating-plan-change {
  position: absolute;
  top: 20px;
  right: 75px;
  width: max-content;
  z-index: 10001;
  border: solid 1px #ccc;
  padding: 10px;

  background-color: #fff;
}
.floating-signals-table-email-count-relay {
  position: absolute;
  top: 380px;
  left: 254px;
  width: 445px;
  z-index: 200000001;
  border: solid 1px #ccc;
  padding: 10px;
  background-color: #fff;
}

.floating-signals-table {
  /*<!--position: absolute;-->*/
  /*<!--top: -45px;-->*/
  /*<!--!*left: 256px;*!-->*/
  /*<!--right: 9px !important;-->*/
  /*<!--width: 900px;-->*/
  /*<!--z-index: 2000000001;-->*/
  /*<!--border: solid 1px #ccc;-->*/
  /*<!--padding: 10px;-->*/
  /*<!--background-color: #fff;-->*/
  /*<!--font-size: 12px;-->*/
  /*<!--text-transform: uppercase;-->*/
  /*<!--flex-direction: row-reverse;-->*/
  /*<!--border-radius: 5px;-->*/
  position: fixed;
  top: 249px;
  /* left: 256px; */
  left: 30px !important;
  width: 883px;
  z-index: 2000000001;
  border: solid 1px #ccc;
  padding: 4px;
  background-color: #fff;
  font-size: 11px;
  text-transform: uppercase;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
  border-radius: 5px;
  max-height: 270px !important;
}

.floating-wrapper {
  position: relative;
  text-align: center;
  /*  font-size: 9px;*/
  font-weight: normal;
  border-radius: 0px;
}
.floating-wrapper-client-op {
  border-radius: 0px;
  position: relative;
  text-align: center;
  font-size: 9px;
  font-weight: normal;
}

.floating-wrapper-client-op-menu {
  position: relative;
}

.floating-wrapper-answers {
  position: relative;
}

.time-range {
  margin-top: 10px;
}

.data-pick {
  font-size: 8pt;
}

.registered-on {
  margin-left: 5px;
  margin-top: -2px;
  width: 170px;
}

.delete-email {
}

.paginationContainer {
  margin-top: 10px;
  margin-left: 10px !important;
  margin-right: 5px;
  width: auto;

  button {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-font-smoothing: subpixel-antialiased;
    font-kerning: normal;
    box-sizing: border-box;
    margin: 0;
    font: inherit;
    overflow: visible;
    text-transform: none;
    -webkit-appearance: button;
    font-family: inherit;
    display: inline-block;
    margin-bottom: 0;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    user-select: none;
    font-size: 12px;
    box-shadow: none !important;
    /*line-height: 18px;*/
    /*font-weight: 400;*/
    color: #555555 !important;
    cursor: pointer;
    border-radius: 0 !important;
    position: relative;
    float: left;
    opacity: 0.4;
    margin-left: 0;
    border-top-left-radius: 2px !important;
    border-bottom-left-radius: 2px !important;
    margin-right: 0 !important;
    background: none !important;
    border: none !important;
    padding: 0 4px !important;
    background-color: Transparent !important;
  }
}

::placeholder {
  color: white;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: white;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: white;
}

/*.nav-tabs {*/

/*margin-bottom: 0;*/
/*margin: 0;*/

/*a {*/
/*  color: black;*/
/*  !*  font-size: 12px;*!*/
/*  !*  transition: background 0.2s ease, color 0.2s ease;*!*/
/*  !*  margin: 0;*!*/

/*  !*  .tab-count {*!*/
/*      color: #ab9b0d;*/
/*  !*  }*!*/
/*  !*}*!*/

/*  !*a:hover {*!*/
/*  color: #1e88e5;*/
/*  !*  margin: 0;*!*/
/*  !*  background-color: white;*!*/
/*  !*  border: none !important;*!*/

/*  .tab-count {*/
/*    color: #ab9b0d;*/
/*    font-weight: 400;*/
/*  }*/
/*}*/
/*li {*/
/*  a {*/
/*    border-radius: unset;*/

/*    }*/
/*  }*/
/*  li.active {*/
/*    !*border-top-color: transparent !important;*!*/
/*    !*font-size: 12px;*!*/
/*    color: #1e88e5;*/

/*    .tab-count {*/
/*      color: #ab9b0d;*/
/*      !*font-weight: 400;*!*/
/*    }*/

/*    a {*/
/*      color:  #1e88e5;*/

/*      !*background-color:*!*/
/*    }*/

/*    a:hover {*/
/*      !*background-color: #44a2d2;*!////////////////*/

/*      !*border: 1px solid lightgrey !important;*!*/
/*      !*border-bottom-color: white !important;*!*/

/*      !*margin: 0;*!//////////////*/

/*        !*margin:0 !important;*!*/

/*    }*/

/*    li.active:hover {*/
/*      !*  border-bottom: 2px solid #44a2d2 !important;*!*/
/*      !*background: #44a2d2;*!*/
/*color: #44a2d2;;*/

/*        !*margin:0 !important;*!*/
/*    }*/
/*  }*/

/*  li:hover {*/
/*    border-top-color: transparent !important;*/
/*      !*margin:0 !important;*!*/

/*    !**/
/*    v*/
/*    background: #e0e0e0;*/
/**!*/
/*  }*/

/*  .non-nav:hover {*/
/*    !*background: transparent;*!*/
/*      margin:0 !important;*/
/*  }*/
/*}*/

/*.nav > li.active:hover{*/
/*    border-style: inset;*/
/*    background-color: white;*/
/*border-top: 1px solid lightgray;*/
/*border-right: 1px solid lightgray;*/
/*border-left: 1px solid lightgray;*/
/*border-bottom: 0px;*/
/*}*/

.nav-tabs > li {
  margin-bottom: unset;
  text-align: center !important;
}

.nav > li > a {
  padding: 10px 10px !important;
  border-radius: unset;
  font-size: 12px;
  color: black;
  font-size: 12px;
  transition: background 0.2s ease, color 0.2s ease;
}
.nav-tabs > li.active > a {
  color: #1e88e5;
  border: 1px solid #ddd;
  background-color: white;
  /*border: none !important;*/
  border-bottom: none !important;
}
.nav-tabs > li.active > a:hover {
  background-color: white;
  border: 1px solid lightgray;
  border-bottom: none !important;
}
.nav > li > a:hover {
  background-color: white;
  border-color: white;
  color: #1e88e5;
}

.tab-count {
  /*  color: #ab9b0d;*/
}

.btn-trash:focus {
  outline: none !important;
}
.btn-trash {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-font-smoothing: subpixel-antialiased;
  /* margin-right: 11px; */
  /* margin-left: 7px; */
  width: 36px;
  margin-top: 0;
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  font-size: 14px;
  cursor: pointer;
  /* float: left; */
  background: none !important;
  border: white !important;
  background-color: Transparent !important;
  border-top-left-radius: 2px !important;
  border-bottom-left-radius: 2px !important;
  padding-left: unset;
  padding-right: unset;
}

.name-input-group {
  /*display: flex;*/
  /*<!--margin-left: -4px;-->*/
  /*padding-right: 0;*/
}

.listview-pagenum {
  text-align: center;
  white-space: nowrap;
  padding: 3px 10px;
  margin-bottom: 6px;
  font-size: 13px;
  color: gray;
}

.listViewPagingInput {
  width: 60px;
  /*width: 70px;*/
  padding: 1px;
  /*margin-top: 5px;*/
  margin-left: 5px;
  font-size: 10pt;
  text-align: center;
  vertical-align: middle;
  height: 24px;
  opacity: 1;
  /*border-radius: 1px;*/
  border-radius: 5px;
  border-style: solid;
  border-color: #808080;
  border-width: thin;
  background-color: #efefef;
  color: gray;
}

.listViewPagingBox {
  /*color: black !important;*/
}

#listViewPagingInputSubmit {
  margin-left: 15px;
  margin-top: 5px;
  border-radius: 5px;
  line-height: 11px;
  cursor: pointer;
  font-weight: 500;
  /*padding: 6px 16px !important;*/
  /*color: black !important;*/
  width: 60px;
  border: thin solid #808080 !important;
  opacity: 1;
  font-size: 11px;
  height: 24px;
}

input[type="search"]::-webkit-search-cancel-button:after {
  color: #808080 !important;
}

.assignment-dropdown-menu {
  border: solid 1px #90a4ae;
  /*  border-radius: 0;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
}

.duplicate-assignment-dropdown-menu {
  position: absolute;
  top: 150px;
  left: 0px;
  padding: 5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
  width: max-content;
  background: white;
  list-style: none;
  z-index: 10001;

  border: solid 1px #90a4ae;
  border-radius: 0;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.bulk-duplicate-assignment-dropdown-menu {
  position: absolute;
  top: 0px;
  left: 700px;
  padding: 5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
  width: max-content;
  background: white;
  list-style: none;
  z-index: 10001;

  border: solid 1px #90a4ae;
  border-radius: 0;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.cancel-edit-menu-item {
  color: #f44336;
  font-weight: bold;
}
.cancel-edit-menu-item-EmailReplayBox {
  color: #f44336;
  font-weight: bold;
  position: absolute;
  top: 187px;
  left: 190px;
  cursor: pointer;
}

.client-op-dropdown {
  position: absolute;
  top: 25px;
  left: 1px;

  z-index: 10001;
  padding: 5px;
  list-style: none;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 0;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.update-country-dropdown {
  border: solid 1px #90a4ae;
  border-radius: 0;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.answers-dropdown {
  width: max-content;
}

.answers-dropdown-menu {
  border: solid 1px #90a4ae;
  border-radius: 0;
  left: -60px;
  position: absolute;
  max-width: 50px !important;
  /*  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
}

.dropdown-menu {
  padding: 5px;
  height: auto;
  max-height: 300px;
  overflow-x: hidden;
  /*max-width: 220px;*/
  width: max-content;
  z-index: 1001 !important;
  /*  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
}

.assign-menu-item {
  margin: 5px;
  font-size: 11px;
  text-transform: uppercase;
  text-align: left;
  padding: 7px;
}

.assign-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}

/*.email-delete-group{
  display: flex;
}*/
.email-checkbox {
  margin-left: -5px;
}

.email-delete-icon {
  color: red;
}

.small-delete-btn {
  color: red;
  margin-left: -2px;
}

.root-layout {
  height: max-content;
  background-color: white;
}

.mng-btn-bar-left {
  width: 45px;
}

.center-assign {
  left: 260px;
  min-width: 100px;
  font-size: 10pt;
  padding: 5px;
  cursor: pointer;
  top: 29px;
  background-color: white;
  z-index: 1;
  border-radius: 10px;
  background-color: #808080;
  max-height: 38.5px;
  width: 221px !important;
}

.center-tag-selected {
  position: relative;
  margin-top: 6px;
  margin-left: 3px;
  left: 200px;
  font-size: 10pt;
  padding: 5px;
}

.center-tag-selected-user {
  position: relative;
  margin-top: 6px;
  margin-left: 3px;
  left: 750px;
  font-size: 10pt;
  padding: 5px;
}

.bulk-assign-dropdown {
  right: 20px;
}

.bulk-assign-a {
  color: #1e88e5;
}

.bulk-assign-a:hover {
  text-decoration: none;
  background: #e0e0e0;
}

.bulk-assign-a-all {
  /*  color: #1e88e5;
  border-top: none;*/
  color: red;
}

.bulk-assign-a-all:hover {
  /*  color: #1e88e5;
    border-top: none;*/
  /*text-decoration: none;*/
  background: #e0e0e0;
  color: red;
}

.bulk-assign-a-cancel {
  color: red !important;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
  outline: none;
  text-transform: capitalize !important;
}

input[type="text"],
textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  /*  padding: 3px 0px 3px 3px;
  margin: 5px 1px 3px 0px;*/
  border: 1px solid #dddddd;
}

input[type="search"]:focus,
textarea:focus {
  /*box-shadow: 0 0 5px rgba(81, 203, 238, 1);*/
  /*!*padding: 3px 0px 3px 3px;*!*/
  outline: none;
  text-transform: capitalize;
  /*border: 1px solid rgba(81, 203, 238, 1);*/
}

.client-checkbox-div {
  margin-right: 5px;
  float: left;
}

.assignment-dropdown {
  margin-left: 22px;
}

.dot-green {
  height: 10px;
  width: 10px;
  background-color: #64dd17;
  border-radius: 50%;
  display: inline-block;
}

.dot-yellow {
  height: 10px;
  width: 10px;
  background-color: #ffd600;
  border-radius: 50%;
  display: inline-block;
}

.dot-red {
  height: 10px;
  width: 10px;
  background-color: #d50000;
  border-radius: 50%;
  display: inline-block;
}

.floating-answer-traffic-lights {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: max-content;
  z-index: 10001;
  padding: 10px;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: Montserrat !important;
  font-size: 12px !important;
}

.fa-chevron-right-black {
  color: black;
  font-weight: 800;
}

.fa-chevron-left-black {
  color: black;
  font-weight: 800;
}

.add-tag-menu-item-title {
  margin-left: 8px;
  font-size: 8pt;
  /* font-weight: bold; */
  text-transform: uppercase;
  max-width: 120px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-top: 2px;
}

/*.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}*/

.span-tab-bd {
  font-weight: 600;
}

.span-tab-ni {
  font-weight: 600;
}

.span-tab-na {
  font-weight: 600;
}

.span-tab-online {
  font-weight: 900;
  color: #008b00 !important;
  font-size: 12px !important;
  /*padding: 6px;*/
}

.span-tab-found {
  font-weight: 600;
  width: 64px;
  color: #ab9b0d !important;
  font-size: 12px !important;
}

.center-msg:hover {
  background: none !important;
}

.center-dup-selected {
  position: relative;
  margin-top: 6px;
  margin-left: 3px;
  left: 200px;
  font-size: 10pt;
  cursor: pointer;
  padding: 5px;
}

.center-filter-selected {
  position: relative;
  display: flex;
  margin-top: 6px;
  margin-left: 3px;
  left: 10px;
  cursor: pointer;
  padding: 5px;
  font-size: 8pt;
}

.new-client-cancel-btn {
  color: red !important;
  float: right;
  margin-right: 5px;
  margin-top: 5px;
}

.new-client-ok-btn {
  color: green !important;
  float: right;
  margin-right: 20px;
  margin-top: 5px;
}

.page-btn {
  font-weight: bold !important;
}

.cms-edit-history-table td {
  border-color: transparent;
}

.cms-edit-history-table-responsive {
  margin-bottom: -18px;
  border-radius: 5px;
}

.cartoon {
  position: absolute;
  height: 265px;
  left: 830px;
}

.cartoon img {
  height: 265px;
}

.online-numbers {
  /*<!--  cursor: pointer;-->*/
  /*<!--  margin-left: 5px;-->*/
  /*<!--  margin-right: -10px;-->*/
  /*<!--  width: fit-content;-->*/
  /*<!--  height: 30px;-->*/
  /*<!--  padding: 4px 4px 4px 4px;-->*/
  /*<!--  //border-radius: 4px;-->*/
  /*<!--  !*-->*/
  /*<!--  border: 1px solid #dee2e6;-->*/
  /*<!--*!-->*/
  /*<!--  color: #18a751;-->*/
  /*<!--  background: #fff;-->*/
  /*<!--  margin-bottom: 5px;-->*/
  /*<!--  max-width: 100%;-->*/
  /*<!--  font-size: 10pt;-->*/
  /*<!--  transition-duration: 0.4s;-->*/

  cursor: pointer;
  margin-left: 5px;
  border-radius: 5px;
  margin-right: -10px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  height: 21px;
  padding: 1px 4px 4px 4px;
  border: 1px solid grey;
  color: grey;
  background: #fff;
  margin-bottom: 5px;
  max-width: 100%;
  font-size: 10pt;
  margin-top: 6px;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
}

.online-numbers:hover {
  /*background-color: #e0e0e0;*/
}

.online-numbers-offline {
  margin-right: -7px;
  margin-left: 7px;
  font-size: 12pt;
}

.online-filter-selected {
  cursor: pointer;
  margin-left: 5px;
  margin-right: -10px;
  width: -webkit-fit-content;
  border-radius: 5px;
  width: -moz-fit-content;
  width: fit-content;
  height: 23px;
  padding: 2px 4px 4px 4px;
  border: 1px solid #18a751;
  color: #18a751;
  background: #fff;
  margin-bottom: 5px;
  max-width: 100%;
  font-size: 10pt;
  margin-top: 4px;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;

  /*cursor: pointer;*/
  /*margin-left: 5px;*/
  /*<!--margin-right: -10px;-->*/
  /*width: fit-content;*/
  /*height: 30px;*/
  /*padding: 4px 4px 4px 4px;*/
  /*
  border-radius: 5px;
*/
  /*color: #008b00;*/
  /*background: #fff;*/
  /*margin-bottom: 5px;*/
  /*max-width: 100%;*/
  /*font-size: 10pt;*/
  /*  box-shadow: 0 0 5px rgba(81, 203, 238, 1);*/
  /*
  border: 1px solid #dee2e6;
*/
  /*
  transition-duration: 0.4s;
*/
}

.online-filter-selected:hover {
  /*  background-color: #e0e0e0;*/
  border: 1px solid #dee2e6;
}

.clear-fix-fn {
  height: 25px;
}

.sms-form-title {
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
}

.sms-preset-list {
  list-style: none;
  padding-left: 0;
  cursor: pointer;
}

.tab-menu-btn {
  cursor: pointer;
  margin-right: 3px;
}

.floating-bn-menu {
  position: absolute;
  left: 146px;
  top: 202px;
}

.floating-ni-menu {
  position: absolute;
  left: 146px;
  top: 202px;
  /*position: relative;*/
  /*top: 10px;*/
  /*<!--right: -114px;-->*/
  /*font-size: 13px !important;*/
  /*text-transform: uppercase;*/
}

.table-locker {
  background-color: black;
  opacity: 0.5;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 45px;
}

.table-locker-text {
  position: absolute;
  left: 30%;
  top: 25%;
  font-size: 30pt;
  color: white;
  opacity: 1;
  background-color: black !important;
}

.block-id-lnk {
  cursor: pointer;
}

.contact-details-edit {
  display: flex;
}

.contact-details-edit-checkboxes {
  display: flex;
}

.contact-details-edit label {
  font-size: 9pt;
  font-weight: normal;
  margin: 5px;
}

.contact-details-edit-checkboxes input {
  margin-top: 6px;
}

.has-error-new-mail {
  color: red;
}

.spinner-email-edit {
  margin-top: -30px;
}

.td-center {
  text-align: left;
}

.text-counter-scheduled {
  float: left;
  font-size: 8pt;
}

.signals-table {
  height: auto;
  max-height: 222px;
  overflow-x: hidden;
}

.signals-spinner {
  position: absolute;
  right: 20px;
  top: 15px;
}

.missed-call {
  background-color: rgba(255, 93, 87, 0.15);
}

.auto-missed-call {
  /*background-color: rgba(242, 222, 222, 0.39);*/
}

.ca-coming {
  background-color: rgba(252, 248, 227, 0.5);
}
.na-reg-close {
  background-color: rgba(145, 13, 111, 0.1);
}
.w100 {
  width: 100%;
}
.mt20 {
  margin-top: 20px;
}
.styleCard {
  background: white !important;
  min-height: 330px;
  /*min-width: fit-content;*/
}
.styleCard-enlarge {
  height: 100%;
}
.w50 {
  width: calc(50%);
}

.left {
  float: left;
}

.margin {
  /*margin: 0.5rem;*/
}

.margin_r_hf {
  /*margin-right: 0.5rem;*/
}

.margin_l_c {
  /*margin-left: 0;*/
}

.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
    background: white;
  */
}

.style-nav.style2 li {
  border-radius: 5px 5px 0px 0px;
  transition: transform 0.1s ease;
}

.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 264px;
  min-width: 72px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(0px) !important;
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}

.styleCardContent {
  background: white;
  min-height: 12rem;
  height: 89%;
}

.padding {
  padding: 1rem;
}

.pageNumbers {
  font-size: 12px !important;
  margin-top: 1px;
}

.bttn {
  font-family: Montserrat !important;
  width: fit-content;
  margin-top: 0.5rem;
  margin-left: 1rem;
  background: #44a2d2;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  /*font-family: inherit;*/
  cursor: pointer;
}
.fa-whatsapp {
  margin-top: -4px;
  margin-right: 5px;
  margin-left: 10px;
  float: right;
  font-size: 20px;
}
/*.fab {
  padding: 2px;
}*/

.sms-send-ico {
  margin-top: -4px;
  margin-right: 5px;
  margin-left: 10px;
  float: right;
  font-size: 20px;
  .fas {
    padding: 2px;
  }
}

.enlarge-div {
  width: 100%;
  height: 5px;
  position: relative;
  /*z-index: 10000;*/
  display: none;
}
.enlarge-table {
  padding-left: 6px;
  padding-right: 6px;
  padding-bottom: 6px;
  padding-top: 6px;
  background: #dadada;
  /*
  border-bottom: solid 1px black;
*/
  /*
  border-radius: 90%;
*/
  position: absolute;
  right: 50%;
  top: -5px;
  margin: auto;
  /*  font-size: 20px;*/
  cursor: pointer;
}
.enlarge-table-down {
  padding-left: 6px;
  padding-right: 6px;
  padding-bottom: 6px;
  background: #dadada;
  /*border-bottom: solid 1px black;*/
  /*
  border-radius: 100%;
*/
  position: absolute;
  right: 50%;
  top: -5px;
  margin: auto;
  /*  font-size: 20px;*/
  cursor: pointer;
  z-index: 1;
  /*  z-index: 15;*/
  display: none;
}

.bttns {
  font-family: Montserrat !important;
  width: fit-content;
  margin-top: 0.5rem;
  margin-left: 1rem;
  background: #efefef;
  color: black;
  border: 0;
  /*border-radius: inherit;*/
  padding: 5px;
  font-size: 12px;
  font-weight: 400;
  /*font-family: inherit;*/
  cursor: pointer;
}
.tnum {
  position: absolute;
  top: 10px;
  margin-right: 10px;
  text-align: center;
  color: #ab9b0d;
}

.tab-ovrd {
  width: 2.58% !important;
}

.nav-tabs li.active a[data-v-8e9bee2a] {
  /*font-weight: 500;*/
  margin: 0;
}
.floating-wrapper div .input-main:hover {
  cursor: pointer !important;
}
.floating-wrapper div .input-main:focus {
  outline: none !important;
  transition: none !important;
  transform: none !important;
}
.input-main {
  text-transform: uppercase !important;
}

input {
  outline: none !important;
}
ul li a {
  align-items: start !important;
}
.move-it-down {
  margin-top: 1px !important;
}

.th-date {
  font-size: 13px;
  text-transform: uppercase;
}

.th-kyword {
  font-size: 13px;
  text-transform: uppercase;
}

.th-device {
  font-size: 13px;
  text-transform: uppercase;
}

.th-campaign-id {
  font-size: 13px;
  text-transform: uppercase;
}

.th-click-on-site {
  font-size: 13px;
  text-transform: uppercase;
}

.th-loc-phys {
  font-size: 13px;
  text-transform: uppercase;
}

.th-ip {
  font-size: 13px;
  text-transform: uppercase;
}
.th-ip input {
  cursor: pointer !important;
}

.th-placement {
  font-size: 13px;
  text-transform: uppercase;
}
.pull-left:hover {
  margin: 0 !important;
}

.temp {
  display: flex;
  flex-direction: row-reverse;
  position: relative;
  padding: 0;
  left: 0;
  background-color: unset;
  width: unset;
}
.signals-table img {
  width: 30px;
}
.sec-td {
  font-size: 10px !important;
  font-weight: 500 !important;
}
.bg-info {
  background-color: white !important;
}

.td-signals {
  padding-top: 5px !important;
  text-align: center !important;
}
.td-signals:nth-child(2) {
  font-size: 11px !important;
}
.forTheMoreBtns {
  position: relative;
  padding-top: 3px;
  text-align: left !important;
  /*position: relative;*/
}

/*.floating-wrapper-client-op .floating-signals-table ul li{*/
/*    width: 200px !important;*/
/*}*/
.floating-wrapper-client-op .floating-signals-table ul li a {
  padding: 0 0 !important;
  width: 125px;
  height: 33px;
  border-radius: 5px;
}

.suggested-users {
  background: yellow;
}
.unsuggested-users {
  background: #f4511e;
  color: white;
}
.forThreeSortingBtns {
  display: flex;
  flex-direction: row;
  position: relative;
}
.fitstSortBtn {
  margin-left: 10px;
}
.sorting-btn {
  cursor: pointer;
  margin-left: 5px;
  width: 20px;
  height: 30px;
  padding: 5px 5px;
  padding-right: 16px !important;
  //border-radius: 4px;
  border: 0;
  color: black;
  background: #d7d7d7;
  margin-bottom: 5px;
  transition-duration: 0.4s;
}
.sorting-btn:focus {
  background-color: #e0e0e0;
  outline: none;
}
.marked {
  background-color: #e0e0e0;
}
.name-recent-sugg-menu {
  position: absolute;
  left: -130px;
}
.mainFlex {
  display: flex;
  max-height: 50px;
}
.colFlex {
  display: flex;
  flex-direction: column;
  min-width: 56px;
}
.topLeft {
  width: 50px;
  height: 6px;
  color: #ab9b0d;
}
.lowLeft {
  width: 50px;
  border-top: dotted 2px black;
  height: 6px;
  color: #ab9b0d;
}
.mainRight {
  width: 67px;
  display: flex;
}
.numInPercents {
  padding-left: 5px;
  color: #ab9b0d !important;
}
.mainRight p {
  margin-top: 8px;
}
.tabName {
  color: #696969 !important;
}
.tabName:hover {
  cursor: pointer;
  color: #44a2d2 !important;
}
.nrTab {
  max-width: 115px;
}
.mergedTab {
  min-width: 150px;
}
.notChoosed {
  margin-top: 11px;
}
.push-down,
.temp {
  margin-top: 5px !important;
}

.table > caption + thead > tr:first-child > th,
.table > colgroup + thead > tr:first-child > th,
.table > thead:first-child > tr:first-child > th,
.table > caption + thead > tr:first-child > td,
.table > colgroup + thead > tr:first-child > td,
.table > thead:first-child > tr:first-child > td {
  border-top: 0;
  //border: none;
}

/*table > thead > tr > th,*/
/*.table > tbody > tr > th,*/
/*.table > tfoot > tr > th,*/
/*.table > thead > tr > td,*/
/*.table > tbody > tr > td,*/
/*.table > tfoot > tr > td {*/
/*  !*padding: 5px !important;*!*/
/*  line-height: 1;*/
/*}*/
.hajbi {
  border: 1px solid black;
}
.odd-nums {
  background-color: #7a7a7a0d;
  box-shadow: inset 1px 1px 5px 3px #00000002;
  border-radius: 5px !important;
}
.odd-nums-selected {
  background-color: #f5f7ff !important;
  box-shadow: inset 1px 1px 5px 3px #00000002;
  border-radius: 5px !important;
}
.colored {
  color: green;
}
.coloredY {
  color: yellow !important;
}
.dNone {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 25%;
  text-align: center;
  font-size: 18px;
  /*z-index: 9999;*/
  /*z-index: 1;*/
  opacity: 0.7;
  border: 4px solid green;
  /*border-top: 4px solid #3498db;*/
  border-radius: 50%;
  width: 15px;
  height: 15px;
  /*animation: spin 2s linear infinite;*/
  top: 2px;
  right: 2px;
}
tr.forLineH {
  height: 40px !important;
  vertical-align: middle;
}
.forLineH td {
  /*padding-top: 8px !important;*/
  /*padding-top: 0px !important;*/
}
table {
  border-collapse: separate !important;
}
/*td { border: solid 1px #000 !important; }*/
tr td:first-child {
  border-top-left-radius: 10px !important;
}
tr td:nth-child(6) {
  border-top-right-radius: 10px !important;
}
tr td:first-child {
  border-bottom-left-radius: 10px !important;
}
tr td:nth-child(6) {
  border-bottom-right-radius: 10px !important;
}

.vertical-scroll-buttons {
  transition: all 0.3s ease-in-out;
  color: #988d23;
  display: flex;
  position: relative;
}
.vertical-scroll-btn-first,
.vertical-scroll-btn-fourth {
  flex: 1;
  outline: none;
  border: none;
  margin-right: 2px;
}
.vertical-scroll-btn-second,
.vertical-scroll-btn-third {
  flex: 4;
  width: 20px;
  /*width: 52px;*/
  /*border-bottom: none;*/
  /*border-top: none;*/
  border: none;
  outline: none;
  font-size: 11.5px;
}
.vertical-scroll-btn-first {
  border-radius: 10px 0px 0px 10px;
  border-bottom: none;
}
.vertical-scroll-btn-fourth {
  border-radius: 0px 10px 10px 0px;
  border-top: none;
}

.vertical-scroll-buttons button:focus {
  background: #d7d7d7;
  color: white;
}
.vertical-scroll-buttons button {
  background: #7a7a7a;
  color: #ffffff;
}
.vertical-scroll-buttons button span {
  font-weight: 500;
}
.vertical-scroll-buttons button:hover {
  background: #515151;
  color: #ffffff;
}
.vertical-scroll-buttons p {
  /*font-size: 10px;*/
  font-size: 14px;
  font-weight: bold;
}
.vertical-scroll-btn-menu:hover {
  background: #6b6a6a;
  color: #ffffff;
}
.vertical-scroll-btn-menu {
  border-radius: 0px 0px 0px 0px;
  background: #a0a0a0;
  color: #ffffff;
  /*margin-right: 2px;*/
  border: none;
  outline: none;
}
.vertical-scroll-btn-menu {
  padding: 1px;
  border: none;
  outline: none;
  width: 122px;
  /* width: fit-content; */
  font-size: 12px;
  /* margin-left: 3px;*/
  min-width: 122px;
}

.vertical-scroll-buttons button[disabled] {
  /*background-color: inherit;*/
  background: #888888;
  opacity: 0.7;
  cursor: not-allowed;
}
.pagination-vertical-dropdown {
  top: 38px;
  left: 28px;
  border-radius: 5px;
  color: #ffffff;
}
.tab-pane-wrapper {
  display: inline-flex;
}
.pagination-vertical-dropdown-down {
  top: 557px;
}
.rotate-pagination-ff {
  transform: rotate(90deg);
}
.center-assign-nav {
  position: absolute;
  left: -166px;
  /*left: -152px;*/
  top: 195px;
}
.favorites-wrapper {
  position: absolute;
  top: 193px;
}

.tab-pane.active.tab-pane-wrapper {
  width: 100%;
}

.f-wrapper {
  //display: flex;

  /*width: 118.5%;*/
}

.name-sort-bar {
  background-color: #00a700;
  width: 200px;
  height: 300px;
  position: absolute;
  top: -337px;
  transition: all 0.3s ease-in-out;

  /*display: none;*/
}
.name-sort-bar-open {
  top: -37px;
  transform: translateY(300px);
}
.tab-sub-menu-btn {
  cursor: pointer;
  /*margin-right: 15px;*/
  /*margin-left: -30px;*/
  /*color: #cbc26f;*/
  color: black;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.tab-sub-menu-btn:hover {
  transform: scale(1.1);
}
.filter-drop-menu {
  /*display: flex;*/
  flex-direction: column;
  /*<!--left: -60px;-->*/
  left: -68px;
}
.filter-drop-menu-btn {
  margin-left: 20px;
  margin-top: 0px;
  margin-right: 10px;
}
.filter-drop-menu-btn i {
  /*color:#cbc26f;*/
  color: black;
  /*background-color: green;*/
  height: 30px;
  width: 30px;
  border-radius: 50%;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  transition: all 0.2s ease-in-out;
}

.filter-drop-menu-btn i:hover {
  opacity: 0.7;
  //transform: scale(1.1);
}
.sort-drop-left {
  flex: 1;
}
.sort-drop-right {
  flex: 1;
}
.sort-drop-center {
  text-align: center;
  padding-left: 8%;
  white-space: nowrap;
  -webkit-box-flex: 10;
  -ms-flex: 10;
  flex: 10;
  padding-top: 4%;
  font-size: 12px;
}
/*.sort-drop-center:nth-child(2), .sort-drop-center:nth-child(1){*/
/*  padding-left: 8%;*/
/*}*/
.sort-drop-flex-wraper {
  display: flex;
}
.sort-drop-flex-wraper:last-of-type {
  margin-bottom: -2px;
}
.dot-right {
  border-radius: 5px 5px 0px 0px;
}
.floating-wrapper .btn-group button {
  font-weight: 600;
  /*margin-right: 20px!important;*/
}

.colored-online-num {
  color: #18a751;
  cursor: pointer;
  margin-left: 5px;
  border-radius: 5px;
  margin-right: -10px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  height: 21px;
  padding: 1px 4px 4px 4px;
  border: 1px solid #18a751;

  background: #fff;
  margin-bottom: 5px;
  max-width: 100%;
  font-size: 10pt;
  margin-top: 6px;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  position: relative;
  top: 4px;
}
.last-input {
}
.bb-wrapper-all {
  flex: 1;
  /*width: 12%;*/
  /*width: 90px;*/
}
.bb-wrapper-all-agent {
  flex: 1;
}
.bb-wrapper-new {
  /*width: 30%;*/
  /*width: 220px;*/
  flex: 1;
}
.bb-wrapper-new-agent {
  flex: 1;
}
.bb-wrapper-ca {
  flex: 1;

  /*width: 32%;*/
  /*width: 235px;*/
}
.bb-wrapper-na {
  flex: 1;
  /*width: 11%;*/
  /*width: 85px;*/
}
.bb-wrapper-tr {
  flex: 1;
  /*margin-right: 10px;*/
  /*width: 4%;*/
  /*width: 35px;*/
}
.bb-wrapper-tr-agent {
  /*margin-right: 0px;*/
}
.bb-wrapper-rf {
  flex: 1;
  /*margin-right: 10px;*/

  /*width: 4%;*/
  /*width: 35px;*/
}
.bb-wrapper-ld {
  flex: 1;
  /*margin-right: 10px;*/

  /*width: 4%;*/
  /*width: 35px;*/
}
.bb-wrapper-dp {
  flex: 1;

  /*width: 15%;*/
  /*width: 110px;*/
}
.bb-wrapper-fn {
  flex: 1;

  /*width: 2%;*/
  /*width: 35px;*/
}
.bb-wrapper-online {
  /*flex: 1;*/
  flex: 0.6;
  /*margin-right: 10px !important;*/
  /*margin-right: 10px;*/

  /*width: 2%;*/
  /*width: 35px;*/
}
.bb-wrapper-sort-menu {
  flex: 1;
}
.bb-wrapper-radio-btn {
  flex: 0.5;
}
.bb-wrapper-arrows-right {
  flex: 1.3;
  display: flex;
}
.bb-wrapper-arrows-left {
  //flex: 2;
  display: flex;
}
.status-tags .floating-wrapper {
  /*margin-right: 3px;*/
}
.status-tags {
  width: 100%;
}
.fa-angle-up {
  /*margin-top: 20px;*/
}
.scroll-middle-wrapper {
  height: 28px;
  width: 100%;
  /*background-color: #0fb97b;*/
  display: flex;
  justify-content: center;
  position: absolute;
  left: 155px;
}
.horizontal-scroll-buttons {
  transition: all 0.3s ease-in-out;
  /*color: #988d23;*/
  color: #cbc26f !important;
  background-color: #efefef !important;
  /*right: 0px;*/
  /*position: absolute;*/
  /* left: 300px; */
  display: flex;
}
.horizontal-scroll-buttons button:focus {
  background: #808080;
  color: #cbc26f;
}
.horizontal-scroll-buttons button:hover {
  background: #808080;
  color: #cbc26f;
}
.btn-online-bb {
  height: 28px;
  padding: 7px 2px;
  font-size: 13px;
  /*width: 33px;*/
  width: 100%;
  max-width: 61px;
  font-weight: 900;
  transition: all 0.2s ease-in;
}
.online-filter-selected-bb {
  color: white;
  background-color: #0fb97b;
  outline: none;
}
.offline-filter-selected-bb {
  /*padding: 0px 2px;*/
  /*width: 33px;*/
}
td.td-signals:nth-child(2),
td.td-signals:nth-child(3) {
  min-width: 100px;
}
td.td-signals:nth-child(7),
td.td-signals:nth-child(8),
td.td-signals:nth-child(9),
td.td-signals:nth-child(10) {
  max-width: 50px;
}
.pull-left:hover,
pull-left active:hover {
  transform: translateY(-5px);
  transition: 1s;
  cursor: pointer;
}
.th-test {
  /*width: 52.5%;*/
  width: 969px !important;
  min-width: 969px !important;
}
.th-test-agent {
  width: 52.5%;
}
.th-plus {
  width: 1.5%;
}
.floating-wrapper.bb-wrapper-sort-menu.widthForIt {
  /*position: absolute;*/
  /*z-index: 1;*/
  /*left: 916px;*/
  background: #d7d7d7;
  border: 1px solid #d7d7d7;
  border-radius: 5px;
  margin: 0 6px 0 6px;
}
.floating-wrapper.bb-wrapper-sort-menu.widthForIt button {
  width: 60px !important;
}

th.th-status .status-main .status-tags .floating-wrapper button:hover {
  /*transform: scale(1.1);*/
}
.btn-online-bb:hover {
  transform: scale(1.1);
}
.fake-tr {
  height: 38.5px;
}
.fake-tr td {
  visibility: hidden;
}
.current-main-tab {
  //padding-top: 8px !important;
  /* padding-left: 5px !important; */
  /*font-weight: 900 !important;*/
  font-size: 11px;
  width: 85px;
  cursor: pointer;
  color: white;
  vertical-align: bottom;
}
input.name-input.last-input {
  //width: 65%;
}

.grandfather {
  //padding-top: 2px;
  padding-left: 0px;
  margin-left: 9px;
  //margin-left: 5px;
  //display: none;
}
.grandfather i {
  /*background-color: green;*/
  height: 25px;
  width: 25px;
  color: white;
  border-radius: 50%;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  transition: all 0.2s ease-in-out;
}
/*.grandfather i:hover {*/
/*  opacity: 0.7;*/
/*  transform: scale(1.1);*/
/*}*/
.fa-dollar-sign {
  background-color: white;
  /*color: #00a700;*/
}
.fa-question {
  /*background-color: palevioletred;*/
}
.fa-bullhorn {
  /*background-color: orange;*/
}
.grandfather .fa-bars {
  background-color: orange;
  /*color: #cbc26f;*/
}
.grandfather .fa-home {
  /*color: goldenrod;*/
  cursor: pointer;
}
div.vertical-scroll-buttons button:disabled {
  cursor: context-menu !important;
}
div.vertical-scroll-buttons button {
  margin-right: 2px;
}
.spans-costs {
  min-width: 76px;
}
span.bb-title {
  position: absolute;
  top: 25px;
  color: black;
  left: 0px;
  font-size: 8px;
}
span.single-bb-title {
  left: 10px;
  top: 28px;
  /*font-weight: normal;*/
  font-weight: 900;
}

div.bb-title-wrapper {
  //position: absolute;
  color: black;
  font-size: 8px;
  width: 100%;
  top: 28px;
  left: 0px;
  text-align: center;
  font-weight: 900;
  //padding-top: 9px;
  // margin-top: 6px !important;
}
.btn-online-bb div.bb-title-wrapper{
  margin-top: 6px !important;
}
//tab-sub-menu-btn.btn.sorting-btn div.bb-title-wrapper {
//margin-top: 0px !important
//}
i.fa-home {
  background-color: #00a700;
  height: 25px;
  width: 25px;
  color: white;
  border-radius: 50%;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  transition: all 0.2s ease-in-out;
  margin-left: 10px;
  cursor: pointer;
  margin-top: 2px;
}
.home-wrapper-second {
  min-width: 35px;
  margin-left: -10px;
}
.forPermitWidth {
  width: 41px;
  //margin-left: -8px;
  flex: 0.6;
  text-align: center;
  padding-top: 6px;
}
.forPermitWidth:focus,
.forPermitWidth:active {
  outline: none !important;
}
i.fa-times-circle:focus,
i.fa-times-circle:active {
  outline: none !important;
}
.forClientAge {
  /*border: 1px solid;*/
  /*height: 25px;*/
  /*padding-top: 3px;*/
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 121px 4px 10px;
  border: 0.1px solid #fff4f4;
  height: 30px;
  /*overflow: hidden;*/
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: normal;
}
.online-active {
  background-color: #1ac51a;
  color: white;
  border-radius: 50%;
  padding: 3px 7px;
  border: 2px solid white;
}

.btn-online-bb,
.online-filter-selected-bb {
  background-color: white;
}
.offline-filter-selected-bb[data-v-4517705f] {
  background-color: #efefef;
  border-radius: 50%;
  padding: 5px 5px;
}
.select-all-wrapper {
  margin-left: 1px;
}
.num-in-i {
  font-size: 8px;
}
.forLineH-status {
  padding-top: 3px !important;
}
div.carousel div.carousel-inner > .active {
  margin-top: -6px !important;
}
th.th-question-11 div.floating-wrapper input.input-main-multi-select {
  min-width: 54%;
}
th.th-question-11 div.floating-wrapper > div {
  text-align: right;
}
.main-table td:nth-child(n + 6) {
  text-align: center;
}
.forDif {
  font-weight: 800;
  color: #ae3ede;
  padding-left: 7px;
  font-size: 10px;
}
.up {
  text-transform: uppercase;
}
.lower {
  text-transform: lowercase;
}
.upper-title {
  text-transform: uppercase;
}
.tab-content {
  //margin-top: 10px;
}
button#dropdownMenu2 {
  padding-top: 8px;
  background: none;
  outline: none;
  border: white;
}
.forAllBtns {
  border-radius: 7px;
  min-width: unset !important;
  max-width: 142px !important;
  width: 129px;
}
i.fas.fa-bars.dropdown-item,
i.fas.fa-dollar-sign.dropdown-item,
i.fas.fa-bullhorn.dropdown-item,
i.fa-question.dropdown-item {
  background: none !important;
  /*border: 1px solid;*/
  padding: 5px;
  /*min-width: 144px;*/
  /*text-align: center;*/
  /*border-radius: 5px;*/
  margin: 5px;
}
.mainforAllBtns {
  /*//min-width: 90px;*/
  width: 123px;
  /* border: 1px solid; */
  background: #808080;
  margin-right: 1px;
  margin-left: -4px;
  /* border-radius: 5px; */
}
.mainforAllBtns:hover {
  background: #6b6a6a;
}
.dropdown.mainforAllBtns.open {
  min-width: 90px;
}

.mainforAllBtns div i {
  cursor: pointer;
  color: grey;
}
.opts span {
  /*font-family: Montserrat !important;*/
  /*font-weight: 500;*/
  /*color: grey;*/
  /*padding-left: 6px;*/
  padding-top: 0 !important;
  /* padding-left: 5px !important; */
  font-weight: 900 !important;
  font-size: 11px;
  width: 85px;
  cursor: pointer;
}
.opts {
  /*<!--margin: -5px;-->*/
  /*<!--border-top: unset !important;-->*/
  /*<!--border-right: unset;-->*/
  /*<!--border-radius: 0px;-->*/
  /*<!--border: 1px solid lightgrey;-->*/
  margin: -5px;
  border-top: unset !important;
  border-right: unset;
  border-radius: 0px;
  border: 1px solid lightgrey;
  /*min-height: 50px;*/
  display: flex;
  /* justify-content: center; */
  align-items: center;
  cursor: pointer;
  min-width: 16px;
  font-size: 13px;
  min-height: 32px;
  text-align: center;
  padding: 10px;
  padding-left: 20px;
}
.opts:hover {
  background-color: lightgrey;
}
.forIcon {
  //min-width: 50px;
  //font-size: 13px;
  min-width: 16px;
  font-size: 13px;
  min-height: 32px;
}
.clickable {
  cursor: pointer !important;
}
.greyed-out {
  opacity: 0.5;
  pointer-events: none;
}
.sms-preset-list .assign-menu-item:last-child {
  text-align: center;
}
.fake-btn-all {
  background: none;
  color: #1ac51a;
  border: none;
  font-size: 10px;
  -webkit-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
  padding-top: 6px;
  width: 100%;
  border-radius: 5px !important;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  outline: none;
  position: relative;
  font-size: 14px;
}

.fake-btn-all:hover,
.fake-btn-all:focus,
.fake-btn-all:active,
.fake-btn-all.active .open .dropdown-toggle.fake-btn-all {
  color: #1ac51a;
  background: none;
  border: none;
  outline: none;
  cursor: default;
}
.btn-all {
  font-size: 10px;
  color: #1ac51a;
  transition: all 0.2s ease-in;
  padding-top: 5px;
  width: 100%;
  border-radius: 5px !important;
  transition: all 0.3s;
  /*background-color: #546e7a;*/
  /*border-color: #546e7a;*/
  outline: none;
  position: relative;
  /*min-height: 27px;*/
  /*min-width: 20px;*/
}

.btn-all:hover,
.btn-all:focus,
.btn-all:active,
.btn-all.active .open .dropdown-toggle.btn-all {
  color: #ffffff;
  background-color: #1ac51a;
  //border-color: #546e7a;
  outline: none;
}
.tags-right-margin {
  margin-right: 7px;
}
/*.tags-scale:hover{*/
/*    transform: scale(1.1);*/
/*  }*/
div.status-tags div.floating-wrapper {
  transition: all 0.25s ease-in;
}
span.pagination-info-span {
  margin-right: 5px;
}
.bb-wrapper-total {
  flex: 1;
}

.forOnOff {
  font-family: "Open Sans";
  font-weight: 300;
  margin: 2rem;
  /*background: #4a4a4a;*/
  -webkit-backface-visibility: hidden;
  margin: 0px !important;
  margin-top: -5px !important;
  padding: 0px !important;
  transform: scale(0.5);
  max-height: 40px;
  right: -4px;
  top: -3px;
  position: absolute;
}

.switch {
  width: 24rem;
  position: relative;
}
.switch input {
  position: absolute;
  top: 0;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
}
.switch input:checked {
  z-index: 1;
}
.switch input:checked + label {
  opacity: 1;
  cursor: default;
}
.switch input:not(:checked) + label:hover {
  opacity: 0.5;
}
.switch label {
  color: #fff;
  opacity: 0.33;
  transition: opacity 0.25s ease;
  cursor: pointer;
}
.switch .toggle-outside {
  height: 100%;
  border-radius: 2rem;
  padding: 0.25rem;
  overflow: hidden;
  transition: 0.25s ease all;
}
.switch .toggle-inside {
  border-radius: 5rem;
  background: #4a4a4a;
  position: absolute;
  transition: 0.25s ease all;
}
.switch--vertical {
  width: 12rem;
  height: 6rem;
}
.switch--vertical input {
  height: 100%;
  width: 3rem;
  right: 0;
  margin: 0;
}
.switch--vertical label {
  font-size: 1.5rem;
  line-height: 3rem;
  display: block;
  width: 8rem;
  height: 50%;
  margin: 0;
  text-align: center;
}
.switch--vertical .toggle-outside {
  background: #fff;
  position: absolute;
  width: 3rem;
  height: 100%;
  right: 0;
  top: 0;
}
.switch--vertical .toggle-inside {
  height: 2.5rem;
  left: 0.25rem;
  top: 0.25rem;
  width: 2.5rem;
}
.switch--vertical input:checked ~ .toggle-outside .toggle-inside {
  top: 0.25rem;
}
.switch--vertical input ~ input:checked ~ .toggle-outside .toggle-inside {
  top: 3.25rem;
}
.switch--no-label label {
  width: 0;
  height: 0;
  visibility: hidden;
  overflow: hidden;
}
.switch--no-label input:checked ~ .toggle-outside .toggle-inside {
  background: #2ecc71;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.switch--no-label input ~ input:checked ~ .toggle-outside {
  background: #fff;
}
.switch--no-label input ~ input:checked ~ .toggle-outside .toggle-inside {
  background: grey;
}
.switch--no-label.switch--vertical {
  width: 3rem;
}
.switch--no-label.switch--horizontal {
  width: 6rem;
}
.switch--no-label.switch--horizontal input,
.switch--no-label.switch--horizontal .toggle-outside {
  left: 0;
}
i.far.fa-times-circle {
  font-size: 20px;
  //position: absolute;
  //top: 242px;
  //left: 34px;
  cursor: pointer;
  font-weight: unset !important;
  line-height: unset !important;
  transition: all 0.25s ease-in;
}
i.far.fa-times-circle:hover {
  transform: translateX(-2px);
  font-size: 23px;
}

.beta-item {
  font-size: 8px;
}
.beta-icon {
  font-size: 10px;
}
.hideIt {
  visibility: hidden !important;
}
.dropdown-menu-assign {
  left: -45px;
  top: 38px;
  border-radius: 5px;
}
.center-assign-btn {
  margin-top: -5px;
  padding: 3px;
  font-size: 11px;
  height: 38px;
  font-weight: 600;
  background-color: #808080;
  border-color: #808080;
}
.center-assign-btn:hover,
.center-assign-btn:focus,
.center-assign-btn:active,
.center-assign-btn.active,
.open .dropdown-toggle.center-assign-btn {
  outline: none;
  cursor: pointer;
  background-color: #808080;
  border-color: #808080;
}

.center-assign-btn-first {
  min-width: 52px !important;
  border-radius: 5px 0px 0px 5px;
  min-width: 186px;
}
.center-assign-btn-last {
  border-radius: 0px 5px 5px 0px !important;
  margin-left: 1px !important;
}
.center-assign-btn:hover {
  filter: brightness(85%);
}
.dropdown-menu-assign::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.dropdown-menu-assign::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
  /*display: none;*/
}

.dropdown-menu-assign::-webkit-scrollbar-thumb {
  background-color: #7a7a7a;
  border: 2px solid #555555;
  border-radius: 5px;
}

.dropdown .dropdown-menu-assign {
  -webkit-transition: max-height 0.3s;
  -moz-transition: max-height 0.3s;
  -ms-transition: max-height 0.3s;
  -o-transition: max-height 0.3s;
  transition: max-height 0.3s;

  max-height: 0;
  display: block;
  //overflow: hidden;
  opacity: 0;
}

.dropdown.open .dropdown-menu-assign {
  max-height: 300px;
  opacity: 1;
}
.for-stats-menu {
  left: -2px !important;
}
.online-selected {
  border-radius: 6px;
  border: 1px solid #0fb97b;
}
.nonOpacity {
  opacity: 0 !important;
}

.forPockeSort {
  height: 10px;
  width: 10px;
  background-image: linear-gradient(red, green);
  position: absolute;
  top: 290px;
  right: 976px;
  cursor: pointer;
  display: none;
}
.rootForPock {
  position: absolute;
  top: 320px;
  left: 868px;
  width: max-content;
  min-width: 161px;
  z-index: 10001;
  padding: 10px;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  font-family: Montserrat;
}
.scroller-div ul {
  list-style-type: none;
}
.scroller-div ul li {
  margin-right: 24px;
  padding-top: 5px;
}
.scroller-div ul li span {
  cursor: pointer;
}
.radio p {
  font-family: Montserrat;
  font-weight: 500;
  padding-left: 19px;
  border-bottom: 1px solid;
}
a.tag-form-ok-btn {
  float: left;
}
a.tag-form-cancel-btn {
  float: right;
}
.title-padding {
  /* //padding-top: 6px !important;*/
}
.invalid-phone{
  color: red;
  font-size: 12px;
  padding: 5px;
}
.gary-back{
  background-color: grey;
}
.tags-menu-wrapper{
  transition: none!important;
}
.totalUnReadEmails{
  color: red;
}

/* ── Professional table styling ── */
.table-main-tag {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}
.table-main-tag thead th {
  background: #f8fafc;
  color: #475569;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 12px 8px;
  border-bottom: 2px solid #e2e8f0;
}
.table-main-tag tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}
.table-main-tag tbody tr:hover {
  background: #f8fafc;
}
.table-main-tag tbody td {
  padding: 8px;
  vertical-align: middle;
  font-size: 13px;
  color: #334155;
}
.newPlusBtn {
  width: 24px;
  height: 24px;
  background: #3b82f6;
  color: white;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}
.newPlusBtn:hover {
  background: #1d4ed8;
  transform: scale(1.1);
}
</style>
